// @__NO_SIDE_EFFECTS__
function kr(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const Re = {}, $n = [], Tn = () => {
}, Jl = () => !1, ps = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), bs = (e) => e.startsWith("onUpdate:"), gt = Object.assign, Zl = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, Ra = Object.prototype.hasOwnProperty, Ae = (e, t) => Ra.call(e, t), ve = Array.isArray, dn = (e) => So(e) === "[object Map]", Jo = (e) => So(e) === "[object Set]", Kr = (e) => So(e) === "[object Date]", Se = (e) => typeof e == "function", De = (e) => typeof e == "string", mt = (e) => typeof e == "symbol", Me = (e) => e !== null && typeof e == "object", Ql = (e) => (Me(e) || Se(e)) && Se(e.then) && Se(e.catch), ei = Object.prototype.toString, So = (e) => ei.call(e), Pa = (e) => So(e).slice(8, -1), ti = (e) => So(e) === "[object Object]", hs = (e) => De(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, so = /* @__PURE__ */ kr(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), ms = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return ((n) => t[n] || (t[n] = e(n)));
}, Da = /-\w/g, rt = ms(
  (e) => e.replace(Da, (t) => t.slice(1).toUpperCase())
), Oa = /\B([A-Z])/g, vn = ms(
  (e) => e.replace(Oa, "-$1").toLowerCase()
), gs = ms((e) => e.charAt(0).toUpperCase() + e.slice(1)), Es = ms(
  (e) => e ? `on${gs(e)}` : ""
), Et = (e, t) => !Object.is(e, t), Ho = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, ni = (e, t, n, o = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: o,
    value: n
  });
}, _r = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Fa = (e) => {
  const t = De(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let qr;
const vs = () => qr || (qr = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function xe(e) {
  if (ve(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const o = e[n], s = De(o) ? ja(o) : xe(o);
      if (s)
        for (const r in s)
          t[r] = s[r];
    }
    return t;
  } else if (De(e) || Me(e))
    return e;
}
const Ba = /;(?![^(]*\))/g, Na = /:([^]+)/, Ua = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function ja(e) {
  const t = {};
  return e.replace(Ua, (n) => n.startsWith("/*") ? "" : n).split(Ba).forEach((n) => {
    if (n) {
      const o = n.split(Na);
      o.length > 1 && (t[o[0].trim()] = o[1].trim());
    }
  }), t;
}
function fe(e) {
  let t = "";
  if (De(e))
    t = e;
  else if (ve(e))
    for (let n = 0; n < e.length; n++) {
      const o = fe(e[n]);
      o && (t += o + " ");
    }
  else if (Me(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const Va = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", Ha = /* @__PURE__ */ kr(Va);
function oi(e) {
  return !!e || e === "";
}
function Ka(e, t, n) {
  if (e.length !== t.length) return !1;
  let o = !0;
  for (let s = 0; o && s < e.length; s++)
    o = ys(e[s], t[s], n);
  return o;
}
function Wr(e, t, n) {
  if (e.size !== t.size) return !1;
  const o = Array.from(t), s = new Uint8Array(o.length);
  for (const r of e) {
    let l = -1;
    for (let i = 0; i < o.length; i++)
      if (!s[i] && ys(r, o[i], n)) {
        l = i;
        break;
      }
    if (l < 0) return !1;
    s[l] = 1;
  }
  return !0;
}
function qa(e, t, n) {
  let o = dn(e), s = dn(t);
  if (o || s || (o = Jo(e), s = Jo(t), o || s))
    return o && s ? Wr(e, t, n) : !1;
  const r = Object.keys(e).length, l = Object.keys(t).length;
  if (r !== l)
    return !1;
  for (const i in e) {
    const a = e.hasOwnProperty(i), d = t.hasOwnProperty(i);
    if (a && !d || !a && d || !ys(e[i], t[i], n))
      return !1;
  }
  return String(e) === String(t);
}
function Yr(e, t, n, o) {
  n || (n = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()]);
  const [s, r] = n;
  if (s.has(e) || r.has(t))
    return s.get(e) === t && r.get(t) === e;
  s.set(e, t), r.set(t, e);
  const l = o(e, t, n);
  return s.delete(e), r.delete(t), l;
}
function ys(e, t, n) {
  if (e === t) return !0;
  let o = Kr(e), s = Kr(t);
  return o || s ? o && s ? e.getTime() === t.getTime() : !1 : (o = mt(e), s = mt(t), o || s ? e === t : (o = ve(e), s = ve(t), o || s ? o && s ? Yr(e, t, n, Ka) : !1 : (o = Me(e), s = Me(t), o || s ? !o || !s ? !1 : Yr(e, t, n, qa) : String(e) === String(t))));
}
const si = (e) => !!(e && e.__v_isRef === !0), q = (e) => De(e) ? e : e == null ? "" : ve(e) || Me(e) && (e.toString === ei || !Se(e.toString)) ? si(e) ? q(e.value) : JSON.stringify(e, ri, 2) : String(e), ri = (e, t) => si(t) ? ri(e, t.value) : dn(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [o, s], r) => (n[Ls(o, r) + " =>"] = s, n),
    {}
  )
} : Jo(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => Ls(n))
} : mt(t) ? Ls(t) : Me(t) && !ve(t) && !ti(t) ? String(t) : t, Ls = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    mt(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
let He;
class Wa {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t = !1) {
    this.detached = t, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !t && He && (He.active ? (this.parent = He, this.index = (He.scopes || (He.scopes = [])).push(
      this
    ) - 1) : (this._active = !1, this._warnOnRun = !1));
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes) {
        const o = this.scopes.slice();
        for (t = 0, n = o.length; t < n; t++)
          o[t].pause();
      }
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes) {
        const s = this.scopes.slice();
        for (t = 0, n = s.length; t < n; t++)
          s[t].resume();
      }
      const o = this.effects.slice();
      for (t = 0, n = o.length; t < n; t++)
        o[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = He;
      try {
        return He = this, t();
      } finally {
        He = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = He, He = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    if (this._on > 0 && --this._on === 0) {
      if (He === this)
        He = this.prevScope;
      else {
        let t = He;
        for (; t; ) {
          if (t.prevScope === this) {
            t.prevScope = this.prevScope;
            break;
          }
          t = t.prevScope;
        }
      }
      this.prevScope = void 0;
    }
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let n, o;
      for (n = 0, o = this.effects.length; n < o; n++)
        this.effects[n].stop();
      for (this.effects.length = 0, n = 0, o = this.cleanups.length; n < o; n++)
        this.cleanups[n]();
      if (this.cleanups.length = 0, this.scopes) {
        const s = this.scopes.slice();
        for (n = 0, o = s.length; n < o; n++)
          s[n].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function Ya() {
  return He;
}
let $e;
const Rs = /* @__PURE__ */ new WeakSet();
class li {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, He && (He.active ? He.effects.push(this) : this.flags &= -2);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Rs.has(this) && (Rs.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || ai(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Gr(this), ci(this);
    const t = $e, n = kt;
    $e = this, kt = !0;
    try {
      return this.fn();
    } finally {
      di(this), $e = t, kt = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Ir(t);
      this.deps = this.depsTail = void 0, Gr(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Rs.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    er(this) && this.run();
  }
  get dirty() {
    return er(this);
  }
}
let ii = 0, ro, lo;
function ai(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = lo, lo = e;
    return;
  }
  e.next = ro, ro = e;
}
function Cr() {
  ii++;
}
function Sr() {
  if (--ii > 0)
    return;
  if (lo) {
    let t = lo;
    for (lo = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; ro; ) {
    let t = ro;
    for (ro = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (o) {
          e || (e = o);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function ci(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function di(e) {
  let t, n = e.depsTail, o = n;
  for (; o; ) {
    const s = o.prevDep;
    o.version === -1 ? (o === n && (n = s), Ir(o), Ga(o)) : t = o, o.dep.activeLink = o.prevActiveLink, o.prevActiveLink = void 0, o = s;
  }
  e.deps = t, e.depsTail = n;
}
function er(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (ui(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function ui(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === uo) || (e.globalVersion = uo, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !er(e))))
    return;
  e.flags |= 2;
  const t = e.dep, n = $e, o = kt;
  $e = e, kt = !0;
  try {
    ci(e);
    const s = e.fn(e._value);
    (t.version === 0 || Et(s, e._value)) && (e.flags |= 128, e._value = s, t.version++);
  } catch (s) {
    throw t.version++, s;
  } finally {
    $e = n, kt = o, di(e), e.flags &= -3;
  }
}
function Ir(e, t = !1) {
  const { dep: n, prevSub: o, nextSub: s } = e;
  if (o && (o.nextSub = s, e.prevSub = void 0), s && (s.prevSub = o, e.nextSub = void 0), n.subs === e && (n.subs = o, !o && n.computed)) {
    n.computed.flags &= -5;
    for (let r = n.computed.deps; r; r = r.nextDep)
      Ir(r, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function Ga(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let kt = !0;
const fi = [];
function pn() {
  fi.push(kt), kt = !1;
}
function bn() {
  const e = fi.pop();
  kt = e === void 0 ? !0 : e;
}
function Gr(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = $e;
    $e = void 0;
    try {
      t();
    } finally {
      $e = n;
    }
  }
}
let uo = 0, Xa = class {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
};
class Ar {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(t) {
    if (!$e || !kt || $e === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== $e)
      n = this.activeLink = new Xa($e, this), $e.deps ? (n.prevDep = $e.depsTail, $e.depsTail.nextDep = n, $e.depsTail = n) : $e.deps = $e.depsTail = n, pi(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const o = n.nextDep;
      o.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = o), n.prevDep = $e.depsTail, n.nextDep = void 0, $e.depsTail.nextDep = n, $e.depsTail = n, $e.deps === n && ($e.deps = o);
    }
    return n;
  }
  trigger(t) {
    this.version++, uo++, this.notify(t);
  }
  notify(t) {
    Cr();
    try {
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      Sr();
    }
  }
}
function pi(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let o = t.deps; o; o = o.nextDep)
        pi(o);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), e.dep.subs = e;
  }
}
const Zo = /* @__PURE__ */ new WeakMap(), En = /* @__PURE__ */ Symbol(
  ""
), tr = /* @__PURE__ */ Symbol(
  ""
), fo = /* @__PURE__ */ Symbol(
  ""
);
function Ge(e, t, n) {
  if (kt && $e) {
    let o = Zo.get(e);
    o || Zo.set(e, o = /* @__PURE__ */ new Map());
    let s = o.get(n);
    s || (o.set(n, s = new Ar()), s.map = o, s.key = n), s.track();
  }
}
function Ht(e, t, n, o, s, r) {
  const l = Zo.get(e);
  if (!l) {
    uo++;
    return;
  }
  const i = (a) => {
    a && a.trigger();
  };
  if (Cr(), t === "clear")
    l.forEach(i);
  else {
    const a = ve(e), d = a && hs(n);
    if (a && n === "length") {
      const c = Number(o);
      l.forEach((f, p) => {
        (p === "length" || p === fo || !mt(p) && p >= c) && i(f);
      });
    } else
      switch ((n !== void 0 || l.has(void 0)) && i(l.get(n)), d && i(l.get(fo)), t) {
        case "add":
          a ? d && i(l.get("length")) : (i(l.get(En)), dn(e) && i(l.get(tr)));
          break;
        case "delete":
          a || (i(l.get(En)), dn(e) && i(l.get(tr)));
          break;
        case "set":
          dn(e) && i(l.get(En));
          break;
      }
  }
  Sr();
}
function Ja(e, t) {
  const n = Zo.get(e);
  return n && n.get(t);
}
function Nn(e) {
  const t = /* @__PURE__ */ _e(e);
  return t === e || (Ge(t, "iterate", fo), /* @__PURE__ */ ht(e)) ? t : /* @__PURE__ */ Rt(e) ? /* @__PURE__ */ un(e) ? t.map((n) => hn(xt(n))) : t.map(hn) : t.map(xt);
}
function xs(e) {
  return Ge(e = /* @__PURE__ */ _e(e), "iterate", fo), e;
}
function zt(e, t) {
  return /* @__PURE__ */ Rt(e) ? hn(/* @__PURE__ */ un(e) ? xt(t) : t) : xt(t);
}
const Za = {
  __proto__: null,
  [Symbol.iterator]() {
    return Ps(this, Symbol.iterator, (e) => zt(this, e));
  },
  concat(...e) {
    return Nn(this).concat(
      ...e.map((t) => ve(t) ? Nn(t) : t)
    );
  },
  entries() {
    return Ps(this, "entries", (e) => (e[1] = zt(this, e[1]), e));
  },
  every(e, t) {
    return Ot(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return Ot(
      this,
      "filter",
      e,
      t,
      (n) => n.map((o) => zt(this, o)),
      arguments
    );
  },
  find(e, t) {
    return Ot(
      this,
      "find",
      e,
      t,
      (n) => zt(this, n),
      arguments
    );
  },
  findIndex(e, t) {
    return Ot(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return Ot(
      this,
      "findLast",
      e,
      t,
      (n) => zt(this, n),
      arguments
    );
  },
  findLastIndex(e, t) {
    return Ot(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return Ot(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return Ds(this, "includes", e);
  },
  indexOf(...e) {
    return Ds(this, "indexOf", e);
  },
  join(e) {
    return Nn(this).join(e);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...e) {
    return Ds(this, "lastIndexOf", e);
  },
  map(e, t) {
    return Ot(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Xn(this, "pop");
  },
  push(...e) {
    return Xn(this, "push", e);
  },
  reduce(e, ...t) {
    return Xr(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Xr(this, "reduceRight", e, t);
  },
  shift() {
    return Xn(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return Ot(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Xn(this, "splice", e);
  },
  toReversed() {
    return Nn(this).toReversed();
  },
  toSorted(e) {
    return Nn(this).toSorted(e);
  },
  toSpliced(...e) {
    return Nn(this).toSpliced(...e);
  },
  unshift(...e) {
    return Xn(this, "unshift", e);
  },
  values() {
    return Ps(this, "values", (e) => zt(this, e));
  }
};
function Ps(e, t, n) {
  const o = xs(e), s = o[t]();
  return o !== e && !/* @__PURE__ */ ht(e) && (s._next = s.next, s.next = () => {
    const r = s._next();
    return r.done || (r.value = n(r.value)), r;
  }), s;
}
const Qa = Array.prototype;
function Ot(e, t, n, o, s, r) {
  const l = xs(e), i = l !== e && !/* @__PURE__ */ ht(e), a = l[t];
  if (a !== Qa[t]) {
    const f = a.apply(e, r);
    return i ? xt(f) : f;
  }
  let d = n;
  l !== e && (i ? d = function(f, p) {
    return n.call(this, zt(e, f), p, e);
  } : n.length > 2 && (d = function(f, p) {
    return n.call(this, f, p, e);
  }));
  const c = a.call(l, d, o);
  return i && s ? s(c) : c;
}
function Xr(e, t, n, o) {
  const s = xs(e), r = s !== e && !/* @__PURE__ */ ht(e);
  let l = n, i = !1;
  s !== e && (r ? (i = o.length === 0, l = function(d, c, f) {
    return i && (i = !1, d = zt(e, d)), n.call(this, d, zt(e, c), f, e);
  }) : n.length > 3 && (l = function(d, c, f) {
    return n.call(this, d, c, f, e);
  }));
  const a = s[t](l, ...o);
  return i ? zt(e, a) : a;
}
function Ds(e, t, n) {
  const o = /* @__PURE__ */ _e(e);
  Ge(o, "iterate", fo);
  const s = o[t](...n);
  return (s === -1 || s === !1) && /* @__PURE__ */ ks(n[0]) ? (n[0] = /* @__PURE__ */ _e(n[0]), o[t](...n)) : s;
}
function Xn(e, t, n = []) {
  pn(), Cr();
  const o = (/* @__PURE__ */ _e(e))[t].apply(e, n);
  return Sr(), bn(), o;
}
const ec = /* @__PURE__ */ kr("__proto__,__v_isRef,__isVue"), bi = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(mt)
);
function tc(e) {
  mt(e) || (e = String(e));
  const t = /* @__PURE__ */ _e(this);
  return Ge(t, "has", e), t.hasOwnProperty(e);
}
class hi {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, o) {
    if (n === "__v_skip") return t.__v_skip;
    const s = this._isReadonly, r = this._isShallow;
    if (n === "__v_isReactive")
      return !s;
    if (n === "__v_isReadonly")
      return s;
    if (n === "__v_isShallow")
      return r;
    if (n === "__v_raw")
      return o === (s ? r ? uc : yi : r ? vi : gi).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(o) ? t : void 0;
    const l = ve(t);
    if (!s) {
      let a;
      if (l && (a = Za[n]))
        return a;
      if (n === "hasOwnProperty")
        return tc;
    }
    const i = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      /* @__PURE__ */ Ve(t) ? t : o
    );
    if ((mt(n) ? bi.has(n) : ec(n)) || (s || Ge(t, "get", n), r))
      return i;
    if (/* @__PURE__ */ Ve(i)) {
      const a = l && hs(n) ? i : i.value;
      return s && Me(a) ? /* @__PURE__ */ or(a) : a;
    }
    return Me(i) ? s ? /* @__PURE__ */ or(i) : /* @__PURE__ */ ws(i) : i;
  }
}
class mi extends hi {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, o, s) {
    let r = t[n];
    const l = ve(t) && hs(n);
    if (!this._isShallow) {
      const d = /* @__PURE__ */ Rt(r);
      if (!/* @__PURE__ */ ht(o) && !/* @__PURE__ */ Rt(o) && (r = /* @__PURE__ */ _e(r), o = /* @__PURE__ */ _e(o)), !l && /* @__PURE__ */ Ve(r) && !/* @__PURE__ */ Ve(o))
        return d || (r.value = o), !0;
    }
    const i = l ? Number(n) < t.length : Ae(t, n), a = Reflect.set(
      t,
      n,
      o,
      /* @__PURE__ */ Ve(t) ? t : s
    );
    return t === /* @__PURE__ */ _e(s) && a && (i ? Et(o, r) && Ht(t, "set", n, o) : Ht(t, "add", n, o)), a;
  }
  deleteProperty(t, n) {
    const o = Ae(t, n);
    t[n];
    const s = Reflect.deleteProperty(t, n);
    return s && o && Ht(t, "delete", n, void 0), s;
  }
  has(t, n) {
    const o = Reflect.has(t, n);
    return (!mt(n) || !bi.has(n)) && Ge(t, "has", n), o;
  }
  ownKeys(t) {
    return Ge(
      t,
      "iterate",
      ve(t) ? "length" : En
    ), Reflect.ownKeys(t);
  }
}
class nc extends hi {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return !0;
  }
  deleteProperty(t, n) {
    return !0;
  }
}
const oc = /* @__PURE__ */ new mi(), sc = /* @__PURE__ */ new nc(), rc = /* @__PURE__ */ new mi(!0);
const nr = (e) => e, Ao = (e) => Reflect.getPrototypeOf(e);
function lc(e, t, n) {
  return function(...o) {
    const s = this.__v_raw, r = /* @__PURE__ */ _e(s), l = dn(r), i = e === "entries" || e === Symbol.iterator && l, a = e === "keys" && l, d = s[e](...o), c = n ? nr : t ? hn : xt;
    return !t && Ge(
      r,
      "iterate",
      a ? tr : En
    ), gt(
      // inheriting all iterator properties
      Object.create(d),
      {
        // iterator protocol
        next() {
          const { value: f, done: p } = d.next();
          return p ? { value: f, done: p } : {
            value: i ? [c(f[0]), c(f[1])] : c(f),
            done: p
          };
        }
      }
    );
  };
}
function Mo(e) {
  return function(...t) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function ic(e, t) {
  const n = {
    get(s) {
      const r = this.__v_raw, l = /* @__PURE__ */ _e(r), i = /* @__PURE__ */ _e(s);
      e || (Et(s, i) && Ge(l, "get", s), Ge(l, "get", i));
      const { has: a } = Ao(l), d = t ? nr : e ? hn : xt;
      if (a.call(l, s))
        return d(r.get(s));
      if (a.call(l, i))
        return d(r.get(i));
      r !== l && r.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !e && Ge(/* @__PURE__ */ _e(s), "iterate", En), s.size;
    },
    has(s) {
      const r = this.__v_raw, l = /* @__PURE__ */ _e(r), i = /* @__PURE__ */ _e(s);
      return e || (Et(s, i) && Ge(l, "has", s), Ge(l, "has", i)), s === i ? r.has(s) : r.has(s) || r.has(i);
    },
    forEach(s, r) {
      const l = this, i = l.__v_raw, a = /* @__PURE__ */ _e(i), d = t ? nr : e ? hn : xt;
      return !e && Ge(a, "iterate", En), i.forEach((c, f) => s.call(r, d(c), d(f), l));
    }
  };
  return gt(
    n,
    e ? {
      add: Mo("add"),
      set: Mo("set"),
      delete: Mo("delete"),
      clear: Mo("clear")
    } : {
      add(s) {
        const r = /* @__PURE__ */ _e(this), l = Ao(r), i = /* @__PURE__ */ _e(s), a = !t && !/* @__PURE__ */ ht(s) && !/* @__PURE__ */ Rt(s) ? i : s;
        return l.has.call(r, a) || Et(s, a) && l.has.call(r, s) || Et(i, a) && l.has.call(r, i) || (r.add(a), Ht(r, "add", a, a)), this;
      },
      set(s, r) {
        !t && !/* @__PURE__ */ ht(r) && !/* @__PURE__ */ Rt(r) && (r = /* @__PURE__ */ _e(r));
        const l = /* @__PURE__ */ _e(this), { has: i, get: a } = Ao(l);
        let d = i.call(l, s);
        d || (s = /* @__PURE__ */ _e(s), d = i.call(l, s));
        const c = a.call(l, s);
        return l.set(s, r), d ? Et(r, c) && Ht(l, "set", s, r) : Ht(l, "add", s, r), this;
      },
      delete(s) {
        const r = /* @__PURE__ */ _e(this), { has: l, get: i } = Ao(r);
        let a = l.call(r, s);
        a || (s = /* @__PURE__ */ _e(s), a = l.call(r, s)), i && i.call(r, s);
        const d = r.delete(s);
        return a && Ht(r, "delete", s, void 0), d;
      },
      clear() {
        const s = /* @__PURE__ */ _e(this), r = s.size !== 0, l = s.clear();
        return r && Ht(
          s,
          "clear",
          void 0,
          void 0
        ), l;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    n[s] = lc(s, e, t);
  }), n;
}
function Mr(e, t) {
  const n = ic(e, t);
  return (o, s, r) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? o : Reflect.get(
    Ae(n, s) && s in o ? n : o,
    s,
    r
  );
}
const ac = {
  get: /* @__PURE__ */ Mr(!1, !1)
}, cc = {
  get: /* @__PURE__ */ Mr(!1, !0)
}, dc = {
  get: /* @__PURE__ */ Mr(!0, !1)
};
const gi = /* @__PURE__ */ new WeakMap(), vi = /* @__PURE__ */ new WeakMap(), yi = /* @__PURE__ */ new WeakMap(), uc = /* @__PURE__ */ new WeakMap();
function fc(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
// @__NO_SIDE_EFFECTS__
function ws(e) {
  return /* @__PURE__ */ Rt(e) ? e : $r(
    e,
    !1,
    oc,
    ac,
    gi
  );
}
// @__NO_SIDE_EFFECTS__
function xi(e) {
  return $r(
    e,
    !1,
    rc,
    cc,
    vi
  );
}
// @__NO_SIDE_EFFECTS__
function or(e) {
  return $r(
    e,
    !0,
    sc,
    dc,
    yi
  );
}
function $r(e, t, n, o, s) {
  if (!Me(e) || e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e))
    return e;
  const r = s.get(e);
  if (r)
    return r;
  const l = fc(Pa(e));
  if (l === 0)
    return e;
  const i = new Proxy(
    e,
    l === 2 ? o : n
  );
  return s.set(e, i), i;
}
// @__NO_SIDE_EFFECTS__
function un(e) {
  return /* @__PURE__ */ Rt(e) ? /* @__PURE__ */ un(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function Rt(e) {
  return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function ht(e) {
  return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function ks(e) {
  return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function _e(e) {
  const t = e && e.__v_raw;
  return t ? /* @__PURE__ */ _e(t) : e;
}
function pc(e) {
  return !Ae(e, "__v_skip") && Object.isExtensible(e) && ni(e, "__v_skip", !0), e;
}
const xt = (e) => Me(e) ? /* @__PURE__ */ ws(e) : e, hn = (e) => Me(e) ? /* @__PURE__ */ or(e) : e;
// @__NO_SIDE_EFFECTS__
function Ve(e) {
  return e ? e.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function U(e) {
  return wi(e, !1);
}
// @__NO_SIDE_EFFECTS__
function wt(e) {
  return wi(e, !0);
}
function wi(e, t) {
  return /* @__PURE__ */ Ve(e) ? e : new bc(e, t);
}
class bc {
  constructor(t, n) {
    this.dep = new Ar(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : /* @__PURE__ */ _e(t), this._value = n ? t : xt(t), this.__v_isShallow = n;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, o = this.__v_isShallow || /* @__PURE__ */ ht(t) || /* @__PURE__ */ Rt(t);
    t = o ? t : /* @__PURE__ */ _e(t), Et(t, n) && (this._rawValue = t, this._value = o ? t : xt(t), this.dep.trigger());
  }
}
function g(e) {
  return /* @__PURE__ */ Ve(e) ? e.value : e;
}
const hc = {
  get: (e, t, n) => t === "__v_raw" ? e : g(Reflect.get(e, t, n)),
  set: (e, t, n, o) => {
    const s = e[t];
    return /* @__PURE__ */ Ve(s) && !/* @__PURE__ */ Ve(n) ? (s.value = n, !0) : Reflect.set(e, t, n, o);
  }
};
function ki(e) {
  return /* @__PURE__ */ un(e) ? e : new Proxy(e, hc);
}
class mc {
  constructor(t, n, o) {
    this._object = t, this._defaultValue = o, this.__v_isRef = !0, this._value = void 0, this._key = mt(n) ? n : String(n), this._raw = /* @__PURE__ */ _e(t);
    let s = !0, r = t;
    if (!ve(t) || mt(this._key) || !hs(this._key))
      do
        s = !/* @__PURE__ */ ks(r) || /* @__PURE__ */ ht(r);
      while (s && (r = r.__v_raw));
    this._shallow = s;
  }
  get value() {
    let t = this._object[this._key];
    return this._shallow && (t = g(t)), this._value = t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    if (this._shallow && /* @__PURE__ */ Ve(this._raw[this._key])) {
      const n = this._object[this._key];
      if (/* @__PURE__ */ Ve(n)) {
        n.value = t;
        return;
      }
    }
    this._object[this._key] = t;
  }
  get dep() {
    return Ja(this._raw, this._key);
  }
}
class gc {
  constructor(t) {
    this._getter = t, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
  }
  get value() {
    return this._value = this._getter();
  }
}
// @__NO_SIDE_EFFECTS__
function _i(e, t, n) {
  return /* @__PURE__ */ Ve(e) ? e : Se(e) ? new gc(e) : Me(e) && arguments.length > 1 ? vc(e, t, n) : /* @__PURE__ */ U(e);
}
function vc(e, t, n) {
  return new mc(e, t, n);
}
class yc {
  constructor(t, n, o) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new Ar(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = uo - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = o;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    $e !== this)
      return ai(this, !0), !0;
  }
  get value() {
    const t = this.dep.track();
    return ui(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter && this.setter(t);
  }
}
// @__NO_SIDE_EFFECTS__
function xc(e, t, n = !1) {
  let o, s;
  return Se(e) ? o = e : (o = e.get, s = e.set), new yc(o, s, n);
}
const $o = {}, Qo = /* @__PURE__ */ new WeakMap();
let Sn;
function wc(e, t = !1, n = Sn) {
  if (n) {
    let o = Qo.get(n);
    o || Qo.set(n, o = []), o.push(e);
  }
}
function kc(e, t, n = Re) {
  const { immediate: o, deep: s, once: r, scheduler: l, augmentJob: i, call: a } = n, d = (k) => s ? k : /* @__PURE__ */ ht(k) || s === !1 || s === 0 ? Kt(k, 1) : Kt(k);
  let c, f, p, v, x = !1, C = !1;
  if (/* @__PURE__ */ Ve(e) ? (f = () => e.value, x = /* @__PURE__ */ ht(e)) : /* @__PURE__ */ un(e) ? (f = () => d(e), x = !0) : ve(e) ? (C = !0, x = e.some((k) => /* @__PURE__ */ un(k) || /* @__PURE__ */ ht(k)), f = () => e.map((k) => {
    if (/* @__PURE__ */ Ve(k))
      return k.value;
    if (/* @__PURE__ */ un(k))
      return d(k);
    if (Se(k))
      return a ? a(k, 2) : k();
  })) : Se(e) ? t ? f = a ? () => a(e, 2) : e : f = () => {
    if (p) {
      pn();
      try {
        p();
      } finally {
        bn();
      }
    }
    const k = Sn;
    Sn = c;
    try {
      return a ? a(e, 3, [v]) : e(v);
    } finally {
      Sn = k;
    }
  } : f = Tn, t && s) {
    const k = f, L = s === !0 ? 1 / 0 : s;
    f = () => Kt(k(), L);
  }
  const A = Ya(), M = () => {
    c.stop(), A && A.active && Zl(A.effects, c);
  };
  if (r && t) {
    const k = t;
    t = (...L) => {
      const z = k(...L);
      return M(), z;
    };
  }
  let y = C ? new Array(e.length).fill($o) : $o;
  const D = (k) => {
    if (!(!(c.flags & 1) || !c.dirty && !k))
      if (t) {
        const L = c.run();
        if (k || s || x || (C ? L.some((z, $) => Et(z, y[$])) : Et(L, y))) {
          p && p();
          const z = Sn;
          Sn = c;
          try {
            const $ = [
              L,
              // pass undefined as the old value when it's changed for the first time
              y === $o ? void 0 : C && y[0] === $o ? [] : y,
              v
            ];
            y = L, a ? a(t, 3, $) : (
              // @ts-expect-error
              t(...$)
            );
          } finally {
            Sn = z;
          }
        }
      } else
        c.run();
  };
  return i && i(D), c = new li(f), c.scheduler = l ? () => l(D, !1) : D, v = (k) => wc(k, !1, c), p = c.onStop = () => {
    const k = Qo.get(c);
    if (k) {
      if (a)
        a(k, 4);
      else
        for (const L of k) L();
      Qo.delete(c);
    }
  }, t ? o ? D(!0) : y = c.run() : l ? l(D.bind(null, !0), !0) : c.run(), M.pause = c.pause.bind(c), M.resume = c.resume.bind(c), M.stop = M, M;
}
function Kt(e, t = 1 / 0, n) {
  if (t <= 0 || !Me(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t))
    return e;
  if (n.set(e, t), t--, /* @__PURE__ */ Ve(e))
    Kt(e.value, t, n);
  else if (ve(e))
    for (let o = 0; o < e.length; o++)
      Kt(e[o], t, n);
  else if (Jo(e) || dn(e))
    e.forEach((o) => {
      Kt(o, t, n);
    });
  else if (ti(e)) {
    for (const o in e)
      Kt(e[o], t, n);
    for (const o of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, o) && Kt(e[o], t, n);
  }
  return e;
}
function Io(e, t, n, o) {
  try {
    return o ? e(...o) : e();
  } catch (s) {
    _s(s, t, n);
  }
}
function _t(e, t, n, o) {
  if (Se(e)) {
    const s = Io(e, t, n, o);
    return s && Ql(s) && s.catch((r) => {
      _s(r, t, n);
    }), s;
  }
  if (ve(e)) {
    const s = [];
    for (let r = 0; r < e.length; r++)
      s.push(_t(e[r], t, n, o));
    return s;
  }
}
function _s(e, t, n, o = !0) {
  const s = t ? t.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: l } = t && t.appContext.config || Re;
  if (t) {
    let i = t.parent;
    const a = t.proxy, d = `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; i; ) {
      const c = i.ec;
      if (c) {
        for (let f = 0; f < c.length; f++)
          if (c[f](e, a, d) === !1)
            return;
      }
      i = i.parent;
    }
    if (r) {
      pn(), Io(r, null, 10, [
        e,
        a,
        d
      ]), bn();
      return;
    }
  }
  _c(e, n, s, o, l);
}
function _c(e, t, n, o = !0, s = !1) {
  if (s)
    throw e;
  console.error(e);
}
const ot = [];
let Mt = -1;
const Vn = [];
let en = null, Un = 0;
const Ci = /* @__PURE__ */ Promise.resolve();
let es = null;
function Lt(e) {
  const t = es || Ci;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Cc(e) {
  let t = Mt + 1, n = ot.length;
  for (; t < n; ) {
    const o = t + n >>> 1, s = ot[o], r = po(s);
    r < e || r === e && s.flags & 2 ? t = o + 1 : n = o;
  }
  return t;
}
function zr(e) {
  if (!(e.flags & 1)) {
    const t = po(e), n = ot[ot.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= po(n) ? ot.push(e) : ot.splice(Cc(t), 0, e), e.flags |= 1, Si();
  }
}
function Si() {
  es || (es = Ci.then(Ai));
}
function Sc(e) {
  if (!ve(e))
    en && e.id === -1 ? en.splice(Un + 1, 0, e) : e.flags & 1 || (Vn.push(e), e.flags |= 1);
  else
    for (let t = 0; t < e.length; t++)
      Vn.push(e[t]);
  Si();
}
function Jr(e, t, n = Mt + 1) {
  for (; n < ot.length; n++) {
    const o = ot[n];
    if (o && o.flags & 2) {
      if (e && o.id !== e.uid)
        continue;
      ot.splice(n, 1), n--, o.flags & 4 && (o.flags &= -2), o(), o.flags & 4 || (o.flags &= -2);
    }
  }
}
function Ii(e) {
  if (Vn.length) {
    const t = [...new Set(Vn)].sort(
      (n, o) => po(n) - po(o)
    );
    if (Vn.length = 0, en) {
      for (let n = 0; n < t.length; n++)
        en.push(t[n]);
      return;
    }
    for (en = t, Un = 0; Un < en.length; Un++) {
      const n = en[Un];
      n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2;
    }
    en = null, Un = 0;
  }
}
const po = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Ai(e) {
  try {
    for (Mt = 0; Mt < ot.length; Mt++) {
      const t = ot[Mt];
      t && !(t.flags & 8) && (t.flags & 4 && (t.flags &= -2), Io(
        t,
        t.i,
        t.i ? 15 : 14
      ), t.flags & 4 || (t.flags &= -2));
    }
  } finally {
    for (; Mt < ot.length; Mt++) {
      const t = ot[Mt];
      t && (t.flags &= -2);
    }
    Mt = -1, ot.length = 0, Ii(), es = null, (ot.length || Vn.length) && Ai();
  }
}
let Ke = null, Mi = null;
function ts(e) {
  const t = Ke;
  return Ke = e, Mi = e && e.type.__scopeId || null, t;
}
function ut(e, t = Ke, n) {
  if (!t || e._n)
    return e;
  const o = (...s) => {
    o._d && ss(-1);
    const r = ts(t), l = Wt.length;
    let i;
    try {
      i = e(...s);
    } finally {
      for (let a = Wt.length; a > l; a--) Pr();
      ts(r), o._d && ss(1);
    }
    return i;
  };
  return o._n = !0, o._c = !0, o._d = !0, o;
}
function Ln(e, t) {
  if (Ke === null)
    return e;
  const n = Ms(Ke), o = e.dirs || (e.dirs = []);
  for (let s = 0; s < t.length; s++) {
    let [r, l, i, a = Re] = t[s];
    r && (Se(r) && (r = {
      mounted: r,
      updated: r
    }), r.deep && Kt(l), o.push({
      dir: r,
      instance: n,
      value: l,
      oldValue: void 0,
      arg: i,
      modifiers: a
    }));
  }
  return e;
}
function yn(e, t, n, o) {
  const s = e.dirs, r = t && t.dirs;
  for (let l = 0; l < s.length; l++) {
    const i = s[l];
    r && (i.oldValue = r[l].value);
    let a = i.dir[o];
    a && (pn(), _t(a, n, 8, [
      e.el,
      i,
      e,
      t
    ]), bn());
  }
}
function Zr(e, t) {
  if (dt) {
    let n = dt.provides;
    const o = dt.parent && dt.parent.provides;
    o === n && (n = dt.provides = Object.create(o)), n[e] = t;
  }
}
function Cs(e, t, n = !1) {
  const o = Qi();
  if (o || Kn) {
    let s = Kn ? Kn._context.provides : o ? o.parent == null || o.ce ? o.vnode.appContext && o.vnode.appContext.provides : o.parent.provides : void 0;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return n && Se(t) ? t.call(o && o.proxy) : t;
  }
}
const Ic = /* @__PURE__ */ Symbol.for("v-scx"), Ac = () => Cs(Ic);
function Pe(e, t, n) {
  return Mc(e, t, n);
}
function Mc(e, t, n = Re) {
  const { immediate: o, deep: s, flush: r, once: l } = n, i = gt({}, n), a = t && o || !t && r !== "post";
  let d;
  if (yo) {
    if (r === "sync") {
      const v = Ac();
      d = v.__watcherHandles || (v.__watcherHandles = []);
    } else if (!a) {
      const v = () => {
      };
      return v.stop = Tn, v.resume = Tn, v.pause = Tn, v;
    }
  }
  const c = dt;
  i.call = (v, x, C) => _t(v, c, x, C);
  let f = !1;
  r === "post" ? i.scheduler = (v) => {
    tt(v, c && c.suspense);
  } : r !== "sync" && (f = !0, i.scheduler = (v, x) => {
    x ? v() : zr(v);
  }), i.augmentJob = (v) => {
    t && (v.flags |= 4), f && (v.flags |= 2, c && (v.id = c.uid, v.i = c));
  };
  const p = kc(e, t, i);
  return yo && (d ? d.push(p) : a && p()), p;
}
const Qt = /* @__PURE__ */ new WeakMap(), $i = /* @__PURE__ */ Symbol("_vte"), Ss = (e) => e.__isTeleport, An = (e) => e && (e.disabled || e.disabled === ""), $c = (e) => e && (e.defer || e.defer === ""), Qr = (e) => typeof SVGElement != "undefined" && e instanceof SVGElement, el = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, sr = (e, t) => {
  const n = e && e.to;
  return De(n) ? t ? t(n) : null : n;
}, zc = {
  name: "Teleport",
  __isTeleport: !0,
  process(e, t, n, o, s, r, l, i, a, d) {
    const {
      mc: c,
      pc: f,
      pbc: p,
      o: { insert: v, querySelector: x, createText: C, createComment: A, parentNode: M }
    } = d, y = An(t.props);
    let { dynamicChildren: D } = t;
    const k = ($, W, N) => {
      $.shapeFlag & 16 && c(
        $.children,
        W,
        N,
        s,
        r,
        l,
        i,
        a
      );
    }, L = ($ = t) => {
      const W = An($.props), N = $.target = sr($.props, x), oe = rr(N, $, C, v);
      N && (l !== "svg" && Qr(N) ? l = "svg" : l !== "mathml" && el(N) && (l = "mathml"), s && s.isCE && (s.ce._teleportTargets || (s.ce._teleportTargets = /* @__PURE__ */ new Set())).add(N), W || (k($, N, oe), to($, !1)));
    }, z = ($) => {
      const W = () => {
        if (Qt.get($) === W) {
          if (Qt.delete($), An($.props)) {
            const N = M($.el) || n;
            k($, N, $.anchor), to($, !0);
          }
          L($);
        }
      };
      Qt.set($, W), tt(W, r);
    };
    if (e == null) {
      const $ = t.el = C(""), W = t.anchor = C("");
      if (v($, n, o), v(W, n, o), $c(t.props) || r && r.pendingBranch) {
        z(t);
        return;
      }
      y && (k(t, n, W), to(t, !0)), L();
    } else {
      t.el = e.el;
      const $ = t.anchor = e.anchor, W = Qt.get(e);
      if (W) {
        W.flags |= 8, Qt.delete(e), z(t);
        return;
      }
      t.targetStart = e.targetStart;
      const N = t.target = e.target, oe = t.targetAnchor = e.targetAnchor, Q = An(e.props), I = Q ? n : N, Y = Q ? $ : oe;
      if (l === "svg" || Qr(N) ? l = "svg" : (l === "mathml" || el(N)) && (l = "mathml"), D ? (p(
        e.dynamicChildren,
        D,
        I,
        s,
        r,
        l,
        i
      ), Rr(e, t, !0)) : a || f(
        e,
        t,
        I,
        Y,
        s,
        r,
        l,
        i,
        !1
      ), y)
        Q ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : zo(
          t,
          n,
          $,
          d,
          1
        );
      else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
        const ge = sr(t.props, x);
        ge && (t.target = ge, zo(
          t,
          ge,
          null,
          d,
          0
        ));
      } else Q && zo(
        t,
        N,
        oe,
        d,
        1
      );
      to(t, y);
    }
  },
  remove(e, t, n, { um: o, o: { remove: s } }, r) {
    const {
      shapeFlag: l,
      children: i,
      anchor: a,
      targetStart: d,
      targetAnchor: c,
      target: f,
      props: p
    } = e, v = An(p), x = r || !v, C = Qt.get(e);
    if (C && (C.flags |= 8, Qt.delete(e)), f && (s(d), s(c)), r && s(a), !C && (v || f) && l & 16)
      for (let A = 0; A < i.length; A++) {
        const M = i[A];
        o(
          M,
          t,
          n,
          x,
          !!M.dynamicChildren
        );
      }
  },
  move: zo,
  hydrate: Tc
};
function zo(e, t, n, { o: { insert: o }, m: s }, r = 2) {
  r === 0 && o(e.targetAnchor, t, n);
  const { el: l, anchor: i, shapeFlag: a, children: d, props: c } = e, f = r === 2;
  if (f && o(l, t, n), !Qt.has(e) && (!f || An(c)) && a & 16)
    for (let p = 0; p < d.length; p++)
      s(
        d[p],
        t,
        n,
        2
      );
  f && o(i, t, n);
}
function Tc(e, t, n, o, s, r, {
  o: { nextSibling: l, parentNode: i, querySelector: a, insert: d, createText: c }
}, f) {
  function p(A, M) {
    let y = M;
    for (; y; ) {
      if (y && y.nodeType === 8) {
        if (y.data === "teleport start anchor")
          t.targetStart = y;
        else if (y.data === "teleport anchor") {
          t.targetAnchor = y, A._lpa = t.targetAnchor && l(t.targetAnchor);
          break;
        }
      }
      y = l(y);
    }
  }
  function v(A, M) {
    M.anchor = f(
      l(A),
      M,
      i(A),
      n,
      o,
      s,
      r
    );
  }
  const x = t.target = sr(
    t.props,
    a
  ), C = An(t.props);
  if (x) {
    const A = x._lpa || x.firstChild;
    t.shapeFlag & 16 && (C ? (v(e, t), p(x, A), t.targetAnchor || rr(
      x,
      t,
      c,
      d,
      // if target is the same as the main view, insert anchors before current node
      // to avoid hydrating mismatch
      i(e) === x ? e : null
    )) : (t.anchor = l(e), p(x, A), t.targetAnchor || rr(x, t, c, d), f(
      A && l(A),
      t,
      x,
      n,
      o,
      s,
      r
    ))), to(t, C);
  } else C && t.shapeFlag & 16 && (v(e, t), t.targetStart = e, t.targetAnchor = l(e));
  return t.anchor && l(t.anchor);
}
const Ec = zc;
function to(e, t) {
  const n = e.ctx;
  if (n && n.ut) {
    let o, s;
    for (t ? (o = e.el, s = e.anchor) : (o = e.targetStart, s = e.targetAnchor); o && o !== s; )
      o.nodeType === 1 && o.setAttribute("data-v-owner", n.uid), o = o.nextSibling;
    n.ut();
  }
}
function rr(e, t, n, o, s = null) {
  const r = t.targetStart = n(""), l = t.targetAnchor = n("");
  return r[$i] = l, e && (o(r, e, s), o(l, e, s)), l;
}
const yt = /* @__PURE__ */ Symbol("_leaveCb"), Jn = /* @__PURE__ */ Symbol("_enterCb");
function Lc() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return Pt(() => {
    e.isMounted = !0;
  }), Je(() => {
    e.isUnmounting = !0;
  }), e;
}
const vt = [Function, Array], zi = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: vt,
  onEnter: vt,
  onAfterEnter: vt,
  onEnterCancelled: vt,
  // leave
  onBeforeLeave: vt,
  onLeave: vt,
  onAfterLeave: vt,
  onLeaveCancelled: vt,
  // appear
  onBeforeAppear: vt,
  onAppear: vt,
  onAfterAppear: vt,
  onAppearCancelled: vt
}, Ti = (e) => {
  const t = e.subTree;
  return t.component ? Ti(t.component) : t;
}, Rc = {
  name: "BaseTransition",
  props: zi,
  setup(e, { slots: t }) {
    const n = Qi(), o = Lc();
    return () => {
      const s = t.default && Ri(t.default(), !0), r = s && s.length ? Ei(s) : (
        // Keep explicit default-slot conditionals on the same transition path
        // as regular v-if branches, which render a comment placeholder.
        n.subTree ? ne() : void 0
      );
      if (!r)
        return;
      const l = /* @__PURE__ */ _e(e), { mode: i } = l;
      if (o.isLeaving)
        return Os(r);
      const a = ns(r);
      if (!a)
        return Os(r);
      let d = lr(
        a,
        l,
        o,
        n,
        // #11061, ensure enterHooks is fresh after clone
        (f) => d = f
      );
      a.type !== Xe && bo(a, d);
      let c = n.subTree && ns(n.subTree);
      if (c && c.type !== Xe && !Mn(c, a) && Ti(n).type !== Xe) {
        let f = lr(
          c,
          l,
          o,
          n
        );
        if (bo(c, f), i === "out-in" && a.type !== Xe)
          return o.isLeaving = !0, f.afterLeave = () => {
            o.isLeaving = !1, n.job.flags & 8 || n.update(), delete f.afterLeave, c = void 0;
          }, Os(r);
        i === "in-out" && a.type !== Xe ? f.delayLeave = (p, v, x) => {
          const C = Li(
            o,
            c
          );
          C[String(c.key)] = c, p[yt] = () => {
            v(), p[yt] = void 0, delete d.delayedLeave, c = void 0;
          }, d.delayedLeave = () => {
            x(), delete d.delayedLeave, c = void 0;
          };
        } : c = void 0;
      } else c && (c = void 0);
      return r;
    };
  }
};
function Ei(e) {
  let t = e[0];
  if (e.length > 1) {
    for (const n of e)
      if (n.type !== Xe) {
        t = n;
        break;
      }
  }
  return t;
}
const Pc = Rc;
function Li(e, t) {
  const { leavingVNodes: n } = e;
  let o = n.get(t.type);
  return o || (o = /* @__PURE__ */ Object.create(null), n.set(t.type, o)), o;
}
function lr(e, t, n, o, s) {
  const {
    appear: r,
    mode: l,
    persisted: i = !1,
    onBeforeEnter: a,
    onEnter: d,
    onAfterEnter: c,
    onEnterCancelled: f,
    onBeforeLeave: p,
    onLeave: v,
    onAfterLeave: x,
    onLeaveCancelled: C,
    onBeforeAppear: A,
    onAppear: M,
    onAfterAppear: y,
    onAppearCancelled: D
  } = t, k = String(e.key), L = Li(n, e), z = (N, oe) => {
    N && _t(
      N,
      o,
      9,
      oe
    );
  }, $ = (N, oe) => {
    const Q = oe[1];
    z(N, oe), ve(N) ? N.every((I) => I.length <= 1) && Q() : N.length <= 1 && Q();
  }, W = {
    mode: l,
    persisted: i,
    beforeEnter(N) {
      let oe = a;
      if (!n.isMounted)
        if (r)
          oe = A || a;
        else
          return;
      N[yt] && N[yt](
        !0
        /* cancelled */
      );
      const Q = L[k];
      Q && Mn(e, Q) && Q.el[yt] && Q.el[yt](), z(oe, [N]);
    },
    enter(N) {
      if (L[k] === e) return;
      let oe = d, Q = c, I = f;
      if (!n.isMounted)
        if (r)
          oe = M || d, Q = y || c, I = D || f;
        else
          return;
      let Y = !1;
      N[Jn] = (de) => {
        Y || (Y = !0, de ? z(I, [N]) : z(Q, [N]), W.delayedLeave && W.delayedLeave(), N[Jn] = void 0);
      };
      const ge = N[Jn].bind(null, !1);
      oe ? $(oe, [N, ge]) : ge();
    },
    leave(N, oe) {
      const Q = String(e.key);
      if (N[Jn] && N[Jn](
        !0
        /* cancelled */
      ), n.isUnmounting)
        return oe();
      z(p, [N]);
      let I = !1;
      N[yt] = (ge) => {
        I || (I = !0, oe(), ge ? z(C, [N]) : z(x, [N]), N[yt] = void 0, L[Q] === e && delete L[Q]);
      };
      const Y = N[yt].bind(null, !1);
      L[Q] = e, v ? $(v, [N, Y]) : Y();
    },
    clone(N) {
      const oe = lr(
        N,
        t,
        n,
        o,
        s
      );
      return s && s(oe), oe;
    }
  };
  return W;
}
function Os(e) {
  if (Tr(e))
    return e = mn(e), e.children = null, e;
}
function ns(e) {
  if (!Tr(e))
    return Ss(e.type) && e.children ? Ei(e.children) : e;
  if (e.component)
    return e.component.subTree;
  const { shapeFlag: t, children: n } = e;
  if (n) {
    if (t & 16)
      return n[0];
    if (t & 32 && Se(n.default))
      return n.default();
  }
}
function bo(e, t) {
  if (e.shapeFlag & 6 && e.component) {
    e.transition = t;
    const n = e.component.subTree;
    bo(
      Ss(n.type) && ns(n) || n,
      t
    );
  } else e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function Ri(e, t = !1, n) {
  let o = [], s = 0;
  for (let r = 0; r < e.length; r++) {
    let l = e[r];
    const i = n == null ? l.key : String(n) + String(l.key != null ? l.key : r);
    l.type === ae ? (l.patchFlag & 128 && s++, o = o.concat(
      Ri(l.children, t, i)
    )) : (t || l.type !== Xe) && o.push(i != null ? mn(l, { key: i }) : l);
  }
  if (s > 1)
    for (let r = 0; r < o.length; r++)
      o[r].patchFlag = -2;
  return o;
}
// @__NO_SIDE_EFFECTS__
function Oe(e, t) {
  return Se(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    gt({ name: e.name }, t, { setup: e })
  ) : e;
}
function Dc(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
function tl(e, t) {
  let n;
  return !!((n = Object.getOwnPropertyDescriptor(e, t)) && !n.configurable);
}
const os = /* @__PURE__ */ new WeakMap();
function io(e, t, n, o, s = !1) {
  if (ve(e)) {
    e.forEach(
      (C, A) => io(
        C,
        t && (ve(t) ? t[A] : t),
        n,
        o,
        s
      )
    );
    return;
  }
  if (Hn(o) && !s) {
    o.shapeFlag & 512 && o.type.__asyncResolved && o.component.subTree.component && io(e, t, n, o.component.subTree);
    return;
  }
  const r = o.shapeFlag & 4 ? Ms(o.component) : o.el, l = s ? null : r, { i, r: a } = e, d = t && t.r, c = i.refs === Re ? i.refs = {} : i.refs, f = i.setupState, p = /* @__PURE__ */ _e(f), v = f === Re ? Jl : (C) => tl(c, C) ? !1 : Ae(p, C), x = (C, A) => !(A && tl(c, A));
  if (d != null && d !== a) {
    if (nl(t), De(d))
      c[d] = null, v(d) && (f[d] = null);
    else if (/* @__PURE__ */ Ve(d)) {
      const C = t;
      x(d, C.k) && (d.value = null), C.k && (c[C.k] = null);
    }
  }
  if (Se(a))
    Io(a, i, 12, [l, c]);
  else {
    const C = De(a), A = /* @__PURE__ */ Ve(a);
    if (C || A) {
      const M = () => {
        if (e.f) {
          const y = C ? v(a) ? f[a] : c[a] : x() || !e.k ? a.value : c[e.k];
          if (s)
            ve(y) && Zl(y, r);
          else if (ve(y))
            y.includes(r) || y.push(r);
          else if (C)
            c[a] = [r], v(a) && (f[a] = c[a]);
          else {
            const D = [r];
            x(a, e.k) && (a.value = D), e.k && (c[e.k] = D);
          }
        } else C ? (c[a] = l, v(a) && (f[a] = l)) : A && (x(a, e.k) && (a.value = l), e.k && (c[e.k] = l));
      };
      if (l) {
        const y = () => {
          M(), os.delete(e);
        };
        y.id = -1, os.set(e, y), tt(y, n);
      } else
        nl(e), M();
    }
  }
}
function nl(e) {
  const t = os.get(e);
  t && (t.flags |= 8, os.delete(e));
}
vs().requestIdleCallback;
vs().cancelIdleCallback;
const Hn = (e) => !!e.type.__asyncLoader, Tr = (e) => e.type.__isKeepAlive;
function Oc(e, t, n = dt, o = !1) {
  if (n) {
    const s = n[e] || (n[e] = []), r = t.__weh || (t.__weh = (...l) => {
      pn();
      const i = Dr(n), a = _t(t, n, e, l);
      return i(), bn(), a;
    });
    return o ? s.unshift(r) : s.push(r), r;
  }
}
const Pi = (e) => (t, n = dt) => {
  (!yo || e === "sp") && Oc(e, (...o) => t(...o), n);
}, Pt = Pi("m"), Je = Pi(
  "bum"
), Fc = "components", Di = /* @__PURE__ */ Symbol.for("v-ndc");
function ho(e) {
  return De(e) ? Bc(Fc, e, !1) || e : e || Di;
}
function Bc(e, t, n = !0, o = !1) {
  const s = Ke || dt;
  if (s) {
    const r = s.type;
    {
      const i = vd(
        r,
        !1
      );
      if (i && (i === t || i === rt(t) || i === gs(rt(t))))
        return r;
    }
    const l = (
      // local registration
      // check instance[type] first which is resolved for options API
      ol(s[e] || r[e], t) || // global registration
      ol(s.appContext[e], t)
    );
    return !l && o ? r : l;
  }
}
function ol(e, t) {
  return e && (e[t] || e[rt(t)] || e[gs(rt(t))]);
}
function Ce(e, t, n, o) {
  let s;
  const r = n, l = ve(e);
  if (l || De(e)) {
    const i = l && /* @__PURE__ */ un(e);
    let a = !1, d = !1;
    i && (a = !/* @__PURE__ */ ht(e), d = /* @__PURE__ */ Rt(e), e = xs(e)), s = new Array(e.length);
    for (let c = 0, f = e.length; c < f; c++)
      s[c] = t(
        a ? d ? hn(xt(e[c])) : xt(e[c]) : e[c],
        c,
        void 0,
        r
      );
  } else if (typeof e == "number") {
    s = new Array(e);
    for (let i = 0; i < e; i++)
      s[i] = t(i + 1, i, void 0, r);
  } else if (Me(e))
    if (e[Symbol.iterator])
      s = Array.from(
        e,
        (i, a) => t(i, a, void 0, r)
      );
    else {
      const i = Object.keys(e);
      s = new Array(i.length);
      for (let a = 0, d = i.length; a < d; a++) {
        const c = i[a];
        s[a] = t(e[c], c, a, r);
      }
    }
  else
    s = [];
  return s;
}
function Nc(e, t, n, o, s, r) {
  if (n == null && (n = {}), Ke.ce || Ke.parent && Hn(Ke.parent) && Ke.parent.ce) {
    const d = n, c = Object.keys(d).length > 0;
    return h(), we(
      ae,
      null,
      [O("slot", d, o)],
      c ? -2 : 64
    );
  }
  let l = e[t];
  l && l._c && (l._d = !1);
  const i = Wt.length;
  h();
  let a;
  try {
    const d = l && Oi(l(n)), c = n.key || r || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    d && d.key;
    a = we(
      ae,
      {
        key: (c && !mt(c) ? c : `_${t}`) + // #7256 force differentiate fallback content from actual content
        (!d && o ? "_fb" : "")
      },
      d || (o ? o() : []),
      d && e._ === 1 ? 64 : -2
    );
  } catch (d) {
    for (let c = Wt.length; c > i; c--) Pr();
    throw d;
  } finally {
    l && l._c && (l._d = !0);
  }
  return a.scopeId && (a.slotScopeIds = [a.scopeId + "-s"]), a;
}
function Oi(e) {
  return e.some((t) => go(t) ? !(t.type === Xe || t.type === ae && !Oi(t.children)) : !0) ? e : null;
}
const ir = (e) => e ? ea(e) ? Ms(e) : ir(e.parent) : null, ao = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ gt(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => ir(e.parent),
    $root: (e) => ir(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => e.type,
    $forceUpdate: (e) => e.f || (e.f = () => {
      zr(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = Lt.bind(e.proxy)),
    $watch: (e) => Tn
  })
), Fs = (e, t) => e !== Re && !e.__isScriptSetup && Ae(e, t), Uc = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: o, data: s, props: r, accessCache: l, type: i, appContext: a } = e;
    if (t[0] !== "$") {
      const p = l[t];
      if (p !== void 0)
        switch (p) {
          case 1:
            return o[t];
          case 2:
            return s[t];
          case 4:
            return n[t];
          case 3:
            return r[t];
        }
      else {
        if (Fs(o, t))
          return l[t] = 1, o[t];
        if (Ae(r, t))
          return l[t] = 3, r[t];
        if (n !== Re && Ae(n, t))
          return l[t] = 4, n[t];
        l[t] = 0;
      }
    }
    const d = ao[t];
    let c, f;
    if (d)
      return t === "$attrs" && Ge(e.attrs, "get", ""), d(e);
    if (
      // css module (injected by vue-loader)
      (c = i.__cssModules) && (c = c[t])
    )
      return c;
    if (n !== Re && Ae(n, t))
      return l[t] = 4, n[t];
    if (
      // global properties
      f = a.config.globalProperties, Ae(f, t)
    )
      return f[t];
  },
  set({ _: e }, t, n) {
    const { data: o, setupState: s, ctx: r } = e;
    return Fs(s, t) ? (s[t] = n, !0) : Ae(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (r[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: o, appContext: s, props: r, type: l }
  }, i) {
    let a;
    return !!(n[i] || Fs(t, i) || Ae(r, i) || Ae(o, i) || Ae(ao, i) || Ae(s.config.globalProperties, i) || (a = l.__cssModules) && a[i]);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : Ae(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
function Fi() {
  return {
    app: null,
    config: {
      isNativeTag: Jl,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let jc = 0;
function Vc(e, t) {
  return function(o, s = null) {
    Se(o) || (o = gt({}, o)), s != null && !Me(s) && (s = null);
    const r = Fi(), l = /* @__PURE__ */ new WeakSet(), i = [];
    let a = !1;
    const d = r.app = {
      _uid: jc++,
      _component: o,
      _props: s,
      _container: null,
      _context: r,
      _instance: null,
      version: xd,
      get config() {
        return r.config;
      },
      set config(c) {
      },
      use(c, ...f) {
        return l.has(c) || (c && Se(c.install) ? (l.add(c), c.install(d, ...f)) : Se(c) && (l.add(c), c(d, ...f))), d;
      },
      mixin(c) {
        return d;
      },
      component(c, f) {
        return f ? (r.components[c] = f, d) : r.components[c];
      },
      directive(c, f) {
        return f ? (r.directives[c] = f, d) : r.directives[c];
      },
      mount(c, f, p) {
        if (!a) {
          const v = d._ceVNode || O(o, s);
          return v.appContext = r, p === !0 ? p = "svg" : p === !1 && (p = void 0), e(v, c, p), a = !0, d._container = c, c.__vue_app__ = d, Ms(v.component);
        }
      },
      onUnmount(c) {
        i.push(c);
      },
      unmount() {
        a && (_t(
          i,
          d._instance,
          16
        ), e(null, d._container), delete d._container.__vue_app__);
      },
      provide(c, f) {
        return r.provides[c] = f, d;
      },
      runWithContext(c) {
        const f = Kn;
        Kn = d;
        try {
          return c();
        } finally {
          Kn = f;
        }
      }
    };
    return d;
  };
}
let Kn = null;
const Hc = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${rt(t)}Modifiers`] || e[`${vn(t)}Modifiers`];
function Kc(e, t, ...n) {
  if (e.isUnmounted) return;
  const o = e.vnode.props || Re;
  let s = n;
  const r = t.startsWith("update:"), l = r && Hc(o, t.slice(7));
  l && (l.trim && (s = n.map((c) => De(c) ? c.trim() : c)), l.number && (s = s.map(_r)));
  let i, a = o[i = Es(t)] || // also try camelCase event handler (#2249)
  o[i = Es(rt(t))];
  !a && r && (a = o[i = Es(vn(t))]), a && _t(
    a,
    e,
    6,
    s
  );
  const d = o[i + "Once"];
  if (d) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[i])
      return;
    e.emitted[i] = !0, _t(
      d,
      e,
      6,
      s
    );
  }
}
function qc(e, t, n = !1) {
  const o = t.emitsCache, s = o.get(e);
  if (s !== void 0)
    return s;
  const r = e.emits;
  let l = {};
  return r ? (ve(r) ? r.forEach((i) => l[i] = null) : gt(l, r), Me(e) && o.set(e, l), l) : (Me(e) && o.set(e, null), null);
}
function Is(e, t) {
  return !e || !ps(t) ? !1 : (t = t.slice(2), t = t === "Once" ? t : t.replace(/Once$/, ""), Ae(e, t[0].toLowerCase() + t.slice(1)) || Ae(e, vn(t)) || Ae(e, t));
}
function sl(e) {
  const {
    type: t,
    vnode: n,
    proxy: o,
    withProxy: s,
    propsOptions: [r],
    slots: l,
    attrs: i,
    emit: a,
    render: d,
    renderCache: c,
    props: f,
    data: p,
    setupState: v,
    ctx: x,
    inheritAttrs: C
  } = e, A = ts(e);
  let M, y;
  try {
    if (n.shapeFlag & 4) {
      const k = s || o, L = k;
      M = Tt(
        d.call(
          L,
          k,
          c,
          f,
          v,
          p,
          x
        )
      ), y = i;
    } else {
      const k = t;
      M = Tt(
        k.length > 1 ? k(
          f,
          { attrs: i, slots: l, emit: a }
        ) : k(
          f,
          null
        )
      ), y = t.props ? i : Wc(i);
    }
  } catch (k) {
    Wt.length = 0, _s(k, e, 1), M = O(Xe);
  }
  let D = M;
  if (y && C !== !1) {
    const k = Object.keys(y), { shapeFlag: L } = D;
    k.length && L & 7 && (r && k.some(bs) && (y = Yc(
      y,
      r
    )), D = mn(D, y, !1, !0));
  }
  if (n.dirs && (D = mn(D, null, !1, !0), D.dirs = D.dirs ? D.dirs.concat(n.dirs) : n.dirs), n.transition) {
    const k = Ss(D.type) && ns(D) || D;
    bo(k, n.transition);
  }
  return M = D, ts(A), M;
}
const Wc = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || ps(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, Yc = (e, t) => {
  const n = {};
  for (const o in e)
    (!bs(o) || !(o.slice(9) in t)) && (n[o] = e[o]);
  return n;
};
function Gc(e, t, n) {
  const { props: o, children: s, component: r } = e, { props: l, children: i, patchFlag: a } = t, d = r.emitsOptions;
  if (t.dirs || t.transition)
    return !0;
  if (n && a >= 0) {
    if (a & 1024)
      return !0;
    if (a & 16)
      return o ? rl(o, l, d) : !!l;
    if (a & 8) {
      const c = t.dynamicProps;
      for (let f = 0; f < c.length; f++) {
        const p = c[f];
        if (Bi(l, o, p) && !Is(d, p))
          return !0;
      }
    }
  } else
    return (s || i) && (!i || !i.$stable) ? !0 : o === l ? !1 : o ? l ? rl(o, l, d) : !0 : !!l;
  return !1;
}
function rl(e, t, n) {
  const o = Object.keys(t);
  if (o.length !== Object.keys(e).length)
    return !0;
  for (let s = 0; s < o.length; s++) {
    const r = o[s];
    if (Bi(t, e, r) && !Is(n, r))
      return !0;
  }
  return !1;
}
function Bi(e, t, n) {
  const o = e[n], s = t[n];
  return n === "style" && Me(o) && Me(s) ? !ys(o, s) : o !== s;
}
function Xc({ vnode: e, parent: t, suspense: n }, o) {
  for (; t; ) {
    const s = t.subTree;
    if (s.suspense && s.suspense.activeBranch === e && (s.suspense.vnode.el = s.el = o, e = s), s === e)
      (e = t.vnode).el = o, t = t.parent;
    else
      break;
  }
  n && n.activeBranch === e && (n.vnode.el = o);
}
const Ni = {}, Ui = () => Object.create(Ni), ji = (e) => Object.getPrototypeOf(e) === Ni;
function Jc(e, t, n, o = !1) {
  const s = {}, r = Ui();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Vi(e, t, s, r);
  for (const l in e.propsOptions[0])
    l in s || (s[l] = void 0);
  n ? e.props = o ? s : /* @__PURE__ */ xi(s) : e.type.props ? e.props = s : e.props = r, e.attrs = r;
}
function Zc(e, t, n, o) {
  const {
    props: s,
    attrs: r,
    vnode: { patchFlag: l }
  } = e, i = /* @__PURE__ */ _e(s), [a] = e.propsOptions;
  let d = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (o || l > 0) && !(l & 16)
  ) {
    if (l & 8) {
      const c = e.vnode.dynamicProps;
      for (let f = 0; f < c.length; f++) {
        let p = c[f];
        if (Is(e.emitsOptions, p))
          continue;
        const v = t[p];
        if (a)
          if (Ae(r, p))
            v !== r[p] && (r[p] = v, d = !0);
          else {
            const x = rt(p);
            s[x] = ar(
              a,
              i,
              x,
              v,
              e,
              !1
            );
          }
        else
          v !== r[p] && (r[p] = v, d = !0);
      }
    }
  } else {
    Vi(e, t, s, r) && (d = !0);
    let c;
    for (const f in i)
      (!t || // for camelCase
      !Ae(t, f) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = vn(f)) === f || !Ae(t, c))) && (a ? n && // for camelCase
      (n[f] !== void 0 || // for kebab-case
      n[c] !== void 0) && (s[f] = ar(
        a,
        i,
        f,
        void 0,
        e,
        !0
      )) : delete s[f]);
    if (r !== i)
      for (const f in r)
        (!t || !Ae(t, f)) && (delete r[f], d = !0);
  }
  d && Ht(e.attrs, "set", "");
}
function Vi(e, t, n, o) {
  const [s, r] = e.propsOptions;
  let l = !1, i;
  if (t)
    for (let a in t) {
      if (so(a))
        continue;
      const d = t[a];
      let c;
      s && Ae(s, c = rt(a)) ? !r || !r.includes(c) ? n[c] = d : (i || (i = {}))[c] = d : Is(e.emitsOptions, a) || (!(a in o) || d !== o[a]) && (o[a] = d, l = !0);
    }
  if (r) {
    const a = /* @__PURE__ */ _e(n), d = i || Re;
    for (let c = 0; c < r.length; c++) {
      const f = r[c];
      n[f] = ar(
        s,
        a,
        f,
        d[f],
        e,
        !Ae(d, f)
      );
    }
  }
  return l;
}
function ar(e, t, n, o, s, r) {
  const l = e[n];
  if (l != null) {
    const i = Ae(l, "default");
    if (i && o === void 0) {
      const a = l.default;
      if (l.type !== Function && !l.skipFactory && Se(a)) {
        const { propsDefaults: d } = s;
        if (n in d)
          o = d[n];
        else {
          const c = Dr(s);
          o = d[n] = a.call(
            null,
            t
          ), c();
        }
      } else
        o = a;
      s.ce && s.ce._setProp(n, o);
    }
    l[
      0
      /* shouldCast */
    ] && (r && !i ? o = !1 : l[
      1
      /* shouldCastTrue */
    ] && (o === "" || o === vn(n)) && (o = !0));
  }
  return o;
}
function Qc(e, t, n = !1) {
  const o = t.propsCache, s = o.get(e);
  if (s)
    return s;
  const r = e.props, l = {}, i = [];
  if (!r)
    return Me(e) && o.set(e, $n), $n;
  if (ve(r))
    for (let d = 0; d < r.length; d++) {
      const c = rt(r[d]);
      ll(c) && (l[c] = Re);
    }
  else if (r)
    for (const d in r) {
      const c = rt(d);
      if (ll(c)) {
        const f = r[d], p = l[c] = ve(f) || Se(f) ? { type: f } : gt({}, f), v = p.type;
        let x = !1, C = !0;
        if (ve(v))
          for (let A = 0; A < v.length; ++A) {
            const M = v[A], y = Se(M) && M.name;
            if (y === "Boolean") {
              x = !0;
              break;
            } else y === "String" && (C = !1);
          }
        else
          x = Se(v) && v.name === "Boolean";
        p[
          0
          /* shouldCast */
        ] = x, p[
          1
          /* shouldCastTrue */
        ] = C, (x || Ae(p, "default")) && i.push(c);
      }
    }
  const a = [l, i];
  return Me(e) && o.set(e, a), a;
}
function ll(e) {
  return e[0] !== "$" && !so(e);
}
const Er = (e) => e === "_" || e === "_ctx" || e === "$stable", Lr = (e) => ve(e) ? e.map(Tt) : [Tt(e)], ed = (e, t, n) => {
  if (t._n)
    return t;
  const o = ut((...s) => Lr(t(...s)), n);
  return o._c = !1, o;
}, Hi = (e, t, n) => {
  const o = e._ctx;
  for (const s in e) {
    if (Er(s)) continue;
    const r = e[s];
    if (Se(r))
      t[s] = ed(s, r, o);
    else if (r != null) {
      const l = Lr(r);
      t[s] = () => l;
    }
  }
}, Ki = (e, t) => {
  const n = Lr(t);
  e.slots.default = () => n;
}, qi = (e, t, n) => {
  for (const o in t)
    (n || !Er(o)) && (e[o] = t[o]);
}, td = (e, t, n) => {
  const o = e.slots = Ui();
  if (e.vnode.shapeFlag & 32) {
    const s = t._;
    s ? (qi(o, t, n), n && ni(o, "_", s, !0)) : Hi(t, o);
  } else t && Ki(e, t);
}, nd = (e, t, n) => {
  const { vnode: o, slots: s } = e;
  let r = !0, l = Re;
  if (o.shapeFlag & 32) {
    const i = t._;
    i ? n && i === 1 ? r = !1 : qi(s, t, n) : (r = !t.$stable, Hi(t, s)), l = t;
  } else t && (Ki(e, t), l = { default: 1 });
  if (r)
    for (const i in s)
      !Er(i) && l[i] == null && delete s[i];
}, tt = id;
function od(e) {
  return sd(e);
}
function sd(e, t) {
  const n = vs();
  n.__VUE__ = !0;
  const {
    insert: o,
    remove: s,
    patchProp: r,
    createElement: l,
    createText: i,
    createComment: a,
    setText: d,
    setElementText: c,
    parentNode: f,
    nextSibling: p,
    setScopeId: v = Tn,
    insertStaticContent: x
  } = e, C = (b, m, R, H = null, B = null, j = null, ee = void 0, Z = null, G = !!m.dynamicChildren) => {
    if (b === m)
      return;
    b && !Mn(b, m) && (H = pe(b), ze(b, B, j, !0), b = null), m.patchFlag === -2 && (G = !1, m.dynamicChildren = null), m.dynamicChildren && b && b.dynamicChildren && b.dynamicChildren.hasOnce && (m.dynamicChildren === $n && (m.dynamicChildren = []), m.dynamicChildren.hasOnce = !0);
    const { type: V, ref: se, shapeFlag: te } = m;
    switch (V) {
      case As:
        A(b, m, R, H);
        break;
      case Xe:
        M(b, m, R, H);
        break;
      case Ko:
        b == null && y(m, R, H, ee);
        break;
      case ae:
        I(
          b,
          m,
          R,
          H,
          B,
          j,
          ee,
          Z,
          G
        );
        break;
      default:
        te & 1 ? L(
          b,
          m,
          R,
          H,
          B,
          j,
          ee,
          Z,
          G
        ) : te & 6 ? Y(
          b,
          m,
          R,
          H,
          B,
          j,
          ee,
          Z,
          G
        ) : (te & 64 || te & 128) && V.process(
          b,
          m,
          R,
          H,
          B,
          j,
          ee,
          Z,
          G,
          Te
        );
    }
    se != null && B ? io(se, b && b.ref, j, m || b, !m) : se == null && b && b.ref != null && io(b.ref, null, j, b, !0);
  }, A = (b, m, R, H) => {
    if (b == null)
      o(
        m.el = i(m.children),
        R,
        H
      );
    else {
      const B = m.el = b.el;
      m.children !== b.children && d(B, m.children);
    }
  }, M = (b, m, R, H) => {
    b == null ? o(
      m.el = a(m.children || ""),
      R,
      H
    ) : m.el = b.el;
  }, y = (b, m, R, H) => {
    [b.el, b.anchor] = x(
      b.children,
      m,
      R,
      H,
      b.el,
      b.anchor
    );
  }, D = ({ el: b, anchor: m }, R, H) => {
    let B;
    for (; b && b !== m; )
      B = p(b), o(b, R, H), b = B;
    o(m, R, H);
  }, k = ({ el: b, anchor: m }) => {
    let R;
    for (; b && b !== m; )
      R = p(b), s(b), b = R;
    s(m);
  }, L = (b, m, R, H, B, j, ee, Z, G) => {
    if (m.type === "svg" ? ee = "svg" : m.type === "math" && (ee = "mathml"), b == null)
      z(
        m,
        R,
        H,
        B,
        j,
        ee,
        Z,
        G
      );
    else {
      const V = b.el && b.el._isVueCE ? b.el : null;
      try {
        V && V._beginPatch(), N(
          b,
          m,
          B,
          j,
          ee,
          Z,
          G
        );
      } finally {
        V && V._endPatch();
      }
    }
  }, z = (b, m, R, H, B, j, ee, Z) => {
    let G, V;
    const { props: se, shapeFlag: te, transition: le, dirs: ie } = b;
    if (G = b.el = l(
      b.type,
      j,
      se && se.is,
      se
    ), te & 8 ? c(G, b.children) : te & 16 && W(
      b.children,
      G,
      null,
      H,
      B,
      Bs(b, j),
      ee,
      Z
    ), ie && yn(b, null, H, "created"), $(G, b, b.scopeId, ee, H), se) {
      for (const F in se)
        F !== "value" && !so(F) && r(G, F, null, se[F], j, H);
      "value" in se && r(G, "value", null, se.value, j), (V = se.onVnodeBeforeMount) && It(V, H, b);
    }
    ie && yn(b, null, H, "beforeMount");
    const P = rd(B, le);
    P && le.beforeEnter(G), o(G, m, R), ((V = se && se.onVnodeMounted) || P || ie) && tt(() => {
      V && It(V, H, b), P && le.enter(G), ie && yn(b, null, H, "mounted");
    }, B);
  }, $ = (b, m, R, H, B) => {
    if (R && v(b, R), H)
      for (let j = 0; j < H.length; j++)
        v(b, H[j]);
    if (B) {
      let j = B.subTree;
      if (m === j || Gi(j.type) && (j.ssContent === m || j.ssFallback === m)) {
        const ee = B.vnode;
        $(
          b,
          ee,
          ee.scopeId,
          ee.slotScopeIds,
          B.parent
        );
      }
    }
  }, W = (b, m, R, H, B, j, ee, Z, G = 0) => {
    for (let V = G; V < b.length; V++) {
      const se = b[V] = Z ? Vt(b[V]) : Tt(b[V]);
      C(
        null,
        se,
        m,
        R,
        H,
        B,
        j,
        ee,
        Z
      );
    }
  }, N = (b, m, R, H, B, j, ee) => {
    const Z = m.el = b.el;
    let { patchFlag: G, dynamicChildren: V, dirs: se } = m;
    G |= b.patchFlag & 16;
    const te = b.props || Re, le = m.props || Re;
    let ie;
    if (R && xn(R, !1), (ie = le.onVnodeBeforeUpdate) && It(ie, R, m, b), se && yn(m, b, R, "beforeUpdate"), R && xn(R, !0), // #6385 the old vnode may be a user-wrapped non-isomorphic block
    // Force full diff when block metadata is unstable.
    V && (!b.dynamicChildren || b.dynamicChildren.length !== V.length) && (G = 0, ee = !1, V = null), (te.innerHTML && le.innerHTML == null || te.textContent && le.textContent == null) && c(Z, ""), V ? oe(
      b.dynamicChildren,
      V,
      Z,
      R,
      H,
      Bs(m, B),
      j
    ) : ee || Ct(
      b,
      m,
      Z,
      null,
      R,
      H,
      Bs(m, B),
      j,
      !1
    ), G > 0) {
      if (G & 16)
        Q(Z, te, le, R, B);
      else if (G & 2 && te.class !== le.class && r(Z, "class", null, le.class, B), G & 4 && r(Z, "style", te.style, le.style, B), G & 8) {
        const P = m.dynamicProps;
        for (let F = 0; F < P.length; F++) {
          const T = P[F], ue = te[T], E = le[T];
          (E !== ue || T === "value") && r(Z, T, ue, E, B, R);
        }
      }
      G & 1 && b.children !== m.children && c(Z, m.children);
    } else !ee && V == null && Q(Z, te, le, R, B);
    ((ie = le.onVnodeUpdated) || se) && tt(() => {
      ie && It(ie, R, m, b), se && yn(m, b, R, "updated");
    }, H);
  }, oe = (b, m, R, H, B, j, ee) => {
    for (let Z = 0; Z < m.length; Z++) {
      const G = b[Z], V = m[Z], se = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        G.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (G.type === ae || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Mn(G, V) || // - In the case of a component, it could contain anything.
        G.shapeFlag & 198) ? f(G.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          R
        )
      );
      C(
        G,
        V,
        se,
        null,
        H,
        B,
        j,
        ee,
        !0
      );
    }
  }, Q = (b, m, R, H, B) => {
    if (m !== R) {
      if (m !== Re)
        for (const j in m)
          !so(j) && !(j in R) && r(
            b,
            j,
            m[j],
            null,
            B,
            H
          );
      for (const j in R) {
        if (so(j)) continue;
        const ee = R[j], Z = m[j];
        ee !== Z && j !== "value" && r(b, j, Z, ee, B, H);
      }
      "value" in R && r(b, "value", m.value, R.value, B);
    }
  }, I = (b, m, R, H, B, j, ee, Z, G) => {
    const V = m.el = b ? b.el : i(""), se = m.anchor = b ? b.anchor : i("");
    let { patchFlag: te, dynamicChildren: le, slotScopeIds: ie } = m;
    ie && (Z = Z ? Z.concat(ie) : ie), b == null ? (o(V, R, H), o(se, R, H), W(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      m.children || [],
      R,
      se,
      B,
      j,
      ee,
      Z,
      G
    )) : te > 0 && te & 64 && le && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    b.dynamicChildren && b.dynamicChildren.length === le.length ? (oe(
      b.dynamicChildren,
      le,
      R,
      B,
      j,
      ee,
      Z
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (m.key != null || B && m === B.subTree) && Rr(
      b,
      m,
      !0
      /* shallow */
    )) : Ct(
      b,
      m,
      R,
      se,
      B,
      j,
      ee,
      Z,
      G
    );
  }, Y = (b, m, R, H, B, j, ee, Z, G) => {
    m.slotScopeIds = Z, b == null ? m.shapeFlag & 512 ? B.ctx.activate(
      m,
      R,
      H,
      ee,
      G
    ) : ge(
      m,
      R,
      H,
      B,
      j,
      ee,
      G
    ) : de(b, m, G);
  }, ge = (b, m, R, H, B, j, ee) => {
    const Z = b.component = pd(
      b,
      H,
      B
    );
    if (Tr(b) && (Z.ctx.renderer = Te), bd(Z, !1, ee), Z.asyncDep) {
      if (B && B.registerDep(Z, me, ee), !b.el) {
        const G = Z.subTree = O(Xe);
        M(null, G, m, R), b.placeholder = G.el;
      }
    } else
      me(
        Z,
        b,
        m,
        R,
        B,
        j,
        ee
      );
  }, de = (b, m, R) => {
    const H = m.component = b.component;
    if (Gc(b, m, R))
      if (H.asyncDep && !H.asyncResolved) {
        m.el = b.el, Fe(H, m, R);
        return;
      } else
        H.next = m, H.update();
    else
      m.el = b.el, H.vnode = m;
  }, me = (b, m, R, H, B, j, ee) => {
    const Z = () => {
      if (b.isMounted) {
        let { next: te, bu: le, u: ie, parent: P, vnode: F } = b;
        {
          const S = Wi(b);
          if (S) {
            te && (te.el = F.el, Fe(b, te, ee)), S.asyncDep.then(() => {
              tt(() => {
                b.isUnmounted || V();
              }, B);
            });
            return;
          }
        }
        let T = te, ue;
        xn(b, !1), te ? (te.el = F.el, Fe(b, te, ee)) : te = F, le && Ho(le), (ue = te.props && te.props.onVnodeBeforeUpdate) && It(ue, P, te, F), xn(b, !0);
        const E = sl(b), w = b.subTree;
        b.subTree = E, C(
          w,
          E,
          // parent may have changed if it's in a teleport
          f(w.el),
          // anchor may have changed if it's in a fragment
          pe(w),
          b,
          B,
          j
        ), te.el = E.el, T === null && Xc(b, E.el), ie && tt(ie, B), (ue = te.props && te.props.onVnodeUpdated) && tt(
          () => It(ue, P, te, F),
          B
        );
      } else {
        let te;
        const { el: le, props: ie } = m, { bm: P, m: F, parent: T, root: ue, type: E } = b, w = Hn(m);
        xn(b, !1), P && Ho(P), !w && (te = ie && ie.onVnodeBeforeMount) && It(te, T, m), xn(b, !0);
        {
          ue.ce && ue.ce._hasShadowRoot() && ue.ce._injectChildStyle(
            E,
            b.parent ? b.parent.type : void 0
          );
          const S = b.subTree = sl(b);
          C(
            null,
            S,
            R,
            H,
            b,
            B,
            j
          ), m.el = S.el;
        }
        if (F && tt(F, B), !w && (te = ie && ie.onVnodeMounted)) {
          const S = m;
          tt(
            () => It(te, T, S),
            B
          );
        }
        (m.shapeFlag & 256 || T && Hn(T.vnode) && T.vnode.shapeFlag & 256) && b.a && tt(b.a, B), b.isMounted = !0, m = R = H = null;
      }
    };
    b.scope.on();
    const G = b.effect = new li(Z);
    b.scope.off();
    const V = b.update = G.run.bind(G), se = b.job = G.runIfDirty.bind(G);
    se.i = b, se.id = b.uid, G.scheduler = () => zr(se), xn(b, !0), V();
  }, Fe = (b, m, R) => {
    m.component = b;
    const H = b.vnode.props;
    b.vnode = m, b.next = null, Zc(b, m.props, H, R), nd(b, m.children, R), pn(), Jr(b), bn();
  }, Ct = (b, m, R, H, B, j, ee, Z, G = !1) => {
    const V = b && b.children, se = b ? b.shapeFlag : 0, te = m.children, { patchFlag: le, shapeFlag: ie } = m;
    if (le > 0) {
      if (le & 128) {
        Gt(
          V,
          te,
          R,
          H,
          B,
          j,
          ee,
          Z,
          G
        );
        return;
      } else if (le & 256) {
        St(
          V,
          te,
          R,
          H,
          B,
          j,
          ee,
          Z,
          G
        );
        return;
      }
    }
    ie & 8 ? (se & 16 && et(V, B, j), te !== V && c(R, te)) : se & 16 ? ie & 16 ? Gt(
      V,
      te,
      R,
      H,
      B,
      j,
      ee,
      Z,
      G
    ) : et(V, B, j, !0) : (se & 8 && c(R, ""), ie & 16 && W(
      te,
      R,
      H,
      B,
      j,
      ee,
      Z,
      G
    ));
  }, St = (b, m, R, H, B, j, ee, Z, G) => {
    b = b || $n, m = m || $n;
    const V = b.length, se = m.length, te = Math.min(V, se);
    let le;
    for (le = 0; le < te; le++) {
      const ie = m[le] = G ? Vt(m[le]) : Tt(m[le]);
      C(
        b[le],
        ie,
        R,
        null,
        B,
        j,
        ee,
        Z,
        G
      );
    }
    V > se ? et(
      b,
      B,
      j,
      !0,
      !1,
      te
    ) : W(
      m,
      R,
      H,
      B,
      j,
      ee,
      Z,
      G,
      te
    );
  }, Gt = (b, m, R, H, B, j, ee, Z, G) => {
    let V = 0;
    const se = m.length;
    let te = b.length - 1, le = se - 1;
    for (; V <= te && V <= le; ) {
      const ie = b[V], P = m[V] = G ? Vt(m[V]) : Tt(m[V]);
      if (Mn(ie, P))
        C(
          ie,
          P,
          R,
          null,
          B,
          j,
          ee,
          Z,
          G
        );
      else
        break;
      V++;
    }
    for (; V <= te && V <= le; ) {
      const ie = b[te], P = m[le] = G ? Vt(m[le]) : Tt(m[le]);
      if (Mn(ie, P))
        C(
          ie,
          P,
          R,
          null,
          B,
          j,
          ee,
          Z,
          G
        );
      else
        break;
      te--, le--;
    }
    if (V > te) {
      if (V <= le) {
        const ie = le + 1, P = ie < se ? m[ie].el : H;
        for (; V <= le; )
          C(
            null,
            m[V] = G ? Vt(m[V]) : Tt(m[V]),
            R,
            P,
            B,
            j,
            ee,
            Z,
            G
          ), V++;
      }
    } else if (V > le)
      for (; V <= te; )
        ze(b[V], B, j, !0), V++;
    else {
      const ie = V, P = V, F = /* @__PURE__ */ new Map();
      for (V = P; V <= le; V++) {
        const Ie = m[V] = G ? Vt(m[V]) : Tt(m[V]);
        Ie.key != null && F.set(Ie.key, V);
      }
      let T, ue = 0;
      const E = le - P + 1;
      let w = !1, S = 0;
      const re = new Array(E);
      for (V = 0; V < E; V++) re[V] = 0;
      for (V = ie; V <= te; V++) {
        const Ie = b[V];
        if (ue >= E) {
          ze(Ie, B, j, !0);
          continue;
        }
        let Ee;
        if (Ie.key != null)
          Ee = F.get(Ie.key);
        else
          for (T = P; T <= le; T++)
            if (re[T - P] === 0 && Mn(Ie, m[T])) {
              Ee = T;
              break;
            }
        Ee === void 0 ? ze(Ie, B, j, !0) : (re[Ee - P] = V + 1, Ee >= S ? S = Ee : w = !0, C(
          Ie,
          m[Ee],
          R,
          null,
          B,
          j,
          ee,
          Z,
          G
        ), ue++);
      }
      const ye = w ? ld(re) : $n;
      for (T = ye.length - 1, V = E - 1; V >= 0; V--) {
        const Ie = P + V, Ee = m[Ie], Dt = m[Ie + 1], We = Ie + 1 < se ? (
          // #13559, #14173 fallback to el placeholder for unresolved async component
          Dt.el || Yi(Dt)
        ) : H;
        re[V] === 0 ? C(
          null,
          Ee,
          R,
          We,
          B,
          j,
          ee,
          Z,
          G
        ) : w && (T < 0 || V !== ye[T] ? lt(Ee, R, We, 2) : T--);
      }
    }
  }, lt = (b, m, R, H, B = null) => {
    const { el: j, type: ee, transition: Z, children: G, shapeFlag: V } = b;
    if (V & 6) {
      lt(b.component.subTree, m, R, H);
      return;
    }
    if (V & 128) {
      b.suspense.move(m, R, H);
      return;
    }
    if (V & 64) {
      ee.move(b, m, R, Te);
      return;
    }
    if (ee === ae) {
      o(j, m, R);
      for (let te = 0; te < G.length; te++)
        lt(G[te], m, R, H);
      o(b.anchor, m, R);
      return;
    }
    if (ee === Ko) {
      D(b, m, R);
      return;
    }
    if (H !== 2 && V & 1 && Z)
      if (H === 0)
        Z.persisted && !j[yt] ? o(j, m, R) : (Z.beforeEnter(j), o(j, m, R), tt(() => Z.enter(j), B));
      else {
        const { leave: te, delayLeave: le, afterLeave: ie } = Z, P = () => {
          b.ctx.isUnmounted ? s(j) : o(j, m, R);
        }, F = () => {
          const T = j._isLeaving || !!j[yt];
          j._isLeaving && j[yt](
            !0
            /* cancelled */
          ), Z.persisted && !T ? P() : te(j, () => {
            P(), ie && ie();
          });
        };
        le ? le(j, P, F) : F();
      }
    else
      o(j, m, R);
  }, ze = (b, m, R, H = !1, B = !1) => {
    const {
      type: j,
      props: ee,
      ref: Z,
      children: G,
      dynamicChildren: V,
      shapeFlag: se,
      patchFlag: te,
      dirs: le,
      cacheIndex: ie,
      memo: P
    } = b;
    if ((te === -2 || V && V.hasOnce) && (B = !1), Z != null && (pn(), io(Z, null, R, b, !0), bn()), ie != null && (!b.ctx || b.ctx === m) && (m.renderCache[ie] = void 0), se & 256) {
      m.ctx.deactivate(b);
      return;
    }
    const F = se & 1 && le, T = !Hn(b);
    let ue;
    if (T && (ue = ee && ee.onVnodeBeforeUnmount) && It(ue, m, b), se & 6)
      qe(b.component, R, H);
    else {
      if (se & 128) {
        b.suspense.unmount(R, H);
        return;
      }
      F && yn(b, null, m, "beforeUnmount"), se & 64 ? b.type.remove(
        b,
        m,
        R,
        Te,
        H
      ) : V && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !V.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (j !== ae || te > 0 && te & 64) ? et(
        V,
        m,
        R,
        !1,
        !0
      ) : (j === ae && te & 384 || !B && se & 16) && et(G, m, R), H && it(b);
    }
    const E = P != null && ie == null;
    (T && (ue = ee && ee.onVnodeUnmounted) || F || E) && tt(() => {
      ue && It(ue, m, b), F && yn(b, null, m, "unmounted"), E && (b.el = null);
    }, R);
  }, it = (b) => {
    const { type: m, el: R, anchor: H, transition: B } = b;
    if (m === ae) {
      Qe(R, H);
      return;
    }
    if (m === Ko) {
      k(b), B && !B.persisted && B.afterLeave && B.afterLeave();
      return;
    }
    const j = () => {
      s(R), B && !B.persisted && B.afterLeave && B.afterLeave();
    };
    if (b.shapeFlag & 1 && B && !B.persisted) {
      const { leave: ee, delayLeave: Z } = B, G = () => ee(R, j);
      Z ? Z(b.el, j, G) : G();
    } else
      j();
  }, Qe = (b, m) => {
    let R;
    for (; b !== m; )
      R = p(b), s(b), b = R;
    s(m);
  }, qe = (b, m, R) => {
    const { bum: H, scope: B, job: j, subTree: ee, um: Z, m: G, a: V } = b;
    il(G), il(V), H && Ho(H), B.stop(), j ? (j.flags |= 8, ze(ee, b, m, R)) : b.vnode.el && ee && (ee.transition = b.vnode.transition, ze(ee, b, m, R)), Z && tt(Z, m), tt(() => {
      b.isUnmounted = !0;
    }, m);
  }, et = (b, m, R, H = !1, B = !1, j = 0) => {
    for (let ee = j; ee < b.length; ee++)
      ze(b[ee], m, R, H, B);
  }, pe = (b) => {
    if (b.shapeFlag & 6)
      return pe(b.component.subTree);
    if (b.shapeFlag & 128)
      return b.suspense.next();
    const m = p(b.anchor || b.el), R = m && m[$i];
    return R ? p(R) : m;
  };
  let Ne = !1;
  const ft = (b, m, R) => {
    let H;
    b == null ? m._vnode && (ze(m._vnode, null, null, !0), H = m._vnode.component) : C(
      m._vnode || null,
      b,
      m,
      null,
      null,
      null,
      R
    ), m._vnode = b, Ne || (Ne = !0, Jr(H), Ii(), Ne = !1);
  }, Te = {
    p: C,
    um: ze,
    m: lt,
    r: it,
    mt: ge,
    mc: W,
    pc: Ct,
    pbc: oe,
    n: pe,
    o: e
  };
  return {
    render: ft,
    hydrate: void 0,
    createApp: Vc(ft)
  };
}
function Bs({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function xn({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function rd(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Rr(e, t, n = !1) {
  const o = e.children, s = t.children;
  if (ve(o) && ve(s))
    for (let r = 0; r < o.length; r++) {
      const l = o[r];
      let i = s[r];
      i.shapeFlag & 1 && !i.dynamicChildren && ((i.patchFlag <= 0 || i.patchFlag === 32) && (i = s[r] = Vt(s[r]), i.el = l.el), !n && i.patchFlag !== -2 && Rr(l, i)), i.type === As && (i.patchFlag === -1 && (i = s[r] = Vt(i)), i.el = l.el), i.type === Xe && !i.el && (i.el = l.el);
    }
}
function ld(e) {
  const t = e.slice(), n = [0];
  let o, s, r, l, i;
  const a = e.length;
  for (o = 0; o < a; o++) {
    const d = e[o];
    if (d !== 0) {
      if (s = n[n.length - 1], e[s] < d) {
        t[o] = s, n.push(o);
        continue;
      }
      for (r = 0, l = n.length - 1; r < l; )
        i = r + l >> 1, e[n[i]] < d ? r = i + 1 : l = i;
      d < e[n[r]] && (r > 0 && (t[o] = n[r - 1]), n[r] = o);
    }
  }
  for (r = n.length, l = n[r - 1]; r-- > 0; )
    n[r] = l, l = t[l];
  return n;
}
function Wi(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : Wi(t);
}
function il(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
function Yi(e) {
  if (e.placeholder)
    return e.placeholder;
  const t = e.component;
  return t ? Yi(t.subTree) : null;
}
const Gi = (e) => e.__isSuspense;
function id(e, t) {
  t && t.pendingBranch ? ve(e) ? t.effects.push(...e) : t.effects.push(e) : Sc(e);
}
const ae = /* @__PURE__ */ Symbol.for("v-fgt"), As = /* @__PURE__ */ Symbol.for("v-txt"), Xe = /* @__PURE__ */ Symbol.for("v-cmt"), Ko = /* @__PURE__ */ Symbol.for("v-stc"), Wt = [];
let bt = null;
function h(e = !1) {
  Wt.push(bt = e ? null : []);
}
function Pr() {
  Wt.pop(), bt = Wt[Wt.length - 1] || null;
}
let mo = 1;
function ss(e, t = !1) {
  mo += e, e < 0 && bt && t && (bt.hasOnce = !0);
}
function Xi(e) {
  return e.dynamicChildren = mo > 0 ? bt || $n : null, Pr(), mo > 0 && bt && bt.push(e), e;
}
function _(e, t, n, o, s, r) {
  return Xi(
    u(
      e,
      t,
      n,
      o,
      s,
      r,
      !0
    )
  );
}
function we(e, t, n, o, s) {
  return Xi(
    O(
      e,
      t,
      n,
      o,
      s,
      !0
    )
  );
}
function go(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Mn(e, t) {
  return e.type === t.type && e.key === t.key;
}
const Ji = ({ key: e }) => e != null ? e : null, qo = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? De(e) || /* @__PURE__ */ Ve(e) || Se(e) ? { i: Ke, r: e, k: t, f: !!n } : e : null);
function u(e, t = null, n = null, o = 0, s = null, r = e === ae ? 0 : 1, l = !1, i = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && Ji(t),
    ref: t && qo(t),
    scopeId: Mi,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: o,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: Ke
  };
  return i ? (rs(a, n), r & 128 && e.normalize(a)) : n && (a.shapeFlag |= De(n) ? 8 : 16), mo > 0 && // avoid a block node from tracking itself
  !l && // has current parent block
  bt && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (a.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  a.patchFlag !== 32 && bt.push(a), a;
}
const O = ad;
function ad(e, t = null, n = null, o = 0, s = null, r = !1) {
  if ((!e || e === Di) && (e = Xe), go(e)) {
    const i = mn(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && rs(i, n), mo > 0 && !r && bt && (i.shapeFlag & 6 ? bt[bt.indexOf(e)] = i : bt.push(i)), i.patchFlag = -2, i;
  }
  if (yd(e) && (e = e.__vccOpts), t) {
    t = cd(t);
    let { class: i, style: a } = t;
    i && !De(i) && (t.class = fe(i)), Me(a) && (/* @__PURE__ */ ks(a) && !ve(a) && (a = gt({}, a)), t.style = xe(a));
  }
  const l = De(e) ? 1 : Gi(e) ? 128 : Ss(e) ? 64 : Me(e) ? 4 : Se(e) ? 2 : 0;
  return u(
    e,
    t,
    n,
    o,
    s,
    l,
    r,
    !0
  );
}
function cd(e) {
  return e ? /* @__PURE__ */ ks(e) || ji(e) ? gt({}, e) : e : null;
}
function mn(e, t, n = !1, o = !1) {
  const { props: s, ref: r, patchFlag: l, children: i, transition: a } = e, d = t ? dd(s || {}, t) : s, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: d,
    key: d && Ji(d),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && r ? ve(r) ? r.concat(qo(t)) : [r, qo(t)] : qo(t)
    ) : r,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: i,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== ae ? l === -1 ? 16 : l | 16 : l,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: a,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && mn(e.ssContent),
    ssFallback: e.ssFallback && mn(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce,
    cacheIndex: e.cacheIndex
  };
  return a && o && bo(
    c,
    a.clone(c)
  ), c;
}
function be(e = " ", t = 0) {
  return O(As, null, e, t);
}
function Zi(e, t) {
  const n = O(Ko, null, e);
  return n.staticCount = t, n;
}
function ne(e = "", t = !1) {
  return t ? (h(), we(Xe, null, e)) : O(Xe, null, e);
}
function Tt(e) {
  return e == null || typeof e == "boolean" ? O(Xe) : ve(e) ? O(
    ae,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : go(e) ? Vt(e) : O(As, null, String(e));
}
function Vt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : mn(e);
}
function rs(e, t) {
  let n = 0;
  const { shapeFlag: o } = e;
  if (t == null)
    t = null;
  else if (ve(t))
    n = 16;
  else if (typeof t == "object")
    if (o & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), rs(e, s()), s._c && (s._d = !0));
      return;
    } else {
      n = 32;
      const s = t._;
      !s && !ji(t) ? t._ctx = Ke : s === 3 && Ke && (Ke.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else if (Se(t)) {
    if (o & 65) {
      rs(e, { default: t });
      return;
    }
    t = { default: t, _ctx: Ke }, n = 32;
  } else
    t = String(t), o & 64 ? (n = 16, t = [be(t)]) : n = 8;
  e.children = t, e.shapeFlag |= n;
}
function dd(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (const s in o)
      if (s === "class")
        t.class !== o.class && (t.class = fe([t.class, o.class]));
      else if (s === "style")
        t.style = xe([t.style, o.style]);
      else if (ps(s)) {
        const r = t[s], l = o[s];
        l && r !== l && !(ve(r) && r.includes(l)) ? t[s] = r ? [].concat(r, l) : l : l == null && r == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
        // the model listener.
        !bs(s) && (t[s] = l);
      } else s !== "" && (t[s] = o[s]);
  }
  return t;
}
function It(e, t, n, o = null) {
  _t(e, t, 7, [
    n,
    o
  ]);
}
const ud = Fi();
let fd = 0;
function pd(e, t, n) {
  const o = e.type, s = (t ? t.appContext : e.appContext) || ud, r = {
    uid: fd++,
    vnode: e,
    type: o,
    parent: t,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new Wa(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(s.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Qc(o, s),
    emitsOptions: qc(o, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Re,
    // inheritAttrs
    inheritAttrs: o.inheritAttrs,
    // state
    ctx: Re,
    data: Re,
    props: Re,
    attrs: Re,
    slots: Re,
    refs: Re,
    setupState: Re,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return r.ctx = { _: r }, r.root = t ? t.root : r, r.emit = Kc.bind(null, r), e.ce && e.ce(r), r;
}
let dt = null;
const Qi = () => dt || Ke;
let ls, vo;
{
  const e = vs(), t = (n, o) => {
    let s;
    return (s = e[n]) || (s = e[n] = []), s.push(o), (r) => {
      s.length > 1 ? s.forEach((l) => l(r)) : s[0](r);
    };
  };
  ls = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => dt = n
  ), vo = t(
    "__VUE_SSR_SETTERS__",
    (n) => yo = n
  );
}
const Dr = (e) => {
  const t = dt;
  return ls(e), e.scope.on(), () => {
    e.scope.off(), ls(t);
  };
}, al = () => {
  dt && dt.scope.off(), ls(null);
};
function ea(e) {
  return e.vnode.shapeFlag & 4;
}
let yo = !1;
function bd(e, t = !1, n = !1) {
  t && vo(t);
  const { props: o, children: s } = e.vnode, r = ea(e);
  Jc(e, o, r, t), td(e, s, n || t);
  const l = r ? hd(e, t) : void 0;
  return t && vo(!1), l;
}
function hd(e, t) {
  const n = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Uc);
  const { setup: o } = n;
  if (o) {
    pn();
    const s = e.setupContext = o.length > 1 ? gd(e) : null, r = Dr(e), l = Io(
      o,
      e,
      0,
      [
        e.props,
        s
      ]
    ), i = Ql(l);
    if (bn(), r(), (i || e.sp) && !Hn(e) && Dc(e), i) {
      if (l.then(al, al), t)
        return l.then((a) => {
          vo(!0);
          try {
            cl(e, a, t);
          } finally {
            vo(!1);
          }
        }).catch((a) => {
          _s(a, e, 0);
        });
      e.asyncDep = l;
    } else
      cl(e, l);
  } else
    ta(e);
}
function cl(e, t, n) {
  Se(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : Me(t) && (e.setupState = ki(t)), ta(e);
}
function ta(e, t, n) {
  const o = e.type;
  e.render || (e.render = o.render || Tn);
}
const md = {
  get(e, t) {
    return Ge(e, "get", ""), e[t];
  }
};
function gd(e) {
  const t = (n) => {
    e.exposed = n || {};
  };
  return {
    attrs: new Proxy(e.attrs, md),
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function Ms(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(ki(pc(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in ao)
        return ao[n](e);
    },
    has(t, n) {
      return n in t || n in ao;
    }
  })) : e.proxy;
}
function vd(e, t = !0) {
  return Se(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function yd(e) {
  return Se(e) && "__vccOpts" in e;
}
const K = (e, t) => /* @__PURE__ */ xc(e, t, yo);
function is(e, t, n) {
  try {
    ss(-1);
    const o = arguments.length;
    return o === 2 ? Me(t) && !ve(t) ? go(t) ? O(e, null, [t]) : O(e, t) : O(e, null, t) : (o > 3 ? n = Array.prototype.slice.call(arguments, 2) : o === 3 && go(n) && (n = [n]), O(e, t, n));
  } finally {
    ss(1);
  }
}
const xd = "3.5.43";
let cr;
const dl = typeof window != "undefined" && window.trustedTypes;
if (dl)
  try {
    cr = /* @__PURE__ */ dl.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch {
  }
const na = cr ? (e) => cr.createHTML(e) : (e) => e, wd = "http://www.w3.org/2000/svg", kd = "http://www.w3.org/1998/Math/MathML", jt = typeof document != "undefined" ? document : null, ul = jt && /* @__PURE__ */ jt.createElement("template"), _d = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, o) => {
    const s = t === "svg" ? jt.createElementNS(wd, e) : t === "mathml" ? jt.createElementNS(kd, e) : n ? jt.createElement(e, { is: n }) : jt.createElement(e);
    return e === "select" && o && o.multiple != null && s.setAttribute("multiple", o.multiple), s;
  },
  createText: (e) => jt.createTextNode(e),
  createComment: (e) => jt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => jt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, o, s, r) {
    const l = n ? n.previousSibling : t.lastChild;
    if (s && (s === r || s.nextSibling))
      for (; t.insertBefore(s.cloneNode(!0), n), !(s === r || !(s = s.nextSibling)); )
        ;
    else {
      ul.innerHTML = na(
        o === "svg" ? `<svg>${e}</svg>` : o === "mathml" ? `<math>${e}</math>` : e
      );
      const i = ul.content;
      if (o === "svg" || o === "mathml") {
        const a = i.firstChild;
        for (; a.firstChild; )
          i.appendChild(a.firstChild);
        i.removeChild(a);
      }
      t.insertBefore(i, n);
    }
    return [
      // first
      l ? l.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, Xt = "transition", Zn = "animation", xo = /* @__PURE__ */ Symbol("_vtc"), oa = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, Cd = /* @__PURE__ */ gt(
  {},
  zi,
  oa
), Sd = (e) => (e.displayName = "Transition", e.props = Cd, e), Yn = /* @__PURE__ */ Sd(
  (e, { slots: t }) => is(Pc, Id(e), t)
), wn = (e, t = []) => {
  ve(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, fl = (e) => e ? ve(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function Id(e) {
  const t = {};
  for (const I in e)
    I in oa || (t[I] = e[I]);
  if (e.css === !1)
    return t;
  const {
    name: n = "v",
    type: o,
    duration: s,
    enterFromClass: r = `${n}-enter-from`,
    enterActiveClass: l = `${n}-enter-active`,
    enterToClass: i = `${n}-enter-to`,
    appearFromClass: a = r,
    appearActiveClass: d = l,
    appearToClass: c = i,
    leaveFromClass: f = `${n}-leave-from`,
    leaveActiveClass: p = `${n}-leave-active`,
    leaveToClass: v = `${n}-leave-to`
  } = e, x = Ad(s), C = x && x[0], A = x && x[1], {
    onBeforeEnter: M,
    onEnter: y,
    onEnterCancelled: D,
    onLeave: k,
    onLeaveCancelled: L,
    onBeforeAppear: z = M,
    onAppear: $ = y,
    onAppearCancelled: W = D
  } = t, N = (I, Y, ge, de) => {
    I._enterCancelled = de, kn(I, Y ? c : i), kn(I, Y ? d : l), ge && ge();
  }, oe = (I, Y) => {
    I._isLeaving = !1, kn(I, f), kn(I, v), kn(I, p), Y && Y();
  }, Q = (I) => (Y, ge) => {
    const de = I ? $ : y, me = () => N(Y, I, ge);
    wn(de, [Y, me]), pl(() => {
      kn(Y, I ? a : r), Ft(Y, I ? c : i), fl(de) || bl(Y, o, C, me);
    });
  };
  return gt(t, {
    onBeforeEnter(I) {
      wn(M, [I]), Ft(I, r), Ft(I, l);
    },
    onBeforeAppear(I) {
      wn(z, [I]), Ft(I, a), Ft(I, d);
    },
    onEnter: Q(!1),
    onAppear: Q(!0),
    onLeave(I, Y) {
      I._isLeaving = !0;
      const ge = () => oe(I, Y);
      Ft(I, f), I._enterCancelled ? (Ft(I, p), gl(I)) : (gl(I), Ft(I, p)), pl(() => {
        I._isLeaving && (kn(I, f), Ft(I, v), fl(k) || bl(I, o, A, ge));
      }), wn(k, [I, ge]);
    },
    onEnterCancelled(I) {
      N(I, !1, void 0, !0), wn(D, [I]);
    },
    onAppearCancelled(I) {
      N(I, !0, void 0, !0), wn(W, [I]);
    },
    onLeaveCancelled(I) {
      oe(I), wn(L, [I]);
    }
  });
}
function Ad(e) {
  if (e == null)
    return null;
  if (Me(e))
    return [Ns(e.enter), Ns(e.leave)];
  {
    const t = Ns(e);
    return [t, t];
  }
}
function Ns(e) {
  return Fa(e);
}
function Ft(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[xo] || (e[xo] = /* @__PURE__ */ new Set())).add(t);
}
function kn(e, t) {
  t.split(/\s+/).forEach((o) => o && e.classList.remove(o));
  const n = e[xo];
  n && (n.delete(t), n.size || (e[xo] = void 0));
}
function pl(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let Md = 0;
function bl(e, t, n, o) {
  const s = e._endId = ++Md, r = () => {
    s === e._endId && o();
  };
  if (n != null)
    return setTimeout(r, n);
  const { type: l, timeout: i, propCount: a } = $d(e, t);
  if (!l)
    return o();
  const d = l + "end";
  let c = 0;
  const f = () => {
    e.removeEventListener(d, p), r();
  }, p = (v) => {
    v.target === e && ++c >= a && f();
  };
  setTimeout(() => {
    c < a && f();
  }, i + 1), e.addEventListener(d, p);
}
function $d(e, t) {
  const n = window.getComputedStyle(e), o = (x) => (n[x] || "").split(", "), s = o(`${Xt}Delay`), r = o(`${Xt}Duration`), l = hl(s, r), i = o(`${Zn}Delay`), a = o(`${Zn}Duration`), d = hl(i, a);
  let c = null, f = 0, p = 0;
  t === Xt ? l > 0 && (c = Xt, f = l, p = r.length) : t === Zn ? d > 0 && (c = Zn, f = d, p = a.length) : (f = Math.max(l, d), c = f > 0 ? l > d ? Xt : Zn : null, p = c ? c === Xt ? r.length : a.length : 0);
  const v = c === Xt && /\b(?:transform|all)(?:,|$)/.test(
    o(`${Xt}Property`).toString()
  );
  return {
    type: c,
    timeout: f,
    propCount: p,
    hasTransform: v
  };
}
function hl(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, o) => ml(n) + ml(e[o])));
}
function ml(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function gl(e) {
  return (e ? e.ownerDocument : document).body.offsetHeight;
}
function zd(e, t, n) {
  const o = e[xo];
  o && (t = (t ? [t, ...o] : [...o]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const vl = /* @__PURE__ */ Symbol("_vod"), Td = /* @__PURE__ */ Symbol("_vsh"), Ed = /* @__PURE__ */ Symbol(""), Ld = /(?:^|;)\s*display\s*:/;
function Rd(e, t, n) {
  const o = e.style, s = De(n);
  let r = !1;
  if (n && !s) {
    if (t)
      if (De(t))
        for (const l of t.split(";")) {
          const i = l.slice(0, l.indexOf(":")).trim();
          n[i] == null && no(o, i, "");
        }
      else
        for (const l in t)
          n[l] == null && no(o, l, "");
    for (const l in n) {
      l === "display" && (r = !0);
      const i = n[l];
      i != null ? Dd(
        e,
        l,
        !De(t) && t ? t[l] : void 0,
        i
      ) || no(o, l, i) : no(o, l, "");
    }
  } else if (s) {
    if (t !== n) {
      const l = o[Ed];
      l && (n += ";" + l), o.cssText = n, r = Ld.test(n);
    }
  } else t && e.removeAttribute("style");
  vl in e && (e[vl] = r ? o.display : "", e[Td] && (o.display = "none"));
}
const To = /\s*!important$/;
function no(e, t, n) {
  if (ve(n))
    n.forEach((o) => no(e, t, o));
  else if (n == null && (n = ""), t.startsWith("--"))
    To.test(n) ? e.setProperty(t, n.replace(To, ""), "important") : e.setProperty(t, n);
  else {
    const o = Pd(e, t);
    To.test(n) ? e.setProperty(
      vn(o),
      n.replace(To, ""),
      "important"
    ) : e[o] = n;
  }
}
const yl = ["Webkit", "Moz", "ms"], Us = {};
function Pd(e, t) {
  const n = Us[t];
  if (n)
    return n;
  let o = rt(t);
  if (o !== "filter" && o in e)
    return Us[t] = o;
  o = gs(o);
  for (let s = 0; s < yl.length; s++) {
    const r = yl[s] + o;
    if (r in e)
      return Us[t] = r;
  }
  return t;
}
function Dd(e, t, n, o) {
  return e.tagName === "TEXTAREA" && (t === "width" || t === "height") && De(o) && n === o;
}
const xl = "http://www.w3.org/1999/xlink";
function wl(e, t, n, o, s, r = Ha(t)) {
  o && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(xl, t.slice(6, t.length)) : e.setAttributeNS(xl, t, n) : n == null || r && !oi(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    r ? "" : mt(n) ? String(n) : n
  );
}
function kl(e, t, n, o, s) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? na(n) : n);
    return;
  }
  const r = e.tagName;
  if (t === "value" && r !== "PROGRESS" && // custom elements may use _value internally
  !r.includes("-")) {
    const i = r === "OPTION" ? e.getAttribute("value") || "" : e.value, a = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (i !== a || !("_value" in e)) && (e.value = a), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let l = !1;
  if (n === "" || n == null) {
    const i = typeof e[t];
    i === "boolean" ? n = oi(n) : n == null && i === "string" ? (n = "", l = !0) : i === "number" && (n = 0, l = !0);
  }
  try {
    e[t] = n;
  } catch {
  }
  l && e.removeAttribute(s || t);
}
function jn(e, t, n, o) {
  e.addEventListener(t, n, o);
}
function Od(e, t, n, o) {
  e.removeEventListener(t, n, o);
}
const _l = /* @__PURE__ */ Symbol("_vei");
function Fd(e, t, n, o, s = null) {
  const r = e[_l] || (e[_l] = {}), l = r[t];
  if (o && l)
    l.value = o;
  else {
    const [i, a] = Ud(t);
    if (o) {
      const d = r[t] = Hd(
        o,
        s
      );
      jn(e, i, d, a);
    } else l && (Od(e, i, l, a), r[t] = void 0);
  }
}
const Bd = /(Once|Passive|Capture)$/, Nd = /^on:?(?:Once|Passive|Capture)$/;
function Ud(e) {
  let t, n;
  for (; (n = e.match(Bd)) && !Nd.test(e); )
    t || (t = {}), e = e.slice(0, e.length - n[1].length), t[n[1].toLowerCase()] = !0;
  return [e[2] === ":" ? e.slice(3) : vn(e.slice(2)), t];
}
let js = 0;
const jd = /* @__PURE__ */ Promise.resolve(), Vd = () => js || (jd.then(() => js = 0), js = Date.now());
function Hd(e, t) {
  const n = (o) => {
    if (!o._vts)
      o._vts = Date.now();
    else if (o._vts <= n.attached)
      return;
    const s = n.value;
    if (ve(s)) {
      const r = o.stopImmediatePropagation;
      o.stopImmediatePropagation = () => {
        r.call(o), o._stopped = !0;
      };
      const l = s.slice(), i = [o];
      for (let a = 0; a < l.length && !o._stopped; a++) {
        const d = l[a];
        d && _t(
          d,
          t,
          5,
          i
        );
      }
    } else
      _t(
        s,
        t,
        5,
        [o]
      );
  };
  return n.value = e, n.attached = Vd(), n;
}
const Cl = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Kd = (e, t, n, o, s, r) => {
  const l = s === "svg";
  t === "class" ? zd(e, o, l) : t === "style" ? Rd(e, n, o) : ps(t) ? bs(t) || Fd(e, t, n, o, r) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : qd(e, t, o, l)) ? (kl(e, t, o), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && wl(e, t, o, l, r, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && // #12408 check if it's declared prop or it's async custom element
  (Wd(e, t) || // @ts-expect-error _def is private
  e._def.__asyncLoader && (/[A-Z]/.test(t) || !De(o))) ? kl(e, rt(t), o, r, t) : (t === "true-value" ? e._trueValue = o : t === "false-value" && (e._falseValue = o), wl(e, t, o, l));
};
function qd(e, t, n, o) {
  if (o)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Cl(t) && Se(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "sandbox" && e.tagName === "IFRAME" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const s = e.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return Cl(t) && De(n) ? !1 : t in e;
}
function Wd(e, t) {
  const n = (
    // @ts-expect-error _def is private
    e._def.props
  );
  if (!n)
    return !1;
  const o = rt(t);
  return Array.isArray(n) ? n.some((s) => rt(s) === o) : Object.keys(n).some((s) => rt(s) === o);
}
const Sl = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return ve(t) ? (n) => Ho(t, n) : t;
};
function Yd(e) {
  e.target.composing = !0;
}
function Il(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const Eo = /* @__PURE__ */ Symbol("_assign"), Lo = /* @__PURE__ */ Symbol("_initialValue");
function Vs(e, t, n) {
  return t && (e = e.trim()), n && (e = _r(e)), e;
}
const Rn = {
  created(e, { modifiers: { lazy: t, trim: n, number: o } }, s) {
    e.parentNode && (e.type === "text" ? e[Lo] = e.defaultValue.replace(/[\r\n]/g, "") : e.type === "textarea" && (e[Lo] = e.defaultValue.replace(/\r\n?/g, `
`))), e[Eo] = Sl(s);
    const r = o || s.props && s.props.type === "number";
    jn(e, t ? "change" : "input", (l) => {
      l.target.composing || e[Eo](Vs(e.value, n, r));
    }), (n || r) && jn(e, "change", () => {
      e.value = Vs(e.value, n, r);
    }), t || (jn(e, "compositionstart", Yd), jn(e, "compositionend", Il), jn(e, "change", Il));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t, modifiers: { trim: n, number: o } }) {
    const s = t == null ? "" : t, r = e[Lo];
    delete e[Lo], r !== void 0 && (e.type === "text" || e.type === "textarea") && e.value !== r ? e[Eo](Vs(e.value, n, o)) : e.value = s;
  },
  beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: o, trim: s, number: r } }, l) {
    if (e[Eo] = Sl(l), e.composing) return;
    const i = (r || e.type === "number") && !/^0\d/.test(e.value) ? _r(e.value) : e.value, a = t == null ? "" : t;
    if (i === a)
      return;
    const d = e.getRootNode();
    (d instanceof Document || d instanceof ShadowRoot) && d.activeElement === e && e.type !== "range" && (o && t === n || s && e.value.trim() === a) || (e.value = a);
  }
}, Gd = ["ctrl", "shift", "alt", "meta"], Xd = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => Gd.some((n) => e[`${n}Key`] && !t.includes(n))
}, st = (e, t) => {
  if (!e) return e;
  const n = e._withMods || (e._withMods = {}), o = t.join(".");
  return n[o] || (n[o] = ((s, ...r) => {
    for (let l = 0; l < t.length; l++) {
      const i = Xd[t[l]];
      if (i && i(s, t)) return;
    }
    return e(s, ...r);
  }));
}, Jd = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, wo = (e, t) => {
  const n = e._withKeys || (e._withKeys = {}), o = t.join(".");
  return n[o] || (n[o] = ((s) => {
    if (!("key" in s))
      return;
    const r = vn(s.key);
    if (t.some(
      (l) => l === r || Jd[l] === r
    ))
      return e(s);
  }));
}, Zd = /* @__PURE__ */ gt({ patchProp: Kd }, _d);
let Al;
function Qd() {
  return Al || (Al = od(Zd));
}
const eu = ((...e) => {
  const t = Qd().createApp(...e), { mount: n } = t;
  return t.mount = (o) => {
    const s = nu(o);
    if (!s) return;
    const r = t._component;
    !Se(r) && !r.render && !r.template && (r.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const l = n(s, !1, tu(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), l;
  }, t;
});
function tu(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function nu(e) {
  return De(e) ? document.querySelector(e) : e;
}
const sa = /* @__PURE__ */ Symbol("boards-list");
function Ze() {
  const e = Cs(sa);
  if (!e) throw new Error("boards list context missing");
  return e;
}
function tn() {
  return { cursor: null, previous: [], next: null, hasMore: !1, startPage: 1 };
}
function ou(e, t) {
  return { ...e, next: t.nextCursor, hasMore: t.hasMore };
}
function dr(e) {
  return e.previous.length > 0;
}
function as(e) {
  return e.hasMore && !!e.next;
}
function su(e) {
  return as(e) ? {
    cursor: e.next,
    previous: [...e.previous, e.cursor],
    next: null,
    hasMore: !1,
    startPage: e.startPage
  } : e;
}
function ru(e) {
  return dr(e) ? {
    cursor: e.previous[e.previous.length - 1],
    previous: e.previous.slice(0, -1),
    next: e.cursor,
    hasMore: !0,
    startPage: e.startPage
  } : e;
}
function ur(e) {
  return (e.startPage || 1) + e.previous.length;
}
function lu(e, t, n) {
  const s = (ur(e) - 1) * t, r = s + n;
  return r <= s ? "" : s + 1 + "-" + r + " of " + (as(e) ? "many" : String(r));
}
const iu = 2e4;
function au(e) {
  return e.background && !e.supersededForeground && e.hasRows;
}
const cu = "/internal/canvas-boards", du = 100, uu = 200, fu = 100;
function ra(e) {
  return e === "created" ? "desc" : "asc";
}
function In(e) {
  return e && e.trim() ? e.trim() : null;
}
function pu(e) {
  const t = new URLSearchParams(), n = In(e.teamId);
  n && t.set("team_id", n), e.view && t.set("view", e.view);
  const o = In(e.cursor);
  o && t.set("cursor", o), t.set("limit", String(Math.min(du, Math.max(1, Math.floor(e.limit) || 1))));
  const s = In(e.customFieldKey), r = e.sort === "custom_field" && !s ? "created" : e.sort;
  r !== "created" && t.set("sort", r), r === "custom_field" && s && t.set("custom_field_key", s), e.order !== ra(r) && t.set("order", e.order);
  const l = In(e.q);
  l && t.set("q", l.slice(0, uu));
  const i = Array.from(new Set(e.ownerUserIds.map((d) => In(d)).filter((d) => !!d))).slice(0, fu);
  i.length && t.set("owner_user_id", i.join(","));
  const a = In(e.accessLevel);
  return a && t.set("access_level", a), t;
}
function Fn(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e) ? e : null;
}
function ct(e) {
  return typeof e == "string" && e ? e : null;
}
function bu(e) {
  const t = Fn(e), n = t ? ct(t.key) : null;
  return !t || !n ? null : { key: n, label: ct(t.label), value: typeof t.value == "string" ? t.value : null };
}
function hu(e) {
  const t = Fn(e), n = t ? ct(t.id) : null;
  return !t || !n ? null : {
    id: n,
    created: ct(t.created),
    title: ct(t.title),
    description: ct(t.description),
    accessLevel: ct(t.access_level) || "PRIVATE",
    ownerUserId: ct(t.owner_user_id),
    ownerEmail: ct(t.owner_email),
    teamId: ct(t.team_id),
    avatarUrl: ct(t.avatar_url),
    customFields: Array.isArray(t.custom_fields) ? t.custom_fields.map(bu).filter((o) => o !== null) : []
  };
}
function mu(e) {
  const t = Fn(e) || {};
  return {
    rows: Array.isArray(t.data) ? t.data.map(hu).filter((n) => n !== null) : [],
    nextCursor: ct(t.next_cursor),
    hasMore: !!t.has_more
  };
}
async function gu(e) {
  var t;
  try {
    const n = Fn((t = Fn(await e.json())) == null ? void 0 : t.error) || {};
    return {
      code: typeof n.code == "string" ? n.code : void 0,
      message: typeof n.message == "string" ? n.message : void 0
    };
  } catch {
    return {};
  }
}
async function la(e, t, n) {
  let o;
  try {
    o = await n(e, { method: "GET", headers: t });
  } catch {
    return { ok: !1, reason: "network" };
  }
  if (!o.ok) {
    const { code: s, message: r } = await gu(o);
    return { ok: !1, reason: s === "INVALID_CURSOR" ? "stale-cursor" : o.status === 401 ? "unauthorized" : o.status === 403 ? "forbidden" : "failed", ...s ? { code: s } : {}, message: r || "HTTP " + o.status };
  }
  try {
    return { ok: !0, body: await o.json() };
  } catch {
    return { ok: !1, reason: "failed", message: "Invalid JSON" };
  }
}
async function vu(e, t, n, o = window.fetch.bind(window)) {
  const s = pu(n).toString(), r = e.replace(/\/$/, "") + cu + (s ? "?" + s : ""), l = await la(r, { Authorization: "Bearer " + t.idToken, "X-Device-Id": t.deviceId }, o);
  return l.ok ? { ok: !0, page: mu(l.body) } : l;
}
async function yu(e, t, n, o = window.fetch.bind(window)) {
  const s = new URLSearchParams();
  n.companyId && s.set("company_id", n.companyId), s.set("team_id", n.teamId), s.set("limit", String(n.limit || 50));
  const r = In(n.q);
  r && s.set("q", r.slice(0, 200)), s.set("status", "joined");
  const l = e.replace(/\/$/, "") + "/teams/" + encodeURIComponent(n.teamId) + "/members?" + s.toString(), i = await la(l, { Authorization: "Bearer " + t }, o);
  if (!i.ok) throw new Error(i.message || i.reason);
  const a = Fn(i.body) || {}, d = Array.isArray(a.data) ? a.data : [], c = [];
  for (const f of d) {
    const p = Fn(f), v = p ? ct(p.user_id) : null, x = p ? ct(p.email) : null;
    v && x && c.push({ userId: v, email: x });
  }
  return c;
}
const fr = { by: "created", desc: !0 }, Yt = "cf:", zn = [24, 48, 96], Hs = { view: "all", accessLevel: null, ownerUserIds: [] };
function xu(e, t) {
  return [
    { value: "all", label: "All boards", description: "Your private boards and all boards shared with you" },
    { value: "mine", label: "My boards", description: "Only boards you are the owner of" },
    { value: "shared_with_me", label: "Shared with me", description: "Your shared boards and other boards shared with you" },
    ...e ? [{ value: "everyone", label: "Everyone's boards", description: "(Admin) All boards across the " + t }] : []
  ];
}
const ko = {
  PRIVATE: "Private",
  SHARED: "Shared",
  RESTRICTED: "Restricted"
};
function wu(e) {
  return [
    { by: "created", label: "Date created" },
    { by: "title", label: "Name" },
    { by: "description", label: "Description" },
    ...e.map((t) => ({ by: Yt + t.key, label: t.label }))
  ];
}
function ku(e) {
  const t = e.desc ? "desc" : "asc";
  return e.by === "title" || e.by === "description" || e.by === "created" ? { sort: e.by, order: t, customFieldKey: null } : e.by.startsWith(Yt) && e.by.length > Yt.length ? { sort: "custom_field", order: t, customFieldKey: e.by.slice(Yt.length) } : { sort: "created", order: ra("created"), customFieldKey: null };
}
function _u(e, t) {
  if (!e || typeof e != "object") return !1;
  const n = e;
  return typeof n.by != "string" || typeof n.desc != "boolean" ? !1 : n.by.startsWith(Yt) ? t.includes(n.by.slice(Yt.length)) : n.by === "created" || n.by === "title" || n.by === "description";
}
function $s(e) {
  const t = e && typeof e == "object" ? e : {}, n = t.view === "mine" || t.view === "shared_with_me" || t.view === "everyone" ? t.view : "all", o = t.accessLevel === "PRIVATE" || t.accessLevel === "SHARED" || t.accessLevel === "RESTRICTED" ? t.accessLevel : null, s = Array.isArray(t.ownerUserIds) ? Array.from(new Set(t.ownerUserIds.filter((r) => typeof r == "string" && !!r.trim()).map((r) => r.trim()))).sort() : [];
  return { view: n, accessLevel: o, ownerUserIds: s };
}
function ia(e) {
  return (e.accessLevel ? 1 : 0) + (e.ownerUserIds.length ? 1 : 0);
}
function Cu(e, t, n) {
  return e.trim() ? !0 : n ? t.view !== "all" || ia(t) > 0 : !1;
}
function Su(e) {
  const t = !!e.teamId, n = $s(e.filters), o = t ? n.view === "everyone" && !e.canSeeEveryone ? "all" : n.view : "all", { sort: s, order: r, customFieldKey: l } = ku(e.sort);
  return {
    teamId: e.teamId,
    view: o,
    cursor: e.cursor,
    limit: e.limit,
    sort: s,
    order: r,
    customFieldKey: l,
    q: e.q.trim() || null,
    ownerUserIds: t ? n.ownerUserIds : [],
    accessLevel: t ? n.accessLevel : null
  };
}
function Iu(e) {
  return JSON.stringify([
    e.teamId || null,
    e.view || null,
    e.sort,
    e.order,
    e.customFieldKey || null,
    e.q || null,
    [...e.ownerUserIds].sort(),
    e.accessLevel || null
  ]);
}
function Au(e) {
  return {
    sort: { ...e.sort },
    pageSize: e.pageSize,
    q: e.q,
    filters: $s(e.filters),
    cursor: e.walk.cursor,
    page: e.walk.cursor ? Math.max(1, Math.floor(e.page) || 1) : 1,
    listing: e.listing
  };
}
function Mu(e, t) {
  if (!e || typeof e != "object") return null;
  const n = e, o = _u(n.sort, t) ? { ...n.sort } : { ...fr }, s = zn.includes(Number(n.pageSize)) ? Number(n.pageSize) : zn[0], r = typeof n.q == "string" ? n.q : "", l = $s(n.filters), i = typeof n.cursor == "string" && n.cursor && typeof n.listing == "string" ? { cursor: n.cursor, page: Math.max(1, Math.floor(Number(n.page)) || 1), listing: n.listing } : null;
  return { sort: o, pageSize: s, q: r, filters: l, resume: i };
}
function $u(e, t) {
  return !e || e.listing !== t ? tn() : { ...tn(), cursor: e.cursor, startPage: e.page };
}
function zu(e, t) {
  return t === "loading" ? "loading" : t === "failed" ? "static" : !e || e.deletedAt ? "removed" : "live";
}
function Tu(e) {
  const t = {};
  for (const o of e.customFields) o.value != null && (t[o.key] = o.value);
  const n = e.created ? Date.parse(e.created) : NaN;
  return {
    id: e.id,
    title: e.title || "",
    description: e.description || "",
    // a personal board has no level of its own; the endpoint reports it as PRIVATE
    accessLevel: e.teamId ? e.accessLevel : null,
    userId: e.ownerUserId,
    teamId: e.teamId,
    customFields: t,
    createdAt: Number.isFinite(n) ? n : null,
    deletedAt: null,
    preview: null,
    previewAt: null,
    // the listing doesn't carry the access map; the document does
    accessUserIds: []
  };
}
function Eu(e) {
  return {
    id: e.id,
    created: new Date(e.createdAt || Date.now()).toISOString(),
    title: e.title || null,
    description: e.description || null,
    accessLevel: e.accessLevel || "PRIVATE",
    ownerUserId: e.userId,
    ownerEmail: null,
    teamId: e.teamId,
    avatarUrl: null,
    customFields: Object.keys(e.customFields).map((t) => ({ key: t, label: null, value: e.customFields[t] || null }))
  };
}
function Lu(e, t) {
  if (!e.length) return t;
  const n = new Set(e.map((o) => o.id));
  return [...e, ...t.filter((o) => !n.has(o.id))];
}
function Ru(e, t) {
  if (e.code === "DOMAIN_LOCKED" && e.message) return e.message;
  switch (e.reason) {
    case "unauthorized":
      return "Your session has expired, sign in again to view boards";
    case "forbidden":
      return t === "everyone" ? "You do not have permission to see everyone's boards" : "You do not have access to these boards";
    case "network":
      return "Could not reach the server, check your connection and try again";
    default:
      return "Could not load boards, please try again";
  }
}
function pr(e, t, n) {
  return n || !!e && e === t;
}
function Ml(e) {
  return e + " " + (e === 1 ? "board" : "boards");
}
function Pu(e, t) {
  return t >= e ? { ok: !0, message: "Deleted " + Ml(t) } : t ? { ok: !1, message: "Deleted " + t + " of " + Ml(e) + ". " + (e - t) + " could not be deleted, please try again" } : { ok: !1, message: "Could not delete the " + (e === 1 ? "board" : "boards") + ", please try again" };
}
function Du(e, t) {
  const n = /* @__PURE__ */ xi(/* @__PURE__ */ new Map()), o = /* @__PURE__ */ new Map(), s = (r, l, i) => {
    const a = n.get(r), d = zu(l, i);
    n.set(r, { board: l, bindState: i, state: d }), d === "removed" && (!a || a.state !== "removed") && t(r);
  };
  return {
    retain(r) {
      const l = o.get(r);
      if (l) {
        l.count++;
        return;
      }
      n.has(r) || n.set(r, { board: null, bindState: "loading", state: "loading" });
      let i = () => {
      };
      try {
        i = e().watchBoard(
          r,
          (a) => s(r, a, "bound"),
          (a) => {
            console.error("[boards] could not follow board", r, a);
            const d = n.get(r);
            s(r, d ? d.board : null, "failed");
          }
        );
      } catch (a) {
        console.error("[boards] could not follow board", r, a), s(r, null, "failed");
      }
      o.set(r, { count: 1, stop: i });
    },
    release(r) {
      const l = o.get(r);
      if (!l || --l.count > 0) return;
      l.stop(), o.delete(r);
      const i = n.get(r);
      i && i.state !== "removed" && n.delete(r);
    },
    get(r) {
      return n.get(r);
    },
    markRemoved(r) {
      const l = n.get(r);
      s(r, l && l.board ? { ...l.board, deletedAt: Date.now() } : null, "bound");
    },
    dispose() {
      for (const r of o.values()) r.stop();
      o.clear(), n.clear();
    }
  };
}
const aa = "rd-boards-list:view:", ca = "rd-boards-list:mode", da = "rd-boards-list:hero";
function Or(e) {
  try {
    return window.localStorage.getItem(e);
  } catch {
    return null;
  }
}
function Fr(e, t) {
  try {
    window.localStorage.setItem(e, t);
  } catch {
  }
}
function Ou(e) {
  const t = Or(aa + e);
  if (!t) return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}
function Fu(e, t) {
  Fr(aa + e, JSON.stringify(t));
}
function Bu() {
  return Or(ca) === "table" ? "table" : "grid";
}
function Nu(e) {
  Fr(ca, e);
}
function Uu() {
  return Or(da) === "min";
}
function ju(e) {
  Fr(da, e ? "min" : "full");
}
function ua(e, t) {
  const n = e.customFields.find((o) => o.key === t);
  return n && n.value || "";
}
function Vu(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? "" : t.getFullYear() + "-" + String(t.getMonth() + 1).padStart(2, "0") + "-" + String(t.getDate()).padStart(2, "0");
}
function Hu(e, t) {
  const n = [];
  if (t) {
    const o = /* @__PURE__ */ new Set();
    for (const s of e)
      for (const r of s.customFields)
        o.has(r.key) || (o.add(r.key), n.push({ text: r.label || r.key, value: (l) => ua(l, r.key) }));
  }
  return [
    { text: "Name", value: (o) => o.title || "" },
    { text: "Description", value: (o) => o.description || "" },
    ...n,
    { text: "Created", value: (o) => Vu(o.created) },
    ...t ? [
      { text: "Owner", value: (o) => o.ownerEmail || "" },
      { text: "Access", value: (o) => ko[o.accessLevel] || "" }
    ] : []
  ];
}
function $l(e) {
  return /[",\r\n]/.test(e) ? '"' + e.replace(/"/g, '""') + '"' : e;
}
function Ku(e, t) {
  const n = (s) => t.by === "title" ? (s.title || "").toLowerCase() : t.by === "description" ? (s.description || "").toLowerCase() : t.by.startsWith(Yt) ? ua(s, t.by.slice(Yt.length)).toLowerCase() : s.created || "", o = t.desc ? -1 : 1;
  return [...e].sort((s, r) => {
    const l = n(s), i = n(r);
    return l < i ? -o : l > i ? o : 0;
  });
}
function qu(e, t, n) {
  const o = Hu(e, t), s = Ku(e, n).map((r) => o.map((l) => $l(l.value(r))).join(","));
  return [o.map((r) => $l(r.text)).join(","), ...s].join(`
`);
}
function Wu(e, t = /* @__PURE__ */ new Date()) {
  const n = (e ? e + "-Boards" : "Boards").replace(/[^a-zA-Z0-9]/g, "-"), o = (r) => String(r).padStart(2, "0"), s = t.getFullYear() + o(t.getMonth() + 1) + o(t.getDate()) + "-" + o(t.getHours()) + o(t.getMinutes()) + o(t.getSeconds());
  return n + "-" + s + ".csv";
}
function Yu(e, t) {
  const n = new Blob([e], { type: "text/csv;charset=utf-8;" }), o = document.createElement("a"), s = URL.createObjectURL(n);
  o.href = s, o.setAttribute("download", t), document.body.appendChild(o), o.click(), document.body.removeChild(o), setTimeout(() => URL.revokeObjectURL(s), 1e3);
}
const At = /* @__PURE__ */ ws(/* @__PURE__ */ new Map()), Br = 600 * 1e3, fa = "rd-boards-deleted";
function Gu(e = Date.now()) {
  try {
    const t = typeof sessionStorage != "undefined" ? sessionStorage.getItem(fa) : null, n = t ? JSON.parse(t) : [];
    return Array.isArray(n) ? n.filter((o) => Array.isArray(o) && typeof o[0] == "string" && typeof o[1] == "number" && e - o[1] < Br) : [];
  } catch {
    return [];
  }
}
const Pn = /* @__PURE__ */ ws(new Map(Gu()));
function Xu() {
  try {
    sessionStorage.setItem(fa, JSON.stringify([...Pn]));
  } catch {
  }
}
function Ju(e, t = Date.now()) {
  const n = Pn.get(e);
  return n != null && t - n < Br;
}
function Zu(e, t = Date.now()) {
  for (const [n, o] of Pn) t - o >= Br && Pn.delete(n);
  for (const n of e) Pn.set(n, t);
  Xu();
}
function Qu(e) {
  const t = K(() => !!e.account.value.teamId), n = K(() => e.user.value.uid + ":" + (e.account.value.teamId || "personal")), o = K(() => ({
    userId: e.user.value.uid,
    teamId: e.account.value.teamId,
    manageAllGenerations: e.permissions.value.manageAllGenerations,
    shareRunnitAssets: e.permissions.value.shareRunnitAssets
  })), s = K(() => e.permissions.value.manageAllGenerations), r = K(() => t.value ? e.account.value.customFields.map((w) => w.key) : []), l = /* @__PURE__ */ U({ ...fr }), i = /* @__PURE__ */ U(zn[0]), a = /* @__PURE__ */ U(""), d = /* @__PURE__ */ U({ ...Hs }), c = /* @__PURE__ */ wt(tn()), f = /* @__PURE__ */ wt({ walk: tn(), pageSize: zn[0] }), p = /* @__PURE__ */ wt([]), v = /* @__PURE__ */ U(!1), x = /* @__PURE__ */ U(!1), C = /* @__PURE__ */ U(!1), A = /* @__PURE__ */ U(!1), M = /* @__PURE__ */ U(!1), y = /* @__PURE__ */ wt(/* @__PURE__ */ new Map());
  let D = 0, k = null, L = null, z = !1, $ = !1;
  const W = Du(e.source, (w) => pe(w)), N = K(() => Su({
    teamId: e.account.value.teamId,
    cursor: c.value.cursor,
    sort: l.value,
    q: a.value,
    filters: d.value,
    limit: i.value,
    canSeeEveryone: s.value
  })), oe = K(() => Iu({ ...N.value })), Q = K(() => {
    const w = At.get(n.value);
    return !w || c.value.cursor ? [] : w.rows;
  }), I = K(() => Lu(Q.value, p.value).filter((w) => !Pn.has(w.id))), Y = K(() => new Set(Q.value.map((w) => w.id))), ge = K(() => Cu(a.value, d.value, t.value)), de = K(() => ur(f.value.walk)), me = K(() => lu(f.value.walk, f.value.pageSize, p.value.filter((w) => !Pn.has(w.id)).length)), Fe = K(() => dr(c.value)), Ct = K(() => as(c.value));
  function St(w) {
    const S = W.get(w);
    return !!S && S.state === "removed";
  }
  function Gt(w) {
    const S = W.get(w.id);
    return S && S.state === "live" ? S.board : null;
  }
  function lt() {
    k === null && (k = window.setTimeout(() => {
      k = null, it();
    }, 0));
  }
  function ze(w) {
    if (p.value = w, f.value = { walk: c.value, pageSize: i.value }, y.value.size) {
      let S = !1;
      const re = new Map(y.value);
      for (const ye of w)
        re.has(ye.id) && re.get(ye.id) !== ye && (re.set(ye.id, ye), S = !0);
      S && (y.value = re);
    }
  }
  async function it(w = !1) {
    const S = ++D;
    w || (z = !0), v.value = !0, x.value = !1;
    const re = N.value;
    let ye;
    try {
      ye = await e.source().fetchPage(re);
    } catch (Ee) {
      console.error("[boards] could not load boards", Ee), ye = { ok: !1, reason: "failed" };
    }
    if ($ || S !== D) return;
    v.value = !1;
    const Ie = z;
    if (z = !1, ye.ok) {
      c.value = ou(c.value, ye.page), ze(ye.page.rows), et(), C.value = !0, ye.page.rows.some((Ee) => Ju(Ee.id)) && qe();
      return;
    }
    if (ye.reason === "stale-cursor" && c.value.cursor) {
      c.value = tn(), lt();
      return;
    }
    au({ background: w, supersededForeground: Ie, hasRows: p.value.length > 0 }) || (x.value = !0, c.value = tn(), ze([])), C.value = !0, e.notify({ status: "error", message: Ru(ye, re.view) });
  }
  function Qe() {
    c.value = tn(), lt();
  }
  function qe(w = iu) {
    $ || (L !== null && window.clearTimeout(L), L = window.setTimeout(() => {
      L = null, $ || it(!0);
    }, w));
  }
  function et() {
    const w = At.get(n.value);
    w && (w.listing === null ? At.set(n.value, { ...w, listing: oe.value }) : w.listing !== oe.value && At.delete(n.value));
  }
  function pe(w) {
    const S = At.get(n.value);
    if (S && S.rows.some((re) => re.id === w)) {
      const re = S.rows.filter((ye) => ye.id !== w);
      re.length ? At.set(n.value, { ...S, rows: re }) : At.delete(n.value);
    }
    if (y.value.has(w)) {
      const re = new Map(y.value);
      re.delete(w), y.value = re;
    }
    qe();
  }
  function Ne(w) {
    Fu(w, Au({
      sort: l.value,
      pageSize: i.value,
      q: a.value,
      filters: d.value,
      walk: c.value,
      listing: oe.value,
      page: ur(c.value)
    }));
  }
  function ft(w) {
    const S = Mu(Ou(w), r.value);
    l.value = S ? S.sort : { ...fr }, i.value = S ? S.pageSize : zn[0], a.value = S ? S.q : "", d.value = S ? S.filters : { ...Hs }, c.value = $u(S ? S.resume : null, oe.value);
  }
  Pe(n, (w, S) => {
    S && Ne(S), y.value = /* @__PURE__ */ new Map(), p.value = [], C.value = !1, ft(w), lt();
  }, { immediate: !0 }), Pe([l, i, a, d, c], () => Ne(n.value)), Pe(s, (w, S) => {
    w === S || d.value.view !== "everyone" || (y.value = /* @__PURE__ */ new Map(), Qe());
  });
  function Te(w) {
    w !== a.value && (y.value = /* @__PURE__ */ new Map(), a.value = w, Qe());
  }
  function ke(w) {
    const S = $s({ ...d.value, ...w });
    JSON.stringify(S) !== JSON.stringify(d.value) && (y.value = /* @__PURE__ */ new Map(), d.value = S, Qe());
  }
  function b() {
    y.value = /* @__PURE__ */ new Map(), a.value = "", d.value = { ...Hs, view: d.value.view }, Qe();
  }
  function m(w) {
    w.by === l.value.by && w.desc === l.value.desc || (l.value = { ...w }, Qe());
  }
  function R(w) {
    w === i.value || !zn.includes(w) || (i.value = w, Qe());
  }
  function H() {
    as(c.value) && (c.value = su(c.value), lt());
  }
  function B() {
    dr(c.value) ? c.value = ru(c.value) : c.value = tn(), lt();
  }
  function j() {
    At.delete(n.value), it();
  }
  function ee(w) {
    return y.value.has(w);
  }
  function Z(w) {
    if (St(w.id)) return;
    const S = new Map(y.value);
    S.has(w.id) ? S.delete(w.id) : S.set(w.id, w), y.value = S;
  }
  const G = K(() => I.value.filter((w) => !St(w.id))), V = K(() => G.value.length > 0 && G.value.every((w) => y.value.has(w.id))), se = K(() => G.value.some((w) => y.value.has(w.id)));
  function te() {
    const w = new Map(y.value);
    if (V.value) for (const S of G.value) w.delete(S.id);
    else for (const S of G.value) w.set(S.id, S);
    y.value = w;
  }
  function le() {
    y.value = /* @__PURE__ */ new Map();
  }
  const ie = K(() => [...y.value.values()]), P = K(() => ie.value.filter((w) => pr(w.ownerUserId, o.value.userId, o.value.manageAllGenerations)));
  async function F(w = "Untitled board") {
    if (A.value) return null;
    A.value = !0;
    try {
      const S = await e.source().createBoard({ title: w, teamId: e.account.value.teamId }), re = At.get(n.value);
      return At.set(n.value, {
        rows: [Eu(S), ...re ? re.rows.filter((ye) => ye.id !== S.id) : []],
        listing: re ? re.listing : null
      }), qe(), S;
    } catch (S) {
      return console.error("[boards] could not create a board", S), e.notify({ status: "error", message: "The board could not be created, please try again" }), null;
    } finally {
      A.value = !1;
    }
  }
  async function T(w) {
    if (!w.length || M.value) return !1;
    M.value = !0;
    try {
      const S = await e.source().readBoards(w.map((We) => We.id)), re = S.filter((We) => pr(We.userId, o.value.userId, o.value.manageAllGenerations)), ye = await e.source().softDelete(re.map((We) => We.id)), Ie = re.filter((We, Ts) => ye[Ts]).map((We) => We.id);
      Zu(Ie);
      for (const We of Ie) W.markRemoved(We);
      const Ee = w.length - S.length, Dt = Pu(w.length, Ee + ye.filter(Boolean).length);
      if (e.notify({ status: Dt.ok ? "success" : "error", message: Dt.message }), Dt.ok) {
        const We = new Map(y.value);
        for (const Ts of w) We.delete(Ts.id);
        y.value = We;
      }
      return Dt.ok;
    } catch (S) {
      return console.error("[boards] could not delete boards", S), e.notify({ status: "error", message: "Could not delete the " + (w.length === 1 ? "board" : "boards") + ", please try again" }), !1;
    } finally {
      M.value = !1;
    }
  }
  function ue() {
    if (!ie.value.length) return;
    const w = t.value ? e.account.value.teamName : null;
    Yu(qu(ie.value, t.value, l.value), Wu(w));
  }
  function E() {
    $ || (Ne(n.value), $ = !0, k !== null && window.clearTimeout(k), L !== null && window.clearTimeout(L), W.dispose());
  }
  return {
    // state
    teamMode: t,
    ctx: o,
    sort: l,
    pageSize: i,
    q: a,
    filters: d,
    rows: p,
    listedRows: I,
    pinnedIds: Y,
    loading: v,
    failed: x,
    settled: C,
    creating: A,
    deleting: M,
    narrowed: ge,
    pageNumber: de,
    pageText: me,
    canBack: Fe,
    canNext: Ct,
    selected: y,
    selectedRows: ie,
    deletableSelected: P,
    pageAllSelected: V,
    pageSomeSelected: se,
    canSeeEveryone: s,
    live: W,
    // reads
    isRemoved: St,
    isSelected: ee,
    boardFor: Gt,
    // changes
    setSearch: Te,
    setFilters: ke,
    clearNarrowing: b,
    setSort: m,
    setPageSize: R,
    nextPage: H,
    previousPage: B,
    refresh: j,
    fetchPage: it,
    toggle: Z,
    togglePage: te,
    clearSelection: le,
    createBoard: F,
    deleteBoards: T,
    exportSelected: ue,
    refetchAfterMirrorLag: qe,
    dispose: E
  };
}
function pa(e, t) {
  return !!e.userId && e.userId === t.userId;
}
function ef(e, t) {
  return pr(e.userId, t.userId, t.manageAllGenerations);
}
function cs(e, t) {
  const n = pa(e, t);
  return n && e.accessLevel !== "PRIVATE" || (n || t.manageAllGenerations) && t.shareRunnitAssets;
}
function Bn(e, t) {
  return !!e.teamId && !!t.teamId && e.teamId === t.teamId && t.manageAllGenerations;
}
function Nr(e, t) {
  return !!t.teamId && (cs(e, t) || Bn(e, t));
}
function tf(e) {
  return !!e.teamId && (e.shareRunnitAssets || e.manageAllGenerations);
}
function nf(e, t) {
  const n = ["open"], o = ef(e, t);
  return o && n.push("edit"), Nr(e, t) && n.push("access"), o && n.push("delete"), n;
}
function zl(e, t = Date.now()) {
  const n = Math.max(0, Math.round((t - e) / 1e3));
  if (n < 45) return "just now";
  const o = Math.round(n / 60);
  if (o < 60) return o + "m ago";
  const s = Math.round(o / 60);
  if (s < 24) return s + "h ago";
  const r = Math.round(s / 24);
  return r < 7 ? r + "d ago" : new Date(e).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
const _n = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const Tl = (...e) => e.filter((t, n, o) => !!t && t.trim() !== "" && o.indexOf(t) === n).join(" ").trim();
function Ks(e) {
  return e != null;
}
function of(e, t = {}) {
  var p, v, x, C, A, M, y, D, k, L, z, $, W, N, oe;
  const n = (p = t.attributeNames) != null ? p : {}, o = (Q) => {
    var I;
    return (I = n[Q]) != null ? I : Q;
  }, s = (x = (v = e.size) != null ? v : e.width) != null ? x : _n.width, r = (A = (C = e.size) != null ? C : e.height) != null ? A : _n.height, l = (y = (M = e.aliases) == null ? void 0 : M.filter((Q) => typeof Q == "string" && Q.trim() !== "").map((Q) => `lucide-${Q}`)) != null ? y : [], i = [...e.name ? [`lucide-${e.name}`] : [], ...l], a = (k = (D = t.className) == null ? void 0 : D.split(" ").filter(Boolean)) != null ? k : [], d = t.includeDefaultClasses === !1 ? Tl(...a) : Tl("lucide", ...i, ...a), c = t.absoluteStrokeWidth ? Number((L = t.strokeWidth) != null ? L : _n["stroke-width"]) * Number(($ = (z = e.size) != null ? z : e.width) != null ? $ : _n.width) / Number((N = (W = t.size) != null ? W : t.width) != null ? N : _n.width) : (oe = t.strokeWidth) != null ? oe : _n["stroke-width"];
  return [
    "svg",
    {
      ...Object.entries(_n).reduce((Q, [I, Y]) => (Q[o(I)] = Y, Q), {}),
      ..."color" in t && t.color && {
        [o("stroke")]: t.color
      },
      ..."size" in t && Ks(t.size) && {
        [o("width")]: t.size,
        [o("height")]: t.size
      },
      ..."width" in t && Ks(t.width) && {
        [o("width")]: t.width
      },
      ..."height" in t && Ks(t.height) && {
        [o("height")]: t.height
      },
      [o("stroke-width")]: c,
      ...d && {
        [o("class")]: d
      },
      [o("viewBox")]: `0 0 ${s} ${r}`,
      ...t.hasA11yProp === !1 ? {
        [o("aria-hidden")]: "true"
      } : {},
      ..."attributes" in t && t.attributes
    },
    e.node.map((Q) => {
      const [I, Y, ge] = Q, de = t.nonScalingStroke ? { [o("vector-effect")]: "non-scaling-stroke", ...Y } : Y;
      return ge ? [I, de, ge] : [I, de];
    })
  ];
}
const sf = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
  return !1;
};
const Ro = (e) => e === "";
const rf = (e) => e == null ? void 0 : e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const lf = /* @__PURE__ */ Symbol("lucide-icons");
function af() {
  return Cs(lf, {});
}
const cf = ({
  name: e,
  iconNode: t,
  "icon-node": n,
  icon: o = {
    name: e && rf(e),
    node: ((A) => (A = t != null ? t : n) != null ? A : [])(),
    size: 24,
    aliases: []
  },
  absoluteStrokeWidth: s,
  "absolute-stroke-width": r,
  nonScalingStroke: l,
  "non-scaling-stroke": i,
  strokeWidth: a,
  "stroke-width": d,
  size: c,
  width: f = c,
  height: p = c,
  color: v,
  ...x
}, { slots: C }) => {
  var I, Y, ge, de;
  const {
    size: M,
    color: y,
    strokeWidth: D = 2,
    absoluteStrokeWidth: k = !1,
    nonScalingStroke: L = !1,
    class: z = ""
  } = af(), $ = Ro(s) || Ro(r) || s === !0 || r === !0 || k === !0, W = Ro(l) || Ro(i) || l === !0 || i === !0 || L === !0;
  delete x.class;
  const N = (I = C.default) == null ? void 0 : I.call(C), [, oe, Q = []] = of(o, {
    color: v != null ? v : y,
    width: (Y = f != null ? f : c) != null ? Y : M,
    height: (ge = p != null ? p : c) != null ? ge : M,
    strokeWidth: (de = a != null ? a : d) != null ? de : D,
    absoluteStrokeWidth: $,
    nonScalingStroke: W,
    className: z,
    hasA11yProp: N != null && N.length > 0 || sf(x),
    attributes: x
  });
  return is("svg", oe, [
    ...Q.map(([me, Fe]) => is(me, Fe)),
    ...N != null ? N : []
  ]);
};
function ce(e, t = []) {
  const n = typeof e == "string" ? {
    name: e,
    node: t
  } : e;
  return (o, { slots: s }) => is(
    cf,
    {
      ...o,
      icon: n
    },
    s.default ? { default: s.default } : void 0
  );
}
const df = {
  name: "arrow-down",
  size: 24,
  node: [
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
  ]
}, uf = ce(df);
const ff = {
  name: "arrow-right",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
  ]
}, pf = ce(ff);
const bf = {
  name: "arrow-up-down",
  size: 24,
  node: [
    ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
    ["path", { d: "M17 20V4", key: "1ejh1v" }],
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }]
  ]
}, hf = ce(bf);
const mf = {
  name: "arrow-up-right",
  size: 24,
  node: [
    ["path", { d: "M7 7h10v10", key: "1tivn9" }],
    ["path", { d: "M7 17 17 7", key: "1vkiza" }]
  ]
}, gf = ce(mf);
const vf = {
  name: "arrow-up",
  size: 24,
  node: [
    ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
    ["path", { d: "M12 19V5", key: "x0mq9r" }]
  ]
}, yf = ce(vf);
const xf = {
  name: "check",
  size: 24,
  node: [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]
}, wf = ce(xf);
const kf = {
  name: "chevron-down",
  size: 24,
  node: [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]]
}, _f = ce(kf);
const Cf = {
  name: "chevron-left",
  size: 24,
  node: [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]]
}, Sf = ce(Cf);
const If = {
  name: "chevron-right",
  size: 24,
  node: [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]]
}, Af = ce(If);
const Mf = {
  name: "circle-alert",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
  ],
  aliases: ["alert-circle"]
}, $f = ce(Mf);
const zf = {
  name: "circle-check",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m16 9-5.5 5.5L8 12", key: "xofnsj" }]
  ],
  aliases: ["check-circle-2"]
}, Tf = ce(zf);
const Ef = {
  name: "circle-minus",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }]
  ],
  aliases: ["minus-circle"]
}, Lf = ce(Ef);
const Rf = {
  name: "circle-play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
        key: "kmsa83"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["play-circle"]
}, Pf = ce(Rf);
const Df = {
  name: "circle-x",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }]
  ],
  aliases: ["x-circle"]
}, Of = ce(Df);
const Ff = {
  name: "copy",
  size: 24,
  node: [
    ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
    ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
  ]
}, Bf = ce(Ff);
const Nf = {
  name: "download",
  size: 24,
  node: [
    ["path", { d: "M12 15V3", key: "m9g1x1" }],
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
    ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
  ]
}, Uf = ce(Nf);
const jf = {
  name: "ellipsis",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
    ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
  ],
  aliases: ["more-horizontal"]
}, Vf = ce(jf);
const Hf = {
  name: "external-link",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "M10 14 21 3", key: "gplh6r" }],
    ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
  ]
}, Kf = ce(Hf);
const qf = {
  name: "frame",
  size: 24,
  node: [
    ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
    ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
    ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
    ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
  ]
}, Wf = ce(qf);
const Yf = {
  name: "globe",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }]
  ]
}, Gf = ce(Yf);
const Xf = {
  name: "hand",
  size: 24,
  node: [
    ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
    ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
    ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
    [
      "path",
      {
        d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        key: "1s1gnw"
      }
    ]
  ]
}, Jf = ce(Xf);
const Zf = {
  name: "heart",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
        key: "mvr1a0"
      }
    ]
  ]
}, Qf = ce(Zf);
const ep = {
  name: "image-plus",
  size: 24,
  node: [
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
    ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
  ]
}, tp = ce(ep);
const np = {
  name: "image",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
  ]
}, op = ce(np);
const sp = {
  name: "layout-grid",
  size: 24,
  node: [
    ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
    ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
    ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
    ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
  ]
}, rp = ce(sp);
const lp = {
  name: "layout-template",
  size: 24,
  node: [
    ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
    ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
    ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
  ]
}, ip = ce(lp);
const ap = {
  name: "link",
  size: 24,
  node: [
    ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
    ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
  ]
}, cp = ce(ap);
const dp = {
  name: "loader-circle",
  size: 24,
  node: [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]],
  aliases: ["loader-2"]
}, up = ce(dp);
const fp = {
  name: "lock",
  size: 24,
  node: [
    ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
    ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
  ]
}, pp = ce(fp);
const bp = {
  name: "maximize-2",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "m21 3-7 7", key: "1l2asr" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
  ]
}, hp = ce(bp);
const mp = {
  name: "minimize-2",
  size: 24,
  node: [
    ["path", { d: "m14 10 7-7", key: "oa77jy" }],
    ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
  ]
}, gp = ce(mp);
const vp = {
  name: "minus",
  size: 24,
  node: [["path", { d: "M5 12h14", key: "1ays0h" }]]
}, yp = ce(vp);
const xp = {
  name: "mouse-pointer-2",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
        key: "edeuup"
      }
    ]
  ]
}, wp = ce(xp);
const kp = {
  name: "pause",
  size: 24,
  node: [
    ["rect", { x: "14", y: "3", width: "5", height: "18", rx: "1", key: "kaeet6" }],
    ["rect", { x: "5", y: "3", width: "5", height: "18", rx: "1", key: "1wsw3u" }]
  ]
}, _p = ce(kp);
const Cp = {
  name: "pencil",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        key: "1a8usu"
      }
    ],
    ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
  ]
}, Sp = ce(Cp);
const Ip = {
  name: "pipette",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12",
        key: "1y3wsu"
      }
    ],
    [
      "path",
      {
        d: "m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z",
        key: "110lr1"
      }
    ],
    ["path", { d: "m2 22 .414-.414", key: "jhxm08" }]
  ]
}, Ap = ce(Ip);
const Mp = {
  name: "play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
        key: "10ikf1"
      }
    ]
  ]
}, $p = ce(Mp);
const zp = {
  name: "plus",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "M12 5v14", key: "s699le" }]
  ]
}, Tp = ce(zp);
const Ep = {
  name: "rectangle-vertical",
  size: 24,
  node: [["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]]
}, Lp = ce(Ep);
const Rp = {
  name: "refresh-cw",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
    ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
    ["path", { d: "M8 16H3v5", key: "1cv678" }]
  ]
}, Pp = ce(Rp);
const Dp = {
  name: "search",
  size: 24,
  node: [
    ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
  ]
}, Op = ce(Dp);
const Fp = {
  name: "settings",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
        key: "1i5ecw"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, Bp = ce(Fp);
const Np = {
  name: "shield-check",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y"
      }
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
  ]
}, Up = ce(Np);
const jp = {
  name: "sliders-horizontal",
  size: 24,
  node: [
    ["path", { d: "M10 5H3", key: "1qgfaw" }],
    ["path", { d: "M12 19H3", key: "yhmn1j" }],
    ["path", { d: "M14 3v4", key: "1sua03" }],
    ["path", { d: "M16 17v4", key: "1q0r14" }],
    ["path", { d: "M21 12h-9", key: "1o4lsq" }],
    ["path", { d: "M21 19h-5", key: "1rlt1p" }],
    ["path", { d: "M21 5h-7", key: "1oszz2" }],
    ["path", { d: "M8 10v4", key: "tgpxqk" }],
    ["path", { d: "M8 12H3", key: "a7s4jb" }]
  ]
}, Vp = ce(jp);
const Hp = {
  name: "sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        key: "1s2grr"
      }
    ],
    ["path", { d: "M20 2v4", key: "1rf3ol" }],
    ["path", { d: "M22 4h-4", key: "gwowj6" }],
    ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
  ],
  aliases: ["stars"]
}, El = ce(Hp);
const Kp = {
  name: "square",
  size: 24,
  node: [["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]]
}, qp = ce(Kp);
const Wp = {
  name: "sticky-note",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
        key: "1dfntj"
      }
    ],
    ["path", { d: "M15 3v5a1 1 0 0 0 1 1h5", key: "6s6qgf" }]
  ]
}, Yp = ce(Wp);
const Gp = {
  name: "table-2",
  size: 24,
  node: [
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
  ]
}, Xp = ce(Gp);
const Jp = {
  name: "trash",
  size: 24,
  node: [
    ["path", { d: "M10 11v6", key: "nco0om" }],
    ["path", { d: "M14 11v6", key: "outv1u" }],
    ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
  ],
  aliases: ["trash-2"]
}, Zp = ce(Jp);
const Qp = {
  name: "user-check",
  size: 24,
  node: [
    ["path", { d: "m16 11 2 2 4-4", key: "9rsbq5" }],
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, eb = ce(Qp);
const tb = {
  name: "user-plus",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
    ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
  ]
}, nb = ce(tb);
const ob = {
  name: "user-round-cog",
  size: 24,
  node: [
    ["path", { d: "m14.305 19.53.923-.382", key: "3m78fa" }],
    ["path", { d: "m15.228 16.852-.923-.383", key: "npixar" }],
    ["path", { d: "m16.852 15.228-.383-.923", key: "5xggr7" }],
    ["path", { d: "m16.852 20.772-.383.924", key: "dpfhf9" }],
    ["path", { d: "m19.148 15.228.383-.923", key: "1reyyz" }],
    ["path", { d: "m19.53 21.696-.382-.924", key: "1goivc" }],
    ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
    ["path", { d: "m20.772 16.852.924-.383", key: "htqkph" }],
    ["path", { d: "m20.772 19.148.924.383", key: "9w9pjp" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
  ],
  aliases: ["user-cog-2"]
}, sb = ce(ob);
const rb = {
  name: "user-round",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
    ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
  ],
  aliases: ["user-2"]
}, lb = ce(rb);
const ib = {
  name: "users",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
    ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, ab = ce(ib);
const cb = {
  name: "video",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
        key: "ftymec"
      }
    ],
    ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
  ]
}, db = ce(cb);
const ub = {
  name: "wand-sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
        key: "ul74o6"
      }
    ],
    ["path", { d: "m14 7 3 3", key: "1r5n42" }],
    ["path", { d: "M5 6v4", key: "ilb8ba" }],
    ["path", { d: "M19 14v4", key: "blhpug" }],
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M7 8H3", key: "zfb6yr" }],
    ["path", { d: "M21 16h-4", key: "1cnmox" }],
    ["path", { d: "M11 3H9", key: "1obp7u" }]
  ],
  aliases: ["wand-2"]
}, fb = ce(ub);
const pb = {
  name: "x",
  size: 24,
  node: [
    ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
    ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
  ]
}, bb = ce(pb), hb = {
  class: "licon",
  "aria-hidden": "true",
  style: { display: "inline-flex", flex: "none" }
}, X = /* @__PURE__ */ Oe({
  __name: "LIcon",
  props: {
    name: {},
    size: { default: 16 },
    stroke: { default: 2 }
  },
  setup(e) {
    const t = {
      ArrowDown: uf,
      ArrowUp: yf,
      ArrowUpDown: hf,
      ArrowUpRight: gf,
      Check: wf,
      ChevronDown: _f,
      ChevronLeft: Sf,
      ChevronRight: Af,
      CircleAlert: $f,
      CircleCheck: Tf,
      Copy: Bf,
      Download: Uf,
      Ellipsis: Vf,
      ExternalLink: Kf,
      Globe: Gf,
      Image: op,
      LayoutGrid: rp,
      Lock: pp,
      Minus: yp,
      Pencil: Sp,
      Plus: Tp,
      RefreshCw: Pp,
      Search: Op,
      ShieldCheck: Up,
      SlidersHorizontal: Vp,
      Sparkles: El,
      StickyNote: Yp,
      Table2: Xp,
      Trash2: Zp,
      UserRound: lb,
      Users: ab,
      Wand2: fb,
      X: bb,
      // Edit and Access Settings
      ArrowRight: pf,
      CircleMinus: Lf,
      CircleX: Of,
      Link: cp,
      LoaderCircle: up,
      UserCheck: eb,
      UserPlus: nb,
      UserRoundCog: sb,
      // the hero's demo window
      Frame: Wf,
      Hand: Jf,
      Heart: Qf,
      ImagePlus: tp,
      LayoutTemplate: ip,
      Maximize2: hp,
      MousePointer2: wp,
      Pause: _p,
      Pipette: Ap,
      Play: $p,
      RectangleVertical: Lp,
      Settings: Bp,
      Square: qp,
      Video: db,
      // the hero's Take the tour (IL-095), and its minimize (IL-108)
      CirclePlay: Pf,
      Minimize2: gp
    }, n = e, o = K(() => t[n.name] || El);
    return (s, r) => (h(), _("span", hb, [
      (h(), we(ho(o.value), {
        size: e.size,
        "stroke-width": e.stroke
      }, null, 8, ["size", "stroke-width"]))
    ]));
  }
});
function Ur(e) {
  let t = 2166136261;
  for (let n = 0; n < e.length; n++)
    t ^= e.charCodeAt(n), t = Math.imul(t, 16777619);
  return t >>> 0;
}
function ba(e) {
  let t = e || 1;
  return () => {
    t |= 0, t = t + 1831565813 | 0;
    let n = Math.imul(t ^ t >>> 15, 1 | t);
    return n = n + Math.imul(n ^ n >>> 7, 61 | n) ^ n, ((n ^ n >>> 14) >>> 0) / 4294967296;
  };
}
const Ll = [
  "linear-gradient(135deg, #9968df, #5a61ed)",
  "linear-gradient(135deg, #c750ce, #7532d3)",
  "linear-gradient(135deg, #5a61ed, #37b6d3)",
  "linear-gradient(135deg, #f08a5d, #c750ce)",
  "linear-gradient(135deg, #37d399, #3b8fe0)",
  "linear-gradient(135deg, #ffb347, #f06292)"
];
function Dn(e) {
  return { background: Ll[Ur(e || "?") % Ll.length] };
}
function On(e) {
  const t = (e || "").split("@")[0].trim();
  if (!t) return "?";
  const n = t.split(/[\s._-]+/).filter(Boolean);
  return n.length >= 2 ? (n[0][0] + n[1][0]).toUpperCase() : t.slice(0, 2).toUpperCase();
}
function mb(e, t = 26) {
  if (e.length <= t) return e;
  const [n, o = ""] = e.split("@"), s = Math.max(4, t - o.length - 4);
  return n.slice(0, s) + "...@" + o;
}
const br = ["rgba(153, 104, 223, 0.22)", "rgba(90, 97, 237, 0.2)", "rgba(199, 80, 206, 0.16)", "rgba(255, 255, 255, 0.07)", "rgba(55, 182, 211, 0.14)"];
function gb(e) {
  const t = ba(Ur(e)), n = 3 + Math.floor(t() * 3), o = [];
  for (let s = 0; s < n; s++) {
    const r = 18 + t() * 30, l = 16 + t() * 34;
    o.push({
      left: 6 + t() * (88 - r),
      top: 8 + t() * (84 - l),
      width: r,
      height: l,
      background: br[Math.floor(t() * br.length)]
    });
  }
  return o;
}
function vb(e) {
  const t = ba(Ur(e) ^ 2654435769), n = Math.round(20 + t() * 60), o = Math.round(20 + t() * 60), s = br[Math.floor(t() * 3)];
  return "radial-gradient(120% 120% at " + n + "% " + o + "%, " + s + ", transparent 60%)";
}
const yb = { class: "bl-access-cell" }, xb = ["title"], wb = {
  key: 0,
  class: "bl-avatar is-more",
  style: { width: "auto", padding: "0 6px" }
}, qs = 3, ha = /* @__PURE__ */ Oe({
  __name: "AccessBadge",
  props: {
    board: {},
    canOpen: { type: Boolean },
    showMembers: { type: Boolean },
    compact: { type: Boolean }
  },
  emits: ["open-access"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = K(() => n.board.accessLevel || "PRIVATE"), l = K(() => r.value === "PRIVATE" ? "Lock" : r.value === "SHARED" ? "Globe" : "Users"), i = /* @__PURE__ */ U([]);
    let a = null;
    Pe(() => [n.board.id, r.value, n.showMembers], ([p, v, x]) => {
      a && a(), a = null, i.value = [], !(v !== "RESTRICTED" || !x) && (a = s.source().watchBoardMembers(p, (C) => {
        i.value = C.map((M) => ({ ...M, label: M.email }));
        const A = n.board.teamId;
        A && C.forEach((M, y) => {
          M.email || s.source().teamMemberEmail(A, M.userId).then((D) => {
            const k = i.value[y];
            k && k.userId === M.userId && (i.value[y] = { ...k, label: D });
          });
        });
      }));
    }, { immediate: !0 }), Je(() => {
      a && a();
    });
    const d = K(() => i.value.slice(0, qs)), c = K(() => {
      const p = i.value.length;
      return p <= qs ? "" : p > 10 ? "10+" : "+" + (p - qs);
    }), f = K(() => r.value !== "RESTRICTED" || !i.value.length ? ko[r.value] : "Restricted to " + i.value.slice(0, 10).map((v) => v.label || "a former member").join(", ") + (i.value.length > 10 ? " and more" : ""));
    return (p, v) => (h(), _("span", yb, [
      (h(), we(ho(e.canOpen ? "button" : "span"), {
        class: fe(["bl-access", "is-" + r.value.toLowerCase()]),
        type: e.canOpen ? "button" : void 0,
        title: e.canOpen ? f.value + ". Manage access" : f.value,
        onClick: v[0] || (v[0] = st((x) => e.canOpen && o("open-access"), ["stop"]))
      }, {
        default: ut(() => [
          O(X, {
            name: l.value,
            size: 11,
            stroke: 2.4
          }, null, 8, ["name"]),
          be(" " + q(g(ko)[r.value]), 1),
          e.compact && i.value.length ? (h(), _(ae, { key: 0 }, [
            be(" · " + q(i.value.length > 10 ? "10+" : i.value.length), 1)
          ], 64)) : ne("", !0)
        ]),
        _: 1
      }, 8, ["class", "type", "title"])),
      d.value.length && !e.compact ? (h(), _("span", {
        key: 0,
        class: "bl-avatars",
        title: f.value
      }, [
        (h(!0), _(ae, null, Ce(d.value, (x) => (h(), _("span", {
          key: x.userId,
          class: "bl-avatar",
          style: xe(g(Dn)(x.userId))
        }, q(g(On)(x.label)), 5))), 128)),
        c.value ? (h(), _("span", wb, q(c.value), 1)) : ne("", !0)
      ], 8, xb)) : ne("", !0)
    ]));
  }
}), ma = /* @__PURE__ */ Oe({
  __name: "BoardCover",
  props: {
    id: {},
    preview: {}
  },
  setup(e) {
    const t = e, n = /* @__PURE__ */ U(!1);
    Pe(() => t.preview, (r) => {
      if (n.value = !1, !r) return;
      const l = new Image();
      l.decoding = "async", l.onload = () => {
        t.preview === r && (n.value = !0);
      }, l.onerror = () => {
        t.preview === r && (n.value = !0);
      }, l.src = r;
    }, { immediate: !0 });
    const o = K(() => gb(t.id)), s = K(() => vb(t.id));
    return (r, l) => e.preview ? (h(), _("div", {
      key: 1,
      class: fe(["bl-cover-img", { "is-loading": !n.value }]),
      style: xe({ backgroundImage: 'url("' + e.preview + '")' })
    }, null, 6)) : (h(), _("div", {
      key: 0,
      class: "bl-placeholder",
      style: xe({ background: s.value })
    }, [
      l[0] || (l[0] = u("div", { class: "bl-placeholder-dots" }, null, -1)),
      (h(!0), _(ae, null, Ce(o.value, (i, a) => (h(), _("i", {
        key: a,
        style: xe({ left: i.left + "%", top: i.top + "%", width: i.width + "%", height: i.height + "%", background: i.background })
      }, null, 4))), 128))
    ], 4));
  }
}), _o = /* @__PURE__ */ Oe({
  __name: "Floating",
  props: {
    open: { type: Boolean },
    anchor: {},
    align: { default: "end" },
    panelClass: { default: "" },
    keepOnScroll: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(e, { expose: t, emit: n }) {
    const o = e, s = n, r = Cs("bl-overlay", /* @__PURE__ */ U(null)), l = /* @__PURE__ */ U(null), i = /* @__PURE__ */ U({ left: 0, top: 0, up: !1 });
    function a() {
      const x = o.anchor, C = l.value;
      if (!x || !C) return;
      const A = x.getBoundingClientRect(), M = C.offsetWidth, y = C.offsetHeight, D = 8;
      let k = o.align === "end" ? A.right - M : A.left;
      k = Math.max(12, Math.min(k, window.innerWidth - M - 12));
      const L = A.bottom + D + y <= window.innerHeight - 12, z = L ? A.bottom + D : Math.max(12, A.top - D - y);
      i.value = { left: k, top: z, up: !L };
    }
    function d(x) {
      const C = x.target;
      l.value && l.value.contains(C) || o.anchor && o.anchor.contains(C) || s("close");
    }
    function c(x) {
      x.key === "Escape" && (x.stopPropagation(), s("close"), o.anchor && o.anchor.focus());
    }
    function f(x) {
      l.value && x.target instanceof Node && l.value.contains(x.target) || (o.keepOnScroll ? a() : s("close"));
    }
    let p = null;
    function v(x) {
      const C = x ? window.addEventListener : window.removeEventListener;
      C("pointerdown", d, !0), C("keydown", c, !0), C("scroll", f, !0), C("resize", a), p && (p.disconnect(), p = null), x && l.value && typeof ResizeObserver != "undefined" && (p = new ResizeObserver(() => a()), p.observe(l.value));
    }
    return Pe(() => o.open, async (x) => {
      if (v(!1), !x) return;
      await Lt(), a(), v(!0);
      const C = l.value && l.value.querySelector("input, button:not([disabled])");
      C && C.focus({ preventScroll: !0 });
    }, { immediate: !0 }), Je(() => v(!1)), t({ place: a }), (x, C) => (h(), we(Ec, {
      to: g(r) || "body",
      disabled: !g(r)
    }, [
      e.open ? (h(), _("div", {
        key: 0,
        ref_key: "panel",
        ref: l,
        class: fe(["bl-float-panel", [e.panelClass, { "is-up": i.value.up }]]),
        style: xe({ left: i.value.left + "px", top: i.value.top + "px" }),
        role: "menu"
      }, [
        Nc(x.$slots, "default")
      ], 6)) : ne("", !0)
    ], 8, ["to", "disabled"]));
  }
}), kb = ["aria-expanded"], ga = /* @__PURE__ */ Oe({
  __name: "BoardMenu",
  props: {
    board: {},
    row: {}
  },
  emits: ["open-change"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = /* @__PURE__ */ U(null), l = /* @__PURE__ */ U(!1), i = (c) => {
      l.value = c, o("open-change", c);
    }, a = K(() => nf(n.board, s.list.ctx.value).filter((c) => c === "edit" ? !!s.actions.edit : c === "access" ? !!s.actions.access : !0));
    function d(c) {
      i(!1);
      const f = n.board.id;
      c === "open" ? s.actions.open(f) : c === "edit" && s.actions.edit ? s.actions.edit(f) : c === "access" && s.actions.access ? s.actions.access([f], () => s.list.refetchAfterMirrorLag()) : c === "delete" && s.requestDelete([n.row], !1);
    }
    return (c, f) => (h(), _(ae, null, [
      u("button", {
        ref_key: "btn",
        ref: r,
        type: "button",
        class: fe(["bl-icon-btn", { "is-on": l.value }]),
        "aria-label": "Manage board",
        title: "Manage board",
        "aria-expanded": l.value,
        onClick: f[0] || (f[0] = st((p) => i(!l.value), ["stop"]))
      }, [
        O(X, {
          name: "Ellipsis",
          size: 17
        })
      ], 10, kb),
      O(_o, {
        open: l.value,
        anchor: r.value,
        onClose: f[5] || (f[5] = (p) => i(!1))
      }, {
        default: ut(() => [
          a.value.includes("open") ? (h(), _("button", {
            key: 0,
            type: "button",
            class: "bl-menu-item",
            onClick: f[1] || (f[1] = (p) => d("open"))
          }, [
            O(X, { name: "ArrowUpRight" }),
            f[6] || (f[6] = u("span", null, "Open board", -1))
          ])) : ne("", !0),
          a.value.includes("edit") ? (h(), _("button", {
            key: 1,
            type: "button",
            class: "bl-menu-item",
            onClick: f[2] || (f[2] = (p) => d("edit"))
          }, [
            O(X, { name: "Pencil" }),
            f[7] || (f[7] = u("span", null, [
              be("Edit"),
              u("small", null, "Name, description and fields")
            ], -1))
          ])) : ne("", !0),
          a.value.includes("access") ? (h(), _("button", {
            key: 2,
            type: "button",
            class: "bl-menu-item",
            onClick: f[3] || (f[3] = (p) => d("access"))
          }, [
            O(X, { name: "Users" }),
            f[8] || (f[8] = u("span", null, [
              be("Access settings"),
              u("small", null, "Owner, who can see it, and members")
            ], -1))
          ])) : ne("", !0),
          a.value.includes("delete") ? (h(), _(ae, { key: 3 }, [
            f[10] || (f[10] = u("div", { class: "bl-menu-sep" }, null, -1)),
            u("button", {
              type: "button",
              class: "bl-menu-item is-danger",
              onClick: f[4] || (f[4] = (p) => d("delete"))
            }, [
              O(X, { name: "Trash2" }),
              f[9] || (f[9] = u("span", null, "Delete board", -1))
            ])
          ], 64)) : ne("", !0)
        ]),
        _: 1
      }, 8, ["open", "anchor"])
    ], 64));
  }
}), _b = {
  key: 1,
  class: "bl-avatar is-more"
}, va = /* @__PURE__ */ Oe({
  __name: "OwnerChip",
  props: {
    board: {},
    row: {},
    canOpen: { type: Boolean },
    compact: { type: Boolean }
  },
  emits: ["open-access"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = /* @__PURE__ */ U(null), l = K(() => !!n.board.userId && n.board.userId === s.user.value.uid);
    Pe(() => [n.board.userId, n.board.teamId], ([d, c]) => {
      r.value = null, !(!d || !c || l.value) && (d === n.row.ownerUserId && n.row.ownerEmail || s.source().teamMemberEmail(c, d).then((f) => {
        n.board.userId === d && (r.value = f);
      }));
    }, { immediate: !0 });
    const i = K(() => l.value ? s.user.value.email : n.board.userId === n.row.ownerUserId && n.row.ownerEmail ? n.row.ownerEmail : r.value), a = K(() => l.value ? "You" : i.value ? n.compact ? i.value.split("@")[0] : mb(i.value, 28) : "No owner");
    return (d, c) => (h(), we(ho(e.canOpen ? "button" : "span"), {
      class: "bl-owner-chip",
      type: e.canOpen ? "button" : void 0,
      title: i.value || a.value,
      onClick: c[0] || (c[0] = st((f) => e.canOpen && o("open-access"), ["stop"]))
    }, {
      default: ut(() => [
        l.value || i.value ? (h(), _("span", {
          key: 0,
          class: "bl-avatar",
          style: xe(g(Dn)(e.board.userId))
        }, q(g(On)(i.value || a.value)), 5)) : (h(), _("span", _b, [
          O(X, {
            name: "UserRound",
            size: 12
          })
        ])),
        u("span", {
          class: fe(["t", { "bl-muted": !l.value && !i.value }])
        }, q(a.value), 3)
      ]),
      _: 1
    }, 8, ["type", "title"]));
  }
});
function hr() {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return !1;
  }
}
function ya() {
  const e = /* @__PURE__ */ U(hr());
  let t = null;
  const n = () => {
    e.value = !!t && t.matches;
  };
  return Pt(() => {
    try {
      t = window.matchMedia("(prefers-reduced-motion: reduce)"), t.addEventListener("change", n);
    } catch {
      t = null;
    }
  }), Je(() => {
    t && t.removeEventListener("change", n);
  }), e;
}
function Cb(e) {
  let t = e ? e.parentElement : null;
  for (; t && t !== document.body && t !== document.documentElement; ) {
    const n = getComputedStyle(t);
    if (/(auto|scroll|overlay)/.test(n.overflowY) && t.scrollHeight > t.clientHeight) return t;
    t = t.parentElement;
  }
  return window;
}
function Sb(e) {
  return e === window ? window.scrollY : e.scrollTop;
}
function Ib(e, t = {}) {
  var n;
  const o = /* @__PURE__ */ U(0), s = (n = t.maxScroll) != null ? n : 520;
  let r = null, l = 0, i = 0, a = 0, d = 0, c = 0, f = null, p = 0, v = 0, x = 0, C = 0, A = 0, M = hr();
  const y = () => {
    const W = e.value;
    if (!W) return;
    const N = Math.min(s, Math.max(0, o.value));
    W.style.setProperty("--px", d.toFixed(4)), W.style.setProperty("--py", c.toFixed(4)), W.style.setProperty("--sy", N.toFixed(1) + "px"), W.style.setProperty("--hero-fade", (N / s).toFixed(4)), f != null && (W.style.setProperty("--mx", C.toFixed(1) + "px"), W.style.setProperty("--my", A.toFixed(1) + "px"));
  }, D = () => {
    const W = e.value;
    if (!W || f == null) return;
    const N = W.getBoundingClientRect();
    v = f - N.left, x = p - N.top;
  }, k = () => {
    l = 0, d += (i - d) * 0.08, c += (a - c) * 0.08, C += (v - C) * 0.16, A += (x - A) * 0.16, y(), (Math.abs(i - d) > 1e-3 || Math.abs(a - c) > 1e-3 || Math.abs(v - C) > 0.5 || Math.abs(x - A) > 0.5) && (l = requestAnimationFrame(k));
  }, L = () => {
    l || (l = requestAnimationFrame(k));
  }, z = (W) => {
    if (M || W.pointerType === "touch") return;
    i = W.clientX / Math.max(1, window.innerWidth) * 2 - 1, a = W.clientY / Math.max(1, window.innerHeight) * 2 - 1;
    const N = f == null;
    f = W.clientX, p = W.clientY, D(), N && (C = v, A = x), L();
  }, $ = () => {
    o.value = r ? Sb(r) : 0, D(), M || L();
  };
  return Pt(() => {
    M = hr(), r = Cb(e.value), r.addEventListener("scroll", $, { passive: !0 }), window.addEventListener("pointermove", z, { passive: !0 }), $(), y();
  }), Je(() => {
    r && r.removeEventListener("scroll", $), window.removeEventListener("pointermove", z), l && cancelAnimationFrame(l);
  }), { scrollY: o };
}
function Ab(e, t) {
  if (e.pointerType === "touch") return;
  const n = t.getBoundingClientRect();
  t.style.setProperty("--cx", ((e.clientX - n.left) / Math.max(1, n.width) * 2 - 1).toFixed(3)), t.style.setProperty("--cy", ((e.clientY - n.top) / Math.max(1, n.height) * 2 - 1).toFixed(3));
}
function Mb(e) {
  e.style.setProperty("--cx", "0"), e.style.setProperty("--cy", "0");
}
function xa(e) {
  const n = Ze().list.live;
  let o = null;
  Pe(() => e.value.id, (a) => {
    o && n.release(o), o = a, n.retain(a);
  }, { immediate: !0 }), Je(() => {
    o && n.release(o);
  });
  const s = K(() => n.get(e.value.id)), r = K(() => s.value ? s.value.state : "loading"), l = K(() => r.value === "live" && s.value && s.value.board ? s.value.board : Tu(e.value)), i = K(() => r.value === "removed");
  return { board: l, state: r, removed: i };
}
const $b = ["tabindex", "aria-label", "data-board"], zb = { class: "bl-cover" }, Tb = { class: "bl-open" }, Eb = ["aria-pressed", "aria-label", "disabled"], Lb = { class: "bl-card-body" }, Rb = { class: "bl-card-title" }, Pb = { class: "t" }, Db = {
  key: 0,
  class: "bl-new-badge"
}, Ob = {
  key: 1,
  class: "bl-deleted-badge"
}, Fb = { class: "bl-card-desc" }, Bb = { class: "bl-card-meta" }, Nb = { key: 1 }, Ub = {
  key: 3,
  class: "bl-muted"
}, jb = {
  key: 0,
  class: "bl-card-fields"
}, Vb = ["title"], Hb = /* @__PURE__ */ Oe({
  __name: "BoardCard",
  props: {
    row: {},
    index: {}
  },
  setup(e) {
    const t = e, n = Ze(), o = n.list, { board: s, state: r, removed: l } = xa(/* @__PURE__ */ _i(t, "row")), i = /* @__PURE__ */ U(null), a = /* @__PURE__ */ U(!1), d = K(() => o.isSelected(t.row.id)), c = K(() => o.pinnedIds.value.has(t.row.id)), f = K(() => r.value === "live"), p = K(() => f.value && !!n.actions.access && Nr(s.value, o.ctx.value)), v = K(() => p.value && Bn(s.value, o.ctx.value)), x = K(() => o.teamMode.value ? n.account.value.customFields.map((k) => ({ label: k.label, value: s.value.customFields[k.key] })).filter((k) => !!k.value).slice(0, 2) : []), C = K(() => s.value.createdAt ? zl(s.value.createdAt) : "");
    function A() {
      l.value || n.actions.open(t.row.id);
    }
    function M() {
      n.actions.access && n.actions.access([t.row.id], () => o.refetchAfterMirrorLag());
    }
    function y(k) {
      k.target === k.currentTarget && (k.preventDefault(), A());
    }
    function D() {
      n.actions.prefetch && n.actions.prefetch();
    }
    return (k, L) => (h(), _("article", {
      ref_key: "el",
      ref: i,
      class: fe(["bl-card", { "is-selected": d.value, "is-removed": g(l) }]),
      style: xe({ "--i-delay": Math.min(e.index, 12) * 45 + "ms" }),
      role: "link",
      tabindex: g(l) ? -1 : 0,
      "aria-label": "Open " + (g(s).title || "Untitled board"),
      "data-board": e.row.id,
      onClick: A,
      onKeydown: [
        wo(y, ["enter"]),
        wo(y, ["space"])
      ],
      onPointerenter: D,
      onPointermove: L[3] || (L[3] = (z) => i.value && g(Ab)(z, i.value)),
      onPointerleave: L[4] || (L[4] = (z) => i.value && g(Mb)(i.value))
    }, [
      u("div", zb, [
        O(ma, {
          id: e.row.id,
          preview: g(s).preview
        }, null, 8, ["id", "preview"]),
        L[6] || (L[6] = u("div", { class: "bl-cover-sheen" }, null, -1)),
        u("span", Tb, [
          L[5] || (L[5] = be("Open ", -1)),
          O(X, {
            name: "ArrowUpRight",
            size: 13
          })
        ])
      ]),
      u("button", {
        type: "button",
        class: fe(["bl-check", { "is-on": d.value }]),
        "aria-pressed": d.value,
        "aria-label": (d.value ? "Deselect " : "Select ") + (g(s).title || "Untitled board"),
        disabled: g(l),
        onClick: L[0] || (L[0] = st((z) => g(o).toggle(e.row), ["stop"]))
      }, [
        O(X, {
          name: "Check",
          size: 14,
          stroke: 3
        })
      ], 10, Eb),
      f.value ? (h(), _("div", {
        key: 0,
        class: fe(["bl-card-menu", { "is-open": a.value }]),
        onClick: L[2] || (L[2] = st(() => {
        }, ["stop"]))
      }, [
        O(ga, {
          board: g(s),
          row: e.row,
          onOpenChange: L[1] || (L[1] = (z) => a.value = z)
        }, null, 8, ["board", "row"])
      ], 2)) : ne("", !0),
      u("div", Lb, [
        u("div", Rb, [
          u("span", Pb, q(g(s).title || "Untitled board"), 1),
          c.value && !g(l) ? (h(), _("span", Db, "New")) : ne("", !0),
          g(l) ? (h(), _("span", Ob, "Deleted")) : ne("", !0)
        ]),
        u("div", Fb, q(g(s).description || " "), 1),
        u("div", Bb, [
          g(o).teamMode.value ? (h(), we(va, {
            key: 0,
            board: g(s),
            row: e.row,
            "can-open": v.value,
            compact: "",
            onOpenAccess: M
          }, null, 8, ["board", "row", "can-open"])) : (h(), _("span", Nb, q(C.value), 1)),
          L[7] || (L[7] = u("span", { class: "sp" }, null, -1)),
          g(o).teamMode.value ? (h(), we(ha, {
            key: 2,
            board: g(s),
            "can-open": p.value,
            "show-members": f.value,
            compact: "",
            onOpenAccess: M
          }, null, 8, ["board", "can-open", "show-members"])) : g(s).previewAt ? (h(), _("span", Ub, "edited " + q(g(zl)(g(s).previewAt)), 1)) : ne("", !0)
        ]),
        x.value.length ? (h(), _("div", jb, [
          (h(!0), _(ae, null, Ce(x.value, (z) => (h(), _("span", {
            key: z.label,
            class: "bl-tag",
            title: z.label + ": " + z.value
          }, [
            u("b", null, q(z.label), 1),
            be(" " + q(z.value), 1)
          ], 8, Vb))), 128))
        ])) : ne("", !0)
      ])
    ], 46, $b));
  }
}), Kb = ["disabled"], qb = { class: "plus" }, Rl = /* @__PURE__ */ Oe({
  __name: "BoardGrid",
  props: {
    skeleton: {}
  },
  emits: ["create"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = Ze().list, l = K(() => !r.narrowed.value && r.pageNumber.value === 1 && !n.skeleton), i = K(() => r.selected.value.size > 0);
    return (a, d) => (h(), _("div", {
      class: fe(["bl-grid", { "is-selecting": i.value }]),
      "data-testid": "boards-grid"
    }, [
      l.value ? (h(), _("button", {
        key: 0,
        type: "button",
        class: "bl-new-card",
        disabled: g(r).creating.value,
        "data-testid": "new-board-card",
        onClick: d[0] || (d[0] = (c) => o("create"))
      }, [
        u("span", qb, [
          O(X, {
            name: "Plus",
            size: 22,
            stroke: 2.4
          })
        ]),
        u("span", null, q(g(r).creating.value ? "Creating..." : "New board"), 1)
      ], 8, Kb)) : ne("", !0),
      e.skeleton ? (h(!0), _(ae, { key: 1 }, Ce(e.skeleton, (c) => (h(), _("div", {
        key: "s" + c,
        class: "bl-card is-skeleton",
        "aria-hidden": "true"
      }, [...d[1] || (d[1] = [
        Zi('<div class="bl-cover bl-skel" style="border-radius:15px;"></div><div class="bl-card-body"><div class="bl-skel" style="height:15px;width:62%;"></div><div class="bl-skel" style="height:11px;width:84%;margin-top:10px;"></div><div class="bl-skel" style="height:22px;width:100%;margin-top:14px;border-radius:999px;"></div></div>', 2)
      ])]))), 128)) : (h(!0), _(ae, { key: 2 }, Ce(g(r).listedRows.value, (c, f) => (h(), we(Hb, {
        key: c.id,
        row: c,
        index: f + (l.value ? 1 : 0)
      }, null, 8, ["row", "index"]))), 128))
    ], 2));
  }
}), Wb = ["data-board"], Yb = ["aria-pressed", "aria-label", "disabled"], Gb = { class: "sticky-n" }, Xb = { class: "bl-name" }, Jb = { class: "bl-thumb" }, Zb = { class: "t" }, Qb = {
  key: 0,
  class: "bl-new-badge"
}, eh = { class: "desc" }, th = { class: "bl-cell-copy" }, nh = ["title"], oh = { class: "bl-cell-copy" }, sh = ["title"], rh = ["onClick"], lh = {
  class: "bl-muted",
  style: { "white-space": "nowrap" }
}, ih = { class: "owner" }, ah = {
  key: 0,
  class: "bl-deleted-badge"
}, ch = /* @__PURE__ */ Oe({
  __name: "BoardTableRow",
  props: {
    row: {},
    index: {}
  },
  setup(e) {
    const t = e, n = Ze(), o = n.list, { board: s, state: r, removed: l } = xa(/* @__PURE__ */ _i(t, "row")), i = K(() => o.isSelected(t.row.id)), a = K(() => o.pinnedIds.value.has(t.row.id)), d = K(() => r.value === "live"), c = K(() => d.value && !!n.actions.access && Nr(s.value, o.ctx.value)), f = K(() => c.value && Bn(s.value, o.ctx.value)), p = K(() => s.value.createdAt ? new Date(s.value.createdAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : ""), v = /* @__PURE__ */ U(null);
    async function x(M, y) {
      try {
        await navigator.clipboard.writeText(y), v.value = M, setTimeout(() => {
          v.value === M && (v.value = null);
        }, 1400);
      } catch {
        n.notify({ status: "error", message: "Could not copy to the clipboard" });
      }
    }
    function C() {
      l.value || n.actions.open(t.row.id);
    }
    function A() {
      n.actions.access && n.actions.access([t.row.id], () => o.refetchAfterMirrorLag());
    }
    return (M, y) => (h(), _("tr", {
      class: fe({ "is-selected": i.value, "is-removed": g(l) }),
      style: xe({ "--i-delay": Math.min(e.index, 14) * 22 + "ms" }),
      "data-board": e.row.id,
      onClick: C,
      onPointerenter: y[4] || (y[4] = (D) => g(n).actions.prefetch && g(n).actions.prefetch())
    }, [
      u("td", {
        class: "check sticky-l",
        onClick: y[1] || (y[1] = st(() => {
        }, ["stop"]))
      }, [
        u("button", {
          type: "button",
          class: fe(["bl-box", { "is-on": i.value }]),
          "aria-pressed": i.value,
          "aria-label": (i.value ? "Deselect " : "Select ") + (g(s).title || "Untitled board"),
          disabled: g(l),
          onClick: y[0] || (y[0] = (D) => g(o).toggle(e.row))
        }, [
          O(X, {
            name: "Check",
            size: 13,
            stroke: 3
          })
        ], 10, Yb)
      ]),
      u("td", Gb, [
        u("div", Xb, [
          u("span", Jb, [
            O(ma, {
              id: e.row.id,
              preview: g(s).preview
            }, null, 8, ["id", "preview"])
          ]),
          u("span", Zb, q(g(s).title || "Untitled board"), 1),
          a.value && !g(l) ? (h(), _("span", Qb, "New")) : ne("", !0)
        ])
      ]),
      u("td", eh, [
        u("div", th, [
          u("span", {
            title: g(s).description
          }, q(g(s).description), 9, nh),
          g(s).description ? (h(), _("button", {
            key: 0,
            type: "button",
            class: fe(["bl-icon-btn bl-copy", { "is-done": v.value === "description" }]),
            style: { width: "28px", height: "28px" },
            title: "Copy to clipboard",
            onClick: y[2] || (y[2] = st((D) => x("description", g(s).description), ["stop"]))
          }, [
            O(X, {
              name: v.value === "description" ? "Check" : "Copy",
              size: 13
            }, null, 8, ["name"])
          ], 2)) : ne("", !0)
        ])
      ]),
      g(o).teamMode.value ? (h(!0), _(ae, { key: 0 }, Ce(g(n).account.value.customFields, (D) => (h(), _("td", {
        key: D.key,
        class: "cf"
      }, [
        u("div", oh, [
          u("span", {
            title: g(s).customFields[D.key]
          }, q(g(s).customFields[D.key] || ""), 9, sh),
          g(s).customFields[D.key] ? (h(), _("button", {
            key: 0,
            type: "button",
            class: fe(["bl-icon-btn bl-copy", { "is-done": v.value === D.key }]),
            style: { width: "28px", height: "28px" },
            title: "Copy to clipboard",
            onClick: st((k) => x(D.key, g(s).customFields[D.key]), ["stop"])
          }, [
            O(X, {
              name: v.value === D.key ? "Check" : "Copy",
              size: 13
            }, null, 8, ["name"])
          ], 10, rh)) : ne("", !0)
        ])
      ]))), 128)) : ne("", !0),
      u("td", lh, q(p.value), 1),
      g(o).teamMode.value ? (h(), _(ae, { key: 1 }, [
        u("td", ih, [
          O(va, {
            board: g(s),
            row: e.row,
            "can-open": f.value,
            compact: "",
            onOpenAccess: A
          }, null, 8, ["board", "row", "can-open"])
        ]),
        u("td", null, [
          O(ha, {
            board: g(s),
            "can-open": c.value,
            "show-members": d.value,
            onOpenAccess: A
          }, null, 8, ["board", "can-open", "show-members"])
        ])
      ], 64)) : ne("", !0),
      u("td", {
        class: "menu sticky-r",
        onClick: y[3] || (y[3] = st(() => {
        }, ["stop"]))
      }, [
        g(l) ? (h(), _("span", ah, "Deleted")) : d.value ? (h(), we(ga, {
          key: 1,
          board: g(s),
          row: e.row
        }, null, 8, ["board", "row"])) : ne("", !0)
      ])
    ], 46, Wb));
  }
}), dh = { class: "bl-table" }, uh = { class: "check sticky-l" }, fh = ["aria-label", "disabled"], ph = ["aria-sort", "onClick"], bh = ["colspan"], Pl = /* @__PURE__ */ Oe({
  __name: "BoardTable",
  props: {
    skeleton: {}
  },
  setup(e) {
    const t = e, n = Ze(), o = n.list, s = K(() => [
      { label: "Name", sort: "title" },
      { label: "Description", sort: "description" },
      ...o.teamMode.value ? n.account.value.customFields.map((p) => ({ label: p.label, sort: Yt + p.key })) : [],
      { label: "Created", sort: "created" },
      ...o.teamMode.value ? [{ label: "Owner", sort: null }, { label: "Access", sort: null }] : []
    ]);
    function r(p) {
      const v = o.sort.value;
      v.by === p ? o.setSort({ by: p, desc: !v.desc }) : o.setSort({ by: p, desc: p === "created" });
    }
    const l = K(() => t.skeleton || 0), i = /* @__PURE__ */ U(null), a = /* @__PURE__ */ U(!1), d = /* @__PURE__ */ U(!1);
    function c() {
      const p = i.value;
      p && (a.value = p.scrollLeft > 2, d.value = p.scrollLeft + p.clientWidth < p.scrollWidth - 2);
    }
    let f = null;
    return Pt(() => {
      c(), i.value && typeof ResizeObserver != "undefined" && (f = new ResizeObserver(c), f.observe(i.value));
    }), Je(() => {
      f && f.disconnect();
    }), Pe(() => o.listedRows.value, () => Lt(c)), (p, v) => (h(), _("div", {
      ref_key: "wrap",
      ref: i,
      class: fe(["bl-table-wrap", { "is-scrolled": a.value, "has-more": d.value }]),
      "data-testid": "boards-table",
      onScrollPassive: c
    }, [
      u("table", dh, [
        u("thead", null, [
          u("tr", null, [
            u("th", uh, [
              u("button", {
                type: "button",
                class: fe(["bl-box", { "is-on": g(o).pageAllSelected.value, "is-some": !g(o).pageAllSelected.value && g(o).pageSomeSelected.value }]),
                "aria-label": g(o).pageAllSelected.value ? "Deselect this page" : "Select this page",
                disabled: !g(o).listedRows.value.length,
                onClick: v[0] || (v[0] = (x) => g(o).togglePage())
              }, [
                O(X, {
                  name: g(o).pageAllSelected.value ? "Check" : "Minus",
                  size: 13,
                  stroke: 3
                }, null, 8, ["name"])
              ], 10, fh)
            ]),
            (h(!0), _(ae, null, Ce(s.value, (x, C) => (h(), _("th", {
              key: x.label,
              class: fe({ "sticky-n": C === 0 })
            }, [
              x.sort ? (h(), _("button", {
                key: 0,
                type: "button",
                class: fe(["bl-th-sort", { "is-on": g(o).sort.value.by === x.sort }]),
                "aria-sort": g(o).sort.value.by === x.sort ? g(o).sort.value.desc ? "descending" : "ascending" : "none",
                onClick: (A) => r(x.sort)
              }, [
                be(q(x.label) + " ", 1),
                O(X, {
                  name: g(o).sort.value.by === x.sort ? g(o).sort.value.desc ? "ArrowDown" : "ArrowUp" : "ArrowUpDown",
                  size: 12,
                  stroke: 2.4
                }, null, 8, ["name"])
              ], 10, ph)) : (h(), _(ae, { key: 1 }, [
                be(q(x.label), 1)
              ], 64))
            ], 2))), 128)),
            v[1] || (v[1] = u("th", { class: "menu sticky-r" }, [
              u("span", { class: "bl-sr" }, "Actions")
            ], -1))
          ])
        ]),
        u("tbody", null, [
          l.value ? (h(!0), _(ae, { key: 0 }, Ce(l.value, (x) => (h(), _("tr", {
            key: "s" + x,
            "aria-hidden": "true",
            style: { cursor: "default" }
          }, [
            v[3] || (v[3] = u("td", { class: "check sticky-l" }, [
              u("div", {
                class: "bl-skel",
                style: { width: "20px", height: "20px", "border-radius": "6px" }
              })
            ], -1)),
            v[4] || (v[4] = u("td", { class: "sticky-n" }, [
              u("div", { style: { display: "flex", "align-items": "center", gap: "12px" } }, [
                u("div", {
                  class: "bl-skel",
                  style: { width: "54px", height: "36px" }
                }),
                u("div", {
                  class: "bl-skel",
                  style: { height: "13px", width: "140px" }
                })
              ])
            ], -1)),
            u("td", {
              colspan: s.value.length
            }, [...v[2] || (v[2] = [
              u("div", {
                class: "bl-skel",
                style: { height: "12px", width: "40%" }
              }, null, -1)
            ])], 8, bh)
          ]))), 128)) : (h(!0), _(ae, { key: 1 }, Ce(g(o).listedRows.value, (x, C) => (h(), we(ch, {
            key: x.id,
            row: x,
            index: C
          }, null, 8, ["row", "index"]))), 128))
        ])
      ])
    ], 34));
  }
}), hh = { class: "bl-bulk-dock" }, mh = {
  key: 0,
  class: "bl-bulk",
  role: "toolbar",
  "aria-label": "Selected boards",
  "data-testid": "bulk-bar"
}, gh = { class: "bl-bulk-count" }, vh = { class: "bl-count" }, yh = /* @__PURE__ */ Oe({
  __name: "BulkBar",
  setup(e) {
    const t = Ze(), n = t.list, o = K(() => n.selected.value.size), s = K(() => !!t.actions.access && tf(n.ctx.value));
    function r() {
      t.actions.access && t.actions.access(n.selectedRows.value.map((l) => l.id), () => {
        n.clearSelection(), n.refetchAfterMirrorLag();
      });
    }
    return (l, i) => (h(), _("div", hh, [
      O(Yn, { name: "bl-bulk" }, {
        default: ut(() => [
          o.value ? (h(), _("div", mh, [
            u("span", gh, [
              u("span", vh, q(o.value), 1),
              i[3] || (i[3] = be(" selected", -1))
            ]),
            u("button", {
              type: "button",
              class: "bl-tool-btn",
              "data-testid": "bulk-csv",
              onClick: i[0] || (i[0] = (a) => g(n).exportSelected())
            }, [
              O(X, {
                name: "Download",
                size: 15
              }),
              i[4] || (i[4] = be(" Download CSV ", -1))
            ]),
            s.value ? (h(), _("button", {
              key: 0,
              type: "button",
              class: "bl-tool-btn",
              "data-testid": "bulk-access",
              onClick: r
            }, [
              O(X, {
                name: "Users",
                size: 15
              }),
              i[5] || (i[5] = be(" Access settings ", -1))
            ])) : ne("", !0),
            g(n).deletableSelected.value.length ? (h(), _("button", {
              key: 1,
              type: "button",
              class: "bl-tool-btn is-danger",
              "data-testid": "bulk-delete",
              onClick: i[1] || (i[1] = (a) => g(t).requestDelete(g(n).deletableSelected.value, !0))
            }, [
              O(X, {
                name: "Trash2",
                size: 15
              }),
              i[6] || (i[6] = be(" Delete ", -1))
            ])) : ne("", !0),
            i[7] || (i[7] = u("span", { class: "bl-bulk-sep" }, null, -1)),
            u("button", {
              type: "button",
              class: "bl-icon-btn",
              "aria-label": "Clear the selection",
              title: "Clear the selection",
              onClick: i[2] || (i[2] = (a) => g(n).clearSelection())
            }, [
              O(X, {
                name: "X",
                size: 16
              })
            ])
          ])) : ne("", !0)
        ]),
        _: 1
      })
    ]));
  }
}), ln = "KEEP";
function Dl(e, t, n) {
  return e && e === n ? t ? "You (" + t + ")" : "You" : t || "No owner";
}
function xh(e, t) {
  const n = e.some((o) => pa(o, t));
  return {
    private: n || t.manageAllGenerations,
    team: t.shareRunnitAssets && (n || t.manageAllGenerations)
  };
}
function wh(e) {
  const t = [];
  return e.bulk && t.push({ value: ln, label: "Keep current", description: "Each board keeps its own access level", icon: "CircleMinus", disabled: !1 }), t.push({ value: "PRIVATE", label: "Private", description: "Only " + (e.ownerIsMe ? "you" : "the owner") + " can access", icon: "Lock", disabled: !e.editable.private }), e.teamBoard && (e.editable.team || e.current === "RESTRICTED") && t.push({ value: "RESTRICTED", label: "Restricted", description: "Specific members can access", icon: "UserCheck", disabled: !e.editable.team }), e.teamBoard && (e.editable.team || e.current === "SHARED") && t.push({ value: "SHARED", label: "Shared", description: "Everyone on the " + e.team + " can access", icon: "Users", disabled: !e.editable.team }), t;
}
function kh(e) {
  if (e.level !== (e.board.accessLevel || "PRIVATE")) return !0;
  if (e.level !== "RESTRICTED") return !1;
  if ([...e.removedUserIds].some((n) => n !== e.ownerUserId)) return !0;
  const t = /* @__PURE__ */ new Set([...e.members.map((n) => n.userId), ...e.board.accessUserIds]);
  return e.addedUserIds.some((n) => n !== e.ownerUserId && !t.has(n));
}
function _h(e) {
  const t = !e.newOwnerUserId || e.accessChanged, n = e.level === "RESTRICTED";
  return {
    runnitId: e.boardId,
    ...e.newOwnerUserId ? { ownerUserId: e.newOwnerUserId } : {},
    ...t ? {
      accessLevel: e.level,
      addedUserIds: n ? e.addedUserIds : [],
      removedUserIds: n ? e.removedUserIds : []
    } : {}
  };
}
function Ch(e, t, n) {
  return e.filter((o) => !n.owner && !n.access ? cs(o, t) || Bn(o, t) : (!n.owner || Bn(o, t)) && (!n.access || cs(o, t)));
}
function Sh(e, t) {
  const n = !!t.newOwnerUserId && t.newOwnerUserId !== e.userId, o = t.level !== ln;
  return !n && !o ? null : {
    runnitId: e.id,
    ...n ? { ownerUserId: t.newOwnerUserId } : {},
    ...o ? {
      accessLevel: t.level,
      ...t.level === "RESTRICTED" ? { setUserIds: t.setUserIds } : {}
    } : {}
  };
}
function Ih(e) {
  const t = e.level !== "PRIVATE" && e.level !== ln;
  return e.bulk ? !e.editableCount || !e.ownerChanged && e.level === ln || t && !e.shareRunnitAssets : (!e.ownerChanged || e.accessChanged) && t && !e.shareRunnitAssets;
}
const Ol = 100, Po = 2e3;
function Ws(e, t) {
  return t.required && !e.trim() ? "Required" : e.length > t.max ? "At most " + t.max.toLocaleString("en-US") + " characters" : null;
}
const Ah = ["disabled", "aria-expanded", "data-testid"], Mh = { class: "bl-owner-search" }, $h = ["aria-multiselectable"], zh = ["aria-selected", "onClick"], Th = {
  key: 0,
  class: "box"
}, Eh = { class: "bl-picker-email" }, Lh = {
  key: 0,
  class: "bl-owner-empty"
}, Rh = {
  key: 0,
  class: "bl-pop-foot"
}, Ph = {
  class: "bl-muted",
  style: { "font-size": "12px" }
}, Dh = ["disabled"], Fl = /* @__PURE__ */ Oe({
  __name: "MemberPicker",
  props: {
    label: {},
    icon: {},
    multiple: { type: Boolean, default: !1 },
    chosenIds: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    testid: { default: void 0 }
  },
  emits: ["pick"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = /* @__PURE__ */ U(null), l = /* @__PURE__ */ U(!1), i = /* @__PURE__ */ U(""), a = /* @__PURE__ */ U([]), d = /* @__PURE__ */ U(!1), c = /* @__PURE__ */ U([]);
    let f = 0, p = 0;
    async function v(y) {
      const D = ++f;
      d.value = !0;
      try {
        const k = await s.source().searchTeamMembers(s.account.value, y);
        D === f && (a.value = k);
      } catch (k) {
        console.error("[boards] could not search members", k), D === f && (a.value = []);
      } finally {
        D === f && (d.value = !1);
      }
    }
    Pe(l, (y) => {
      clearTimeout(p), y && (i.value = "", c.value = [], v(""));
    }), Pe(i, (y) => {
      l.value && (clearTimeout(p), p = window.setTimeout(() => {
        v(y);
      }, 250));
    }), Je(() => clearTimeout(p));
    const x = K(() => n.multiple ? a.value.filter((y) => !n.chosenIds.includes(y.userId)) : a.value), C = (y) => n.multiple ? c.value.some((D) => D.userId === y.userId) : n.chosenIds.includes(y.userId);
    function A(y) {
      if (!n.multiple) {
        o("pick", [y]), l.value = !1;
        return;
      }
      c.value = C(y) ? c.value.filter((D) => D.userId !== y.userId) : [...c.value, y];
    }
    function M() {
      c.value.length && (o("pick", c.value), l.value = !1);
    }
    return (y, D) => (h(), _(ae, null, [
      u("button", {
        ref_key: "btn",
        ref: r,
        type: "button",
        class: "bl-btn is-ghost is-sm",
        disabled: e.disabled,
        "aria-expanded": l.value,
        "data-testid": e.testid,
        onClick: D[0] || (D[0] = (k) => l.value = !l.value)
      }, [
        O(X, {
          name: e.icon,
          size: 14
        }, null, 8, ["name"]),
        be(" " + q(e.label), 1)
      ], 8, Ah),
      O(_o, {
        open: l.value,
        anchor: r.value,
        "panel-class": "bl-pop bl-picker is-over-dialog",
        "keep-on-scroll": "",
        onClose: D[2] || (D[2] = (k) => l.value = !1)
      }, {
        default: ut(() => [
          u("label", Mh, [
            O(X, {
              name: "Search",
              size: 14
            }),
            Ln(u("input", {
              "onUpdate:modelValue": D[1] || (D[1] = (k) => i.value = k),
              type: "text",
              placeholder: "Search by email",
              "aria-label": "Search people on the team",
              "data-testid": "member-search"
            }, null, 512), [
              [Rn, i.value]
            ])
          ]),
          u("div", {
            class: "bl-owner-list",
            role: "listbox",
            "aria-multiselectable": e.multiple
          }, [
            (h(!0), _(ae, null, Ce(x.value, (k) => (h(), _("button", {
              key: k.userId,
              type: "button",
              class: fe(["bl-owner", { "is-on": C(k) }]),
              role: "option",
              "aria-selected": C(k),
              "data-testid": "member-option",
              onClick: (L) => A(k)
            }, [
              e.multiple ? (h(), _("span", Th, [
                C(k) ? (h(), we(X, {
                  key: 0,
                  name: "Check",
                  size: 11,
                  stroke: 3.2
                })) : ne("", !0)
              ])) : ne("", !0),
              u("span", {
                class: "bl-avatar",
                style: xe(g(Dn)(k.userId))
              }, q(g(On)(k.email)), 5),
              u("span", Eh, q(k.userId === g(s).user.value.uid ? "You (" + k.email + ")" : k.email), 1),
              !e.multiple && C(k) ? (h(), we(X, {
                key: 1,
                name: "Check",
                size: 14,
                class: "bl-picker-check"
              })) : ne("", !0)
            ], 10, zh))), 128)),
            x.value.length ? ne("", !0) : (h(), _("div", Lh, q(d.value ? "Searching..." : "No one on the " + g(s).labels.value.team + " matches"), 1))
          ], 8, $h),
          e.multiple ? (h(), _("div", Rh, [
            u("span", Ph, q(c.value.length ? c.value.length + " chosen" : "Choose people to add"), 1),
            u("button", {
              type: "button",
              class: "bl-btn is-sm",
              disabled: !c.value.length,
              "data-testid": "member-add",
              onClick: M
            }, "Add " + q(c.value.length || ""), 9, Dh)
          ])) : ne("", !0)
        ]),
        _: 1
      }, 8, ["open", "anchor"])
    ], 64));
  }
}), Oh = ["aria-label"], Fh = { class: "bl-dialog-head" }, Bh = { class: "bl-dialog-icon is-accent" }, Nh = { key: 0 }, Uh = { key: 1 }, jh = {
  key: 0,
  class: "bl-dialog-loading"
}, Vh = {
  key: 1,
  class: "bl-dialog-body"
}, Hh = {
  key: 0,
  class: "bl-acc-section",
  "data-testid": "access-owner"
}, Kh = { class: "bl-acc-owner" }, qh = {
  key: 1,
  class: "bl-avatar is-lg is-more"
}, Wh = { class: "who" }, Yh = {
  key: 0,
  class: "cap"
}, Gh = ["disabled"], Xh = {
  key: 1,
  class: "bl-acc-section"
}, Jh = {
  class: "bl-acc-levels",
  role: "radiogroup",
  "aria-label": "Who can access"
}, Zh = ["aria-checked", "disabled", "data-testid", "onClick"], Qh = { class: "ic" }, e0 = { class: "t" }, t0 = { class: "d" }, n0 = {
  key: 0,
  class: "ok"
}, o0 = {
  key: 0,
  class: "bl-acc-hint"
}, s0 = {
  key: 2,
  class: "bl-acc-section",
  "data-testid": "access-members"
}, r0 = { class: "bl-acc-section-head" }, l0 = {
  key: 0,
  class: "bl-acc-hint"
}, i0 = { class: "bl-acc-members" }, a0 = ["aria-label", "onClick"], c0 = { class: "em" }, d0 = ["aria-label", "onClick"], u0 = {
  key: 0,
  class: "bl-acc-empty"
}, f0 = ["data-member"], p0 = ["aria-label", "onClick"], b0 = {
  key: 1,
  class: "bl-box-gap"
}, h0 = { class: "st" }, m0 = ["onClick"], g0 = {
  key: 2,
  class: "bl-acc-tag"
}, v0 = ["aria-label", "onClick"], y0 = {
  key: 0,
  class: "bl-acc-empty"
}, x0 = {
  key: 3,
  class: "bl-acc-section"
}, w0 = { class: "bl-acc-boards" }, k0 = ["data-board"], _0 = { class: "nm" }, C0 = {
  key: 0,
  class: "ow"
}, S0 = { class: "lv" }, I0 = {
  key: 0,
  class: "bl-muted"
}, A0 = ["data-status"], M0 = { class: "bl-dialog-actions" }, $0 = ["disabled"], z0 = ["disabled"], T0 = /* @__PURE__ */ Oe({
  __name: "AccessDialog",
  props: {
    request: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = K(() => s.user.value.uid), l = K(() => s.list.ctx.value), i = K(() => s.labels.value.team), a = /* @__PURE__ */ wt([]), d = /* @__PURE__ */ U(!1), c = /* @__PURE__ */ U(!1), f = /* @__PURE__ */ U("PRIVATE"), p = /* @__PURE__ */ wt(null), v = /* @__PURE__ */ U([]), x = /* @__PURE__ */ U([]), C = /* @__PURE__ */ wt([]), A = /* @__PURE__ */ U({}), M = /* @__PURE__ */ U({}), y = /* @__PURE__ */ U([]), D = /* @__PURE__ */ U(null), k = /* @__PURE__ */ new Set(), L = K(() => !!n.request), z = K(() => !!n.request && n.request.ids.length > 1), $ = K(() => z.value ? null : a.value[0] || null), W = (P, F, T) => P + " " + (P === 1 ? F : T);
    function N(P, F) {
      !P || !F || F in A.value || k.has(F) || (k.add(F), s.source().teamMember(P, F).then((T) => {
        A.value = { ...A.value, [F]: T };
      }).catch((T) => {
        console.error("[boards] could not look up a member", T), A.value = { ...A.value, [F]: null };
      }).finally(() => k.delete(F)));
    }
    function oe() {
      a.value = [], C.value = [], p.value = null, v.value = [], x.value = [], M.value = {}, y.value = [], c.value = !1;
    }
    Pe(() => n.request, async (P) => {
      if (oe(), !!P) {
        d.value = !0;
        try {
          const F = await s.source().readBoards(P.ids);
          if (n.request !== P) return;
          if (!F.length) {
            s.notify({ status: "error", message: P.ids.length === 1 ? "This board is no longer available" : "The selected boards are no longer available" }), o("close");
            return;
          }
          if (a.value = F, P.ids.length > 1) {
            f.value = ln;
            for (const ue of F) N(ue.teamId, ue.userId);
            return;
          }
          const T = F[0];
          if (f.value = T.accessLevel || "PRIVATE", N(T.teamId, T.userId), T.teamId) {
            const ue = await s.source().readBoardMembers(T.id);
            if (n.request !== P) return;
            C.value = ue;
            for (const E of ue) N(T.teamId, E.userId);
            for (const E of T.accessUserIds) N(T.teamId, E);
          }
        } catch (F) {
          console.error("[boards] could not open Access Settings", F), s.notify({ status: "error", message: "Access Settings couldn't be opened. Please try again" }), o("close");
        } finally {
          n.request === P && (d.value = !1);
        }
      }
    }, { immediate: !0 });
    const Q = K(() => z.value ? a.value.some((P) => Bn(P, l.value)) : !!$.value && Bn($.value, l.value)), I = K(() => z.value ? !!p.value : !!p.value && !!$.value && p.value.userId !== $.value.userId), Y = K(() => z.value || !$.value ? null : I.value && p.value ? p.value.userId : $.value.userId), ge = K(() => !!Y.value && Y.value === r.value);
    function de(P) {
      if (!P) return null;
      if (P === r.value) return s.user.value.email;
      const F = A.value[P];
      return F ? F.email : null;
    }
    const me = K(() => {
      const P = $.value;
      return !z.value && !I.value && !!P && !!P.userId && P.userId !== r.value && !(P.userId in A.value);
    }), Fe = K(() => z.value || I.value ? p.value ? p.value.email : null : de(Y.value)), Ct = K(() => z.value ? p.value ? p.value.email : "Keep each board's current owner" : me.value ? "Loading..." : ge.value ? "You" : Fe.value || "No owner"), St = K(() => {
      if (z.value) return p.value ? "Will own the " + W(H.value.length, "selected board", "selected boards") : "";
      const P = $.value;
      return I.value && P ? "Changing from " + Dl(P.userId, de(P.userId), r.value) : ge.value && Fe.value || "";
    });
    function Gt(P) {
      const F = P[0];
      if (F) {
        if (z.value) {
          p.value = F;
          return;
        }
        p.value = $.value && F.userId === $.value.userId ? null : F, x.value = x.value.filter((T) => T !== F.userId);
      }
    }
    const lt = K(() => !!s.account.value.teamId && !!(a.value[0] && a.value[0].teamId)), ze = K(() => xh(z.value ? a.value.filter((P) => cs(P, l.value)) : a.value, l.value)), it = K(() => wh({ bulk: z.value, teamBoard: lt.value, current: f.value, editable: ze.value, ownerIsMe: ge.value, team: i.value })), Qe = K(() => it.value.length > 0 && (ze.value.private || ze.value.team)), qe = (P) => P === ln ? "keep" : P.toLowerCase(), et = K(() => {
      const P = $.value;
      if (!P) return [];
      const F = new Set(x.value), T = /* @__PURE__ */ new Set(), ue = [], E = (w, S, re) => {
        T.has(w) || (T.add(w), !(!S && F.has(w)) && ue.push({ userId: w, adding: S, addedAt: re, isOwner: w === Y.value }));
      };
      for (const w of C.value) E(w.userId, !1, w.addedAt);
      for (const w of P.accessUserIds) E(w, !1, null);
      for (const w of v.value) E(w.userId, !0, null);
      return Y.value && E(Y.value, !0, null), ue.sort((w, S) => w.adding === S.adding ? (S.addedAt || 0) - (w.addedAt || 0) : w.adding ? -1 : 1);
    }), pe = K(() => {
      const P = {};
      for (const F of v.value) P[F.userId] = F.email;
      return p.value && (P[p.value.userId] = p.value.email), P;
    });
    function Ne(P) {
      return pe.value[P.userId] || de(P.userId);
    }
    function ft(P) {
      if (P.adding) return "To be added";
      if (P.userId !== r.value && !(P.userId in A.value)) return "Loading...";
      const F = P.userId === r.value ? { joined: !0 } : A.value[P.userId];
      return F ? F.joined ? P.addedAt ? "Added " + new Date(P.addedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "Date unavailable" : "Hasn't joined the " + i.value + " yet" : "No longer on the " + i.value;
    }
    function Te(P) {
      const F = A.value[P.userId], T = s.account.value;
      return P.adding || !F || F.joined || !F.inviteCode || !T.teamId ? null : window.location.origin + "/team-signup?teamName=" + encodeURIComponent(T.teamName || "") + "&teamId=" + T.teamId + "&inviteCode=" + F.inviteCode;
    }
    async function ke(P) {
      const F = Te(P);
      if (F)
        try {
          await navigator.clipboard.writeText(F), D.value = P.userId, setTimeout(() => {
            D.value === P.userId && (D.value = null);
          }, 1400);
        } catch {
          s.notify({ status: "error", message: "Could not copy to the clipboard" });
        }
    }
    function b(P) {
      const F = new Set(et.value.map((ue) => ue.userId)), T = [...v.value];
      for (const ue of P)
        x.value.includes(ue.userId) ? x.value = x.value.filter((E) => E !== ue.userId) : !F.has(ue.userId) && !T.some((E) => E.userId === ue.userId) && T.push(ue);
      v.value = T;
    }
    function m(P) {
      const F = Y.value, T = P.filter((E) => E !== F);
      v.value = v.value.filter((E) => !T.includes(E.userId));
      const ue = T.filter((E) => C.value.some((w) => w.userId === E) || !!$.value && $.value.accessUserIds.includes(E));
      x.value = [.../* @__PURE__ */ new Set([...x.value, ...ue])], y.value = y.value.filter((E) => !T.includes(E));
    }
    function R(P) {
      y.value = y.value.includes(P) ? y.value.filter((F) => F !== P) : [...y.value, P];
    }
    const H = K(() => z.value ? Ch(a.value, l.value, { owner: !!p.value, access: f.value !== ln }) : a.value), B = K(() => new Set(H.value.map((P) => P.id))), j = K(() => a.value.length - H.value.length);
    function ee(P) {
      return !!p.value && B.value.has(P.id) && P.userId !== p.value.userId;
    }
    const Z = K(() => {
      const P = W(H.value.length, "selected board", "selected boards");
      return Q.value ? "Choose a new owner, an access level, or both, for the " + P + " below." : "Choose an access level for the " + P + " below.";
    }), G = K(() => {
      const P = $.value;
      return z.value || !P || f.value === ln ? !1 : kh({ board: P, level: f.value, members: C.value, addedUserIds: v.value.map((F) => F.userId), removedUserIds: new Set(x.value), ownerUserId: Y.value });
    }), V = K(() => z.value || I.value || G.value), se = K(() => d.value || c.value || Ih({
      bulk: z.value,
      level: f.value,
      ownerChanged: I.value,
      accessChanged: G.value,
      editableCount: H.value.length,
      shareRunnitAssets: l.value.shareRunnitAssets
    }));
    async function te() {
      const P = n.request;
      if (!(!P || se.value)) {
        c.value = !0;
        try {
          if (!z.value) {
            const S = $.value;
            if (!S) return;
            const re = I.value && p.value ? p.value.userId : null, ye = G.value, Ie = f.value, Ee = [.../* @__PURE__ */ new Set([...v.value.map((Dt) => Dt.userId), ...Ie === "RESTRICTED" && Y.value ? [Y.value] : []])];
            await s.source().saveAccess(_h({ boardId: S.id, level: Ie, newOwnerUserId: re, accessChanged: ye, addedUserIds: Ee, removedUserIds: x.value })), s.notify({ status: "success", message: re && !ye ? "Owner changed" : "Access settings saved" }), P.onSaved(), o("close");
            return;
          }
          const F = H.value, T = v.value.map((S) => S.userId), ue = {};
          for (const S of F) ue[S.id] = "saving";
          M.value = ue;
          const w = (await Promise.all(F.map(async (S) => {
            try {
              const re = Sh(S, { newOwnerUserId: p.value ? p.value.userId : null, level: f.value, setUserIds: T });
              return re && await s.source().saveAccess(re), M.value = { ...M.value, [S.id]: "ok" }, !0;
            } catch (re) {
              return console.error("[boards] could not update a board's access", S.id, re), M.value = { ...M.value, [S.id]: "failed" }, !1;
            }
          }))).filter((S) => !S).length;
          if (P.onSaved(), w) {
            s.notify({ status: "error", message: W(w, "board", "boards") + " of " + F.length + " couldn't be updated" });
            return;
          }
          s.notify({ status: "success", message: "Updated " + W(F.length, "board", "boards") }), o("close");
        } catch (F) {
          console.error("[boards] could not save access settings", F), s.notify({ status: "error", message: "The access settings couldn't be saved. Please try again" });
        } finally {
          c.value = !1;
        }
      }
    }
    const le = K(() => z.value ? "Access settings for " + W(H.value.length || a.value.length, "board", "boards") : "Access settings for " + ($.value ? "'" + ($.value.title || "Untitled board") + "'" : "this board"));
    function ie(P) {
      P.key === "Escape" && !c.value && (P.stopPropagation(), o("close"));
    }
    return Pe(L, (P) => {
      P ? window.addEventListener("keydown", ie) : window.removeEventListener("keydown", ie);
    }, { immediate: !0 }), Je(() => window.removeEventListener("keydown", ie)), (P, F) => (h(), we(Yn, { name: "bl-fade" }, {
      default: ut(() => [
        L.value ? (h(), _("div", {
          key: 0,
          class: "bl-scrim",
          role: "presentation",
          onClick: F[4] || (F[4] = st((T) => !c.value && o("close"), ["self"]))
        }, [
          u("div", {
            class: fe(["bl-dialog is-access", { "is-bulk": z.value }]),
            role: "dialog",
            "aria-modal": "true",
            "aria-label": le.value,
            "data-testid": "access-dialog"
          }, [
            u("div", Fh, [
              u("div", Bh, [
                O(X, {
                  name: "Users",
                  size: 19
                })
              ]),
              u("div", null, [
                u("h3", null, q(le.value), 1),
                z.value ? (h(), _("p", Nh, [
                  be(q(Z.value), 1),
                  j.value ? (h(), _(ae, { key: 0 }, [
                    be(q(W(j.value, "selected board", "selected boards")) + " you can't change will be left as " + q(j.value === 1 ? "it is" : "they are") + ".", 1)
                  ], 64)) : ne("", !0)
                ])) : (h(), _("p", Uh, "Who owns it, and who can open it."))
              ])
            ]),
            d.value ? (h(), _("div", jh, [
              O(X, {
                name: "LoaderCircle",
                size: 20,
                class: "bl-spin"
              })
            ])) : (h(), _("div", Vh, [
              Q.value ? (h(), _("section", Hh, [
                F[5] || (F[5] = u("div", { class: "bl-acc-label" }, "Owner", -1)),
                u("div", Kh, [
                  (z.value ? p.value : Fe.value || ge.value) ? (h(), _("span", {
                    key: 0,
                    class: "bl-avatar is-lg",
                    style: xe(g(Dn)(z.value ? p.value && p.value.userId : Y.value))
                  }, q(g(On)(Fe.value || Ct.value)), 5)) : (h(), _("span", qh, [
                    O(X, {
                      name: "UserRound",
                      size: 16
                    })
                  ])),
                  u("span", Wh, [
                    u("span", {
                      class: fe(["name", { "bl-muted": z.value ? !p.value : me.value }])
                    }, q(Ct.value), 3),
                    St.value ? (h(), _("span", Yh, q(St.value), 1)) : ne("", !0)
                  ]),
                  I.value ? (h(), _("button", {
                    key: 2,
                    type: "button",
                    class: "bl-btn is-ghost is-sm",
                    disabled: c.value,
                    "data-testid": "access-owner-reset",
                    onClick: F[0] || (F[0] = (T) => p.value = null)
                  }, q(z.value ? "Keep current owners" : "Undo"), 9, Gh)) : ne("", !0),
                  O(Fl, {
                    label: "Change",
                    icon: "UserRoundCog",
                    "chosen-ids": Y.value ? [Y.value] : p.value ? [p.value.userId] : [],
                    disabled: c.value,
                    testid: "access-owner-change",
                    onPick: Gt
                  }, null, 8, ["chosen-ids", "disabled"])
                ])
              ])) : ne("", !0),
              Qe.value ? (h(), _("section", Xh, [
                F[6] || (F[6] = u("div", { class: "bl-acc-label" }, "Who can access", -1)),
                u("div", Jh, [
                  (h(!0), _(ae, null, Ce(it.value, (T) => (h(), _("button", {
                    key: T.value,
                    type: "button",
                    role: "radio",
                    class: fe(["bl-acc-level", ["is-" + qe(T.value), { "is-on": f.value === T.value }]]),
                    "aria-checked": f.value === T.value,
                    disabled: T.disabled || c.value,
                    "data-testid": "access-level-" + qe(T.value),
                    onClick: (ue) => f.value = T.value
                  }, [
                    u("span", Qh, [
                      O(X, {
                        name: T.icon,
                        size: 15
                      }, null, 8, ["name"])
                    ]),
                    u("span", e0, q(T.label), 1),
                    u("span", t0, q(T.description), 1),
                    f.value === T.value ? (h(), _("span", n0, [
                      O(X, {
                        name: "Check",
                        size: 13,
                        stroke: 3
                      })
                    ])) : ne("", !0)
                  ], 10, Zh))), 128))
                ]),
                f.value !== "PRIVATE" && f.value !== "KEEP" && !l.value.shareRunnitAssets ? (h(), _("p", o0, "Sharing a board needs permission to share on this " + q(i.value) + ".", 1)) : ne("", !0)
              ])) : ne("", !0),
              f.value === "RESTRICTED" ? (h(), _("section", s0, [
                u("div", r0, [
                  u("div", null, [
                    F[7] || (F[7] = u("div", {
                      class: "bl-acc-label",
                      style: { "margin-bottom": "0" }
                    }, "Members with access", -1)),
                    z.value ? (h(), _("p", l0, "Each board's owner is always included.")) : ne("", !0)
                  ]),
                  y.value.length ? (h(), _("button", {
                    key: 0,
                    type: "button",
                    class: "bl-btn is-ghost is-sm",
                    "data-testid": "access-remove-selected",
                    onClick: F[1] || (F[1] = (T) => m(y.value))
                  }, [
                    O(X, {
                      name: "CircleX",
                      size: 14
                    }),
                    be(" Remove " + q(y.value.length), 1)
                  ])) : ne("", !0),
                  O(Fl, {
                    label: "Add members",
                    icon: "UserPlus",
                    multiple: "",
                    "chosen-ids": z.value ? v.value.map((T) => T.userId) : et.value.map((T) => T.userId),
                    disabled: c.value,
                    testid: "access-add-members",
                    onPick: b
                  }, null, 8, ["chosen-ids", "disabled"])
                ]),
                u("div", i0, [
                  z.value ? (h(), _(ae, { key: 0 }, [
                    (h(!0), _(ae, null, Ce(v.value, (T) => (h(), _("div", {
                      key: T.userId,
                      class: "bl-acc-member",
                      "data-testid": "access-member"
                    }, [
                      u("button", {
                        type: "button",
                        class: fe(["bl-box", { "is-on": y.value.includes(T.userId) }]),
                        "aria-label": "Select " + T.email,
                        onClick: (ue) => R(T.userId)
                      }, [
                        O(X, {
                          name: "Check",
                          size: 12,
                          stroke: 3
                        })
                      ], 10, a0),
                      u("span", {
                        class: "bl-avatar",
                        style: xe(g(Dn)(T.userId))
                      }, q(g(On)(T.email)), 5),
                      u("span", c0, q(T.email), 1),
                      F[8] || (F[8] = u("span", { class: "st" }, "To be added", -1)),
                      u("button", {
                        type: "button",
                        class: "bl-icon-btn",
                        "aria-label": "Remove " + T.email,
                        onClick: (ue) => m([T.userId])
                      }, [
                        O(X, {
                          name: "X",
                          size: 14
                        })
                      ], 8, d0)
                    ]))), 128)),
                    v.value.length ? ne("", !0) : (h(), _("div", u0, [
                      O(X, {
                        name: "UserPlus",
                        size: 18
                      }),
                      F[9] || (F[9] = be(" No members added yet", -1))
                    ]))
                  ], 64)) : (h(), _(ae, { key: 1 }, [
                    (h(!0), _(ae, null, Ce(et.value, (T) => (h(), _("div", {
                      key: T.userId,
                      class: "bl-acc-member",
                      "data-member": T.userId,
                      "data-testid": "access-member"
                    }, [
                      T.isOwner ? (h(), _("span", b0)) : (h(), _("button", {
                        key: 0,
                        type: "button",
                        class: fe(["bl-box", { "is-on": y.value.includes(T.userId) }]),
                        "aria-label": "Select " + (Ne(T) || "member"),
                        onClick: (ue) => R(T.userId)
                      }, [
                        O(X, {
                          name: "Check",
                          size: 12,
                          stroke: 3
                        })
                      ], 10, p0)),
                      u("span", {
                        class: "bl-avatar",
                        style: xe(g(Dn)(T.userId))
                      }, q(g(On)(Ne(T))), 5),
                      u("span", {
                        class: fe(["em", { "bl-muted": !Ne(T) }])
                      }, q(T.userId === r.value ? "You (" + (Ne(T) || "") + ")" : Ne(T) || "A former member"), 3),
                      u("span", h0, [
                        be(q(ft(T)) + " ", 1),
                        Te(T) ? (h(), _("button", {
                          key: 0,
                          type: "button",
                          class: fe(["bl-icon-btn bl-copy", { "is-done": D.value === T.userId }]),
                          title: "Copy the invitation link",
                          onClick: (ue) => ke(T)
                        }, [
                          O(X, {
                            name: D.value === T.userId ? "Check" : "Link",
                            size: 13
                          }, null, 8, ["name"])
                        ], 10, m0)) : ne("", !0)
                      ]),
                      T.isOwner ? (h(), _("span", g0, "Owner")) : (h(), _("button", {
                        key: 3,
                        type: "button",
                        class: "bl-icon-btn",
                        "aria-label": "Remove " + (Ne(T) || "member"),
                        "data-testid": "access-member-remove",
                        onClick: (ue) => m([T.userId])
                      }, [
                        O(X, {
                          name: "X",
                          size: 14
                        })
                      ], 8, v0))
                    ], 8, f0))), 128)),
                    et.value.length ? ne("", !0) : (h(), _("div", y0, [
                      O(X, {
                        name: "UserPlus",
                        size: 18
                      }),
                      F[10] || (F[10] = be(" No members added yet", -1))
                    ]))
                  ], 64))
                ])
              ])) : ne("", !0),
              z.value ? (h(), _("section", x0, [
                F[11] || (F[11] = u("div", { class: "bl-acc-label" }, "Selected boards", -1)),
                u("div", w0, [
                  (h(!0), _(ae, null, Ce(a.value, (T) => (h(), _("div", {
                    key: T.id,
                    class: fe(["bl-acc-board", { "is-skipped": !B.value.has(T.id) }]),
                    "data-board": T.id
                  }, [
                    u("span", _0, q(T.title || "Untitled board"), 1),
                    Q.value ? (h(), _("span", C0, [
                      u("span", {
                        class: fe({ "bl-muted": ee(T) })
                      }, q(T.userId && (T.userId === r.value || T.userId in A.value) ? g(Dl)(T.userId, de(T.userId), r.value) : "Loading..."), 3),
                      ee(T) ? (h(), _(ae, { key: 0 }, [
                        O(X, {
                          name: "ArrowRight",
                          size: 12
                        }),
                        be(" " + q(p.value && p.value.email), 1)
                      ], 64)) : ne("", !0)
                    ])) : ne("", !0),
                    u("span", S0, [
                      B.value.has(T.id) ? (h(), _("span", {
                        key: 1,
                        class: fe(["bl-access", "is-" + (T.accessLevel || "PRIVATE").toLowerCase()])
                      }, q(g(ko)[T.accessLevel || "PRIVATE"]), 3)) : (h(), _("i", I0, "Can't be changed"))
                    ]),
                    u("span", {
                      class: "sv",
                      "data-status": M.value[T.id] || ""
                    }, [
                      M.value[T.id] === "saving" ? (h(), we(X, {
                        key: 0,
                        name: "LoaderCircle",
                        size: 15,
                        class: "bl-spin"
                      })) : M.value[T.id] === "ok" ? (h(), we(X, {
                        key: 1,
                        name: "CircleCheck",
                        size: 15
                      })) : M.value[T.id] === "failed" ? (h(), we(X, {
                        key: 2,
                        name: "CircleX",
                        size: 15
                      })) : ne("", !0)
                    ], 8, A0)
                  ], 10, k0))), 128))
                ])
              ])) : ne("", !0)
            ])),
            u("div", M0, [
              V.value ? (h(), _(ae, { key: 0 }, [
                u("button", {
                  type: "button",
                  class: "bl-btn is-ghost",
                  disabled: c.value,
                  onClick: F[2] || (F[2] = (T) => o("close"))
                }, "Cancel", 8, $0),
                u("button", {
                  type: "button",
                  class: "bl-btn",
                  disabled: se.value,
                  "data-testid": "access-save",
                  onClick: te
                }, q(c.value ? "Saving..." : z.value ? "Update " + W(H.value.length, "board", "boards") : "Save"), 9, z0)
              ], 64)) : (h(), _("button", {
                key: 1,
                type: "button",
                class: "bl-btn is-ghost",
                "data-testid": "access-close",
                onClick: F[3] || (F[3] = (T) => o("close"))
              }, "Close"))
            ])
          ], 10, Oh)
        ])) : ne("", !0)
      ]),
      _: 1
    }));
  }
}), E0 = ["aria-label"], L0 = { class: "bl-dialog-icon" }, R0 = { key: 0 }, P0 = { key: 1 }, D0 = {
  key: 2,
  class: "bl-field"
}, O0 = { class: "bl-dialog-actions" }, F0 = ["disabled"], B0 = ["disabled"], N0 = /* @__PURE__ */ Oe({
  __name: "DeleteDialog",
  props: {
    rows: {},
    bulk: { type: Boolean },
    skipped: {},
    busy: { type: Boolean }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = /* @__PURE__ */ U(""), r = /* @__PURE__ */ U(null), l = /* @__PURE__ */ U(null), i = K(() => !!n.rows && n.rows.length > 0), a = K(() => n.rows ? n.rows.length : 0), d = K(() => !n.bulk || s.value.trim().toLowerCase() === "delete"), c = K(() => n.bulk ? "Delete " + a.value + " " + (a.value === 1 ? "board" : "boards") + "?" : "Delete this board?"), f = K(() => n.rows && n.rows[0] ? n.rows[0].title || "Untitled board" : "");
    Pe(i, async (x) => {
      s.value = "", x && (await Lt(), n.bulk && r.value ? r.value.focus() : l.value && l.value.focus());
    });
    function p(x) {
      x.key === "Escape" && !n.busy && o("cancel");
    }
    function v() {
      d.value && !n.busy && o("confirm");
    }
    return (x, C) => (h(), we(Yn, { name: "bl-fade" }, {
      default: ut(() => [
        i.value ? (h(), _("div", {
          key: 0,
          class: "bl-scrim",
          role: "presentation",
          onClick: C[2] || (C[2] = st((A) => !e.busy && o("cancel"), ["self"])),
          onKeydown: p
        }, [
          u("div", {
            class: "bl-dialog",
            role: "alertdialog",
            "aria-modal": "true",
            "aria-label": c.value,
            "data-testid": "delete-dialog"
          }, [
            u("div", L0, [
              O(X, {
                name: "Trash2",
                size: 20
              })
            ]),
            u("h3", null, q(c.value), 1),
            e.bulk ? (h(), _("p", P0, [
              be(" The " + q(a.value === 1 ? "board" : a.value + " boards") + " you selected will be removed for everyone who can open them. ", 1),
              e.skipped ? (h(), _(ae, { key: 0 }, [
                be(q(e.skipped) + " selected " + q(e.skipped === 1 ? "board" : "boards") + " you can't delete will be left as " + q(e.skipped === 1 ? "it is" : "they are") + ".", 1)
              ], 64)) : ne("", !0)
            ])) : (h(), _("p", R0, [
              u("strong", null, q(f.value), 1),
              C[3] || (C[3] = be(" will be removed for everyone who can open it. ", -1))
            ])),
            e.bulk ? (h(), _("div", D0, [
              C[4] || (C[4] = u("label", { for: "bl-delete-confirm" }, [
                be("Type "),
                u("strong", { style: { color: "#fff" } }, "Delete"),
                be(" to confirm")
              ], -1)),
              Ln(u("input", {
                id: "bl-delete-confirm",
                ref_key: "input",
                ref: r,
                "onUpdate:modelValue": C[0] || (C[0] = (A) => s.value = A),
                type: "text",
                autocomplete: "off",
                "data-testid": "delete-confirm-input",
                onKeydown: wo(v, ["enter"])
              }, null, 544), [
                [Rn, s.value]
              ])
            ])) : ne("", !0),
            u("div", O0, [
              u("button", {
                type: "button",
                class: "bl-btn is-ghost",
                disabled: e.busy,
                onClick: C[1] || (C[1] = (A) => o("cancel"))
              }, "Cancel", 8, F0),
              u("button", {
                ref_key: "confirmBtn",
                ref: l,
                type: "button",
                class: "bl-btn is-danger",
                disabled: !d.value || e.busy,
                "data-testid": "delete-confirm",
                onClick: v
              }, q(e.busy ? "Deleting..." : "Delete"), 9, B0)
            ])
          ], 8, E0)
        ], 32)) : ne("", !0)
      ]),
      _: 1
    }));
  }
}), U0 = { class: "bl-dialog-head" }, j0 = { class: "bl-dialog-icon is-accent" }, V0 = {
  key: 0,
  class: "bl-dialog-loading"
}, H0 = { class: "bl-field is-form" }, K0 = ["aria-invalid", "onKeydown"], q0 = { class: "bl-field-foot" }, W0 = { class: "bl-field-error" }, Y0 = { class: "bl-field is-form" }, G0 = ["aria-invalid"], X0 = { class: "bl-field-foot" }, J0 = { class: "bl-field-error" }, Z0 = ["for"], Q0 = ["id", "onUpdate:modelValue", "aria-invalid", "data-testid", "onKeydown"], e1 = { class: "bl-field-foot" }, t1 = { class: "bl-field-error" }, n1 = { class: "bl-dialog-actions" }, o1 = ["disabled"], s1 = ["disabled"], r1 = /* @__PURE__ */ Oe({
  __name: "EditDialog",
  props: {
    boardId: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = /* @__PURE__ */ wt(null), l = /* @__PURE__ */ U(""), i = /* @__PURE__ */ U(""), a = /* @__PURE__ */ U({}), d = /* @__PURE__ */ U(!1), c = /* @__PURE__ */ U(!1), f = /* @__PURE__ */ U(null), p = K(() => !!n.boardId), v = K(() => r.value && r.value.teamId && s.list.teamMode.value ? s.account.value.customFields : []);
    Pe(() => n.boardId, async (k) => {
      if (r.value = null, c.value = !1, !!k)
        try {
          const [L] = await s.source().readBoards([k]);
          if (n.boardId !== k) return;
          if (!L) {
            s.notify({ status: "error", message: "This board is no longer available" }), o("close");
            return;
          }
          r.value = L, l.value = L.title, i.value = L.description, a.value = { ...L.customFields }, await Lt(), f.value && f.value.focus();
        } catch (L) {
          console.error("[boards] could not read the board to edit", L), s.notify({ status: "error", message: "This board couldn't be opened for editing. Please try again" }), o("close");
        }
    }, { immediate: !0 });
    const x = K(() => {
      const k = {
        title: Ws(l.value, { required: !0, max: Ol }),
        description: Ws(i.value, { max: Po })
      };
      for (const L of v.value) k[L.key] = Ws(a.value[L.key] || "", { max: Po });
      return k;
    }), C = K(() => Object.values(x.value).every((k) => !k)), A = (k) => c.value || k !== "title" ? x.value[k] : null;
    async function M() {
      c.value = !0;
      const k = r.value;
      if (!(!k || d.value || !C.value)) {
        d.value = !0;
        try {
          const L = {};
          for (const z of v.value) {
            const $ = (a.value[z.key] || "").trim();
            $ && (L[z.key] = $);
          }
          await s.source().updateBoard(k.id, {
            title: l.value.trim() || null,
            description: i.value.trim() || null,
            ...v.value.length ? { customFields: L } : {}
          }), s.notify({ status: "success", message: "Board settings saved" }), o("close");
        } catch (L) {
          console.error("[boards] could not save the board settings", L), s.notify({ status: "error", message: "The board settings couldn't be saved. Please try again" });
        } finally {
          d.value = !1;
        }
      }
    }
    function y(k) {
      k.key === "Escape" && !d.value ? (k.stopPropagation(), o("close")) : k.key === "Enter" && (k.metaKey || k.ctrlKey) && (k.preventDefault(), M());
    }
    const D = (k, L) => k.length >= L * 0.8 ? k.length.toLocaleString("en-US") + " / " + L.toLocaleString("en-US") : "";
    return Pe(p, (k) => {
      k ? window.addEventListener("keydown", y) : window.removeEventListener("keydown", y);
    }, { immediate: !0 }), Je(() => window.removeEventListener("keydown", y)), (k, L) => (h(), we(Yn, { name: "bl-fade" }, {
      default: ut(() => [
        p.value ? (h(), _("div", {
          key: 0,
          class: "bl-scrim",
          role: "presentation",
          onClick: L[3] || (L[3] = st((z) => !d.value && o("close"), ["self"]))
        }, [
          u("form", {
            class: "bl-dialog is-form",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "Edit board",
            "data-testid": "edit-dialog",
            onSubmit: st(M, ["prevent"])
          }, [
            u("div", U0, [
              u("div", j0, [
                O(X, {
                  name: "Pencil",
                  size: 19
                })
              ]),
              u("div", null, [
                L[4] || (L[4] = u("h3", null, "Edit board", -1)),
                u("p", null, "Its name and description" + q(v.value.length ? ", and your company's fields" : "") + ".", 1)
              ])
            ]),
            r.value ? (h(), _(ae, { key: 1 }, [
              u("div", H0, [
                L[5] || (L[5] = u("label", { for: "bl-edit-title" }, "Name", -1)),
                Ln(u("input", {
                  id: "bl-edit-title",
                  ref_key: "nameEl",
                  ref: f,
                  "onUpdate:modelValue": L[0] || (L[0] = (z) => l.value = z),
                  type: "text",
                  autocomplete: "off",
                  "aria-invalid": !!A("title"),
                  "data-testid": "edit-title",
                  onKeydown: wo(st(M, ["prevent"]), ["enter"])
                }, null, 40, K0), [
                  [Rn, l.value]
                ]),
                u("div", q0, [
                  u("span", W0, q(A("title") || ""), 1),
                  u("span", null, q(D(l.value, g(Ol))), 1)
                ])
              ]),
              u("div", Y0, [
                L[6] || (L[6] = u("label", { for: "bl-edit-description" }, "Description", -1)),
                Ln(u("textarea", {
                  id: "bl-edit-description",
                  "onUpdate:modelValue": L[1] || (L[1] = (z) => i.value = z),
                  rows: "3",
                  "aria-invalid": !!A("description"),
                  "data-testid": "edit-description"
                }, null, 8, G0), [
                  [Rn, i.value]
                ]),
                u("div", X0, [
                  u("span", J0, q(A("description") || ""), 1),
                  u("span", null, q(D(i.value, g(Po))), 1)
                ])
              ]),
              (h(!0), _(ae, null, Ce(v.value, (z) => (h(), _("div", {
                key: z.key,
                class: "bl-field is-form"
              }, [
                u("label", {
                  for: "bl-edit-cf-" + z.key
                }, q(z.label), 9, Z0),
                Ln(u("input", {
                  id: "bl-edit-cf-" + z.key,
                  "onUpdate:modelValue": ($) => a.value[z.key] = $,
                  type: "text",
                  autocomplete: "off",
                  "aria-invalid": !!A(z.key),
                  "data-testid": "edit-field-" + z.key,
                  onKeydown: wo(st(M, ["prevent"]), ["enter"])
                }, null, 40, Q0), [
                  [Rn, a.value[z.key]]
                ]),
                u("div", e1, [
                  u("span", t1, q(A(z.key) || ""), 1),
                  u("span", null, q(D(a.value[z.key] || "", g(Po))), 1)
                ])
              ]))), 128))
            ], 64)) : (h(), _("div", V0, [
              O(X, {
                name: "LoaderCircle",
                size: 20,
                class: "bl-spin"
              })
            ])),
            u("div", n1, [
              u("button", {
                type: "button",
                class: "bl-btn is-ghost",
                disabled: d.value,
                onClick: L[2] || (L[2] = (z) => o("close"))
              }, "Cancel", 8, o1),
              u("button", {
                type: "submit",
                class: "bl-btn",
                disabled: !r.value || d.value || c.value && !C.value,
                "data-testid": "edit-save"
              }, q(d.value ? "Saving..." : "Save"), 9, s1)
            ])
          ], 32)
        ])) : ne("", !0)
      ]),
      _: 1
    }));
  }
}), l1 = ["data-testid"], i1 = {
  key: 0,
  class: "bl-empty-art",
  "aria-hidden": "true"
}, a1 = ["disabled"], c1 = ["disabled"], Ys = /* @__PURE__ */ Oe({
  __name: "EmptyState",
  props: {
    kind: {},
    busy: { type: Boolean }
  },
  emits: ["create", "clear", "retry"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = K(() => n.kind === "failed" ? { title: "Could not load boards", body: "Something went wrong on the way. Your boards are safe; try again in a moment." } : n.kind === "no-match" ? { title: "No boards match", body: "Nothing here matches your search or filters. Try other words, or clear them to see every board." } : { title: "Start your first board", body: "A board is an endless space for a project: generate, compare and present image and video options side by side." });
    return (r, l) => (h(), _("div", {
      class: "bl-empty",
      "data-testid": "empty-" + e.kind
    }, [
      e.kind === "empty" ? (h(), _("div", i1, [...l[3] || (l[3] = [
        u("div", null, [
          u("i", { style: { left: "8%", top: "18%", width: "44%", height: "58%", "animation-delay": "-1s" } }),
          u("i", { style: { left: "56%", top: "6%", width: "36%", height: "42%", "animation-delay": "-3s" } }),
          u("i", { style: { left: "50%", top: "56%", width: "30%", height: "34%", "animation-delay": "-2s", background: "linear-gradient(160deg, #f6dc8a, #f1c96a)" } })
        ], -1)
      ])])) : (h(), _("div", {
        key: 1,
        class: "bl-dialog-icon",
        style: xe(e.kind === "no-match" ? { background: "rgba(153,104,223,0.14)", borderColor: "rgba(194,164,236,0.35)", color: "var(--lead-icon)" } : {})
      }, [
        O(X, {
          name: e.kind === "failed" ? "CircleAlert" : "Search",
          size: 20
        }, null, 8, ["name"])
      ], 4)),
      u("h3", null, q(s.value.title), 1),
      u("p", null, q(s.value.body), 1),
      e.kind === "empty" ? (h(), _("button", {
        key: 2,
        type: "button",
        class: "bl-btn",
        disabled: e.busy,
        onClick: l[0] || (l[0] = (i) => o("create"))
      }, [
        O(X, {
          name: "Plus",
          size: 16,
          stroke: 2.4
        }),
        l[4] || (l[4] = be(" New board ", -1))
      ], 8, a1)) : e.kind === "no-match" ? (h(), _("button", {
        key: 3,
        type: "button",
        class: "bl-btn is-ghost",
        onClick: l[1] || (l[1] = (i) => o("clear"))
      }, "Clear search and filters")) : (h(), _("button", {
        key: 4,
        type: "button",
        class: "bl-btn is-ghost",
        disabled: e.busy,
        onClick: l[2] || (l[2] = (i) => o("retry"))
      }, [
        O(X, {
          name: "RefreshCw",
          size: 15
        }),
        l[5] || (l[5] = be(" Try again ", -1))
      ], 8, c1))
    ], 8, l1));
  }
}), Do = null, d1 = "", wa = "1 33 239 173", ka = [
  {
    d: "M160.973 91.1044H105.586C103.271 91.1044 101.134 89.8671 99.9766 87.8597L74.5215 43.7307C72.0284 39.4055 75.1448 33.9999 80.1311 33.9999H135.518C137.833 33.9999 139.97 35.2372 141.128 37.2447L166.579 81.3772C169.072 85.7024 165.956 91.108 160.97 91.108L160.973 91.1044Z",
    fill: "#CC5FD1",
    origin: "50% 17.1%",
    axis: [0.87, 0.49],
    out: [0, -1]
  },
  {
    d: "M150.485 148.213H205.872C208.187 148.213 210.324 146.975 211.481 144.968L236.933 100.835C239.426 96.5102 236.31 91.1046 231.323 91.1046H175.936C173.621 91.1046 171.484 92.3419 170.327 94.3494L144.875 138.482C142.382 142.807 145.498 148.213 150.485 148.213Z",
    fill: "#9A6ADF",
    origin: "79.5% 50.1%",
    axis: [0.87, -0.49],
    out: [1, 0]
  },
  {
    d: "M160.974 205.317H105.587C103.271 205.317 101.134 204.079 99.9769 202.072L74.5254 157.939C72.0323 153.614 75.1487 148.209 80.135 148.209H135.522C137.837 148.209 139.974 149.446 141.132 151.453L166.583 195.586C169.076 199.911 165.96 205.317 160.974 205.317Z",
    fill: "#B0B3F6",
    origin: "50% 83.1%",
    axis: [0.87, 0.49],
    out: [0, 1]
  },
  {
    d: "M40.7394 200.572L67.1953 151.857C68.2994 149.821 68.2389 147.35 67.0279 145.371L40.4581 101.905C37.8545 97.6479 31.6216 97.8048 29.2389 102.194L2.78656 150.909C1.68245 152.945 1.74299 155.416 2.95395 157.395L29.5238 200.86C32.1274 205.118 38.3603 204.961 40.743 200.572H40.7394Z",
    fill: "#A691DF",
    origin: "14.2% 68%",
    axis: [0, 1],
    out: [-0.94, 0.34]
  }
];
`${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='${wa}'>${ka.map((e) => `<path d='${e.d}'/>`).join("")}</svg>`
)}`;
const fn = { w: 1180, h: 620, bar: 44, shown: 540 }, _a = { w: fn.w, h: fn.h - fn.bar }, ds = { x: _a.w / 2, y: 217 }, mr = fn.shown - fn.bar - 16, qt = { w: 600, h: 138, x: (_a.w - 600) / 2, y: mr - 138 }, an = { x: qt.x + 54, y: qt.y + 12, w: 44, h: 44 }, oo = { x: qt.x + qt.w - 12 - 62, y: qt.y + qt.h - 12 - 30, w: 62, h: 30 }, Wo = "https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-", Le = (e) => Wo + e + "-400w.webp", he = {
  whiteCard: Le("e05-option-a-white-card-model-c61989"),
  golden: Le("t03-autumn-golden-hour-3768d6"),
  dusk: Le("t07-alpenglow-dusk-1d0baa"),
  blueHour: Le("t04-winter-blue-hour-50f063"),
  night: Le("t06-night-facade-lighting-69ccb0"),
  aerial: Le("s01-existing-site-aerial-f3aa4c"),
  depot: Le("s02-existing-depot-street-7c94e0"),
  creek: Le("s03-existing-buried-creek-channel-160598"),
  sketchCanyon: Le("e02-option-b-sketch-canyon-374663"),
  sketchSalt: Le("e03-option-c-sketch-salt-11df63"),
  sketchShore: Le("e01-option-a-sketch-shoreline-c101a0"),
  whiteCardSet: Le("e04-white-card-options-a-b-c-1713cd"),
  lobbyModel: Le("i01-lobby-white-model-d9fd93"),
  optionB: Le("e06-option-b-render-parked-80d4c0"),
  optionC: Le("e07-option-c-render-parked-e0c191"),
  watercolor: Le("e08-option-a-watercolor-db5917"),
  openCrown: Le("e10-hero-v2-open-crown-4a3b4d"),
  terraces: Le("e12-hero-v3-deeper-terraces-1c4ede"),
  brickPodium: Le("e15-hero-v4-brick-podium-11449d"),
  lobby: Le("i02-lobby-v1-geometry-materials-ef49f9"),
  lobbyBright: Le("i06-lobby-v4-competition-brightening-34918a"),
  masterplan: Le("l02-watercolor-masterplan-6b0e55"),
  creekWalk: Le("l04-creek-walk-marketing-hero-92d17d"),
  gardens: Le("l08-daytime-gardens-with-people-8fb7f2"),
  dollyIn: Wo + "v02-hero-dolly-in-88196408-poster-400w.webp",
  dayToNight: Wo + "v03-aerial-day-to-night-time-lapse-744df3b5-poster-400w.webp",
  skyLounge: Wo + "v06-sky-lounge-sunset-time-lapse-a0a91aee-poster-400w.webp"
}, Jt = { w: 252, h: 160 }, Bt = [0, 1304, 2608], Nt = [0, 470, 1e3], Ut = 1164, Ca = [
  { title: "Site photos", x: Bt[0], y: Nt[0], w: Ut, h: 300 },
  { title: "Massing sketches", x: Bt[1], y: Nt[0], w: Ut, h: 300 },
  { title: "White card models", x: Bt[2], y: Nt[0], w: Ut, h: 300 },
  { title: "Direction renders", x: Bt[0], y: Nt[1], w: Ut, h: 330 },
  { title: "Hero options", x: Bt[1], y: Nt[1], w: Ut, h: 330 },
  { title: "Facade iterations", x: Bt[2], y: Nt[1], w: Ut, h: 330 },
  { title: "Lobby", x: Bt[0], y: Nt[2], w: Ut, h: 300 },
  { title: "Bench Gardens", x: Bt[1], y: Nt[2], w: Ut, h: 300 },
  { title: "Motion", x: Bt[2], y: Nt[2], w: Ut, h: 300 }
], Sa = Ca[4], qn = { id: "white-card", src: he.whiteCard, x: 1608, y: 500, w: 150, h: 200 }, cn = [
  { id: "golden", src: he.golden, x: 1798, y: 500, w: 150, h: 200 },
  { id: "dusk", src: he.dusk, x: 1962, y: 500, w: 150, h: 200 },
  { id: "blue-hour", src: he.blueHour, x: 2126, y: 500, w: 150, h: 200 },
  { id: "night", src: he.night, x: 2290, y: 500, w: 150, h: 200 }
], Ia = [
  { id: "aerial", src: he.aerial, x: 304, y: 30, w: 260, h: 146 },
  { id: "depot", src: he.depot, x: 578, y: 30, w: 260, h: 146 },
  { id: "creek", src: he.creek, x: 852, y: 30, w: 260, h: 146 },
  { id: "sketch-canyon", src: he.sketchCanyon, x: 1332, y: 30, w: 180, h: 240 },
  { id: "sketch-salt", src: he.sketchSalt, x: 1526, y: 30, w: 180, h: 240 },
  { id: "sketch-shore", src: he.sketchShore, x: 1720, y: 30, w: 180, h: 240 },
  { id: "white-card-set", src: he.whiteCardSet, x: 2912, y: 30, w: 400, h: 225 },
  { id: "lobby-model", src: he.lobbyModel, x: 3326, y: 30, w: 400, h: 225 },
  { id: "option-b", src: he.optionB, x: 304, y: 500, w: 200, h: 267 },
  { id: "option-c", src: he.optionC, x: 518, y: 500, w: 200, h: 267 },
  { id: "watercolor", src: he.watercolor, x: 732, y: 500, w: 200, h: 267 },
  qn,
  { id: "open-crown", src: he.openCrown, x: 2636, y: 500, w: 200, h: 267 },
  { id: "terraces", src: he.terraces, x: 2850, y: 500, w: 200, h: 267 },
  { id: "brick-podium", src: he.brickPodium, x: 3064, y: 500, w: 200, h: 267 },
  { id: "lobby", src: he.lobby, x: 304, y: 1030, w: 316, h: 236 },
  { id: "lobby-bright", src: he.lobbyBright, x: 634, y: 1030, w: 316, h: 236 },
  { id: "masterplan", src: he.masterplan, x: 1332, y: 1030, w: 316, h: 237 },
  { id: "creek-walk", src: he.creekWalk, x: 1662, y: 1030, w: 400, h: 225 },
  { id: "gardens", src: he.gardens, x: 2076, y: 1030, w: 364, h: 205 },
  { id: "dolly-in", src: he.dollyIn, x: 2912, y: 1030, w: 180, h: 240, video: !0 },
  { id: "day-to-night", src: he.dayToNight, x: 3106, y: 1030, w: 300, h: 169, video: !0 },
  { id: "sky-lounge", src: he.skyLounge, x: 3420, y: 1030, w: 300, h: 169, video: !0 }
], nt = { id: "hero", kind: "Image", model: "Nano Banana Pro", name: "Hero options", x: 1332, y: 500, thumbs: [], foot: "No runs yet" }, Aa = [
  { id: "site", kind: "Image", model: "Nano Banana Pro", name: "Site photos", x: 28, y: 30, thumbs: [he.aerial, he.depot, he.creek], foot: "Updated Sep 2" },
  { id: "sketch", kind: "Image", model: "Nano Banana 2", name: "Sketch options", x: 1928, y: 30, thumbs: [he.sketchCanyon, he.sketchSalt, he.sketchShore], foot: "Updated Sep 4" },
  { id: "white", kind: "Image", model: "Seedream 5 Lite", name: "White card", x: 2636, y: 30, thumbs: [he.whiteCardSet, he.lobbyModel], foot: "Updated Sep 5" },
  { id: "directions", kind: "Image", model: "Nano Banana 2", name: "Directions", x: 28, y: 500, thumbs: [he.optionB, he.optionC, he.watercolor], foot: "Updated Sep 6" },
  nt,
  { id: "facade", kind: "Image", model: "Nano Banana Pro", name: "Facade", x: 3292, y: 500, thumbs: [he.openCrown, he.terraces, he.brickPodium], foot: "Updated Sep 9" },
  { id: "lobby", kind: "Image", model: "Nano Banana 2", name: "Lobby", x: 28, y: 1030, thumbs: [he.lobby, he.lobbyBright], foot: "Updated Sep 11" },
  { id: "motion", kind: "Video", model: "Kling 2.6 Pro", name: "Hero dolly-in", x: 2636, y: 1030, thumbs: [he.dollyIn, he.dayToNight, he.skyLounge], foot: "Updated Sep 12" }
], Oo = { id: "cover", text: "Golden hour for the cover. Client review Thursday.", by: "MT", tint: "amethyst", x: 1332, y: 676, w: 252, h: 96 }, Ma = [
  { id: "creek", text: "Option B reads best from the creek.", by: "KB", tint: "amber", x: 2194, y: 30, w: 246, h: 120 },
  { id: "canyon", text: "Canyon for the competition entry.", by: "JR", tint: "rose", x: 946, y: 500, w: 190, h: 120 },
  { id: "podium", text: "Brick podium is the keeper.", by: "MT", tint: "mint", x: 3292, y: 676, w: 252, h: 96 }
], gr = "Photoreal, at golden hour, dusk, blue hour and night";
function vr(e) {
  const t = (n, o) => n >= e.x && n < e.x + e.w && o >= e.y && o < e.y + e.h;
  return Ia.filter((n) => t(n.x, n.y)).length + Aa.filter((n) => t(n.x, n.y)).length + Ma.filter((n) => t(n.x, n.y)).length;
}
const Fo = { x: 1886, y: 650 }, u1 = 0.6;
function f1(e, t = 0) {
  const n = e.x + (e.w || 0) / 2, o = e.y + (e.h || 0) / 2, s = Math.hypot(Fo.x, Fo.y), r = u1 * Math.pow(Math.min(1, Math.hypot(n - Fo.x, o - Fo.y) / s), 0.85) - t;
  return Math.max(0, Math.round(r * 1e3) / 1e3);
}
const Bo = { fx: 1886, fy: 628, z: 0.29 }, Yo = { fx: 1886, fy: 653, z: 0.9 };
function p1(e, t, n) {
  return { x: ds.x + (t - e.fx) * e.z, y: ds.y + (n - e.fy) * e.z };
}
function Bl(e, t, n) {
  return { fx: e.fx + (t.fx - e.fx) * n, fy: e.fy + (t.fy - e.fy) * n, z: e.z * Math.pow(t.z / e.z, n) };
}
function No(e, t, n, o) {
  const s = 3 * e, r = 3 * (n - e) - s, l = 1 - s - r, i = 3 * t, a = 3 * (o - t) - i, d = 1 - i - a, c = (v) => ((l * v + r) * v + s) * v, f = (v) => ((d * v + a) * v + i) * v, p = (v) => (3 * l * v + 2 * r) * v + s;
  return (v) => {
    if (v <= 0) return 0;
    if (v >= 1) return 1;
    let x = v;
    for (let M = 0; M < 8; M++) {
      const y = c(x) - v;
      if (Math.abs(y) < 1e-6) return f(x);
      const D = p(x);
      if (Math.abs(D) < 1e-6) break;
      x -= y / D;
    }
    let C = 0, A = 1;
    x = v;
    for (let M = 0; M < 30; M++) {
      const y = c(x);
      if (Math.abs(y - v) < 1e-6) break;
      y < v ? C = x : A = x, x = (C + A) / 2;
    }
    return f(x);
  };
}
const je = {
  /** the camera's dive: slow away, slow to rest */
  dive: No(0.65, 0, 0.3, 1),
  /** the pull back: it eases away, then settles over a long tail */
  settle: No(0.5, 0, 0.12, 1),
  /** the pointer: quick to start, gentle to arrive */
  move: No(0.4, 0, 0.2, 1),
  /** the board's --ease-out-soft: things arriving */
  out: No(0.16, 1, 0.3, 1),
  linear: (e) => e,
  sine: (e) => 0.5 - 0.5 * Math.cos(Math.PI * e)
}, Co = (e) => e < 0 ? 0 : e > 1 ? 1 : e;
function Ue(e, t, n, o = je.linear) {
  return o(Co((e - t) / (n - t)));
}
function b1(e) {
  const n = e - 1;
  return 1 + n * n * ((1.9 + 1) * n + 1.9);
}
const Go = 30, J = {
  zoomIn: [1.2, 3.8],
  cursorIn: [3.9, 4.2],
  toSession: [4, 4.7],
  clickSession: 4.75,
  promptOpen: [4.8, 5.3],
  toWhiteCard: [5.45, 6.05],
  /** Shift goes down: the keycap shows beside the pointer */
  shift: 6.05,
  /** the press on the model: its copy lifts */
  press: 6.2,
  drag: [6.25, 7.05],
  drop: 7.1,
  type: [7.4, 9.4],
  toRun: [9.5, 10],
  run: 10.05,
  land: 11.95,
  toHeart: [12.65, 13.25],
  heart: 13.35,
  note: 14.05,
  toEmpty: [14.85, 15.45],
  deselect: 15.5,
  promptClose: [15.55, 16],
  cursorOut: [15.75, 16.15],
  zoomOut: [16.05, 19.65],
  sheen: [21.2, 23.9],
  /** the run's additions leave, while the board is small, ready for the next loop */
  reset: [28.2, 29.2]
}, Nl = 14.75;
function h1(e) {
  return e < J.zoomIn[0] ? Bo : e < J.zoomIn[1] ? Bl(Bo, Yo, Ue(e, J.zoomIn[0], J.zoomIn[1], je.dive)) : e < J.zoomOut[0] ? Yo : e < J.zoomOut[1] ? Bl(Yo, Bo, Ue(e, J.zoomOut[0], J.zoomOut[1], je.settle)) : Bo;
}
function Gs(e, t) {
  return p1(Yo, e, t);
}
const pt = {
  start: { x: 760, y: 262 },
  session: Gs(nt.x + 132, nt.y + 50),
  whiteCard: Gs(qn.x + 78, qn.y + 112),
  slot: { x: an.x + an.w / 2 + 2, y: an.y + an.h / 2 + 2 },
  run: { x: oo.x + oo.w / 2 + 4, y: oo.y + oo.h / 2 + 3 },
  heart: Gs(cn[0].x + 17, cn[0].y + 17),
  // clear canvas, below Hero options and right of the prompt
  empty: { x: 968, y: 398 }
}, m1 = [
  { at: J.toSession, from: pt.start, to: pt.session, arc: 0.12 },
  { at: J.toWhiteCard, from: pt.session, to: pt.whiteCard, arc: -0.1 },
  { at: J.drag, from: pt.whiteCard, to: pt.slot, arc: 0.16 },
  { at: J.toRun, from: pt.slot, to: pt.run, arc: -0.08 },
  { at: J.toHeart, from: pt.run, to: pt.heart, arc: 0.1 },
  { at: J.toEmpty, from: pt.heart, to: pt.empty, arc: -0.12 }
];
function Xs(e) {
  let t = pt.start;
  for (const n of m1) {
    if (e < n.at[0]) return t;
    if (e < n.at[1]) {
      const o = Ue(e, n.at[0], n.at[1], je.move), s = n.to.x - n.from.x, r = n.to.y - n.from.y, l = Math.sin(Math.PI * o) * n.arc;
      return { x: n.from.x + s * o - r * l, y: n.from.y + r * o + s * l };
    }
    t = n.to;
  }
  return t;
}
const $a = [J.clickSession, J.run, J.heart, J.deselect], Ul = (() => {
  const e = Array.from(gr, (s, r) => {
    const l = gr[r - 1], i = (Math.sin(r * 12.9898) * 43758.5453 % 1 + 1) % 1;
    return (l === "," ? 3.2 : l === " " ? 1.5 : 1) * (0.82 + 0.36 * i);
  }), t = e.reduce((s, r) => s + r, 0), n = J.type[1] - J.type[0];
  let o = 0;
  return e.map((s) => (o += s, J.type[0] + o / t * n));
})();
function g1(e) {
  if (e < J.type[0] || e >= J.reset[1]) return 0;
  let t = 0;
  for (; t < Ul.length && Ul[t] <= e; ) t++;
  return t;
}
function v1(e, t, n, o) {
  return e < t || e > n ? 0 : Math.min(Co((e - t) / o), Co((n - e) / o));
}
function y1(e) {
  for (const t of $a) if (e >= t - 0.02 && e < t + 0.14) return 1;
  return e >= J.press && e < J.drop ? 1 : 0;
}
function Uo(e) {
  const t = (e % Go + Go) % Go, n = h1(t), o = 1 - Ue(t, J.reset[0], J.reset[1], je.sine), s = t >= J.land && t < J.reset[1], r = Xs(t), l = Math.min(Ue(t, J.cursorIn[0], J.cursorIn[1], je.sine), 1 - Ue(t, J.cursorOut[0], J.cursorOut[1], je.sine));
  let i = { x: r.x, y: r.y, shown: 0, size: 0 };
  for (const I of $a)
    if (t >= I && t < I + 0.5) {
      const Y = (t - I) / 0.5;
      i = { x: Xs(I).x, y: Xs(I).y, shown: 0.42 * (1 - Y), size: 0.45 + 0.75 * je.out(Y) };
    }
  const a = Ue(t, J.press, J.press + 0.2, je.out), d = Ue(t, J.drop, J.drop + 0.18, je.sine), c = Ue(t, J.drag[1] - 0.3, J.drag[1], je.sine), f = {
    x: r.x,
    y: r.y,
    shown: t >= J.press && t < J.drop + 0.18 ? a * (1 - d) : 0,
    tilt: -7 * (1 - c),
    ring: c
  }, p = Ue(t, J.promptOpen[0], J.promptOpen[1], je.out) * (1 - Ue(t, J.promptClose[0], J.promptClose[1], je.sine)), v = g1(t), x = t >= J.type[0] && t < J.type[1] + 0.05, C = (I) => Math.floor((t - I) / 0.53) % 2 === 0 ? 1 : 0;
  let A = 0;
  p > 0.5 && t < J.run && (A = x ? 1 : C(t < J.type[0] ? J.promptOpen[1] : J.type[1]));
  const M = t >= J.drop && t < J.promptClose[1] ? Ue(t, J.drop, J.drop + 0.55, je.out) : 0, y = t - J.drop, D = M > 0 && y < 5 ? Math.min(Co(y / 0.6), Co((5 - y) / 1)) * (0.55 + 0.45 * Math.sin(y / 2.5 * Math.PI * 2 - Math.PI / 2)) : 0, k = t >= J.promptClose[1] ? 0 : Ue(t, J.type[0], J.type[0] + 0.25, je.sine), L = t >= J.run - 0.02 && t < J.run + 0.14 ? 1 : 0, z = t >= J.run && t < J.land, $ = Ue(t, J.clickSession, J.clickSession + 0.18) * (1 - Ue(t, J.deselect, J.deselect + 0.18));
  let W = nt.foot;
  z ? W = "Generating… 0:0" + Math.floor(t - J.run) : s && t < J.reset[0] && (W = "Updated just now");
  const N = (I) => s ? Ue(t, J.land + I * 0.08, J.land + I * 0.08 + 0.65, je.out) * o : 0, oe = cn.map((I, Y) => N(Y)), Q = t >= J.note && t < J.reset[1];
  return {
    cam: n,
    pointer: { x: r.x, y: r.y, shown: l, pressed: y1(t), shift: v1(t, J.shift, J.drop + 0.3, 0.15) },
    ripple: i,
    ghost: f,
    dock: 1 - p,
    prompt: p,
    refIn: M,
    refGlow: D,
    typed: v,
    caret: A,
    runLit: k,
    runPressed: L,
    runBusy: z,
    sessionSelected: $,
    sessionFoot: W,
    sessionThumbs: oe,
    sessionCount: s ? 4 : 0,
    shimmer: z,
    results: oe,
    heart: t >= J.heart && t < J.reset[1] ? b1(Ue(t, J.heart, J.heart + 0.38)) * o : 0,
    note: Q ? Ue(t, J.note, J.note + 0.65, je.out) * o : 0,
    frameItems: vr(Sa) + (s && t < J.reset[0] ? cn.length : 0) + (Q && t < J.reset[0] ? 1 : 0),
    sheen: t >= J.sheen[0] && t < J.sheen[1] ? Ue(t, J.sheen[0], J.sheen[1], je.sine) : -1
  };
}
const x1 = ["viewBox"], w1 = ["d", "fill"], k1 = { class: "bl-hd-canvas" }, _1 = { class: "bl-hd-ftitle" }, C1 = { key: 1 }, S1 = { class: "bl-hd-flabel" }, I1 = ["src", "fetchpriority"], A1 = {
  key: 0,
  class: "bl-hd-play"
}, M1 = ["src"], $1 = { class: "bl-hd-session-head" }, z1 = { class: "bl-hd-badge" }, T1 = { class: "bl-hd-session-titles" }, E1 = { class: "kind" }, L1 = { class: "model" }, R1 = { class: "name" }, P1 = { class: "bl-hd-count" }, D1 = { class: "bl-hd-thumbs" }, O1 = ["src"], F1 = { class: "bl-hd-foot" }, B1 = { class: "bl-hd-session-head" }, N1 = { class: "bl-hd-badge" }, U1 = { class: "bl-hd-session-titles" }, j1 = { class: "kind" }, V1 = { class: "model" }, H1 = { class: "name" }, K1 = ["src"], q1 = { class: "text" }, W1 = { class: "meta" }, Y1 = { class: "text" }, G1 = { class: "meta" }, X1 = { class: "bl-hd-add is-plus" }, J1 = { class: "bl-hd-rail" }, Z1 = { class: "is-on" }, Q1 = { class: "bl-hd-prompt-side" }, em = ["src"], tm = { class: "bl-hd-prompt-text" }, nm = { class: "bl-hd-prompt-foot" }, om = { class: "chip" }, sm = { class: "chip" }, rm = { class: "cog" }, lm = { class: "step" }, im = ["src"], am = /* @__PURE__ */ Oe({
  __name: "HeroDemo",
  props: {
    paused: { type: Boolean },
    opening: { type: Boolean }
  },
  setup(e, { expose: t }) {
    const n = e, o = ya(), s = /* @__PURE__ */ U(null), r = /* @__PURE__ */ U(null), l = /* @__PURE__ */ U(null), i = /* @__PURE__ */ U(null), a = /* @__PURE__ */ U(null), d = /* @__PURE__ */ U(null), c = /* @__PURE__ */ U(null), f = /* @__PURE__ */ U(null), p = /* @__PURE__ */ U(null), v = /* @__PURE__ */ U(null), x = /* @__PURE__ */ U(null), C = /* @__PURE__ */ U(null), A = /* @__PURE__ */ U(null), M = /* @__PURE__ */ U(null), y = /* @__PURE__ */ U(null), D = /* @__PURE__ */ U(null), k = /* @__PURE__ */ U(null), L = /* @__PURE__ */ U(null), z = /* @__PURE__ */ U(null), $ = /* @__PURE__ */ U(null), W = /* @__PURE__ */ U(null), N = /* @__PURE__ */ U(null), oe = /* @__PURE__ */ U(null), Q = /* @__PURE__ */ U(null), I = /* @__PURE__ */ U(null), Y = /* @__PURE__ */ U(null), ge = [], de = [];
    let me = null, Fe = null;
    const Ct = (E) => {
      me = E;
    }, St = (E) => {
      Fe = E;
    }, Gt = Aa.filter((E) => E !== nt), lt = Ia;
    function ze(E) {
      const w = { left: E.x + "px", top: E.y + "px" };
      return E.w && (w.width = E.w + "px"), E.h && (w.height = E.h + "px"), w;
    }
    function it(E) {
      return E + (E === 1 ? " item" : " items");
    }
    function Qe(E) {
      const w = E.target;
      w.classList.remove("is-broken"), w.classList.add("is-in");
    }
    function qe(E) {
      const w = E.target;
      w.classList.add("is-broken"), !(w.dataset.retried || !T) && (w.dataset.retried = "1", window.setTimeout(() => {
        T && (w.src = w.src + (w.src.includes("?") ? "&" : "?") + "retry=1");
      }, 2e3));
    }
    const et = /* @__PURE__ */ new WeakMap();
    function pe(E, w, S) {
      if (!E) return;
      let re = et.get(E);
      re || et.set(E, re = {}), re[w] !== S && (re[w] = S, E.style.setProperty(w, S));
    }
    function Ne(E, w) {
      E && E.textContent !== w && (E.textContent = w);
    }
    function ft(E, w, S) {
      E && E.classList.contains(w) !== S && E.classList.toggle(w, S);
    }
    const Te = (E) => E.toFixed(2), ke = (E) => E.toFixed(3);
    function b(E, w = !1) {
      const { cam: S } = E;
      pe(i.value, "transform", `translate(${Te(ds.x - S.fx * S.z)}px, ${Te(ds.y - S.fy * S.z)}px) scale(${S.z.toFixed(4)})`), pe(i.value, "--z", ke(S.z)), pe(i.value, "--iz", ke(1 / S.z)), Ne(d.value, Math.round(S.z * 100) + "%"), pe(c.value, "opacity", ke(E.dock)), pe(c.value, "transform", `translate(-50%, ${Te((1 - E.dock) * 10)}px)`), pe(f.value, "opacity", ke(E.prompt)), pe(f.value, "transform", `translateY(${Te((1 - E.prompt) * 14)}px)`), pe(f.value, "visibility", E.prompt > 1e-3 ? "visible" : "hidden"), pe(p.value, "opacity", E.typed ? "0" : "1"), Ne(v.value, gr.slice(0, E.typed)), pe(x.value, "opacity", String(w ? 0 : E.caret)), pe(A.value, "opacity", ke(E.refIn)), pe(A.value, "transform", `scale(${ke(0.82 + 0.18 * E.refIn)})`), pe(M.value, "opacity", ke(E.refGlow)), ft(C.value, "is-target", E.ghost.ring > 0.5 && E.ghost.shown > 0 && !E.refIn), ft(y.value, "is-lit", E.runLit > 0.5), ft(y.value, "is-pressed", E.runPressed > 0), ft(y.value, "is-busy", E.runBusy), pe(D.value, "opacity", ke(E.sessionSelected)), Ne(k.value, E.sessionFoot), pe(L.value, "opacity", E.sessionCount ? "1" : "0"), ft(z.value, "is-busy", E.shimmer), E.sessionThumbs.forEach((Ie, Ee) => {
        pe(de[Ee], "opacity", ke(Ie)), pe(de[Ee], "transform", `scale(${ke(0.82 + 0.18 * Ie)})`);
      }), E.results.forEach((Ie, Ee) => {
        pe(ge[Ee], "opacity", ke(Ie)), pe(ge[Ee], "transform", `translateY(${Te((1 - Ie) * 34)}px)`);
      }), pe(Fe, "opacity", E.heart > 0 ? "1" : "0"), pe(Fe, "transform", `scale(${ke(E.heart)})`), pe($.value, "opacity", ke(E.note)), pe($.value, "transform", `translateY(${Te((1 - E.note) * 34)}px)`), Ne(me, it(E.frameItems));
      const re = E.pointer;
      pe(W.value, "opacity", w ? "0" : ke(re.shown)), pe(W.value, "transform", `translate(${Te(re.x)}px, ${Te(re.y)}px)`), ft(W.value, "is-pressed", re.pressed > 0), pe(N.value, "opacity", ke(re.shift)), pe(I.value, "opacity", w ? "0" : ke(E.ripple.shown)), pe(I.value, "transform", `translate(${Te(E.ripple.x)}px, ${Te(E.ripple.y)}px) scale(${ke(E.ripple.size)})`);
      const ye = E.ghost;
      pe(oe.value, "opacity", w ? "0" : ke(ye.shown)), pe(oe.value, "transform", `translate(${Te(ye.x + 12)}px, ${Te(ye.y + 14)}px) rotate(${Te(ye.tilt)}deg) scale(${ke(0.86 + 0.14 * ye.shown)})`), pe(Q.value, "opacity", ke(ye.ring)), pe(Y.value, "opacity", E.sheen < 0 ? "0" : ke(Math.sin(Math.PI * E.sheen))), pe(Y.value, "transform", `translateX(${Te(-100 + 270 * Math.max(0, E.sheen))}%)`);
    }
    let m = 0, R = 0, H = 0, B = !1, j = !1;
    function ee() {
      return !o.value && B && j && !0 && !n.paused && !n.opening && !document.hidden;
    }
    function Z(E) {
      const w = Uo(0);
      b({ ...w, cam: E.cam, dock: w.dock * E.chrome }, !0), pe(s.value, "--build", ke(E.build)), pe(l.value, "opacity", ke(E.chrome)), pe(a.value, "opacity", ke(E.chrome));
      const S = E.glint || { pic: 0, session: 0, note: 0, frame: 0 };
      pe(s.value, "--g-pic", ke(S.pic)), pe(s.value, "--g-session", ke(S.session)), pe(s.value, "--g-note", ke(S.note)), pe(s.value, "--g-frame", ke(S.frame));
    }
    t({ paintOpening: Z });
    const G = (E, w = 0) => ({ "--d": String(f1(E, w)) });
    function V(E) {
      R = (E - H) / 1e3 % Go, b(Uo(R)), m = requestAnimationFrame(V);
    }
    function se() {
      if (ee()) {
        m || (H = performance.now() - R * 1e3, m = requestAnimationFrame(V));
        return;
      }
      m && (cancelAnimationFrame(m), m = 0), o.value && b(Uo(Nl), !0);
    }
    Pe(() => n.paused, se), Pe(o, se);
    function te() {
      const E = s.value;
      E && r.value && pe(r.value, "transform", `scale(${(E.clientWidth / fn.w).toFixed(5)})`);
    }
    function le() {
      const E = Array.from(s.value ? s.value.querySelectorAll("img") : []), w = Promise.allSettled(E.map((S) => S.decode ? S.decode() : Promise.resolve()));
      return Promise.race([w.then(() => {
      }), new Promise((S) => window.setTimeout(S, 4500))]);
    }
    let ie = null, P = null;
    const F = () => se();
    let T = !0;
    Pt(() => {
      te(), typeof ResizeObserver != "undefined" && s.value && (P = new ResizeObserver(te), P.observe(s.value)), b(Uo(o.value ? Nl : 0), o.value), typeof IntersectionObserver != "undefined" && s.value ? (ie = new IntersectionObserver((E) => {
        B = E.some((w) => w.isIntersecting), se();
      }, { threshold: 0.08 }), ie.observe(s.value)) : B = !0, document.addEventListener("visibilitychange", F), le().then(() => {
        T && (j = !0, se());
      });
    }), Je(() => {
      T = !1, m && cancelAnimationFrame(m), m = 0, ie && ie.disconnect(), P && P.disconnect(), document.removeEventListener("visibilitychange", F);
    });
    const ue = (E) => "is-" + E.tint;
    return (E, w) => (h(), _("div", {
      ref_key: "root",
      ref: s,
      class: fe(["bl-hd", { "is-opening": e.opening }]),
      "aria-hidden": "true",
      "data-testid": "hero-demo"
    }, [
      u("div", {
        ref_key: "win",
        ref: r,
        class: "bl-hd-win",
        style: xe({ width: g(fn).w + "px", height: g(fn).h + "px" })
      }, [
        u("div", {
          ref_key: "bar",
          ref: l,
          class: "bl-hd-bar"
        }, [
          w[0] || (w[0] = u("span", { class: "bl-hd-lights" }, [
            u("i"),
            u("i"),
            u("i")
          ], -1)),
          (h(), _("svg", {
            class: "bl-hd-mark",
            viewBox: g(wa),
            width: "25",
            height: "18"
          }, [
            (h(!0), _(ae, null, Ce(g(ka), (S) => (h(), _("path", {
              key: S.d,
              d: S.d,
              fill: S.fill
            }, null, 8, w1))), 128))
          ], 8, x1)),
          w[1] || (w[1] = u("span", { class: "bl-hd-crumbs" }, [
            be("Boards "),
            u("span", { class: "sep" }, "/"),
            be(),
            u("b", null, "Bonneville Tower")
          ], -1)),
          w[2] || (w[2] = u("span", { class: "bl-hd-saved" }, [
            u("i"),
            be("Saved")
          ], -1)),
          w[3] || (w[3] = u("span", { class: "bl-hd-kebab" }, [
            u("i"),
            u("i"),
            u("i")
          ], -1))
        ], 512),
        u("div", k1, [
          u("div", {
            ref_key: "world",
            ref: i,
            class: "bl-hd-world"
          }, [
            w[6] || (w[6] = u("div", { class: "bl-hd-dots is-fine" }, null, -1)),
            w[7] || (w[7] = u("div", { class: "bl-hd-dots is-coarse" }, null, -1)),
            (h(!0), _(ae, null, Ce(g(Ca), (S) => (h(), _("div", {
              key: S.title,
              class: "bl-hd-frame",
              style: xe({ ...ze(S), ...G(S, 0.06) })
            }, [
              u("span", _1, [
                be(q(S.title) + " ", 1),
                S === g(Sa) ? (h(), _("small", {
                  key: 0,
                  ref_for: !0,
                  ref: Ct
                }, q(it(g(vr)(S))), 513)) : (h(), _("small", C1, q(it(g(vr)(S))), 1))
              ]),
              u("span", S1, q(S.title), 1)
            ], 4))), 128)),
            (h(!0), _(ae, null, Ce(g(lt), (S) => (h(), _("div", {
              key: S.id,
              class: fe(["bl-hd-pic", { "is-video": S.video }]),
              style: xe({ ...ze(S), ...G(S) })
            }, [
              u("img", {
                src: S.src,
                alt: "",
                decoding: "async",
                fetchpriority: S === g(qn) ? "high" : "low",
                onLoad: Qe,
                onError: qe
              }, null, 40, I1),
              S.video ? (h(), _("span", A1, [
                O(X, {
                  name: "Play",
                  size: 11,
                  stroke: 2.4
                })
              ])) : ne("", !0)
            ], 6))), 128)),
            (h(!0), _(ae, null, Ce(g(cn), (S, re) => (h(), _("div", {
              key: S.id,
              ref_for: !0,
              ref: (ye) => {
                ye && (ge[re] = ye);
              },
              class: fe(["bl-hd-pic is-result", { "is-first": re === 0 }]),
              style: xe(ze(S))
            }, [
              u("img", {
                src: S.src,
                alt: "",
                decoding: "async",
                onLoad: Qe,
                onError: qe
              }, null, 40, M1),
              re === 0 ? (h(), _("span", {
                key: 0,
                ref_for: !0,
                ref: St,
                class: "bl-hd-heart"
              }, [
                O(X, {
                  name: "Heart",
                  size: 10,
                  stroke: 2.6
                })
              ], 512)) : ne("", !0)
            ], 6))), 128)),
            (h(!0), _(ae, null, Ce(g(Gt), (S) => (h(), _("div", {
              key: S.id,
              class: "bl-hd-session",
              style: xe({ ...ze({ x: S.x, y: S.y, w: g(Jt).w, h: g(Jt).h }), ...G({ x: S.x, y: S.y, w: g(Jt).w, h: g(Jt).h }) })
            }, [
              u("div", $1, [
                u("span", z1, [
                  O(X, {
                    name: S.kind,
                    size: 17
                  }, null, 8, ["name"])
                ]),
                u("span", T1, [
                  u("span", E1, [
                    be(q(S.kind), 1),
                    w[4] || (w[4] = u("span", { class: "sep" }, "·", -1)),
                    u("span", L1, q(S.model), 1)
                  ]),
                  u("span", R1, q(S.name), 1)
                ]),
                u("span", P1, q(S.thumbs.length), 1)
              ]),
              u("div", D1, [
                (h(), _(ae, null, Ce(4, (re) => u("span", {
                  key: re,
                  class: fe(["bl-hd-thumb", { "is-empty": !S.thumbs[re - 1] }])
                }, [
                  S.thumbs[re - 1] ? (h(), _("img", {
                    key: 0,
                    src: S.thumbs[re - 1],
                    alt: "",
                    decoding: "async",
                    fetchpriority: "low",
                    onLoad: Qe,
                    onError: qe
                  }, null, 40, O1)) : ne("", !0)
                ], 2)), 64))
              ]),
              u("div", F1, q(S.foot), 1)
            ], 4))), 128)),
            u("div", {
              class: "bl-hd-session is-hero",
              style: xe({ ...ze({ x: g(nt).x, y: g(nt).y, w: g(Jt).w, h: g(Jt).h }), ...G({ x: g(nt).x, y: g(nt).y, w: g(Jt).w, h: g(Jt).h }) })
            }, [
              u("span", {
                ref_key: "ring",
                ref: D,
                class: "bl-hd-ring"
              }, null, 512),
              u("div", B1, [
                u("span", N1, [
                  O(X, {
                    name: "Image",
                    size: 17
                  })
                ]),
                u("span", U1, [
                  u("span", j1, [
                    be(q(g(nt).kind), 1),
                    w[5] || (w[5] = u("span", { class: "sep" }, "·", -1)),
                    u("span", V1, q(g(nt).model), 1)
                  ]),
                  u("span", H1, q(g(nt).name), 1)
                ]),
                u("span", {
                  ref_key: "count",
                  ref: L,
                  class: "bl-hd-count"
                }, q(g(cn).length), 513)
              ]),
              u("div", {
                ref_key: "thumbsRow",
                ref: z,
                class: "bl-hd-thumbs"
              }, [
                (h(!0), _(ae, null, Ce(g(cn), (S, re) => (h(), _("span", {
                  key: S.id,
                  class: "bl-hd-thumb is-empty"
                }, [
                  u("img", {
                    ref_for: !0,
                    ref: (ye) => {
                      ye && (de[re] = ye);
                    },
                    src: S.src,
                    alt: "",
                    decoding: "async",
                    class: "is-in",
                    onLoad: Qe,
                    onError: qe
                  }, null, 40, K1)
                ]))), 128))
              ], 512),
              u("div", {
                ref_key: "foot",
                ref: k,
                class: "bl-hd-foot"
              }, q(g(nt).foot), 513)
            ], 4),
            (h(!0), _(ae, null, Ce(g(Ma), (S) => (h(), _("div", {
              key: S.id,
              class: fe(["bl-hd-note", ue(S)]),
              style: xe({ ...ze(S), ...G(S) })
            }, [
              u("span", q1, q(S.text), 1),
              u("span", W1, q(S.by), 1)
            ], 6))), 128)),
            u("div", {
              ref_key: "note",
              ref: $,
              class: fe(["bl-hd-note", ue(g(Oo))]),
              style: xe(ze(g(Oo)))
            }, [
              u("span", Y1, q(g(Oo).text), 1),
              u("span", G1, q(g(Oo).by), 1)
            ], 6)
          ], 512),
          u("div", {
            ref_key: "dock",
            ref: c,
            class: "bl-hd-dock",
            style: xe({ top: g(mr) - 46 + "px" })
          }, [
            u("span", X1, [
              O(X, {
                name: "Plus",
                size: 17,
                stroke: 2.4
              })
            ]),
            u("span", J1, [
              u("i", Z1, [
                O(X, {
                  name: "MousePointer2",
                  size: 15
                })
              ]),
              u("i", null, [
                O(X, {
                  name: "Hand",
                  size: 15
                })
              ]),
              w[8] || (w[8] = u("b", null, null, -1)),
              u("i", null, [
                O(X, {
                  name: "Image",
                  size: 15
                })
              ]),
              u("i", null, [
                O(X, {
                  name: "StickyNote",
                  size: 15
                })
              ]),
              u("i", null, [
                O(X, {
                  name: "Frame",
                  size: 15
                })
              ]),
              u("i", null, [
                O(X, {
                  name: "Square",
                  size: 15
                })
              ])
            ])
          ], 4),
          u("div", {
            ref_key: "prompt",
            ref: f,
            class: "bl-hd-prompt",
            style: xe(ze(g(qt)))
          }, [
            u("span", Q1, [
              u("i", null, [
                O(X, {
                  name: "LayoutTemplate",
                  size: 15
                })
              ]),
              u("i", null, [
                O(X, {
                  name: "Pipette",
                  size: 15
                })
              ]),
              u("i", null, [
                O(X, {
                  name: "Maximize2",
                  size: 14
                })
              ])
            ]),
            u("span", {
              ref_key: "slot",
              ref: C,
              class: "bl-hd-slot",
              style: xe({ left: g(an).x - g(qt).x + "px", top: g(an).y - g(qt).y + "px", width: g(an).w + "px", height: g(an).h + "px" })
            }, [
              O(X, {
                name: "ImagePlus",
                size: 17
              }),
              u("span", {
                ref_key: "refGlow",
                ref: M,
                class: "glow"
              }, null, 512),
              u("img", {
                ref_key: "refThumb",
                ref: A,
                src: g(qn).src,
                alt: "",
                decoding: "async",
                class: "is-in",
                onError: qe
              }, null, 40, em)
            ], 4),
            u("span", tm, [
              u("span", {
                ref_key: "placeholder",
                ref: p,
                class: "ph"
              }, "Describe what " + q(g(nt).name) + " should make", 513),
              u("span", {
                ref_key: "typedEl",
                ref: v,
                class: "typed"
              }, null, 512),
              u("span", {
                ref_key: "caret",
                ref: x,
                class: "caret"
              }, null, 512)
            ]),
            u("span", nm, [
              u("span", om, [
                w[9] || (w[9] = u("small", null, "Model", -1)),
                be(q(g(nt).model), 1),
                O(X, {
                  name: "ChevronDown",
                  size: 12
                })
              ]),
              u("span", sm, [
                O(X, {
                  name: "RectangleVertical",
                  size: 12
                }),
                w[10] || (w[10] = be("896×1152", -1))
              ]),
              u("span", rm, [
                O(X, {
                  name: "Settings",
                  size: 14
                })
              ]),
              w[11] || (w[11] = u("span", { class: "sp" }, null, -1)),
              u("span", lm, [
                O(X, {
                  name: "Minus",
                  size: 11
                }),
                u("b", null, q(g(cn).length), 1),
                O(X, {
                  name: "Plus",
                  size: 11
                })
              ]),
              u("span", {
                ref_key: "run",
                ref: y,
                class: "run",
                style: xe({ width: g(oo).w + "px" })
              }, "Run", 4)
            ])
          ], 4),
          u("span", {
            ref_key: "zoomPill",
            ref: a,
            class: "bl-hd-zoom",
            style: xe({ top: g(mr) - 34 + "px" })
          }, [
            O(X, {
              name: "Minus",
              size: 12
            }),
            u("span", {
              ref_key: "zoomText",
              ref: d,
              class: "pct"
            }, "29%", 512),
            O(X, {
              name: "Plus",
              size: 12
            })
          ], 4),
          u("span", {
            ref_key: "ghost",
            ref: oe,
            class: "bl-hd-ghost"
          }, [
            u("img", {
              src: g(qn).src,
              alt: "",
              class: "is-in",
              onError: qe
            }, null, 40, im),
            u("span", {
              ref_key: "ghostRing",
              ref: Q,
              class: "ring"
            }, null, 512)
          ], 512),
          u("span", {
            ref_key: "ripple",
            ref: I,
            class: "bl-hd-ripple"
          }, null, 512),
          u("span", {
            ref_key: "pointer",
            ref: W,
            class: "bl-hd-pointer"
          }, [
            w[12] || (w[12] = u("svg", {
              class: "arrow",
              width: "22",
              height: "22",
              viewBox: "0 0 22 22"
            }, [
              u("path", {
                d: "M4 2.5v15.2l3.9-3.7 2.6 6 2.7-1.2-2.6-5.9h5.4z",
                fill: "#fff",
                stroke: "#0b0d14",
                "stroke-width": "1.3",
                "stroke-linejoin": "round"
              })
            ], -1)),
            u("span", {
              ref_key: "shiftKey",
              ref: N,
              class: "bl-hd-key"
            }, "⇧ Shift", 512)
          ], 512)
        ]),
        u("span", {
          ref_key: "sheen",
          ref: Y,
          class: "bl-hd-sheen"
        }, null, 512)
      ], 4)
    ], 2));
  }
}), cm = {
  class: "bl-hero-clip",
  "aria-hidden": "true"
}, dm = { class: "bl-hero-light" }, um = { class: "bl-hero-lit" }, fm = { class: "bl-hero-stage" }, pm = {
  key: 0,
  class: "bl-hero-top"
}, bm = { class: "bl-hero-corner" }, hm = { class: "bl-hero-copy" }, mm = { class: "bl-hero-text" }, gm = { class: "bl-title" }, vm = { class: "bl-hero-actions" }, ym = { class: "bl-btn-split" }, xm = ["disabled"], wm = ["disabled"], km = ["aria-label", "title"], _m = /* @__PURE__ */ Oe({
  __name: "ListHero",
  props: {
    canDemo: { type: Boolean }
  },
  emits: ["create", "create-demo"],
  setup(e, { emit: t }) {
    const n = t, o = Ze(), s = o.list, r = K(() => {
      if (s.teamMode.value) return o.account.value.teamName || "";
      const z = (o.user.value.name || "").split(" ")[0];
      return z ? z + "’s" : "Your";
    }), l = [
      { c: "186, 172, 232", x: -27, y: -22, s: 44, a: 0.15 },
      { c: "170, 178, 240", x: 83, y: -28, s: 44, a: 0.13 },
      { c: "160, 152, 214", x: -31, y: 38, s: 40, a: 0.09 },
      { c: "186, 172, 232", x: 89, y: 32, s: 40, a: 0.09 }
    ];
    function i(z, $, W = !1) {
      return {
        "--i": $,
        left: z.x + "%",
        top: z.y + "%",
        width: z.s + "%",
        background: `radial-gradient(closest-side, rgba(${z.c}, ${W ? z.a * 1.7 : z.a}), rgba(${z.c}, 0))`
      };
    }
    const a = ya(), d = /* @__PURE__ */ U(!1), c = /* @__PURE__ */ U(!1), f = /* @__PURE__ */ U(null);
    let p = null;
    const v = /* @__PURE__ */ U(null), x = /* @__PURE__ */ U({ left: 0, width: 0 });
    function C() {
      const z = v.value && v.value.querySelector("button.is-on");
      z && (x.value = { left: z.offsetLeft, width: z.offsetWidth });
    }
    Pt(() => {
      Lt(C), document.fonts && document.fonts.ready.then(C), typeof IntersectionObserver != "undefined" && f.value ? (p = new IntersectionObserver((z) => {
        c.value = z.some(($) => $.isIntersecting);
      }), p.observe(f.value)) : c.value = !0;
    }), Je(() => {
      p && p.disconnect();
    }), Pe(() => !!o.actions.classic, () => Lt(C));
    const A = /* @__PURE__ */ U(!1), M = /* @__PURE__ */ U(null), y = /* @__PURE__ */ U(Uu()), D = /* @__PURE__ */ U(null), k = /* @__PURE__ */ U(null);
    function L(z) {
      y.value = z, ju(z), A.value = !1, Lt(() => {
        C();
        const $ = z ? k.value : D.value;
        $ && $.focus();
      });
    }
    return (z, $) => (h(), _("header", {
      ref_key: "hero",
      ref: f,
      class: fe(["bl-hero", { "is-live": c.value && !d.value && !g(a) && !y.value, "is-min": y.value }]),
      "data-testid": "boards-hero"
    }, [
      y.value ? ne("", !0) : (h(), _(ae, { key: 0 }, [
        u("div", cm, [
          $[11] || ($[11] = u("div", { class: "bl-hero-atmo" }, null, -1)),
          u("div", dm, [
            (h(), _(ae, null, Ce(l, (W, N) => u("span", {
              key: N,
              class: "glow",
              style: xe(i(W, N))
            }, null, 4)), 64))
          ]),
          u("div", um, [
            (h(), _(ae, null, Ce(l, (W, N) => u("span", {
              key: N,
              class: "glow",
              style: xe(i(W, N, !0))
            }, null, 4)), 64))
          ]),
          u("div", fm, [
            O(am, { paused: d.value }, null, 8, ["paused"])
          ])
        ]),
        g(Do) ? (h(), _("div", pm, [
          (h(), we(ho(g(Do)), { align: "start" }))
        ])) : ne("", !0),
        u("div", bm, [
          g(o).actions.tour ? (h(), _("button", {
            key: 0,
            type: "button",
            class: "bl-hero-tour",
            "data-testid": "hero-tour",
            onClick: $[0] || ($[0] = (W) => g(o).actions.tour && g(o).actions.tour())
          }, [
            O(X, {
              name: "CirclePlay",
              size: 14,
              stroke: 2.2
            }),
            $[12] || ($[12] = u("span", null, "Take the tour", -1))
          ])) : ne("", !0),
          u("button", {
            ref_key: "minimizeBtn",
            ref: D,
            type: "button",
            class: "bl-hero-round",
            "aria-label": "Minimize the introduction",
            title: "Minimize",
            "data-testid": "hero-minimize",
            onClick: $[1] || ($[1] = (W) => L(!0))
          }, [
            O(X, {
              name: "Minimize2",
              size: 14,
              stroke: 2.2
            })
          ], 512)
        ])
      ], 64)),
      u("div", hm, [
        u("div", mm, [
          u("h1", gm, [
            be(q(r.value) + " ", 1),
            $[13] || ($[13] = u("em", null, "boards", -1))
          ]),
          $[14] || ($[14] = u("p", { class: "bl-sub" }, "An infinite canvas for every project: generate, compare and present image and video options side by side.", -1))
        ]),
        u("div", vm, [
          y.value && g(Do) ? (h(), we(ho(g(Do)), {
            key: 0,
            align: "end"
          })) : ne("", !0),
          y.value && g(o).actions.tour ? (h(), _("button", {
            key: 1,
            type: "button",
            class: "bl-hero-tour",
            "data-testid": "hero-tour",
            onClick: $[2] || ($[2] = (W) => g(o).actions.tour && g(o).actions.tour())
          }, [
            O(X, {
              name: "CirclePlay",
              size: 14,
              stroke: 2.2
            }),
            $[15] || ($[15] = u("span", null, "Take the tour", -1))
          ])) : ne("", !0),
          u("div", ym, [
            u("button", {
              type: "button",
              class: "bl-btn",
              disabled: g(s).creating.value,
              "data-testid": "new-board",
              onClick: $[3] || ($[3] = (W) => n("create"))
            }, [
              O(X, {
                name: "Plus",
                size: 16,
                stroke: 2.4
              }),
              be(" " + q(g(s).creating.value ? "Creating..." : "New board"), 1)
            ], 8, xm),
            e.canDemo ? (h(), _("button", {
              key: 0,
              ref_key: "moreBtn",
              ref: M,
              type: "button",
              class: "bl-btn",
              "aria-label": "More ways to start a board",
              disabled: g(s).creating.value,
              onClick: $[4] || ($[4] = (W) => A.value = !A.value)
            }, [
              O(X, {
                name: "ChevronDown",
                size: 16
              })
            ], 8, wm)) : ne("", !0)
          ]),
          O(_o, {
            open: A.value && e.canDemo,
            anchor: M.value,
            align: "start",
            onClose: $[7] || ($[7] = (W) => A.value = !1)
          }, {
            default: ut(() => [
              u("button", {
                type: "button",
                class: "bl-menu-item",
                "data-testid": "open-demo",
                onClick: $[5] || ($[5] = (W) => {
                  A.value = !1, n("create-demo", !1);
                })
              }, [
                O(X, { name: "Sparkles" }),
                $[16] || ($[16] = u("span", null, [
                  be("Demo board"),
                  u("small", null, "Your Bonneville Tower board, for showing Boards v2")
                ], -1))
              ]),
              u("button", {
                type: "button",
                class: "bl-menu-item",
                "data-testid": "new-demo",
                onClick: $[6] || ($[6] = (W) => {
                  A.value = !1, n("create-demo", !0);
                })
              }, [
                O(X, { name: "Plus" }),
                $[17] || ($[17] = u("span", null, [
                  be("New demo board"),
                  u("small", null, "A fresh copy of the Bonneville Tower board")
                ], -1))
              ])
            ]),
            _: 1
          }, 8, ["open", "anchor"]),
          g(o).actions.classic ? (h(), _("div", {
            key: 2,
            ref_key: "switchEl",
            ref: v,
            class: "bl-switch",
            role: "radiogroup",
            "aria-label": "Boards version"
          }, [
            u("span", {
              class: "bl-switch-pill",
              style: xe({ left: x.value.left + "px", width: x.value.width + "px", right: "auto" })
            }, null, 4),
            u("button", {
              type: "button",
              role: "radio",
              "aria-checked": "false",
              "data-testid": "switch-classic",
              onClick: $[8] || ($[8] = (W) => g(o).actions.classic && g(o).actions.classic())
            }, "Classic"),
            $[18] || ($[18] = u("button", {
              type: "button",
              role: "radio",
              "aria-checked": "true",
              class: "is-on"
            }, "Boards v2", -1))
          ], 512)) : ne("", !0),
          y.value ? (h(), _("button", {
            key: 3,
            ref_key: "expandBtn",
            ref: k,
            type: "button",
            class: "bl-hero-round",
            "aria-label": "Show the full introduction",
            title: "Show the introduction",
            "data-testid": "hero-expand",
            onClick: $[9] || ($[9] = (W) => L(!1))
          }, [
            O(X, {
              name: "Maximize2",
              size: 14,
              stroke: 2.2
            })
          ], 512)) : ne("", !0)
        ])
      ]),
      y.value ? ne("", !0) : (h(), _(ae, { key: 1 }, [
        $[19] || ($[19] = u("div", { class: "bl-hero-room" }, null, -1)),
        g(a) ? ne("", !0) : (h(), _("button", {
          key: 0,
          type: "button",
          class: "bl-hero-pause",
          "aria-label": d.value ? "Play the Boards v2 demo" : "Pause the Boards v2 demo",
          title: d.value ? "Play" : "Pause",
          "data-testid": "hero-pause",
          onClick: $[10] || ($[10] = (W) => d.value = !d.value)
        }, [
          O(X, {
            name: d.value ? "Play" : "Pause",
            size: 13,
            stroke: 2.4
          }, null, 8, ["name"])
        ], 8, km))
      ], 64))
    ], 2));
  }
}), Cm = {
  class: "bl-pager",
  "aria-label": "Pages",
  "data-testid": "boards-pager"
}, Sm = { class: "bl-size" }, Im = ["disabled", "onClick"], Am = { "data-testid": "page-text" }, Mm = { class: "bl-pages" }, $m = ["disabled"], zm = ["disabled"], Tm = /* @__PURE__ */ Oe({
  __name: "ListPager",
  setup(e) {
    const t = Ze().list;
    return (n, o) => (h(), _("nav", Cm, [
      u("span", Sm, [
        o[2] || (o[2] = be(" Per page ", -1)),
        (h(!0), _(ae, null, Ce(g(zn), (s) => (h(), _("button", {
          key: s,
          type: "button",
          class: fe({ "is-on": g(t).pageSize.value === s }),
          disabled: g(t).loading.value,
          onClick: (r) => g(t).setPageSize(s)
        }, q(s), 11, Im))), 128))
      ]),
      u("span", Am, q(g(t).pageText.value), 1),
      u("span", Mm, [
        u("button", {
          type: "button",
          class: "bl-icon-btn",
          "aria-label": "Previous page",
          disabled: g(t).loading.value || g(t).pageNumber.value <= 1,
          onClick: o[0] || (o[0] = (s) => g(t).previousPage())
        }, [
          O(X, {
            name: "ChevronLeft",
            size: 17
          })
        ], 8, $m),
        u("button", {
          type: "button",
          class: "bl-icon-btn",
          "aria-label": "Next page",
          disabled: g(t).loading.value || !g(t).canNext.value,
          "data-testid": "next-page",
          onClick: o[1] || (o[1] = (s) => g(t).nextPage())
        }, [
          O(X, {
            name: "ChevronRight",
            size: 17
          })
        ], 8, zm)
      ])
    ]));
  }
}), Em = { class: "bl-owner-search" }, Lm = {
  class: "bl-owner-list",
  role: "listbox",
  "aria-multiselectable": "true"
}, Rm = ["aria-selected", "onClick"], Pm = { class: "box" }, Dm = { style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" } }, Om = {
  key: 0,
  class: "bl-owner-empty"
}, Fm = /* @__PURE__ */ Oe({
  __name: "OwnerFilter",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = /* @__PURE__ */ U(""), l = /* @__PURE__ */ U([]), i = /* @__PURE__ */ U(!1), a = /* @__PURE__ */ new Map();
    let d = 0, c = 0;
    for (const x of s.list.rows.value) x.ownerUserId && x.ownerEmail && a.set(x.ownerUserId, x.ownerEmail);
    async function f(x) {
      const C = ++d;
      i.value = !0;
      try {
        const A = await s.source().searchTeamMembers(s.account.value, x);
        if (C !== d) return;
        for (const M of A) a.set(M.userId, M.email);
        l.value = A;
      } catch (A) {
        console.error("[boards] could not search members", A), C === d && (l.value = []);
      } finally {
        C === d && (i.value = !1);
      }
    }
    Pe(r, (x) => {
      clearTimeout(c), c = window.setTimeout(() => {
        f(x);
      }, 280);
    }), f(""), Je(() => clearTimeout(c));
    const p = K(() => {
      const x = n.modelValue.map((A) => ({ userId: A, email: a.get(A) || "Unknown member" })), C = l.value.filter((A) => !n.modelValue.includes(A.userId));
      return [...x, ...C];
    });
    function v(x) {
      const C = n.modelValue.includes(x) ? n.modelValue.filter((A) => A !== x) : [...n.modelValue, x];
      o("update:modelValue", C);
    }
    return (x, C) => (h(), _("div", null, [
      u("label", Em, [
        O(X, {
          name: "Search",
          size: 14
        }),
        Ln(u("input", {
          "onUpdate:modelValue": C[0] || (C[0] = (A) => r.value = A),
          type: "text",
          placeholder: "Search people",
          "aria-label": "Search owners"
        }, null, 512), [
          [Rn, r.value]
        ])
      ]),
      u("div", Lm, [
        (h(!0), _(ae, null, Ce(p.value, (A) => (h(), _("button", {
          key: A.userId,
          type: "button",
          class: fe(["bl-owner", { "is-on": e.modelValue.includes(A.userId) }]),
          role: "option",
          "aria-selected": e.modelValue.includes(A.userId),
          onClick: (M) => v(A.userId)
        }, [
          u("span", Pm, [
            e.modelValue.includes(A.userId) ? (h(), we(X, {
              key: 0,
              name: "Check",
              size: 11,
              stroke: 3.2
            })) : ne("", !0)
          ]),
          u("span", {
            class: "bl-avatar",
            style: xe(g(Dn)(A.userId))
          }, q(g(On)(A.email)), 5),
          u("span", Dm, q(A.userId === g(s).user.value.uid ? "You (" + A.email + ")" : A.email), 1)
        ], 10, Rm))), 128)),
        p.value.length ? ne("", !0) : (h(), _("div", Om, q(i.value ? "Searching..." : "No members match"), 1))
      ])
    ]));
  }
}), Bm = { class: "bl-toolbar-row" }, Nm = ["aria-selected", "title", "onClick"], Um = {
  key: 1,
  class: "bl-heading"
}, jm = { class: "bl-toolbar-tools" }, Vm = { class: "bl-search" }, Hm = ["placeholder"], Km = {
  key: 1,
  class: "bl-kbd",
  "aria-hidden": "true"
}, qm = ["aria-expanded"], Wm = {
  key: 0,
  class: "bl-count"
}, Ym = ["aria-expanded"], Gm = { class: "bl-sort-label" }, Xm = {
  class: "bl-seg",
  role: "radiogroup",
  "aria-label": "Show boards as"
}, Jm = ["aria-checked"], Zm = ["aria-checked"], Qm = ["aria-hidden"], eg = ["tabindex", "disabled"], tg = {
  key: 0,
  class: "bl-chips"
}, ng = {
  key: 0,
  class: "bl-chip"
}, og = {
  key: 1,
  class: "bl-chip"
}, sg = { class: "bl-pop-section" }, rg = { class: "bl-levels" }, lg = ["onClick"], ig = { class: "bl-pop-section" }, ag = { class: "bl-pop-foot" }, cg = ["disabled"], dg = ["onClick"], ug = ["onClick"], fg = /* @__PURE__ */ Oe({
  __name: "ListToolbar",
  props: {
    mode: {},
    docked: { type: Boolean },
    offerNew: { type: Boolean }
  },
  emits: ["mode", "create"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = Ze(), r = s.list, l = K(() => xu(r.canSeeEveryone.value, s.labels.value.team)), i = /* @__PURE__ */ U(null), a = /* @__PURE__ */ U({ left: 0, width: 0 });
    function d() {
      const Q = i.value;
      if (!Q) return;
      const I = Q.querySelector(".bl-tab.is-on");
      I && (a.value = { left: I.offsetLeft, width: I.offsetWidth });
    }
    Pe(() => [r.filters.value.view, l.value.length, r.teamMode.value], () => Lt(d)), Pt(() => {
      Lt(d), window.addEventListener("resize", d), document.fonts && document.fonts.ready.then(d);
    }), Je(() => window.removeEventListener("resize", d));
    const c = /* @__PURE__ */ U(r.q.value);
    let f = 0;
    Pe(c, (Q) => {
      clearTimeout(f), f = window.setTimeout(() => r.setSearch(Q.trim()), 260);
    }), Pe(() => r.q.value, (Q) => {
      Q !== c.value.trim() && (c.value = Q);
    });
    const p = /* @__PURE__ */ U(null), v = K(() => {
      const Q = r.teamMode.value && s.account.value.customFields.length ? s.account.value.customFields[0].label : "";
      return Q ? "Search by name or " + Q.toLowerCase() + "..." : "Search board names...";
    });
    function x(Q) {
      const I = Q.target;
      Q.key !== "/" || I && /^(INPUT|TEXTAREA|SELECT)$/.test(I.tagName) || I && I.isContentEditable || (Q.preventDefault(), p.value && p.value.focus());
    }
    Pt(() => window.addEventListener("keydown", x)), Je(() => {
      window.removeEventListener("keydown", x), clearTimeout(f);
    });
    const C = /* @__PURE__ */ U(null), A = /* @__PURE__ */ U(!1), M = K(() => ia(r.filters.value)), y = [
      { value: null, label: "Any" },
      { value: "PRIVATE", label: "Private" },
      { value: "SHARED", label: "Shared" },
      { value: "RESTRICTED", label: "Restricted" }
    ], D = K({
      get: () => r.filters.value.ownerUserIds,
      set: (Q) => r.setFilters({ ownerUserIds: Q })
    }), k = /* @__PURE__ */ U(null), L = /* @__PURE__ */ U(!1), z = K(() => wu(r.teamMode.value ? s.account.value.customFields : [])), $ = K(() => {
      const Q = z.value.find((I) => I.by === r.sort.value.by);
      return Q ? Q.label : "Date created";
    });
    function W(Q) {
      r.setSort({ by: Q, desc: Q === r.sort.value.by ? r.sort.value.desc : Q === "created" }), L.value = !1;
    }
    function N(Q) {
      r.setSort({ by: r.sort.value.by, desc: Q });
    }
    const oe = K(() => r.sort.value.by === "created" ? [{ desc: !0, label: "Newest first" }, { desc: !1, label: "Oldest first" }] : [{ desc: !1, label: "A to Z" }, { desc: !0, label: "Z to A" }]);
    return (Q, I) => (h(), _("div", {
      class: fe(["bl-toolbar", { "is-docked": n.docked }]),
      "data-testid": "boards-toolbar"
    }, [
      u("div", Bm, [
        g(r).teamMode.value ? (h(), _("div", {
          key: 0,
          ref_key: "tabsEl",
          ref: i,
          class: "bl-tabs",
          role: "tablist",
          "aria-label": "Which boards"
        }, [
          u("span", {
            class: "bl-tab-ink",
            style: xe({ left: a.value.left + "px", width: a.value.width + "px" })
          }, null, 4),
          (h(!0), _(ae, null, Ce(l.value, (Y) => (h(), _("button", {
            key: Y.value,
            type: "button",
            role: "tab",
            class: fe(["bl-tab", { "is-on": g(r).filters.value.view === Y.value }]),
            "aria-selected": g(r).filters.value.view === Y.value,
            title: Y.description,
            onClick: (ge) => g(r).setFilters({ view: Y.value })
          }, [
            Y.value === "everyone" ? (h(), we(X, {
              key: 0,
              name: "ShieldCheck",
              size: 14
            })) : ne("", !0),
            be(" " + q(Y.label), 1)
          ], 10, Nm))), 128))
        ], 512)) : (h(), _("div", Um, "Your boards")),
        u("div", jm, [
          u("label", Vm, [
            O(X, {
              name: "Search",
              size: 15
            }),
            Ln(u("input", {
              ref_key: "searchEl",
              ref: p,
              "onUpdate:modelValue": I[0] || (I[0] = (Y) => c.value = Y),
              type: "search",
              placeholder: v.value,
              "aria-label": "Search boards",
              "data-testid": "boards-search"
            }, null, 8, Hm), [
              [Rn, c.value]
            ]),
            c.value ? (h(), _("button", {
              key: 0,
              type: "button",
              class: "bl-search-clear",
              "aria-label": "Clear search",
              onClick: I[1] || (I[1] = (Y) => c.value = "")
            }, [
              O(X, {
                name: "X",
                size: 14
              })
            ])) : (h(), _("span", Km, "/"))
          ]),
          g(r).teamMode.value ? (h(), _("button", {
            key: 0,
            ref_key: "filtersBtn",
            ref: C,
            type: "button",
            class: fe(["bl-tool-btn", { "is-open": A.value, "is-active": M.value > 0 }]),
            "aria-expanded": A.value,
            "data-testid": "boards-filters",
            onClick: I[2] || (I[2] = (Y) => A.value = !A.value)
          }, [
            O(X, {
              name: "SlidersHorizontal",
              size: 15
            }),
            I[16] || (I[16] = be(" Filters ", -1)),
            M.value ? (h(), _("span", Wm, q(M.value), 1)) : ne("", !0)
          ], 10, qm)) : ne("", !0),
          u("button", {
            ref_key: "sortBtn",
            ref: k,
            type: "button",
            class: fe(["bl-tool-btn", { "is-open": L.value }]),
            "aria-expanded": L.value,
            "data-testid": "boards-sort",
            onClick: I[3] || (I[3] = (Y) => L.value = !L.value)
          }, [
            O(X, {
              name: "ArrowUpDown",
              size: 15
            }),
            u("span", Gm, q($.value), 1)
          ], 10, Ym),
          u("div", Xm, [
            u("span", {
              class: "bl-seg-pill",
              style: xe({ transform: n.mode === "table" ? "translateX(34px)" : "none" })
            }, null, 4),
            u("button", {
              type: "button",
              role: "radio",
              "aria-checked": n.mode === "grid",
              class: fe({ "is-on": n.mode === "grid" }),
              title: "Grid",
              "data-testid": "mode-grid",
              onClick: I[4] || (I[4] = (Y) => o("mode", "grid"))
            }, [
              O(X, {
                name: "LayoutGrid",
                size: 16
              })
            ], 10, Jm),
            u("button", {
              type: "button",
              role: "radio",
              "aria-checked": n.mode === "table",
              class: fe({ "is-on": n.mode === "table" }),
              title: "Table",
              "data-testid": "mode-table",
              onClick: I[5] || (I[5] = (Y) => o("mode", "table"))
            }, [
              O(X, {
                name: "Table2",
                size: 16
              })
            ], 10, Zm)
          ]),
          u("button", {
            type: "button",
            class: fe(["bl-icon-btn bl-refresh", { "is-spinning": g(r).loading.value }]),
            title: "Refresh",
            "aria-label": "Refresh",
            style: { width: "40px", height: "40px" },
            onClick: I[6] || (I[6] = (Y) => g(r).refresh())
          }, [
            O(X, {
              name: "RefreshCw",
              size: 16
            })
          ], 2),
          u("div", {
            class: fe(["bl-toolbar-new", { "is-on": n.offerNew }]),
            "aria-hidden": !n.offerNew
          }, [
            u("button", {
              type: "button",
              class: "bl-btn is-sm",
              tabindex: n.offerNew ? 0 : -1,
              disabled: g(r).creating.value,
              "data-testid": "toolbar-new-board",
              onClick: I[7] || (I[7] = (Y) => o("create"))
            }, [
              O(X, {
                name: "Plus",
                size: 15,
                stroke: 2.4
              }),
              be(" " + q(g(r).creating.value ? "Creating..." : "New board"), 1)
            ], 8, eg)
          ], 10, Qm)
        ])
      ]),
      g(r).teamMode.value && M.value ? (h(), _("div", tg, [
        g(r).filters.value.accessLevel ? (h(), _("span", ng, [
          be(" Access: " + q(g(ko)[g(r).filters.value.accessLevel]) + " ", 1),
          u("button", {
            type: "button",
            "aria-label": "Remove the access filter",
            onClick: I[8] || (I[8] = (Y) => g(r).setFilters({ accessLevel: null }))
          }, [
            O(X, {
              name: "X",
              size: 12
            })
          ])
        ])) : ne("", !0),
        g(r).filters.value.ownerUserIds.length ? (h(), _("span", og, [
          be(q(g(r).filters.value.ownerUserIds.length === 1 ? "1 owner" : g(r).filters.value.ownerUserIds.length + " owners") + " ", 1),
          u("button", {
            type: "button",
            "aria-label": "Remove the owner filter",
            onClick: I[9] || (I[9] = (Y) => g(r).setFilters({ ownerUserIds: [] }))
          }, [
            O(X, {
              name: "X",
              size: 12
            })
          ])
        ])) : ne("", !0),
        u("button", {
          type: "button",
          class: "bl-chip-clear",
          onClick: I[10] || (I[10] = (Y) => g(r).setFilters({ accessLevel: null, ownerUserIds: [] }))
        }, "Clear filters")
      ])) : ne("", !0),
      O(_o, {
        open: A.value,
        anchor: C.value,
        "panel-class": "bl-pop",
        "keep-on-scroll": "",
        onClose: I[14] || (I[14] = (Y) => A.value = !1)
      }, {
        default: ut(() => [
          u("div", sg, [
            I[17] || (I[17] = u("h4", null, "Access", -1)),
            u("div", rg, [
              (h(), _(ae, null, Ce(y, (Y) => u("button", {
                key: Y.label,
                type: "button",
                class: fe(["bl-level", { "is-on": g(r).filters.value.accessLevel === Y.value }]),
                onClick: (ge) => g(r).setFilters({ accessLevel: Y.value })
              }, q(Y.label), 11, lg)), 64))
            ])
          ]),
          u("div", ig, [
            I[18] || (I[18] = u("h4", null, "Owner", -1)),
            O(Fm, {
              modelValue: D.value,
              "onUpdate:modelValue": I[11] || (I[11] = (Y) => D.value = Y)
            }, null, 8, ["modelValue"])
          ]),
          u("div", ag, [
            u("button", {
              type: "button",
              class: "bl-chip-clear",
              disabled: !M.value,
              onClick: I[12] || (I[12] = (Y) => g(r).setFilters({ accessLevel: null, ownerUserIds: [] }))
            }, "Clear all", 8, cg),
            u("button", {
              type: "button",
              class: "bl-btn is-sm",
              onClick: I[13] || (I[13] = (Y) => A.value = !1)
            }, "Done")
          ])
        ]),
        _: 1
      }, 8, ["open", "anchor"]),
      O(_o, {
        open: L.value,
        anchor: k.value,
        onClose: I[15] || (I[15] = (Y) => L.value = !1)
      }, {
        default: ut(() => [
          I[19] || (I[19] = u("div", { class: "bl-menu-label" }, "Sort by", -1)),
          (h(!0), _(ae, null, Ce(z.value, (Y) => (h(), _("button", {
            key: Y.by,
            type: "button",
            class: fe(["bl-menu-item", { "is-on": g(r).sort.value.by === Y.by }]),
            onClick: (ge) => W(Y.by)
          }, [
            be(q(Y.label) + " ", 1),
            g(r).sort.value.by === Y.by ? (h(), we(X, {
              key: 0,
              class: "check",
              name: "Check",
              size: 15
            })) : ne("", !0)
          ], 10, dg))), 128)),
          I[20] || (I[20] = u("div", { class: "bl-menu-sep" }, null, -1)),
          (h(!0), _(ae, null, Ce(oe.value, (Y) => (h(), _("button", {
            key: Y.label,
            type: "button",
            class: fe(["bl-menu-item", { "is-on": g(r).sort.value.desc === Y.desc }]),
            onClick: (ge) => N(Y.desc)
          }, [
            be(q(Y.label) + " ", 1),
            g(r).sort.value.desc === Y.desc ? (h(), we(X, {
              key: 0,
              class: "check",
              name: "Check",
              size: 15
            })) : ne("", !0)
          ], 10, ug))), 128))
        ]),
        _: 1
      }, 8, ["open", "anchor"])
    ], 2));
  }
}), pg = /* @__PURE__ */ Oe({
  __name: "ToastHost",
  props: {
    notice: {}
  },
  setup(e) {
    return (t, n) => (h(), we(Yn, { name: "bl-toast" }, {
      default: ut(() => [
        e.notice ? (h(), _("div", {
          key: 0,
          class: fe(["bl-toast", "is-" + e.notice.status]),
          role: "status",
          "data-testid": "toast"
        }, [
          O(X, {
            name: e.notice.status === "error" ? "CircleAlert" : "CircleCheck",
            size: 17
          }, null, 8, ["name"]),
          be(" " + q(e.notice.message), 1)
        ], 2)) : ne("", !0)
      ]),
      _: 1
    }));
  }
}), za = { w: 3200, h: 1500, cell: 16, scale: 760, levels: 22, seed: 11 };
function bg(e, t, n) {
  let o = Math.imul(e, 374761393) ^ Math.imul(t, 668265263) ^ Math.imul(n + 1, 1442695041);
  return o = Math.imul(o ^ o >>> 13, 1274126177), o ^= o >>> 16, (o >>> 0) / 4294967296;
}
const jl = (e) => e * e * e * (e * (e * 6 - 15) + 10);
function hg(e, t, n) {
  const o = Math.floor(e), s = Math.floor(t), r = (c, f) => {
    const p = bg(c, f, n) * Math.PI * 2;
    return Math.cos(p) * (e - c) + Math.sin(p) * (t - f);
  }, l = jl(e - o), i = jl(t - s), a = r(o, s) + (r(o + 1, s) - r(o, s)) * l, d = r(o, s + 1) + (r(o + 1, s + 1) - r(o, s + 1)) * l;
  return a + (d - a) * i;
}
function Js(e, t, n) {
  let o = 0, s = 1, r = 0, l = e, i = t;
  for (let a = 0; a < 4; a++) {
    o += s * hg(l, i, n + a * 31), r += s, s *= 0.5;
    const d = l * 0.8 - i * 0.6, c = l * 0.6 + i * 0.8;
    l = d * 2 + 5.3, i = c * 2 - 1.7;
  }
  return o / r;
}
function mg(e, t, n) {
  const o = e / n.scale, s = t / n.scale, r = Js(o, s, n.seed), l = Js(o + 5.2, s + 1.3, n.seed);
  return Js(o + 1.6 * r, s + 1.6 * l, n.seed + 7);
}
function gg(e) {
  const t = Math.ceil(e.w / e.cell) + 1, n = Math.ceil(e.h / e.cell) + 1, o = new Float32Array(t * n);
  let s = 1 / 0, r = -1 / 0;
  for (let l = 0; l < n; l++)
    for (let i = 0; i < t; i++) {
      const a = mg(i * e.cell, l * e.cell, e);
      o[l * t + i] = a, a < s && (s = a), a > r && (r = a);
    }
  return { f: o, nx: t, ny: n, min: s, max: r };
}
const nn = 0, on = 1, sn = 2, rn = 3, vg = [
  [],
  [[rn, sn]],
  [[sn, on]],
  [[rn, on]],
  [[nn, on]],
  [],
  [[nn, sn]],
  [[rn, nn]],
  [[rn, nn]],
  [[nn, sn]],
  [],
  [[nn, on]],
  [[rn, on]],
  [[sn, on]],
  [[rn, sn]],
  []
];
function yg(e = za) {
  const { f: t, nx: n, ny: o, min: s, max: r } = gg(e), l = o * (n - 1), i = [];
  for (let a = 1; a <= e.levels; a++) {
    const d = s + (r - s) * a / (e.levels + 1), c = /* @__PURE__ */ new Map(), f = (M) => {
      let y = c.get(M);
      if (y) return y;
      if (M < l) {
        const D = Math.floor(M / (n - 1)), k = M - D * (n - 1), L = t[D * n + k], z = t[D * n + k + 1];
        y = [(k + (d - L) / (z - L)) * e.cell, D * e.cell];
      } else {
        const D = M - l, k = Math.floor(D / n), L = D - k * n, z = t[k * n + L], $ = t[(k + 1) * n + L];
        y = [L * e.cell, (k + (d - z) / ($ - z)) * e.cell];
      }
      return c.set(M, y), y;
    }, p = [], v = /* @__PURE__ */ new Map(), x = (M, y) => {
      const D = p.length / 2;
      p.push(M, y);
      for (const k of [M, y]) {
        const L = v.get(k);
        L ? L.push(D) : v.set(k, [D]);
      }
    };
    for (let M = 0; M < o - 1; M++)
      for (let y = 0; y < n - 1; y++) {
        const D = t[M * n + y], k = t[M * n + y + 1], L = t[(M + 1) * n + y + 1], z = t[(M + 1) * n + y], $ = (D > d ? 8 : 0) | (k > d ? 4 : 0) | (L > d ? 2 : 0) | (z > d ? 1 : 0);
        if ($ === 0 || $ === 15) continue;
        const W = [M * (n - 1) + y, l + M * n + y + 1, (M + 1) * (n - 1) + y, l + M * n + y];
        let N = vg[$];
        if ($ === 5 || $ === 10) {
          const oe = (D + k + L + z) / 4 > d;
          N = $ === 5 === oe ? [[rn, nn], [sn, on]] : [[nn, on], [rn, sn]];
        }
        for (const [oe, Q] of N) x(W[oe], W[Q]);
      }
    const C = new Uint8Array(p.length / 2), A = (M, y) => {
      const D = v.get(M) || [];
      for (const k of D) if (k !== y && !C[k]) return k;
      return -1;
    };
    for (let M = 0; M < C.length; M++) {
      if (C[M]) continue;
      C[M] = 1;
      const y = [p[M * 2 + 1]];
      let D = M, k = p[M * 2 + 1];
      for (; ; ) {
        const N = A(k, D);
        if (N < 0) break;
        C[N] = 1, k = p[N * 2] === k ? p[N * 2 + 1] : p[N * 2], D = N, y.push(k);
      }
      const L = [];
      for (D = M, k = p[M * 2]; ; ) {
        const N = A(k, D);
        if (N < 0) break;
        C[N] = 1, k = p[N * 2] === k ? p[N * 2 + 1] : p[N * 2], D = N, L.push(k);
      }
      const z = L.reverse().concat([p[M * 2]], y), $ = z.length > 3 && z[0] === z[z.length - 1];
      $ && z.pop();
      const W = [];
      for (const N of z) {
        const oe = f(N);
        W.push(oe[0], oe[1]);
      }
      W.length >= 6 && xg(W, $, e.cell) && i.push({ level: a, points: W, closed: $ });
    }
  }
  return i;
}
function xg(e, t, n) {
  if (t) {
    let s = 1 / 0, r = 1 / 0, l = -1 / 0, i = -1 / 0;
    for (let a = 0; a < e.length; a += 2)
      s = Math.min(s, e[a]), l = Math.max(l, e[a]), r = Math.min(r, e[a + 1]), i = Math.max(i, e[a + 1]);
    return Math.max(l - s, i - r) >= n * 2.4;
  }
  let o = 0;
  for (let s = 2; s < e.length; s += 2) o += Math.hypot(e[s] - e[s - 2], e[s + 1] - e[s - 1]);
  return o >= n * 3;
}
function wg(e, t = 0.9) {
  const n = e.length / 2;
  if (n < 3) return e.slice();
  const o = new Uint8Array(n);
  o[0] = 1, o[n - 1] = 1;
  const s = [[0, n - 1]];
  for (; s.length; ) {
    const [l, i] = s.pop(), a = e[l * 2], d = e[l * 2 + 1], c = e[i * 2] - a, f = e[i * 2 + 1] - d, p = Math.hypot(c, f) || 1;
    let v = -1, x = t;
    for (let C = l + 1; C < i; C++) {
      const A = Math.abs((e[C * 2] - a) * f - (e[C * 2 + 1] - d) * c) / p;
      A > x && (x = A, v = C);
    }
    v > 0 && (o[v] = 1, s.push([l, v], [v, i]));
  }
  const r = [];
  for (let l = 0; l < n; l++) o[l] && r.push(e[l * 2], e[l * 2 + 1]);
  return r;
}
const at = (e) => (Math.round(e * 10) / 10).toString();
function kg(e) {
  const t = e.points, n = t.length / 2, o = (r) => {
    const l = r % n, i = (r + 1) % n;
    return [(t[l * 2] + t[i * 2]) / 2, (t[l * 2 + 1] + t[i * 2 + 1]) / 2];
  };
  if (e.closed) {
    const r = o(0);
    let l = "M" + at(r[0]) + " " + at(r[1]);
    for (let i = 1; i <= n; i++) {
      const a = i % n, d = o(i);
      l += "Q" + at(t[a * 2]) + " " + at(t[a * 2 + 1]) + " " + at(d[0]) + " " + at(d[1]);
    }
    return l + "Z";
  }
  let s = "M" + at(t[0]) + " " + at(t[1]);
  for (let r = 1; r < n - 1; r++) {
    const l = o(r);
    s += "Q" + at(t[r * 2]) + " " + at(t[r * 2 + 1]) + " " + at(l[0]) + " " + at(l[1]);
  }
  return s + "L" + at(t[(n - 1) * 2]) + " " + at(t[(n - 1) * 2 + 1]);
}
function _g(e = za) {
  const t = yg(e), n = [], o = [];
  for (const s of t) {
    const r = kg({ ...s, points: wg(s.points) });
    (s.level % 5 === 0 ? o : n).push(r);
  }
  return '<svg xmlns="http://www.w3.org/2000/svg" width="' + e.w + '" height="' + e.h + '" viewBox="0 0 ' + e.w + " " + e.h + '"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"><path stroke-opacity="0.55" stroke-width="1" d="' + n.join("") + '"/><path stroke-opacity="1" stroke-width="1.25" d="' + o.join("") + '"/></g></svg>';
}
let Qn = null;
function Cg() {
  if (Qn) return Qn;
  const e = _g();
  try {
    Qn = URL.createObjectURL(new Blob([e], { type: "image/svg+xml" }));
  } catch {
    Qn = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(e);
  }
  return Qn;
}
const Sg = { class: "bl-wrap" }, Ig = { class: "bl-body" }, Ag = { key: "loading" }, Mg = /* @__PURE__ */ Oe({
  __name: "BoardsListApp",
  props: {
    env: {}
  },
  setup(e) {
    const n = e.env, o = /* @__PURE__ */ wt(null);
    let s = 0;
    function r(de) {
      if (n.notify) {
        n.notify(de);
        return;
      }
      o.value = de, clearTimeout(s), s = window.setTimeout(() => {
        o.value = null;
      }, 4200);
    }
    const l = Qu({ source: n.source, user: n.user, account: n.account, permissions: n.permissions, notify: r }), i = /* @__PURE__ */ wt(null), a = /* @__PURE__ */ U(!1), d = /* @__PURE__ */ U(0);
    function c(de, me) {
      i.value = [...de], a.value = me, d.value = me ? Math.max(0, l.selected.value.size - de.length) : 0;
    }
    async function f() {
      const de = i.value;
      de && (await l.deleteBoards(de), i.value = null);
    }
    const p = /* @__PURE__ */ U(null), v = /* @__PURE__ */ wt(null), x = {
      ...n.actions,
      edit: (de) => {
        p.value = de;
      },
      access: (de, me) => {
        v.value = { ids: [...de], onSaved: me };
      }
    }, C = /* @__PURE__ */ U(null);
    Zr("bl-overlay", C);
    const A = {
      list: l,
      user: n.user,
      account: n.account,
      labels: n.labels,
      source: n.source,
      actions: x,
      notify: r,
      requestDelete: c
    };
    Zr(sa, A);
    const M = /* @__PURE__ */ U(Bu());
    function y(de) {
      M.value = de, Nu(de);
    }
    async function D() {
      const de = await l.createBoard();
      de && n.actions.open(de.id, { created: !0 });
    }
    async function k(de = !1) {
      if (n.createDemo)
        try {
          const me = await n.createDemo({ fresh: de });
          me && n.actions.open(me);
        } catch (me) {
          console.error("[boards] could not create the demo board", me), r({ status: "error", message: "The demo board could not be created, please try again" });
        }
    }
    const L = /* @__PURE__ */ U(null), z = /* @__PURE__ */ U(null), { scrollY: $ } = Ib(L), W = /* @__PURE__ */ U(!1), N = /* @__PURE__ */ U(!1), oe = /* @__PURE__ */ U("");
    Pt(() => {
      const de = () => {
        oe.value = 'url("' + Cg() + '")';
      }, me = window.requestIdleCallback;
      me ? me(de, { timeout: 700 }) : window.setTimeout(de, 120);
    });
    function Q() {
      const de = z.value && z.value.$el;
      if (!de) return;
      W.value = de.getBoundingClientRect().top <= n.stickyTop.value + 0.5 && $.value > 4;
      const me = L.value && L.value.querySelector('[data-testid="new-board"]');
      N.value = !!me && me.getBoundingClientRect().bottom <= n.stickyTop.value + de.offsetHeight;
    }
    Pe($, Q);
    const I = K(() => l.settled.value ? l.failed.value && !l.listedRows.value.length ? "failed" : l.listedRows.value.length ? "list" : l.narrowed.value ? "no-match" : "empty" : "loading"), Y = K(() => I.value === "list" && (l.rows.value.length > 0 || l.canBack.value));
    function ge(de) {
      de.key === "Escape" && !i.value && !p.value && !v.value && l.selected.value.size && l.clearSelection();
    }
    return Pt(() => window.addEventListener("keydown", ge)), Je(() => {
      window.removeEventListener("keydown", ge), clearTimeout(s), l.dispose();
    }), (de, me) => (h(), _("div", {
      ref_key: "root",
      ref: L,
      class: fe(["bd-root bl-root", { "has-survey": !!oe.value }]),
      style: xe({ "--bl-sticky-top": g(n).stickyTop.value + "px", "--bl-survey": oe.value || void 0 }),
      "data-testid": "boards-list"
    }, [
      me[5] || (me[5] = Zi('<div class="bl-ambient" aria-hidden="true"><div class="bl-sky"></div><div class="bl-survey"></div><div class="bl-survey is-lamp"></div><div class="bl-grain"></div></div>', 1)),
      u("div", Sg, [
        O(_m, {
          "can-demo": !!g(n).createDemo && g(n).user.value.isAdmin,
          onCreate: D,
          onCreateDemo: k
        }, null, 8, ["can-demo"]),
        O(fg, {
          ref_key: "toolbar",
          ref: z,
          mode: M.value,
          docked: W.value,
          "offer-new": N.value,
          onMode: y,
          onCreate: D
        }, null, 8, ["mode", "docked", "offer-new"]),
        u("main", Ig, [
          O(Yn, {
            name: "bl-swap",
            mode: "out-in"
          }, {
            default: ut(() => [
              I.value === "loading" ? (h(), _("div", Ag, [
                M.value === "grid" ? (h(), we(Rl, {
                  key: 0,
                  skeleton: 8
                })) : (h(), we(Pl, {
                  key: 1,
                  skeleton: 6
                }))
              ])) : I.value === "failed" ? (h(), we(Ys, {
                key: "failed",
                kind: "failed",
                busy: g(l).loading.value,
                onRetry: me[0] || (me[0] = (Fe) => g(l).fetchPage())
              }, null, 8, ["busy"])) : I.value === "no-match" ? (h(), we(Ys, {
                key: "no-match",
                kind: "no-match",
                onClear: me[1] || (me[1] = (Fe) => g(l).clearNarrowing())
              })) : I.value === "empty" ? (h(), we(Ys, {
                key: "empty",
                kind: "empty",
                busy: g(l).creating.value,
                onCreate: D
              }, null, 8, ["busy"])) : M.value === "grid" ? (h(), we(Rl, {
                key: "grid",
                onCreate: D
              })) : (h(), we(Pl, { key: "table" }))
            ]),
            _: 1
          }),
          Y.value ? (h(), we(Tm, { key: 0 })) : ne("", !0),
          O(yh)
        ])
      ]),
      O(N0, {
        rows: i.value,
        bulk: a.value,
        skipped: d.value,
        busy: g(l).deleting.value,
        onCancel: me[2] || (me[2] = (Fe) => i.value = null),
        onConfirm: f
      }, null, 8, ["rows", "bulk", "skipped", "busy"]),
      O(r1, {
        "board-id": p.value,
        onClose: me[3] || (me[3] = (Fe) => p.value = null)
      }, null, 8, ["board-id"]),
      O(T0, {
        request: v.value,
        onClose: me[4] || (me[4] = (Fe) => v.value = null)
      }, null, 8, ["request"]),
      O(pg, { notice: o.value }, null, 8, ["notice"]),
      u("div", {
        ref_key: "overlay",
        ref: C,
        class: "bl-overlays"
      }, null, 512)
    ], 6));
  }
});
function Xo(e) {
  if (e == null) return;
  if (typeof e == "number") return e;
  if (e instanceof Date) return e.getTime();
  const t = e;
  if (typeof t.toMillis == "function") return t.toMillis();
}
const Vl = "CANVAS";
function $g(e) {
  return e === "PRIVATE" || e === "SHARED" || e === "RESTRICTED" ? e : null;
}
function Hl(e, t) {
  var n, o, s;
  const r = {}, l = t.customFields;
  if (l && typeof l == "object")
    for (const [a, d] of Object.entries(l)) d != null && d !== "" && (r[a] = String(d));
  const i = t.canvasPreview && typeof t.canvasPreview == "object" ? t.canvasPreview : null;
  return {
    id: e,
    title: typeof t.title == "string" ? t.title : "",
    description: typeof t.description == "string" ? t.description : "",
    // a personal board has no level of its own, whatever its document says
    accessLevel: t.teamId ? $g(t.accessLevel) || "PRIVATE" : null,
    userId: typeof t.userId == "string" ? t.userId : null,
    teamId: typeof t.teamId == "string" ? t.teamId : null,
    customFields: r,
    createdAt: (n = Xo(t.createdAt)) != null ? n : null,
    deletedAt: (o = Xo(t.deletedAt)) != null ? o : null,
    preview: i && typeof i.url == "string" ? i.url : null,
    previewAt: i && (s = Xo(i.at)) != null ? s : null,
    accessUserIds: t.userIds && typeof t.userIds == "object" ? Object.entries(t.userIds).filter(([, a]) => !!a).map(([a]) => a) : []
  };
}
function zg(e, t, n) {
  const o = /* @__PURE__ */ new Map();
  return {
    async fetchPage(s) {
      let r;
      try {
        r = await t.credentials();
      } catch (i) {
        return console.error("[boards] could not get API credentials", i), { ok: !1, reason: "failed" };
      }
      if (!r) return { ok: !1, reason: "unauthorized" };
      const l = await vu(t.baseUrl, r, s);
      return !l.ok && l.code && t.onRejected && t.onRejected(l.code), l;
    },
    watchBoard(s, r, l) {
      return e.db.collection("runnits").doc(s).onSnapshot(
        (i) => r(i.exists ? Hl(i.id, i.data()) : null),
        (i) => l(i)
      );
    },
    watchBoardMembers(s, r) {
      return e.db.collection("runnits").doc(s).collection("runnitMembers").orderBy("createdAt", "asc").limit(11).onSnapshot(
        (l) => {
          const i = l.docs.map((a) => {
            const d = a.data();
            return { userId: typeof d.userId == "string" ? d.userId : a.id, email: null };
          });
          r(i);
        },
        (l) => {
          console.error("[boards] could not load a board's members", l), r([]);
        }
      );
    },
    teamMemberEmail(s, r) {
      const l = s + "/" + r;
      let i = o.get(l);
      return i || (i = e.db.collection("teams").doc(s).collection("teamMembers").where("userId", "==", r).where("isAccepted", "==", !0).limit(1).get().then((a) => {
        const d = a.docs[0], c = d ? d.data().email : null;
        return typeof c == "string" ? c : null;
      }).catch((a) => (console.error("[boards] could not look up a member", a), o.delete(l), null)), o.set(l, i)), i;
    },
    async searchTeamMembers(s, r) {
      if (!s.teamId) return [];
      const l = await t.credentials();
      return l ? yu(t.baseUrl, l.idToken, { teamId: s.teamId, companyId: s.companyId, q: r }) : [];
    },
    async createBoard({ title: s, teamId: r }) {
      const l = n(), i = {
        createdAt: e.FieldValue.serverTimestamp(),
        deletedAt: null,
        userId: l.uid,
        teamId: r,
        type: Vl,
        // as v1 creates a board: private, owned by its creator
        accessLevel: "PRIVATE",
        title: s,
        description: "",
        avatarId: null,
        avatar: null
      };
      return {
        id: (await e.db.collection("runnits").add(i)).id,
        title: s,
        description: "",
        accessLevel: r ? "PRIVATE" : null,
        userId: l.uid,
        teamId: r,
        customFields: {},
        createdAt: Date.now(),
        deletedAt: null,
        preview: null,
        previewAt: null,
        accessUserIds: []
      };
    },
    async readBoards(s) {
      const r = await Promise.all(s.map((i) => e.db.collection("runnits").doc(i).get())), l = [];
      for (const i of r) {
        if (!i.exists) continue;
        const a = i.data();
        a.deletedAt || a.type !== Vl || l.push(Hl(i.id, a));
      }
      return l;
    },
    async updateBoard(s, r) {
      await e.db.collection("runnits").doc(s).update({
        title: r.title,
        description: r.description,
        ...r.customFields ? { customFields: r.customFields } : {}
      });
    },
    async readBoardMembers(s) {
      return (await e.db.collection("runnits").doc(s).collection("runnitMembers").limit(4e3).get()).docs.map((i) => {
        var a;
        const d = i.data();
        return { userId: typeof d.userId == "string" ? d.userId : i.id, addedAt: (a = Xo(d.createdAt)) != null ? a : null };
      }).sort((i, a) => (i.addedAt || 0) - (a.addedAt || 0));
    },
    async teamMember(s, r) {
      const i = (await e.db.collection("teams").doc(s).collection("teamMembers").where("userId", "==", r).limit(1).get()).docs[0];
      if (!i) return null;
      const a = i.data();
      return {
        userId: r,
        email: typeof a.email == "string" ? a.email : "",
        joined: !!a.acceptedAt,
        inviteCode: typeof a.inviteCode == "string" ? a.inviteCode : null
      };
    },
    async saveAccess(s) {
      const l = await e.functions.httpsCallable("manageRunnitBoardAccessSettings")(s), i = l && l.data;
      if (!i || !i.success) throw new Error(i && i.message || "The access settings were not saved");
    },
    softDelete(s) {
      const r = /* @__PURE__ */ new Date();
      return Promise.all(s.map((l) => e.db.collection("runnits").doc(l).update({ deletedAt: r }).then(
        () => !0,
        (i) => (console.error("[boards] could not delete board", l, i), !1)
      )));
    }
  };
}
const Tg = '.bd-root{--steel-pink-300: #812686;--steel-pink-500: #c750ce;--amethyst-300: #5722a2;--amethyst-400: #7532d3;--amethyst-500: #9968df;--amethyst-600: #ae86e5;--amethyst-700: #c2a4ec;--amethyst-800: #d6c2f2;--vista-blue-300: #1822dc;--vista-blue-400: #5a61ed;--vista-blue-500: #a3a7f5;--vista-blue-600: #b6b9f7;--bg-deep: #04030c;--bg-base: #070910;--bg-raised: #0b0d14;--bg-surface: #121521;--bg-overlay: rgba(4, 3, 12, .86);--hairline: rgba(255, 255, 255, .1);--hairline-soft: rgba(255, 255, 255, .06);--inset-highlight: inset 0 1px 0 rgba(255, 255, 255, .08);--fg-1: #ffffff;--fg-2: rgba(255, 255, 255, .72);--fg-3: rgba(255, 255, 255, .58);--fg-4: rgba(255, 255, 255, .38);--fg-5: rgba(255, 255, 255, .25);--success: #37d399;--warning: #ffb347;--danger: #ff5c7a;--grad-cta: linear-gradient(90deg, var(--amethyst-500) 0%, #8f72ff 50%, var(--vista-blue-400) 100%);--grad-glass: linear-gradient(180deg, rgba(255, 255, 255, .09), rgba(255, 255, 255, .03));--grad-purple-pink: linear-gradient(90deg, var(--steel-pink-500), var(--amethyst-500), var(--vista-blue-500));--shadow-card: 0 18px 60px rgba(5, 8, 20, .28);--shadow-deep: 0 30px 100px rgba(2, 6, 23, .55);--radius-xs: 6px;--radius-sm: 10px;--radius-md: 16px;--radius-lg: 24px;--radius-pill: 999px;--font-sans: "SpaceGrotesk", "Space Grotesk", system-ui, -apple-system, "Segoe UI", sans-serif;--ease-out-soft: cubic-bezier(.16, 1, .3, 1);--dur-fast: .2s;--dur-med: .3s;--dur-slow: .5s}.bd-root,.bd-root *,.bd-root *:before,.bd-root *:after{box-sizing:border-box;background-repeat:repeat}.bd-root{font-family:var(--font-sans);font-size:14px;line-height:normal;color:var(--fg-2);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}.bd-root button,.bd-root input,.bd-root textarea{font-family:var(--font-sans);letter-spacing:inherit}:where(.bd-root) button,:where(.bd-root) input,:where(.bd-root) textarea{margin:0}.bd-root button{-webkit-tap-highlight-color:transparent}.bd-root button:focus{outline:none}.bd-root button:focus-visible{outline:2px solid rgba(163,167,245,.7);outline-offset:2px}.bd-root p{margin:0}', Eg = `.bl-root{--lead: #9968df;--lead-icon: #c2a4ec;--lead-soft: rgba(153, 104, 223, .16);--lead-glow: rgba(153, 104, 223, .24);--glass-fill: rgba(11, 13, 20, .92);--glass-edge: linear-gradient(180deg, rgba(255, 255, 255, .11), rgba(255, 255, 255, .03));--row-h: 60px;--bl-sticky-top: 0px;--bl-top: 44px;position:relative;isolation:isolate;min-height:calc(100vh - var(--bl-sticky-top));padding:0 0 140px;background:var(--bg-deep);color:var(--fg-2);overflow-x:clip}.bl-root ul,.bl-root ol{margin:0;padding:0;list-style:none}.bl-root a{color:inherit;text-decoration:none}.bl-root h1,.bl-root h2,.bl-root h3{margin:0;font-weight:600}.bl-root input::placeholder{color:var(--fg-4);opacity:1}.bl-root [hidden]{display:none!important}.bl-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}.bl-ambient{position:absolute;inset:0;z-index:0;pointer-events:none;overflow:hidden}.bl-sky{position:absolute;inset:0;background:radial-gradient(70% 520px at 50% -140px,rgba(226,230,255,.075),transparent 72%),radial-gradient(120% 900px at 50% -200px,rgba(196,200,232,.035),transparent 70%)}.bl-survey{position:absolute;left:0;right:0;top:0;height:1500px;background-image:var(--bl-survey, none);background-size:3200px 1500px;background-position:50% 0;background-repeat:no-repeat;opacity:0;-webkit-mask-image:linear-gradient(180deg,#000 0,rgba(0,0,0,.75) 38%,rgba(0,0,0,.3) 70%,transparent 100%);mask-image:linear-gradient(180deg,#000 0,rgba(0,0,0,.75) 38%,rgba(0,0,0,.3) 70%,transparent 100%);transform:translate3d(calc(var(--px, 0) * -6px),calc(var(--sy, 0px) * -.1 + var(--py, 0) * -4px),0);transition:opacity 1.4s var(--ease-out-soft);will-change:transform}.bl-root.has-survey .bl-survey{opacity:.1}.bl-survey.is-lamp{-webkit-mask-image:radial-gradient(360px circle at var(--mx, 50%) var(--my, 120px),#000,rgba(0,0,0,.35) 45%,transparent 72%);mask-image:radial-gradient(360px circle at var(--mx, 50%) var(--my, 120px),#000,rgba(0,0,0,.35) 45%,transparent 72%);transform:none;will-change:auto}.bl-root.has-survey .bl-survey.is-lamp{opacity:.34}.bl-grain{position:absolute;inset:0;opacity:.05;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23g)'/%3E%3C/svg%3E");background-size:180px 180px}.bl-wrap{position:relative;z-index:1;max-width:1320px;margin:0 auto;padding:var(--bl-top) 32px 0}.bl-switch{position:relative;display:inline-flex;padding:3px;border-radius:999px;background:#ffffff0a;border:1px solid var(--hairline);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px)}.bl-switch button{position:relative;z-index:1;height:30px;padding:0 14px;border:0;border-radius:999px;background:transparent;color:var(--fg-3);font-size:12.5px;font-weight:600;cursor:pointer;transition:color var(--dur-fast) var(--ease-out-soft)}.bl-switch button:hover{color:var(--fg-1)}.bl-switch button.is-on{color:#fff;cursor:default}.bl-switch-pill{position:absolute;top:3px;bottom:3px;right:3px;border-radius:999px;background:linear-gradient(180deg,#9968df6b,#5a61ed52);border:1px solid rgba(194,164,236,.35);box-shadow:0 6px 20px #745aff40,inset 0 1px #ffffff1f;transition:left var(--dur-med) var(--ease-out-soft),width var(--dur-med) var(--ease-out-soft)}.bl-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:42px;padding:0 20px;border:0;border-radius:13px;background:var(--grad-cta);color:#fff;font-size:13.5px;font-weight:600;cursor:pointer;box-shadow:0 14px 34px var(--lead-glow),inset 0 1px #ffffff38;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft),filter var(--dur-fast);white-space:nowrap}.bl-btn:hover{transform:translateY(-1px);filter:brightness(1.07);box-shadow:0 18px 40px #9968df57,inset 0 1px #ffffff38}.bl-btn:active{transform:translateY(0)}.bl-btn:disabled{opacity:.55;cursor:default;transform:none;filter:none}.bl-btn.is-ghost{background:#ffffff0d;border:1px solid var(--hairline);color:var(--fg-1);box-shadow:none;backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px)}.bl-btn.is-ghost:hover{background:#ffffff17}.bl-btn.is-danger{background:linear-gradient(90deg,#ff5c7a,#e2456a);box-shadow:0 14px 34px #ff5c7a47}.bl-btn.is-sm{height:34px;padding:0 14px;font-size:12.5px;border-radius:11px}.bl-btn-split{display:inline-flex}.bl-btn-split .bl-btn:first-child:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.bl-btn-split .bl-btn+.bl-btn{padding:0 11px;border-top-left-radius:0;border-bottom-left-radius:0;margin-left:1px}.bl-icon-btn{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border:1px solid transparent;border-radius:11px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-icon-btn:hover{background:#ffffff12;color:var(--fg-1)}.bl-icon-btn.is-on{background:#9968df29;color:#fff;border-color:#c2a4ec4d}.bl-icon-btn:disabled{opacity:.4;cursor:default;background:transparent}.bl-toolbar{position:sticky;top:var(--bl-sticky-top);z-index:20;margin:0 -32px;padding:12px 32px;transition:background var(--dur-med) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft),border-color var(--dur-med);border-bottom:1px solid transparent}.bl-toolbar:before{content:"";position:absolute;z-index:-1;top:0;bottom:0;left:calc(50% - 50vw);right:calc(50% - 50vw);opacity:0;background:#060610bd;backdrop-filter:blur(22px) saturate(140%);-webkit-backdrop-filter:blur(22px) saturate(140%);border-bottom:1px solid var(--hairline-soft);box-shadow:0 18px 40px #02040e73;transition:opacity var(--dur-med) var(--ease-out-soft);pointer-events:none}.bl-toolbar.is-docked:before{opacity:1}.bl-toolbar-row{display:flex;flex-wrap:wrap;align-items:center;gap:10px;min-height:44px}.bl-toolbar-tools{display:flex;align-items:center;gap:10px;margin-left:auto}.bl-toolbar-new{max-width:0;margin-left:-10px;overflow:hidden;opacity:0;pointer-events:none;transition:max-width var(--dur-med) var(--ease-out-soft),margin-left var(--dur-med) var(--ease-out-soft),opacity var(--dur-fast)}.bl-toolbar-new>.bl-btn,.bl-toolbar-new>.bl-btn:hover{box-shadow:inset 0 1px #ffffff38;transform:none}.bl-toolbar-new.is-on{max-width:160px;margin-left:0;opacity:1;pointer-events:auto}.bl-toolbar-row .sp{flex:1}.bl-heading{font-size:15px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.bl-heading small{margin-left:8px;font-size:12px;font-weight:500;color:var(--fg-4)}.bl-tabs{position:relative;display:inline-flex;gap:2px;padding:4px;border-radius:14px;background:#ffffff09;border:1px solid var(--hairline-soft)}.bl-tab{position:relative;z-index:1;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 13px;border:0;border-radius:10px;background:transparent;color:var(--fg-3);font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;transition:color var(--dur-fast)}.bl-tab:hover{color:var(--fg-1)}.bl-tab.is-on{color:#fff}.bl-tab .licon{opacity:.85}.bl-tab-ink{position:absolute;top:4px;bottom:4px;border-radius:10px;background:#ffffff14;border:1px solid rgba(255,255,255,.08);box-shadow:inset 0 1px #ffffff14;transition:left var(--dur-med) var(--ease-out-soft),width var(--dur-med) var(--ease-out-soft)}.bl-search{position:relative;display:flex;align-items:center;width:280px;height:40px;padding:0 12px;gap:8px;border-radius:13px;background:#ffffff0a;border:1px solid var(--hairline);transition:border-color var(--dur-fast),background var(--dur-fast),width var(--dur-med) var(--ease-out-soft),box-shadow var(--dur-med)}.bl-search:focus-within{width:340px;background:#ffffff0f;border-color:#c2a4ec73;box-shadow:0 0 0 4px #9968df1f}.bl-search .licon{color:var(--fg-4)}.bl-search input{flex:1;min-width:0;height:100%;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:13px}.bl-search-clear{color:var(--fg-4);cursor:pointer;border:0;background:none;padding:2px;border-radius:6px;display:inline-flex}.bl-search-clear:hover{color:var(--fg-1);background:#ffffff14}.bl-kbd{font-size:10.5px;color:var(--fg-4);padding:2px 6px;border-radius:6px;border:1px solid var(--hairline)}.bl-tool-btn{display:inline-flex;align-items:center;gap:7px;height:40px;padding:0 13px;border-radius:13px;border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-2);font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.bl-tool-btn:hover{background:#ffffff14;color:var(--fg-1)}.bl-tool-btn.is-open,.bl-tool-btn.is-active{border-color:#c2a4ec66;background:#9968df1f;color:#fff}.bl-count{min-width:18px;height:18px;padding:0 5px;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:10.5px;font-weight:700;display:inline-flex;align-items:center;justify-content:center}.bl-seg{position:relative;display:inline-flex;padding:3px;border-radius:13px;background:#ffffff0a;border:1px solid var(--hairline)}.bl-seg button{position:relative;z-index:1;display:inline-flex;align-items:center;justify-content:center;width:34px;height:32px;border:0;border-radius:10px;background:transparent;color:var(--fg-4);cursor:pointer;transition:color var(--dur-fast)}.bl-seg button:hover{color:var(--fg-1)}.bl-seg button.is-on{color:#fff}.bl-seg-pill{position:absolute;top:3px;bottom:3px;width:34px;border-radius:10px;background:#9968df47;border:1px solid rgba(194,164,236,.32);transition:transform var(--dur-med) var(--ease-out-soft)}.bl-chips{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}.bl-chip{display:inline-flex;align-items:center;gap:7px;height:28px;padding:0 6px 0 11px;border-radius:999px;background:#9968df1f;border:1px solid rgba(194,164,236,.28);color:var(--fg-1);font-size:12px;font-weight:500}.bl-chip button{display:inline-flex;border:0;padding:3px;border-radius:999px;background:transparent;color:var(--fg-3);cursor:pointer}.bl-chip button:hover{background:#ffffff1a;color:#fff}.bl-chip-clear{border:0;background:none;color:var(--fg-4);font-size:12px;font-weight:600;cursor:pointer;padding:0 6px}.bl-chip-clear:hover{color:var(--fg-1)}.bl-refresh.is-spinning .licon{animation:bl-spin .9s linear infinite}.bl-float-panel{position:fixed;z-index:300;min-width:220px;padding:6px;border-radius:16px;background:linear-gradient(#0f111cf7,#0f111cf7) padding-box,var(--glass-edge) border-box;border:1px solid transparent;box-shadow:0 30px 80px #02040eb3,inset 0 1px #ffffff0f;transform-origin:top right;animation:bl-pop-in .18s var(--ease-out-soft)}.bl-float-panel.is-up{transform-origin:bottom right}@keyframes bl-pop-in{0%{opacity:0;transform:translateY(-4px) scale(.97)}to{opacity:1;transform:none}}.bl-menu-item{display:flex;align-items:center;gap:11px;width:100%;min-height:38px;padding:7px 11px;border:0;border-radius:11px;background:transparent;color:var(--fg-2);font-size:13px;text-align:left;cursor:pointer}.bl-menu-item:hover,.bl-menu-item:focus-visible{background:#ffffff12;color:#fff;outline:none}.bl-menu-item .licon{color:var(--fg-3)}.bl-menu-item:hover .licon{color:var(--lead-icon)}.bl-menu-item.is-danger,.bl-menu-item.is-danger .licon{color:#ff8aa0}.bl-menu-item.is-danger:hover{background:#ff5c7a1f}.bl-menu-item.is-on{color:#fff}.bl-menu-item .check{margin-left:auto;color:var(--lead-icon)}.bl-menu-item small{display:block;font-size:11px;color:var(--fg-4);margin-top:2px}.bl-menu-sep{height:1px;margin:5px 6px;background:var(--hairline-soft)}.bl-menu-label{padding:8px 11px 4px;font-size:10.5px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.bl-pop{width:340px;padding:16px}.bl-pop h4{margin:0 0 8px;font-size:11px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.bl-pop-section+.bl-pop-section{margin-top:18px}.bl-levels{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.bl-level{height:34px;border-radius:10px;border:1px solid var(--hairline);background:#ffffff08;color:var(--fg-3);font-size:12px;font-weight:600;cursor:pointer;transition:all var(--dur-fast)}.bl-level:hover{color:#fff;background:#ffffff12}.bl-level.is-on{color:#fff;background:#9968df33;border-color:#c2a4ec73}.bl-owner-search{display:flex;align-items:center;gap:8px;height:36px;padding:0 10px;border-radius:10px;border:1px solid var(--hairline);background:#ffffff08}.bl-owner-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:12.5px}.bl-owner-list{max-height:220px;overflow-y:auto;margin-top:8px;padding-right:2px}.bl-owner{display:flex;align-items:center;gap:10px;width:100%;padding:7px 8px;border:0;border-radius:10px;background:transparent;color:var(--fg-2);font-size:12.5px;text-align:left;cursor:pointer}.bl-owner:hover{background:#ffffff0f;color:#fff}.bl-owner .box{width:16px;height:16px;border-radius:5px;border:1.5px solid rgba(255,255,255,.28);display:inline-flex;align-items:center;justify-content:center;flex:none}.bl-owner.is-on .box{background:var(--grad-cta);border-color:transparent;color:#fff}.bl-owner-empty{padding:10px 8px;font-size:12px;color:var(--fg-4)}.bl-pop-foot{display:flex;justify-content:space-between;align-items:center;margin-top:16px;padding-top:12px;border-top:1px solid var(--hairline-soft)}.bl-avatar{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:999px;font-size:9.5px;font-weight:700;color:#fff;flex:none;box-shadow:0 0 0 2px var(--bg-raised)}.bl-avatars{display:inline-flex}.bl-avatars .bl-avatar+.bl-avatar{margin-left:-6px}.bl-avatar.is-more{background:#ffffff1f;color:var(--fg-2)}.bl-access-cell{display:inline-flex;align-items:center;gap:8px;white-space:nowrap;flex:none}.bl-access{display:inline-flex;align-items:center;gap:5px;height:22px;padding:0 8px 0 7px;border-radius:999px;font-size:11px;font-weight:600;border:1px solid transparent;white-space:nowrap}.bl-access.is-private{color:#f0a3f4;background:#c750ce1f;border-color:#c750ce47}.bl-access.is-shared{color:#b6b9f7;background:#5a61ed24;border-color:#5a61ed52}.bl-access.is-restricted{color:#ffcf8a;background:#ffb3471a;border-color:#ffb34747}button.bl-access{cursor:pointer;transition:filter var(--dur-fast),transform var(--dur-fast)}button.bl-access:hover{filter:brightness(1.2);transform:translateY(-1px)}.bl-owner-chip{display:inline-flex;align-items:center;gap:7px;min-width:0;max-width:100%;font-size:12px;color:var(--fg-2);border:0;background:none;padding:0}.bl-owner-chip span.t{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}button.bl-owner-chip{cursor:pointer;border-radius:999px}button.bl-owner-chip:hover span.t{color:#fff;text-decoration:underline;text-decoration-color:#ffffff4d;text-underline-offset:3px}.bl-new-badge{display:inline-flex;align-items:center;height:18px;padding:0 7px;border-radius:999px;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#fff;background:var(--grad-cta);box-shadow:0 4px 14px #745aff59}.bl-deleted-badge{font-size:11px;font-weight:600;color:var(--fg-4)}.bl-body{position:relative;margin-top:10px}.bl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(268px,1fr));gap:22px}.bl-card{position:relative;display:flex;flex-direction:column;min-width:0;border-radius:20px;padding:6px;background:linear-gradient(var(--glass-fill),var(--glass-fill)) padding-box,var(--glass-edge) border-box;border:1px solid transparent;box-shadow:var(--shadow-card),var(--inset-highlight);cursor:pointer;outline:none;transition:transform .42s var(--ease-out-soft),box-shadow .42s var(--ease-out-soft),background .3s,opacity .3s;animation:bl-rise .56s var(--ease-out-soft) both;animation-delay:var(--i-delay, 0ms)}@keyframes bl-rise{0%{opacity:0;transform:translateY(16px) scale(.985)}to{opacity:1;transform:none}}.bl-card:hover,.bl-card:focus-visible{transform:translateY(-5px);background:linear-gradient(var(--glass-fill),var(--glass-fill)) padding-box,linear-gradient(160deg,#c2a4ec8c,#5a61ed2e 55%,#ffffff0a) border-box;box-shadow:0 30px 80px #03061499,0 0 44px #9968df29,var(--inset-highlight)}.bl-card.is-selected{background:linear-gradient(#161228f0,#161228f0) padding-box,linear-gradient(160deg,#c2a4ecd9,#5a61ed80) border-box}.bl-card.is-removed{opacity:.4;cursor:default;pointer-events:none;transform:none}.bl-cover{position:relative;aspect-ratio:16 / 10;border-radius:15px;overflow:hidden;background:#0a0b14;isolation:isolate}.bl-cover-img{position:absolute;inset:-8px;background-size:cover;background-position:center;transform:translate3d(calc(var(--cx, 0) * -6px),calc(var(--cy, 0) * -6px),0) scale(1);transition:transform .7s var(--ease-out-soft),opacity .5s var(--ease-out-soft)}.bl-card:hover .bl-cover-img{transform:translate3d(calc(var(--cx, 0) * -6px),calc(var(--cy, 0) * -6px),0) scale(1.045)}.bl-cover-img.is-loading{opacity:0}.bl-cover:after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,#04030c00 55%,#04030c80);pointer-events:none}.bl-cover-sheen{position:absolute;inset:0;z-index:1;background:radial-gradient(420px circle at calc(50% + var(--cx, 0) * 50%) calc(50% + var(--cy, 0) * 50%),rgba(255,255,255,.12),transparent 45%);opacity:0;transition:opacity .4s var(--ease-out-soft);pointer-events:none}.bl-card:hover .bl-cover-sheen{opacity:1}.bl-placeholder{position:absolute;inset:0}.bl-placeholder-dots{position:absolute;inset:0;background-image:radial-gradient(rgba(255,255,255,.09) 1px,transparent 1.3px);background-size:14px 14px}.bl-placeholder i{position:absolute;border-radius:7px;border:1px solid rgba(255,255,255,.1);transition:transform .7s var(--ease-out-soft)}.bl-card:hover .bl-placeholder i{transform:translate3d(calc(var(--cx, 0) * -5px),calc(var(--cy, 0) * -5px),0)}.bl-open{position:absolute;right:12px;bottom:12px;z-index:2;display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 12px;border-radius:999px;background:#0808129e;border:1px solid rgba(255,255,255,.16);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);color:#fff;font-size:12px;font-weight:600;opacity:0;transform:translateY(6px);transition:opacity .26s var(--ease-out-soft),transform .36s var(--ease-out-soft)}.bl-card:hover .bl-open,.bl-card:focus-visible .bl-open{opacity:1;transform:none}.bl-check{position:absolute;top:16px;left:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:9px;border:1.5px solid rgba(255,255,255,.55);background:#08081273;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:transparent;cursor:pointer;opacity:0;transform:scale(.9);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast),border-color var(--dur-fast)}.bl-card:hover .bl-check,.bl-grid.is-selecting .bl-check,.bl-check:focus-visible{opacity:1;transform:none}.bl-check.is-on{opacity:1;transform:none;background:var(--grad-cta);border-color:transparent;color:#fff;box-shadow:0 6px 18px #745aff73}.bl-card-menu{position:absolute;top:14px;right:14px;z-index:3;opacity:0;transition:opacity var(--dur-fast)}.bl-card:hover .bl-card-menu,.bl-card-menu.is-open,.bl-card:focus-within .bl-card-menu{opacity:1}.bl-card-menu .bl-icon-btn{background:#0808128c;border-color:#ffffff24;color:#fff;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}.bl-card-menu .bl-icon-btn:hover{background:#080812cc}.bl-card-body{padding:13px 10px 9px;min-width:0}.bl-card-title{display:flex;align-items:center;gap:8px;font-size:15px;font-weight:600;letter-spacing:-.01em;color:#fff;min-width:0}.bl-card-title span.t{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bl-card-desc{margin-top:4px;font-size:12.5px;color:var(--fg-4);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-height:18px}.bl-card-meta{display:flex;align-items:center;gap:10px;margin-top:12px;min-width:0;font-size:12px;color:var(--fg-4)}.bl-card-meta .sp{flex:1;min-width:6px}.bl-card-meta .bl-owner-chip{flex:0 1 auto}.bl-card-fields{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}.bl-tag{display:inline-flex;align-items:center;gap:5px;max-width:100%;height:22px;padding:0 8px;border-radius:8px;background:#ffffff0d;border:1px solid var(--hairline-soft);font-size:11px;color:var(--fg-3);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.bl-tag b{font-weight:600;color:var(--fg-4)}.bl-new-card{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;min-height:100%;border-radius:20px;border:1.5px dashed rgba(255,255,255,.12);background:#ffffff04;color:var(--fg-3);font-size:14px;font-weight:600;cursor:pointer;transition:border-color var(--dur-med),background var(--dur-med),color var(--dur-med),transform var(--dur-med) var(--ease-out-soft);animation:bl-rise .56s var(--ease-out-soft) both}.bl-new-card:hover{border-color:#c2a4ec80;background:#9968df0f;color:#fff;transform:translateY(-3px)}.bl-new-card .plus{width:52px;height:52px;border-radius:17px;display:flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:0 14px 34px #745aff66;transition:transform var(--dur-med) var(--ease-out-soft)}.bl-new-card:hover .plus{transform:rotate(90deg) scale(1.05)}.bl-skel{position:relative;overflow:hidden;background:#ffffff0a;border-radius:10px}.bl-skel:after{content:"";position:absolute;inset:0;transform:translate(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.06),transparent);animation:bl-shimmer 1.4s ease-in-out infinite}@keyframes bl-shimmer{to{transform:translate(100%)}}.bl-card.is-skeleton{cursor:default;animation:none}.bl-card.is-skeleton:hover{transform:none;box-shadow:var(--shadow-card),var(--inset-highlight);background:linear-gradient(var(--glass-fill),var(--glass-fill)) padding-box,var(--glass-edge) border-box}.bl-table-wrap{border-radius:22px;padding:6px;background:linear-gradient(var(--glass-fill),var(--glass-fill)) padding-box,var(--glass-edge) border-box;border:1px solid transparent;box-shadow:var(--shadow-card),var(--inset-highlight);overflow-x:auto;animation:bl-rise .48s var(--ease-out-soft) both}.bl-table{width:100%;border-collapse:separate;border-spacing:0;font-size:13px;--cell-bg: #0b0d14}.bl-table tr{--cell-bg: #0b0d14}.bl-table td,.bl-table th{background:var(--cell-bg)}.bl-table .sticky-l{position:sticky;left:0;z-index:2}.bl-table .sticky-n{position:sticky;left:52px;z-index:2}.bl-table .sticky-r{position:sticky;right:0;z-index:2}.bl-table th.sticky-l,.bl-table th.sticky-n,.bl-table th.sticky-r{z-index:3}.bl-table .sticky-n,.bl-table .sticky-r{transition:box-shadow var(--dur-med) var(--ease-out-soft)}.bl-table-wrap.is-scrolled .sticky-n{box-shadow:14px 0 18px -14px #000000e6}.bl-table-wrap.has-more .sticky-r{box-shadow:-14px 0 18px -14px #000000e6}.bl-table td.desc .bl-cell-copy{max-width:200px}.bl-table td.cf .bl-cell-copy{max-width:130px}.bl-table td.owner .bl-owner-chip{max-width:140px}.bl-table .bl-name{max-width:250px}.bl-table th{position:sticky;top:0;height:44px;padding:0 8px;text-align:left;font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap;border-bottom:1px solid var(--hairline-soft);background:#0b0d14fa}.bl-table th:first-child{border-top-left-radius:16px}.bl-table th:last-child{border-top-right-radius:16px}.bl-root .bl-th-sort{text-transform:uppercase;letter-spacing:.1em}.bl-th-sort{display:inline-flex;align-items:center;gap:5px;border:0;background:none;padding:4px 6px;margin-left:-6px;border-radius:8px;color:inherit;font:inherit;letter-spacing:inherit;text-transform:inherit;cursor:pointer}.bl-th-sort:hover{color:var(--fg-1);background:#ffffff0d}.bl-th-sort.is-on{color:var(--lead-icon)}.bl-th-sort .licon{opacity:.4;transition:opacity var(--dur-fast),transform var(--dur-med) var(--ease-out-soft)}.bl-th-sort:hover .licon,.bl-th-sort.is-on .licon{opacity:1}.bl-table td{height:var(--row-h);padding:0 8px;color:var(--fg-2);border-bottom:1px solid rgba(255,255,255,.04);vertical-align:middle;max-width:320px}.bl-table tbody tr{position:relative;cursor:pointer;transition:background var(--dur-fast);animation:bl-row-in .42s var(--ease-out-soft) both;animation-delay:var(--i-delay, 0ms)}@keyframes bl-row-in{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.bl-table tbody tr:last-child td{border-bottom:0}.bl-table tbody tr:hover{--cell-bg: #10121c}.bl-table tbody tr:hover td:first-child{box-shadow:inset 2px 0 0 var(--lead)}.bl-table tbody tr.is-selected{--cell-bg: #151228}.bl-table tbody tr.is-selected:hover{--cell-bg: #19152f}.bl-table tbody tr.is-removed{opacity:.42;pointer-events:none;cursor:default}.bl-table td.check,.bl-table th.check{width:52px;padding:0 6px 0 16px}.bl-table td.menu,.bl-table th.menu{width:56px;text-align:right;padding-right:14px}.bl-name{display:flex;align-items:center;gap:12px;min-width:0}.bl-thumb{position:relative;width:54px;height:36px;flex:none;border-radius:9px;overflow:hidden;background:#0a0b14;border:1px solid var(--hairline-soft);background-size:cover;background-position:center}.bl-name .t{font-weight:600;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bl-cell-copy{display:flex;align-items:center;gap:4px;min-width:0}.bl-cell-copy span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--fg-3)}.bl-copy{opacity:0;flex:none}tr:hover .bl-copy{opacity:1}.bl-copy.is-done{opacity:1;color:var(--success)}.bl-box{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:6px;border:1.5px solid rgba(255,255,255,.3);background:transparent;color:transparent;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast);padding:0}.bl-box:hover{border-color:#fff9}.bl-box.is-on,.bl-box.is-some{background:var(--grad-cta);border-color:transparent;color:#fff}.bl-muted{color:var(--fg-4)}.bl-pager{display:flex;align-items:center;justify-content:flex-end;gap:14px;margin-top:22px;font-size:12.5px;color:var(--fg-4)}.bl-pager .bl-pages{display:inline-flex;gap:6px}.bl-size{display:inline-flex;align-items:center;gap:4px}.bl-size button{height:28px;min-width:34px;padding:0 8px;border-radius:9px;border:1px solid transparent;background:transparent;color:var(--fg-4);font-size:12px;font-weight:600;cursor:pointer}.bl-size button:hover{color:var(--fg-1)}.bl-size button.is-on{color:#fff;border-color:var(--hairline);background:#ffffff0d}.bl-bulk-dock{position:sticky;bottom:26px;z-index:30;display:flex;justify-content:center;pointer-events:none;margin-top:26px}.bl-bulk{display:flex;align-items:center;gap:6px;padding:7px 7px 7px 16px;border-radius:18px;background:linear-gradient(#100f1ef0,#100f1ef0) padding-box,linear-gradient(160deg,#c2a4ec8c,#5a61ed40) border-box;border:1px solid transparent;box-shadow:0 26px 70px #02040ebf,0 0 40px #9968df2e;backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);pointer-events:auto}.bl-bulk-count{display:inline-flex;align-items:center;gap:9px;margin-right:8px;font-size:13px;font-weight:600;color:#fff;white-space:nowrap}.bl-bulk .bl-tool-btn{height:36px;border-color:transparent;background:transparent}.bl-bulk .bl-tool-btn:hover{background:#ffffff14}.bl-bulk .bl-tool-btn.is-danger{color:#ff8aa0}.bl-bulk .bl-tool-btn.is-danger:hover{background:#ff5c7a24}.bl-bulk-sep{width:1px;height:22px;background:var(--hairline);margin:0 2px}.bl-bulk-enter-active,.bl-bulk-leave-active{transition:opacity .26s var(--ease-out-soft),transform .42s var(--ease-out-soft)}.bl-bulk-enter-from,.bl-bulk-leave-to{opacity:0;transform:translateY(24px) scale(.98)}.bl-empty{display:flex;flex-direction:column;align-items:center;text-align:center;padding:70px 24px 80px;border-radius:24px;border:1px dashed rgba(255,255,255,.1);background:#ffffff04;animation:bl-rise .52s var(--ease-out-soft) both}.bl-empty h3{font-size:22px;letter-spacing:-.02em;color:#fff}.bl-empty p{margin-top:8px!important;max-width:44ch;font-size:14px;line-height:1.55;color:var(--fg-3)}.bl-empty .bl-btn{margin-top:22px}.bl-empty-art{position:relative;width:260px;height:150px;margin-bottom:26px;perspective:900px}.bl-empty-art>div{position:absolute;inset:0;transform:rotateX(18deg) rotate(-6deg);transform-style:preserve-3d}.bl-empty-art i{position:absolute;border-radius:12px;background:linear-gradient(#10121ee6,#10121ee6) padding-box,linear-gradient(160deg,#c2a4ec80,#5a61ed1a) border-box;border:1px solid transparent;box-shadow:0 20px 50px #02061799}.bl-scrim{position:fixed;inset:0;z-index:400;display:flex;align-items:center;justify-content:center;padding:24px;background:#03030a9e;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}.bl-dialog{width:440px;max-width:100%;padding:26px;border-radius:24px;background:linear-gradient(#0e0f1afa,#0e0f1afa) padding-box,var(--glass-edge) border-box;border:1px solid transparent;box-shadow:0 40px 120px #01020acc,inset 0 1px #ffffff12}.bl-dialog-icon{width:46px;height:46px;border-radius:15px;display:flex;align-items:center;justify-content:center;background:#ff5c7a1f;border:1px solid rgba(255,92,122,.3);color:#ff8aa0;margin-bottom:16px}.bl-dialog h3{font-size:19px;letter-spacing:-.02em;color:#fff}.bl-dialog p{margin-top:8px!important;font-size:13.5px;line-height:1.6;color:var(--fg-3)}.bl-dialog p strong{color:var(--fg-1)}.bl-dialog-actions{display:flex;justify-content:flex-end;gap:10px;margin-top:24px}.bl-field{margin-top:18px}.bl-field label{display:block;margin-bottom:7px;font-size:12px;color:var(--fg-3)}.bl-field input{width:100%;height:42px;padding:0 13px;border-radius:12px;border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-1);font-size:14px;outline:none;transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.bl-field input:focus{border-color:#ff5c7a8c;box-shadow:0 0 0 4px #ff5c7a1f}.bl-fade-enter-active,.bl-fade-leave-active{transition:opacity .22s var(--ease-out-soft)}.bl-fade-enter-active .bl-dialog,.bl-fade-leave-active .bl-dialog{transition:transform .32s var(--ease-out-soft),opacity .22s}.bl-fade-enter-from,.bl-fade-leave-to{opacity:0}.bl-fade-enter-from .bl-dialog,.bl-fade-leave-to .bl-dialog{transform:translateY(14px) scale(.97);opacity:0}.bl-dialog.is-form{width:520px}.bl-dialog.is-access{width:660px}.bl-dialog.is-access.is-bulk{width:780px}.bl-dialog.is-form,.bl-dialog.is-access{display:flex;flex-direction:column;max-height:calc(100vh - 48px)}.bl-dialog-head{display:flex;align-items:flex-start;gap:14px}.bl-dialog-head .bl-dialog-icon{flex:none;margin-bottom:0}.bl-dialog-head p{margin-top:4px!important}.bl-dialog-icon.is-accent{background:#9968df24;border-color:#c2a4ec52;color:var(--lead-icon)}.bl-dialog-body{flex:1;min-height:0;overflow-y:auto;margin:0 -26px;padding:0 26px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.bl-dialog-loading{display:flex;justify-content:center;padding:44px 0 24px;color:var(--fg-4)}.bl-spin{animation:bl-spin .9s linear infinite}@keyframes bl-spin{to{transform:rotate(360deg)}}.bl-field.is-form{margin-top:16px}.bl-field.is-form input,.bl-field.is-form textarea{width:100%;padding:0 13px;border-radius:12px;border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-1);font-family:inherit;font-size:14px;outline:none;transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.bl-field.is-form textarea{display:block;min-height:88px;padding:11px 13px;line-height:1.5;resize:vertical}.bl-field.is-form input:focus,.bl-field.is-form textarea:focus{border-color:#c2a4ec8c;box-shadow:0 0 0 4px #9968df24}.bl-field.is-form [aria-invalid=true]{border-color:#ff5c7a8c}.bl-field-foot{display:flex;justify-content:space-between;gap:12px;min-height:16px;margin-top:5px;font-size:11px;color:var(--fg-5);font-variant-numeric:tabular-nums}.bl-field-error{color:#ff8aa0}.bl-acc-section{margin-top:22px}.bl-acc-label{margin-bottom:10px;font-size:10.5px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.bl-acc-hint{margin:6px 0 0!important;font-size:12px!important;color:var(--fg-4)!important}.bl-acc-owner{display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:16px;border:1px solid var(--hairline);background:#ffffff08}.bl-acc-owner .who{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.bl-acc-owner .name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;font-weight:600;color:var(--fg-1)}.bl-acc-owner .cap{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px;color:var(--fg-4)}.bl-avatar.is-lg{width:36px;height:36px;font-size:13px}.bl-acc-levels{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px}.bl-acc-level{--tone: 194, 164, 236;position:relative;display:flex;flex-direction:column;align-items:flex-start;gap:6px;padding:14px;border-radius:16px;border:1px solid var(--hairline);background:#ffffff08;color:var(--fg-2);font-family:inherit;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.bl-acc-level.is-private{--tone: 240, 163, 244}.bl-acc-level.is-restricted{--tone: 255, 207, 138}.bl-acc-level.is-shared{--tone: 182, 185, 247}.bl-acc-level.is-keep{--tone: 200, 203, 220}.bl-acc-level:hover:not(:disabled){background:#ffffff0f;transform:translateY(-1px)}.bl-acc-level.is-on{border-color:rgba(var(--tone),.6);background:rgba(var(--tone),.09);box-shadow:0 0 0 3px rgba(var(--tone),.12),0 14px 34px #02040e59}.bl-acc-level:disabled{opacity:.42;cursor:default}.bl-acc-level .ic{width:30px;height:30px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:rgba(var(--tone),.14);color:rgb(var(--tone))}.bl-acc-level .t{font-size:13.5px;font-weight:600;color:var(--fg-1)}.bl-acc-level .d{font-size:12px;line-height:1.45;color:var(--fg-4)}.bl-acc-level .ok{position:absolute;top:12px;right:12px;width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:rgb(var(--tone));color:#12101c}.bl-acc-section-head{display:flex;align-items:center;gap:8px;margin-bottom:10px}.bl-acc-section-head>div:first-child{flex:1;min-width:0}.bl-acc-members,.bl-acc-boards{max-height:300px;overflow-y:auto;border-radius:16px;border:1px solid var(--hairline-soft);background:#ffffff05;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.bl-acc-member{display:grid;grid-template-columns:22px 28px minmax(0,1fr) auto 34px;align-items:center;gap:10px;min-height:52px;padding:6px 10px 6px 14px}.bl-acc-member+.bl-acc-member,.bl-acc-board+.bl-acc-board{border-top:1px solid var(--hairline-soft)}.bl-acc-member .em{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:13px;color:var(--fg-1)}.bl-acc-member .st{display:inline-flex;align-items:center;gap:4px;white-space:nowrap;font-size:12px;color:var(--fg-4)}.bl-acc-member .bl-box{width:20px;height:20px}.bl-box-gap{width:20px}.bl-acc-tag{justify-self:end;padding-right:6px;font-size:11.5px;font-style:italic;color:var(--fg-4)}.bl-acc-empty{display:flex;align-items:center;justify-content:center;gap:8px;padding:24px;font-size:13px;color:var(--fg-4)}.bl-acc-board{display:flex;align-items:center;gap:12px;min-height:46px;padding:8px 14px;font-size:13px}.bl-acc-board .nm{flex:1.3;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--fg-1);font-weight:500}.bl-acc-board .ow{flex:1.7;min-width:0;display:flex;align-items:center;gap:6px;overflow:hidden;white-space:nowrap;color:var(--fg-3)}.bl-acc-board .ow>span{overflow:hidden;text-overflow:ellipsis}.bl-acc-board .lv{flex:none;width:116px}.bl-acc-board .sv{flex:none;width:18px;display:inline-flex;color:var(--fg-4)}.bl-acc-board .sv[data-status=ok]{color:#6ee7b7}.bl-acc-board .sv[data-status=failed]{color:#ff8aa0}.bl-acc-board.is-skipped .nm,.bl-acc-board.is-skipped .ow{opacity:.5}.bl-float-panel.is-over-dialog{z-index:410}.bl-pop.bl-picker{width:330px}.bl-picker-email{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bl-picker-check{color:var(--lead-icon)}@media(max-width:640px){.bl-acc-member{grid-template-columns:22px 28px minmax(0,1fr) 34px}.bl-acc-member .st,.bl-acc-board .ow{display:none}}.bl-toast{position:fixed;left:50%;bottom:28px;z-index:500;display:flex;align-items:center;gap:10px;max-width:min(560px,calc(100vw - 32px));padding:12px 16px;border-radius:14px;transform:translate(-50%);background:#10101ef5;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040eb3;color:var(--fg-1);font-size:13px}.bl-toast.is-error .licon{color:#ff8aa0}.bl-toast.is-success .licon{color:var(--success)}.bl-toast-enter-active,.bl-toast-leave-active{transition:opacity .24s var(--ease-out-soft),transform .36s var(--ease-out-soft)}.bl-toast-enter-from,.bl-toast-leave-to{opacity:0;transform:translate(-50%,12px)}.bl-swap-enter-active,.bl-swap-leave-active{transition:opacity .22s var(--ease-out-soft),transform .32s var(--ease-out-soft)}.bl-swap-enter-from{opacity:0;transform:translateY(10px)}.bl-swap-leave-to{opacity:0;transform:translateY(-6px)}@media(max-width:1240px){.bl-sort-label{display:none}.bl-search{width:220px}.bl-search:focus-within{width:260px}}@media(max-width:900px){.bl-root{--bl-top: 20px}.bl-wrap{padding:var(--bl-top) 16px 0}.bl-toolbar{margin:0 -16px;padding:10px 16px}.bl-tabs{order:-1;width:100%;overflow-x:auto;scrollbar-width:none}.bl-heading{width:100%}.bl-search,.bl-search:focus-within{flex:1 1 100%;width:auto}.bl-toolbar-tools{margin-left:0;width:100%;flex-wrap:wrap}.bl-grid{grid-template-columns:1fr;gap:16px}.bl-new-card{display:none}.bl-pager,.bl-bulk{flex-wrap:wrap;justify-content:center}}@media(prefers-reduced-motion:reduce){.bl-root *,.bl-root *:before,.bl-root *:after{animation-duration:1ms!important;animation-iteration-count:1!important;transition-duration:1ms!important}.bl-survey,.bl-cover-img{transform:none!important}}`, Lg = '.bl-hero{--stage-w: min(80%, 940px);position:relative;display:flex;flex-direction:column;align-items:center;margin:0 0 44px;border-radius:28px;background:var(--bg-deep);border:1px solid transparent;box-shadow:0 40px 120px #00000073;text-align:center}.bl-hero:before{content:"";position:absolute;inset:-1px;z-index:1;padding:1px;border-radius:inherit;background:linear-gradient(180deg,#d6c8f24d,#ffffff17 34%,#ffffff0d 70%,#ffffff12);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0);pointer-events:none}.bl-hero-clip{position:absolute;inset:0;border-radius:inherit;overflow:hidden;container-type:inline-size;pointer-events:none}.bl-hero-atmo{position:absolute;inset:0;background:radial-gradient(64% 44% at 50% -10%,rgba(255,255,255,.05),transparent 66%)}.bl-hero-light{position:absolute;inset:0}.bl-hero-lit{position:absolute;inset:0;-webkit-mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);-webkit-mask-size:3200px 1500px,100% 100%;-webkit-mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;-webkit-mask-repeat:no-repeat,no-repeat;-webkit-mask-composite:source-in;mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);mask-size:3200px 1500px,100% 100%;mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;mask-repeat:no-repeat,no-repeat;mask-composite:intersect}.bl-hero .glow{position:absolute;aspect-ratio:1;border-radius:50%;animation:bl-glow-drift calc(26s + var(--i) * 4.3s) ease-in-out calc(var(--i) * -5.1s) infinite alternate,bl-glow-breathe calc(12s + var(--i) * 2.2s) ease-in-out calc(var(--i) * -3.7s) infinite;animation-play-state:paused}.bl-hero-light .glow{filter:blur(40px)}.bl-hero.is-live .glow{animation-play-state:running}@keyframes bl-glow-drift{0%{transform:translate(0) scale(1)}50%{transform:translate(1.5cqw,9cqw) scale(1.08)}to{transform:translate(-1cqw,-5cqw) scale(.95)}}@keyframes bl-glow-breathe{0%,to{opacity:.6}50%{opacity:1}}.bl-hero-stage{position:absolute;left:50%;bottom:0;width:var(--stage-w);aspect-ratio:1180 / 540;transform:translate(-50%)}.bl-hero-stage:before{content:"";position:absolute;left:6%;right:6%;top:-14%;height:50%;border-radius:50%;background:radial-gradient(50% 50% at 50% 50%,rgba(170,160,225,.13),rgba(150,156,230,.04) 55%,transparent 75%);filter:blur(40px)}.bl-hero-room{flex:none;width:var(--stage-w);aspect-ratio:1180 / 540;margin-top:34px}.bl-hero-top{position:absolute;left:18px;top:18px;z-index:4;display:flex;text-align:left}.bl-hero-copy{position:relative;z-index:2;max-width:880px;padding:50px 24px 0}.bl-title{font-size:clamp(36px,4vw,54px);line-height:1.03;letter-spacing:-.045em;font-weight:500!important;color:#fff;background:linear-gradient(180deg,#fff 35%,#ffffffbd);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-title em{font-style:normal;background:linear-gradient(100deg,#efe6ff 0%,var(--amethyst-700) 48%,var(--vista-blue-500) 100%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-sub{max-width:820px;margin:14px auto 0!important;font-size:15.5px;line-height:1.55;color:#ffffff8f;text-wrap:balance}.bl-hero-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:12px;margin-top:24px}.bl-hero-pause{position:absolute;right:16px;bottom:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:#12121a9e;color:#ffffffc7;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-pause:hover{background:#282836cc;color:#fff;border-color:#fff3}.bl-hero-pause:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-corner{position:absolute;right:18px;top:18px;z-index:4;display:flex;align-items:center;gap:8px}.bl-hero-tour{display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 13px 0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;font:500 12.5px var(--font-sans);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-tour .licon{color:var(--amethyst-700)}.bl-hero-tour:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-tour:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-round{display:inline-flex;flex:none;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-round:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-round:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero.is-min{flex-direction:row;align-items:stretch;margin:0 0 26px;border-radius:0;background:none;border-color:transparent;box-shadow:none;text-align:left}.bl-hero.is-min:before{display:none}.bl-hero.is-min .bl-hero-copy{display:flex;flex:1;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:18px 32px;max-width:none;padding:8px 0 0;animation:bl-head-in .3s var(--ease-out-soft)}.bl-hero.is-min .bl-hero-text{flex:1 1 360px;min-width:0}.bl-hero.is-min .bl-title{font-size:clamp(28px,2.4vw,34px);letter-spacing:-.04em}.bl-hero.is-min .bl-sub{max-width:560px;margin:8px 0 0!important;font-size:14px;text-wrap:pretty}.bl-hero.is-min .bl-hero-actions{flex:none;justify-content:flex-end;gap:10px;margin-top:0}.bl-hero.is-min .bl-hero-tour{height:38px;padding:0 14px 0 12px}.bl-hero.is-min .bl-hero-round{width:38px;height:38px}@keyframes bl-head-in{0%{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.bl-hd{position:absolute;inset:0;pointer-events:none}.bl-hd-win{position:absolute;left:0;top:0;transform-origin:0 0;border-radius:16px;overflow:hidden;background:#070910;box-shadow:0 0 0 1px #ffffff1f,0 -8px 40px #00000080,0 50px 140px #000000e6;font-family:var(--font-sans);color:var(--fg-2);text-align:left;user-select:none;-webkit-user-select:none;contain:layout paint}.bl-hd-win:after{content:"";position:absolute;inset:0;z-index:9;border-radius:inherit;box-shadow:inset 0 1px #ffffff1a;pointer-events:none}.bl-hd img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .6s var(--ease-out-soft)}.bl-hd img.is-in{opacity:1}.bl-hd img.is-broken{visibility:hidden}.bl-hd-bar{position:absolute;left:0;right:0;top:0;z-index:3;display:flex;align-items:center;gap:12px;height:44px;padding:0 16px;background:linear-gradient(180deg,#10121b,#0b0d14);border-bottom:1px solid rgba(255,255,255,.06)}.bl-hd-lights{display:inline-flex;gap:8px;margin-right:12px}.bl-hd-lights i{width:12px;height:12px;border-radius:50%;background:#ff5f57;box-shadow:inset 0 0 0 .5px #0000004d}.bl-hd-lights i:nth-child(2){background:#febc2e}.bl-hd-lights i:nth-child(3){background:#28c840}.bl-hd-mark{flex:none}.bl-hd-crumbs{font-size:13px;color:var(--fg-4);letter-spacing:-.005em;white-space:nowrap}.bl-hd-crumbs .sep{margin:0 5px;color:var(--fg-5)}.bl-hd-crumbs b{color:var(--fg-1);font-weight:600}.bl-hd-saved{margin-left:auto;display:inline-flex;align-items:center;gap:6px;font-size:11.5px;color:var(--fg-4)}.bl-hd-saved i{width:6px;height:6px;border-radius:50%;background:#ffffff47}.bl-hd-kebab{display:inline-flex;flex-direction:column;gap:2.5px;padding:0 8px 0 14px}.bl-hd-kebab i{width:3px;height:3px;border-radius:50%;background:var(--fg-4)}.bl-hd-canvas{position:absolute;inset:44px 0 0;overflow:hidden;background:radial-gradient(55% 75% at 16% 0%,rgba(117,50,211,.17),transparent 70%),radial-gradient(45% 60% at 90% 10%,rgba(90,97,237,.1),transparent 70%),#070910}.bl-hd-world{position:absolute;left:0;top:0;width:0;height:0;transform-origin:0 0}.bl-hd-dots{position:absolute;left:-900px;top:-800px;width:5600px;height:3400px}.bl-hd-dots.is-fine{background-image:radial-gradient(circle,rgba(255,255,255,.14) 1.2px,transparent 1.7px);background-size:26px 26px;opacity:clamp(0,calc((var(--z, 1) - .4) * 4),1)}.bl-hd-dots.is-coarse{background-image:radial-gradient(circle,rgba(255,255,255,.12) 3.4px,transparent 4.6px);background-size:104px 104px;opacity:clamp(0,calc((.66 - var(--z, 1)) * 4),1)}.bl-hd-frame{position:absolute;border-radius:22px;background:#ffffff06;border:1.5px solid rgba(255,255,255,.065)}.bl-hd-ftitle{position:absolute;left:4px;bottom:calc(100% + 10px);white-space:nowrap;font-size:11.5px;font-weight:600;letter-spacing:.26em;text-transform:uppercase;color:#ffffff94;opacity:clamp(0,calc((var(--z, 1) - .42) * 5),1)}.bl-hd-ftitle small{margin-left:8px;font-size:11.5px;font-weight:500;letter-spacing:.02em;text-transform:none;color:#ffffff4d}.bl-hd-flabel{position:absolute;left:0;bottom:100%;transform-origin:0 100%;transform:scale(var(--iz, 1)) translateY(-6px);white-space:nowrap;padding:3px 7px;border-radius:6px;background:#0c0e16eb;border:1px solid rgba(255,255,255,.1);font-size:8.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#ffffffb8;opacity:clamp(0,calc((.5 - var(--z, 1)) * 5),1)}.bl-hd-pic{position:absolute;border-radius:9px;overflow:hidden;background:#ffffff0b;box-shadow:0 14px 40px #02040c73,inset 0 0 0 1px #ffffff0d}.bl-hd-pic.is-result{opacity:0}.bl-hd-pic.is-video img{animation:bl-hd-drift 9s ease-in-out infinite alternate;animation-play-state:paused}.bl-hero.is-live .bl-hd-pic.is-video img{animation-play-state:running}@keyframes bl-hd-drift{0%{transform:scale(1)}to{transform:scale(1.09) translate(-2%,-1.5%)}}.bl-hd-play,.bl-hd-heart{position:absolute;left:9px;top:9px;display:flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#080a129e;box-shadow:inset 0 0 0 1px #ffffff2e;color:#fff}.bl-hd-play .licon svg{fill:currentColor}.bl-hd-heart{color:#ff6b8b;opacity:0}.bl-hd-heart .licon svg{fill:currentColor}.bl-hd-session{position:absolute;border-radius:16px;padding:14px;background:linear-gradient(180deg,#ffffff13,#ffffff08),#0c0e17;border:1px solid rgba(255,255,255,.1);box-shadow:inset 0 1px #ffffff14,0 18px 60px #05081459}.bl-hd-session-head{display:flex;align-items:center;gap:10px}.bl-hd-badge{display:flex;flex:none;align-items:center;justify-content:center;width:36px;height:36px;border-radius:12px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;color:var(--amethyst-700)}.bl-hd-session-titles{display:flex;flex:1;flex-direction:column;min-width:0}.bl-hd-session-titles .kind{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;overflow:hidden}.bl-hd-session-titles .sep{margin:0 6px;color:var(--fg-5);letter-spacing:0}.bl-hd-session-titles .model{font-size:10px;font-weight:500;text-transform:none;letter-spacing:.01em;color:var(--fg-5)}.bl-hd-session-titles .name{margin-top:1px;font-size:14.5px;font-weight:600;color:#fff;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bl-hd-count{flex:none;padding:3px 9px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:11px;font-weight:600;color:var(--fg-3)}.bl-hd-thumbs{display:flex;gap:6px;margin-top:12px}.bl-hd-thumb{position:relative;flex:1;aspect-ratio:1;border-radius:8px;overflow:hidden;border:1px solid rgba(255,255,255,.07);background:#ffffff0a}.bl-hd-thumb.is-empty{border:1px dashed rgba(255,255,255,.1);background:#ffffff05}.is-hero .bl-hd-thumb img{transition:none}.bl-hd-thumbs.is-busy .bl-hd-thumb:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:bl-hd-shimmer 1.2s linear infinite}@keyframes bl-hd-shimmer{0%{transform:translate(-100%)}to{transform:translate(100%)}}.bl-hd-foot{margin-top:11px;font-size:11px;color:var(--fg-4);white-space:nowrap}.bl-hd-ring{position:absolute;inset:-4px;border-radius:19px;border:1.7px solid var(--amethyst-500);box-shadow:0 0 0 4.5px #9968df33;opacity:0}.bl-hd-note{position:absolute;display:flex;flex-direction:column;padding:16px;border-radius:16px;box-shadow:inset 0 1px #ffffff1a,0 18px 60px #0508144d}.bl-hd-note .text{flex:1;font-size:13.5px;line-height:1.45;color:#ffffffdb;letter-spacing:-.005em}.bl-hd-note .meta{margin-top:8px;font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#ffffff61}.bl-hd-note.is-amethyst{background:linear-gradient(180deg,#9968df33,#9968df17),#0b0b16;border:1px solid rgba(194,164,236,.24)}.bl-hd-note.is-amber{background:linear-gradient(180deg,#f0b44a2e,#f0b44a14),#0d0b0c;border:1px solid rgba(247,212,143,.22)}.bl-hd-note.is-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14),#0d0a12;border:1px solid rgba(245,163,199,.22)}.bl-hd-note.is-mint{background:linear-gradient(180deg,#34c79a29,#34c79a12),#080d10;border:1px solid rgba(143,229,201,.2)}.bl-hd.is-opening .bl-hd-frame,.bl-hd.is-opening .bl-hd-pic:not(.is-result),.bl-hd.is-opening .bl-hd-session,.bl-hd.is-opening .bl-hd-note{--p: clamp(0, calc((var(--build, 0) - var(--d, 0)) * 2.5), 1);--q: calc(1 - var(--p));opacity:var(--p);transform:translate3d(0,calc(var(--q) * var(--q) * 56px),0) scale(calc(1 - .1 * var(--q) * var(--q)));filter:blur(calc(var(--q) * var(--q) * 16px))}.bl-hd.is-opening .bl-hd-frame:after,.bl-hd.is-opening .bl-hd-pic:not(.is-result):after,.bl-hd.is-opening .bl-hd-session:after,.bl-hd.is-opening .bl-hd-note:after{content:"";position:absolute;inset:calc(-3px * var(--iz, 1));border-radius:inherit;pointer-events:none;box-shadow:0 0 0 calc(1.5px * var(--iz, 1)) #decefaeb,0 0 calc(26px * var(--iz, 1)) calc(4px * var(--iz, 1)) #9968df80;opacity:0}.bl-hd.is-opening .bl-hd-pic:not(.is-result):after{inset:0;z-index:1;box-shadow:inset 0 0 0 calc(2.5px * var(--iz, 1)) #decefaf2,inset 0 0 calc(38px * var(--iz, 1)) #9968dfb3;opacity:var(--g-pic, 0)}.bl-hd.is-opening .bl-hd-session:after{opacity:var(--g-session, 0)}.bl-hd.is-opening .bl-hd-note:after{opacity:var(--g-note, 0)}.bl-hd.is-opening .bl-hd-frame:after{opacity:var(--g-frame, 0)}.bl-hd-dock{position:absolute;left:50%;z-index:2;display:flex;align-items:center;gap:6px;padding:5px;border-radius:15px;background:#121521e6;border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff14,0 30px 80px #0206178c}.bl-hd-add{display:inline-flex;height:34px;border-radius:10px;overflow:hidden;background:var(--grad-cta);color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-add.is-plus{width:34px;align-items:center;justify-content:center}.bl-hd-add.is-plus .licon{transition:transform .3s cubic-bezier(.16,1,.3,1)}.bl-hd-add.is-plus.is-open .licon{transform:rotate(45deg)}.bl-hd-rail{display:inline-flex;align-items:center;gap:2px}.bl-hd-rail i{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:9px;color:var(--fg-3)}.bl-hd-rail i.is-on{background:#9968df29;color:#fff}.bl-hd-rail b{width:1px;height:18px;margin:0 4px;background:var(--hairline-soft)}.bl-hd-prompt{position:absolute;z-index:2;border-radius:18px;border:1px solid rgba(255,255,255,.075);background:#0b0d15fb;box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 30px 80px #02040c9e;visibility:hidden}.bl-hd-prompt-side{position:absolute;left:12px;top:12px;display:flex;flex-direction:column;gap:7px}.bl-hd-prompt-side i{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:9px;color:var(--fg-4)}.bl-hd-slot{position:absolute;display:flex;align-items:center;justify-content:center;border-radius:10px;border:1px dashed rgba(255,255,255,.16);background:#ffffff05;color:var(--fg-4)}.bl-hd-slot.is-target{border:1px solid rgba(194,164,236,.7);background:#9968df24;color:var(--amethyst-700)}.bl-hd-slot img{position:absolute;inset:-1px;width:calc(100% + 2px);height:calc(100% + 2px);border-radius:10px;transition:none}.bl-hd-slot .glow{position:absolute;inset:-4px;z-index:1;border-radius:13px;box-shadow:0 0 0 1.5px #c2a4ecd9,0 0 22px 4px #9968df6b;opacity:0}.bl-hd-prompt-text{position:absolute;left:54px;right:18px;top:66px;height:22px;white-space:nowrap;font-size:15px;line-height:22px;letter-spacing:-.005em;color:#fff}.bl-hd-prompt-text .ph{position:absolute;left:0;top:0;color:var(--fg-4)}.bl-hd-prompt-text .caret{display:inline-block;width:1.5px;height:18px;margin-left:1px;vertical-align:-3px;border-radius:1px;background:var(--amethyst-700)}.bl-hd-prompt-foot{position:absolute;left:54px;right:12px;bottom:12px;display:flex;align-items:center;gap:7px}.bl-hd-prompt-foot .chip{display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 11px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:12px;color:var(--fg-2);white-space:nowrap}.bl-hd-prompt-foot .chip small{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.bl-hd-prompt-foot .chip .licon{color:var(--fg-4)}.bl-hd-prompt-foot .cog{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;color:var(--fg-4)}.bl-hd-prompt-foot .sp{flex:1}.bl-hd-prompt-foot .step{display:inline-flex;align-items:center;gap:10px;height:30px;padding:0 11px;border-radius:999px;border:1px solid rgba(255,255,255,.08);color:var(--fg-4);font-size:12.5px}.bl-hd-prompt-foot .step b{color:#fff;font-weight:600}.bl-hd-prompt-foot .run{position:relative;isolation:isolate;display:inline-flex;align-items:center;justify-content:center;height:30px;border-radius:999px;background:#ffffff12;font-size:12.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-4);transition:color .3s,box-shadow .3s,transform .12s var(--ease-out-soft),opacity .2s}.bl-hd-prompt-foot .run:before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;background:var(--grad-cta);opacity:0;transition:opacity .3s}.bl-hd-prompt-foot .run.is-lit{color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-prompt-foot .run.is-lit:before{opacity:1}.bl-hd-prompt-foot .run.is-pressed{transform:scale(.95)}.bl-hd-prompt-foot .run.is-busy{opacity:.72}.bl-hd-zoom{position:absolute;right:16px;z-index:2;display:inline-flex;align-items:center;gap:10px;height:34px;padding:0 11px;border-radius:12px;background:#121521e6;border:1px solid var(--hairline);color:var(--fg-4);font-size:12px}.bl-hd-zoom .pct{min-width:30px;text-align:center;color:var(--fg-2);font-variant-numeric:tabular-nums}.bl-hd-ghost{position:absolute;left:0;top:0;z-index:5;width:54px;height:72px;border-radius:8px;opacity:0;transform-origin:0 0;box-shadow:0 16px 40px #0000008c}.bl-hd-ghost img{border-radius:8px}.bl-hd-ghost .ring{position:absolute;inset:-3px;border-radius:10px;box-shadow:0 0 0 1.5px var(--amethyst-700),0 0 18px #9968df80;opacity:0}.bl-hd-ripple{position:absolute;left:-18px;top:-18px;z-index:6;width:36px;height:36px;border-radius:50%;border:1.5px solid rgba(255,255,255,.9);opacity:0}.bl-hd-pointer{position:absolute;left:0;top:0;z-index:7;opacity:0}.bl-hd-pointer .arrow{display:block;margin:-3px 0 0 -4px;filter:drop-shadow(0 3px 6px rgba(0,0,0,.45));transform-origin:4px 3px;transition:transform .09s ease-out}.bl-hd-pointer.is-pressed .arrow{transform:scale(.86)}.bl-hd-key{position:absolute;left:16px;top:-26px;padding:3px 7px;border-radius:6px;background:#f5f5faf5;box-shadow:0 1px #00000040,0 6px 16px #00000059;font-size:11px;font-weight:600;white-space:nowrap;color:#11131c;opacity:0}.bl-hd-sheen{position:absolute;top:-10%;bottom:-10%;left:0;z-index:8;width:60%;opacity:0;pointer-events:none;background:linear-gradient(105deg,transparent 25%,rgba(255,255,255,.1) 50%,transparent 75%);mix-blend-mode:screen}@media(max-width:900px){.bl-hero{--stage-w: 92%;margin:0 0 30px;border-radius:22px}.bl-hero-pause{top:14px;right:14px;bottom:auto}.bl-hero-corner{top:14px;right:56px}.bl-hero-copy{padding-top:54px}.bl-sub{font-size:14.5px}}@media(max-width:600px){.bl-hero-stage,.bl-hero-room{display:none}.bl-hero-copy{padding:52px 18px 34px}.bl-hero.is-min{margin-bottom:18px}.bl-hero.is-min .bl-hero-copy{padding:4px 0 0}.bl-hero.is-min .bl-hero-actions{flex:1 1 100%;justify-content:flex-start}}', Rg = ".bd-root.bd-tip{position:fixed;left:0;top:0;z-index:2147483600;pointer-events:none;display:flex;flex-direction:column;gap:3px;width:max-content;max-width:280px;padding:6px 10px 7px;border-radius:9px;background:#131520fa;border:1px solid rgba(255,255,255,.11);box-shadow:inset 0 1px #ffffff0b,0 12px 32px #02040c8c,0 2px 8px #02040c66;color:var(--fg-1);font-size:12px;font-weight:500;line-height:1.35;letter-spacing:-.005em;text-align:left;white-space:normal;overflow-wrap:anywhere;opacity:0;transform:translateY(3px);transition:opacity .12s ease,transform .16s var(--ease-out-soft)}.bd-root.bd-tip.is-below{transform:translateY(-3px)}.bd-root.bd-tip.on{opacity:1;transform:none}.bd-root.bd-tip.is-now{transition:none}.bd-tip .ln{display:flex;align-items:center;gap:10px}.bd-tip .tx{flex:1 1 auto;min-width:0}.bd-tip .keys{flex:none;display:inline-flex;gap:3px;margin-right:-3px}.bd-tip kbd{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid rgba(255,255,255,.1);background:#ffffff12;box-shadow:inset 0 -1px #0000004d;color:var(--fg-2);font-family:var(--font-sans);font-size:10.5px;font-weight:600;line-height:1}.bd-tip .hint{font-size:11.5px;font-weight:400;line-height:1.4;color:var(--fg-3)}@media(prefers-reduced-motion:reduce){.bd-root.bd-tip,.bd-root.bd-tip.is-below{transition:none;transform:none}}", Pg = 260, Dg = 400, Zs = 8, eo = 8, us = "bd-tip", Qs = "(?:Esc|Enter|Del|Space|Tab|↵|⌫|[←→↑↓\\[\\]/\\\\,.=+\\-?])", Og = new RegExp("^(?:[A-Z]|" + Qs + "|[⌘⇧⌥⌃]+(?:[A-Z0-9]|" + Qs + ")|(?:(?:Ctrl|Alt|Shift|Cmd)\\+)+(?:[A-Z0-9]|" + Qs + "))$");
function Ta(e) {
  const [t, ...n] = e.split(`
`), o = t.trim(), s = /^(.*\S)\s+\(([^()]+)\)$/.exec(o), r = s ? s[2].trim() : "", l = s && Og.test(r) ? Fg(r) : [];
  return { label: l.length ? s[1] : o, keys: l, hint: n.map((i) => i.trim()).filter(Boolean).join(" ") };
}
function Fg(e) {
  const t = /^((?:(?:Ctrl|Alt|Shift|Cmd)\+)+)(.+)$/.exec(e);
  if (t) return [...t[1].split("+").filter(Boolean), t[2]];
  const n = /^([⌘⇧⌥⌃]*)(.+)$/u.exec(e);
  return n ? [...Array.from(n[1]), n[2]] : [e];
}
let jo = 0, Cn = null, Ye = null, Be = null, jr = "pointer", zs = !1, Wn = !1, Vr = -1 / 0, fs = 0, yr = 0, co = null;
const gn = /* @__PURE__ */ new WeakMap(), xr = /* @__PURE__ */ new WeakSet();
function Ea(e) {
  const t = e instanceof Element ? e : null, n = t ? t.closest("[title]") : null;
  return !n || !n.closest(".bd-root") || n === Ye || !gn.has(n) && !(n.getAttribute("title") || "").trim() ? null : n;
}
function Bg(e) {
  const t = gn.get(e);
  if (t != null) return t;
  const n = e.getAttribute("title");
  return !n || !n.trim() ? null : (gn.set(e, n), e.setAttribute("title", ""), !e.hasAttribute("aria-label") && !e.hasAttribute("aria-labelledby") && !(e.textContent || "").trim() && (e.setAttribute("aria-label", Ta(n).label), xr.add(e)), n);
}
function Ng(e) {
  const t = gn.get(e);
  gn.delete(e), t != null && e.getAttribute("title") === "" && e.setAttribute("title", t), xr.has(e) && (e.removeAttribute("aria-label"), xr.delete(e));
  const n = (e.getAttribute("aria-describedby") || "").split(/\s+/).filter((o) => o && o !== us);
  n.length ? e.setAttribute("aria-describedby", n.join(" ")) : e.removeAttribute("aria-describedby");
}
function Ug() {
  if (!Be) return;
  const e = Be.getAttribute("title");
  if (e !== "") {
    if (e == null) {
      gn.delete(Be), Hr();
      return;
    }
    gn.set(Be, e), Be.setAttribute("title", ""), Wn && wr(!0);
  }
}
function La(e, t) {
  Bg(e) != null && (Be = e, jr = t, zs = !1, co = new MutationObserver(Ug), co.observe(e, { attributes: !0, attributeFilter: ["title"] }), clearTimeout(fs), performance.now() - Vr < Dg ? wr(!0) : fs = window.setTimeout(() => wr(!1), Pg));
}
function Gn() {
  clearTimeout(fs), co && co.disconnect(), co = null;
  const e = Be;
  Be = null, zs = !1, Hr(), e && Ng(e);
}
function jg() {
  return Ye && Ye.isConnected || (Ye = document.createElement("div"), Ye.className = "bd-root bd-tip", Ye.id = us, Ye.setAttribute("role", "tooltip"), Ye.setAttribute("data-testid", "board-tip"), document.body.appendChild(Ye)), Ye;
}
function Vg(e, t) {
  e.replaceChildren();
  const n = document.createElement("span");
  n.className = "ln";
  const o = document.createElement("span");
  if (o.className = "tx", o.textContent = t.label, n.appendChild(o), t.keys.length) {
    const s = document.createElement("span");
    s.className = "keys";
    for (const r of t.keys) {
      const l = document.createElement("kbd");
      l.textContent = r, s.appendChild(l);
    }
    n.appendChild(s);
  }
  if (e.appendChild(n), t.hint) {
    const s = document.createElement("span");
    s.className = "hint", s.textContent = t.hint, e.appendChild(s);
  }
}
function Hg(e, t) {
  const n = t.getBoundingClientRect(), o = e.offsetWidth, s = e.offsetHeight;
  let r = n.top - Zs - s, l = !1;
  r < eo && (r = n.bottom + Zs, l = !0, r + s > window.innerHeight - eo && (r = Math.max(eo, n.top - Zs - s), l = !1));
  const i = Math.max(eo, Math.min(window.innerWidth - eo - o, n.left + n.width / 2 - o / 2));
  e.classList.toggle("is-below", l), e.style.left = Math.round(i) + "px", e.style.top = Math.round(r) + "px";
}
function wr(e) {
  const t = Be, n = t ? gn.get(t) : null;
  if (!t || !n || zs || !t.isConnected || t.querySelector(".tip")) return;
  const o = jg();
  Vg(o, Ta(n)), o.classList.toggle("is-now", e || Wn), Wn || o.classList.remove("on"), Hg(o, t), o.offsetWidth, o.classList.add("on"), Wn = !0, Vr = performance.now();
  const s = (t.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
  s.includes(us) || t.setAttribute("aria-describedby", [...s, us].join(" ")), clearInterval(yr), yr = window.setInterval(() => {
    (!Be || !Be.isConnected) && Gn();
  }, 250);
}
function Hr() {
  clearTimeout(fs), clearInterval(yr), Wn && (Vr = performance.now()), Wn = !1, Ye && Ye.classList.remove("on");
}
function Kl(e) {
  if (e.pointerType === "touch") return;
  const t = Ea(e.target);
  t !== Be && (Be && Gn(), t && !e.buttons && La(t, "pointer"));
}
function ql(e) {
  Be && jr === "pointer" && !e.relatedTarget && Gn();
}
function $t() {
  Be && (zs = !0, Hr());
}
function Wl(e) {
  e.key === "Escape" && $t();
}
function Yl(e) {
  const t = e.target;
  Be && (t === document || t instanceof Node && t.contains(Be)) && $t();
}
function Gl(e) {
  const t = e.target;
  if (!(t instanceof HTMLElement) || !t.matches(":focus-visible")) return;
  const n = Ea(t);
  !n || n === Be || (Be && Gn(), La(n, "focus"));
}
function Xl() {
  Be && jr === "focus" && Gn();
}
function Kg() {
  if (typeof document == "undefined") return () => {
  };
  jo++, jo === 1 && (Cn = document.createElement("style"), Cn.setAttribute("data-rd-board-tips", ""), Cn.textContent = Rg, document.head.appendChild(Cn), document.addEventListener("pointerover", Kl, !0), document.addEventListener("pointerout", ql, !0), document.addEventListener("pointerdown", $t, !0), document.addEventListener("keydown", Wl, !0), document.addEventListener("focusin", Gl, !0), document.addEventListener("focusout", Xl, !0), window.addEventListener("scroll", Yl, !0), window.addEventListener("wheel", $t, { capture: !0, passive: !0 }), window.addEventListener("blur", $t), window.addEventListener("resize", $t));
  let e = !1;
  return () => {
    e || (e = !0, jo--, !(jo > 0) && (Gn(), document.removeEventListener("pointerover", Kl, !0), document.removeEventListener("pointerout", ql, !0), document.removeEventListener("pointerdown", $t, !0), document.removeEventListener("keydown", Wl, !0), document.removeEventListener("focusin", Gl, !0), document.removeEventListener("focusout", Xl, !0), window.removeEventListener("scroll", Yl, !0), window.removeEventListener("wheel", $t, !0), window.removeEventListener("blur", $t), window.removeEventListener("resize", $t), Ye && Ye.remove(), Ye = null, Cn && Cn.remove(), Cn = null));
  };
}
const qg = `
/* the list sits in the host's page, inside .v-application: undo what its resets reach */
.bl-root input[type="search"]::-webkit-search-cancel-button { -webkit-appearance: none; appearance: none; }
.bl-root button { text-transform: none; letter-spacing: normal; }
`;
let Vo = 0, Zt = null;
function Wg() {
  return Vo++, Zt || (Zt = document.createElement("style"), Zt.setAttribute("data-rd-boards-list", ""), Zt.textContent = [Tg, Eg, Lg, d1, qg].join(`
`), document.head.appendChild(Zt)), () => {
    Vo = Math.max(0, Vo - 1), !Vo && Zt && (Zt.remove(), Zt = null);
  };
}
function Gg(e, t) {
  const n = Wg(), o = Kg(), s = /* @__PURE__ */ U(t.user), r = /* @__PURE__ */ U(t.account), l = /* @__PURE__ */ U(t.permissions), i = /* @__PURE__ */ U(t.labels), a = /* @__PURE__ */ U(t.stickyTop || 0);
  let d;
  if (t.source) d = t.source;
  else if (t.firebase && t.api) d = zg(t.firebase, t.api, () => s.value);
  else throw new Error("mountBoardsList needs a source, or the host's firebase and api");
  const c = {
    user: s,
    account: r,
    permissions: l,
    labels: i,
    stickyTop: a,
    source: () => d,
    actions: {
      open: t.openBoard,
      // the list's own Edit and Access Settings dialogs (BoardsListApp) take these
      edit: null,
      access: null,
      classic: t.openClassic || null,
      prefetch: t.prefetchBoard || null,
      tour: t.openTour || null
    },
    notify: t.notify || null,
    createDemo: t.createDemoBoard || null,
    openStress: t.openStress || null,
    backend: t.backend || (t.firebase ? "Firebase project " + (t.firebase.db.app.options.projectId || "unknown") : "this browser (the harness)")
  }, f = eu(Mg, { env: c });
  return f.config.errorHandler = (p) => console.error("[boards]", p), f.mount(e), {
    update(p) {
      p.user && (s.value = p.user), p.account && (r.value = p.account), p.permissions && (l.value = p.permissions), p.labels && (i.value = p.labels), typeof p.stickyTop == "number" && (a.value = p.stickyTop);
    },
    unmount() {
      f.unmount(), o(), n();
    }
  };
}
export {
  Gg as mountBoardsList
};
